export default {
    "scalars": [
        3,
        6,
        8,
        9,
        13,
        14,
        24,
        29,
        30,
        31,
        32,
        39,
        49,
        51,
        70,
        72,
        78,
        84,
        85,
        86,
        91,
        95,
        99,
        103,
        104,
        110,
        115,
        117,
        119,
        124,
        137,
        143,
        147,
        162,
        166,
        173,
        174,
        178,
        182,
        183,
        185,
        187,
        188,
        194,
        195,
        198,
        200,
        201,
        203,
        204,
        208,
        209,
        212,
        213,
        220,
        221,
        228,
        229,
        233,
        236,
        238,
        240,
        241,
        251,
        268,
        269,
        271,
        272,
        281,
        282,
        286,
        287,
        295,
        296,
        303,
        304,
        305,
        309,
        310,
        318,
        324,
        329,
        330,
        331,
        333,
        336,
        337,
        345,
        346,
        347,
        348,
        349,
        355,
        357,
        360,
        362,
        364,
        365,
        366,
        372,
        376,
        377,
        418,
        422,
        424,
        430,
        431,
        432,
        433,
        435,
        436,
        437,
        442,
        446,
        458,
        468,
        469,
        475,
        476,
        478,
        479,
        492,
        493,
        508,
        513,
        514,
        519,
        523,
        529,
        532,
        534,
        535,
        549,
        558,
        559,
        560,
        563,
        566,
        567,
        570,
        573,
        575,
        576,
        577,
        579,
        580,
        582,
        589,
        593,
        606,
        607,
        611,
        612,
        613,
        617,
        618,
        624,
        626,
        630,
        631,
        635,
        636,
        637,
        638,
        646,
        647,
        649,
        657,
        659,
        661,
        666,
        677,
        678,
        680,
        684,
        685,
        695,
        696,
        701,
        702,
        703,
        706,
        707,
        714,
        715,
        725,
        727,
        728,
        732,
        738,
        740,
        745,
        746,
        747,
        750,
        753,
        756,
        768,
        771,
        782,
        783,
        784,
        785,
        788,
        789,
        790,
        795,
        805,
        809,
        810,
        823,
        824,
        825,
        826,
        827,
        828,
        830,
        831,
        836,
        837,
        841,
        843,
        844,
        845,
        846,
        848,
        862,
        866,
        867,
        868,
        875,
        876,
        878,
        887,
        888,
        901,
        902,
        906,
        907,
        908,
        909,
        913,
        914,
        915,
        916,
        927,
        928,
        929,
        931,
        932,
        936,
        938,
        950,
        953,
        954,
        955,
        960,
        962,
        968,
        979,
        981,
        984,
        986,
        991,
        993,
        1007,
        1008,
        1012,
        1014,
        1015,
        1020,
        1028,
        1048,
        1050,
        1054,
        1055,
        1056,
        1057,
        1058,
        1064,
        1065,
        1066,
        1196
    ],
    "types": {
        "ACHPayment": {
            "achNumber": [
                955
            ],
            "amount": [
                286
            ],
            "bankId": [
                345
            ],
            "id": [
                345
            ],
            "legalHold": [
                85
            ],
            "paymentSchedule": [
                785
            ],
            "purchaseId": [
                345
            ],
            "type": [
                637
            ],
            "__typename": [
                955
            ]
        },
        "ATMPayment": {
            "amount": [
                286
            ],
            "atmId": [
                345
            ],
            "financialAccountId": [
                345
            ],
            "id": [
                345
            ],
            "legalHold": [
                85
            ],
            "paymentSchedule": [
                785
            ],
            "purchaseId": [
                345
            ],
            "type": [
                637
            ],
            "__typename": [
                955
            ]
        },
        "Account": {
            "accountId": [
                345
            ],
            "accountSubtype": [
                9
            ],
            "accountType": [
                14
            ],
            "activityType": [
                3
            ],
            "childAccounts": [
                2
            ],
            "code": [
                955
            ],
            "createdAt": [
                198
            ],
            "currencyCode": [
                173
            ],
            "isCash": [
                85
            ],
            "name": [
                955
            ],
            "normality": [
                573
            ],
            "parentAccount": [
                2
            ],
            "parentAccountId": [
                345
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "AccountActivityType": {},
        "AccountConnection": {
            "edges": [
                5
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "AccountEdge": {
            "node": [
                2
            ],
            "__typename": [
                955
            ]
        },
        "AccountEntryType": {},
        "AccountImpactSummary": {
            "accountName": [
                955
            ],
            "credits": [
                286
            ],
            "debits": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "AccountSubType": {},
        "AccountSubtype": {},
        "AccountTotalAmount": {
            "accountId": [
                345
            ],
            "accountName": [
                955
            ],
            "totalAmount": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "AccountTotalAmountConnection": {
            "edges": [
                12
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "AccountTotalAmountEdge": {
            "node": [
                10
            ],
            "__typename": [
                955
            ]
        },
        "AccountTransactionType": {},
        "AccountType": {},
        "AccountTypesToSubtypesMap": {
            "accountSubtypes": [
                9
            ],
            "accountType": [
                14
            ],
            "normality": [
                573
            ],
            "__typename": [
                955
            ]
        },
        "AccountingAgingCategory": {
            "accountingAgingCategoryId": [
                955
            ],
            "accountingAgingCategoryName": [
                955
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "creatorId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "endDays": [
                357
            ],
            "startDays": [
                357
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "AccountingAgingCategoryConnection": {
            "edges": [
                18
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "AccountingAgingCategoryEdge": {
            "cursor": [
                955
            ],
            "node": [
                16
            ],
            "__typename": [
                955
            ]
        },
        "AccountingEntry": {
            "accountingEntryId": [
                955
            ],
            "createdAt": [
                194
            ],
            "date": [
                194
            ],
            "deletedAt": [
                194
            ],
            "description": [
                955
            ],
            "materialAdjustment": [
                537
            ],
            "materialAdjustmentId": [
                955
            ],
            "outboundScaleTicket": [
                584
            ],
            "outboundScaleTicketId": [
                955
            ],
            "scaleTicket": [
                877
            ],
            "scaleTicketId": [
                955
            ],
            "type": [
                6
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "AccountingEntryConnection": {
            "edges": [
                22
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "AccountingEntryDetail": {
            "accountingEntry": [
                19
            ],
            "accountingEntryDetailId": [
                955
            ],
            "accountingEntryId": [
                955
            ],
            "amount": [
                357
            ],
            "chartAccount": [
                106
            ],
            "chartAccountId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "quantity": [
                357
            ],
            "updatedAt": [
                194
            ],
            "weight": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "AccountingEntryEdge": {
            "cursor": [
                955
            ],
            "node": [
                19
            ],
            "__typename": [
                955
            ]
        },
        "AccountingPeriod": {
            "accountingPeriodId": [
                345
            ],
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "closeDate": [
                194
            ],
            "closedAt": [
                198
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "endDate": [
                198
            ],
            "lockDate": [
                194
            ],
            "startDate": [
                198
            ],
            "type": [
                24
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "AccountingPeriodType": {},
        "ActionInput": {
            "create": [
                502
            ],
            "delete": [
                1033
            ],
            "update": [
                1033
            ],
            "__typename": [
                955
            ]
        },
        "ActivateInventoryPeriodInput": {
            "periodId": [
                345
            ],
            "startDate": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "AddDeductionToPurchaseItemResult": {
            "deduction": [
                199
            ],
            "item": [
                441
            ],
            "purchase": [
                763
            ],
            "__typename": [
                955
            ]
        },
        "AddDeductionToPurchaseResult": {
            "deduction": [
                199
            ],
            "purchase": [
                763
            ],
            "__typename": [
                955
            ]
        },
        "AddressInputType": {},
        "AdjustmentQuantityEntryType": {},
        "AdjustmentType": {},
        "AdjustmentWacEntryType": {},
        "AggregateError": {
            "errors": [
                255
            ],
            "__typename": [
                955
            ]
        },
        "AmazonFields": {
            "algorithm": [
                955
            ],
            "bucket": [
                955
            ],
            "credential": [
                955
            ],
            "date": [
                955
            ],
            "policy": [
                955
            ],
            "signature": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ApiKey": {
            "apiKey": [
                955
            ],
            "apiKeyName": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "createdAt": [
                194
            ],
            "mostRecentIP": [
                955
            ],
            "mostRecentUse": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ApiKeyConnection": {
            "edges": [
                37
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ApiKeyEdge": {
            "cursor": [
                955
            ],
            "node": [
                35
            ],
            "__typename": [
                955
            ]
        },
        "AppVersion": {
            "binaryAppVersion": [
                955
            ],
            "codePushLabel": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "AppVersionStatus": {},
        "Asset": {
            "assetCommodity": [
                536
            ],
            "assetDescription": [
                42
            ],
            "assetId": [
                49
            ],
            "assetMovements": [
                50
            ],
            "assetName": [
                955
            ],
            "assetTare": [
                357
            ],
            "assetType": [
                52,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "assignedCompanies": [
                130
            ],
            "createdAt": [
                194
            ],
            "currentCompany": [
                130
            ],
            "currentLocation": [
                524
            ],
            "customAttributes": [
                446
            ],
            "gpsIdentifier": [
                955
            ],
            "gpsLocation": [
                314
            ],
            "grade": [
                337
            ],
            "lastMoved": [
                194
            ],
            "locked": [
                85
            ],
            "materialId": [
                955
            ],
            "notes": [
                955
            ],
            "payloads": [
                619
            ],
            "primaryGroup": [
                338
            ],
            "privilegedFacilities": [
                524
            ],
            "privilegedGroups": [
                338
            ],
            "recycler": [
                96
            ],
            "status": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "AssetConnection": {
            "edges": [
                45
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "AssetDescription": {
            "assetDescription": [
                955
            ],
            "assetDescriptionId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "AssetDescriptionConnection": {
            "edges": [
                44
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "AssetDescriptionEdge": {
            "cursor": [
                955
            ],
            "node": [
                42
            ],
            "__typename": [
                955
            ]
        },
        "AssetEdge": {
            "cursor": [
                955
            ],
            "node": [
                40
            ],
            "__typename": [
                955
            ]
        },
        "AssetHistory": {
            "asset": [
                40
            ],
            "assetHistoryId": [
                955
            ],
            "assetMovement": [
                50
            ],
            "centralizedCompanyId": [
                955
            ],
            "daysOnSite": [
                357
            ],
            "job": [
                447
            ],
            "jobNumber": [
                357
            ],
            "serviceDate": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "AssetHistoryConnection": {
            "edges": [
                48
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "AssetHistoryEdge": {
            "cursor": [
                955
            ],
            "node": [
                46
            ],
            "__typename": [
                955
            ]
        },
        "AssetId": {},
        "AssetMovement": {
            "asset": [
                40
            ],
            "assetMovementId": [
                955
            ],
            "creator": [
                1037
            ],
            "date": [
                194
            ],
            "fromLocation": [
                524
            ],
            "recycler": [
                96
            ],
            "toLocation": [
                524
            ],
            "__typename": [
                955
            ]
        },
        "AssetTransportationCompatibility": {},
        "AssetType": {
            "assetDescriptions": [
                42
            ],
            "assetTypeCategory": [
                955
            ],
            "assetTypeId": [
                955
            ],
            "assetTypeValue": [
                955
            ],
            "flexibleQuantity": [
                85
            ],
            "numAssets": [
                357
            ],
            "transportationTypes": [
                1017
            ],
            "utilizationRate": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "AssetTypeConnection": {
            "edges": [
                55
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "AssetTypeCount": {
            "assetType": [
                52
            ],
            "count": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "AssetTypeEdge": {
            "cursor": [
                955
            ],
            "node": [
                52
            ],
            "__typename": [
                955
            ]
        },
        "AssetTypeQuantity": {
            "assetTypeId": [
                955
            ],
            "assetTypeValue": [
                955
            ],
            "quantity": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "Atm": {
            "address": [
                955
            ],
            "atmId": [
                955
            ],
            "description": [
                955
            ],
            "facilityId": [
                955
            ],
            "ipAddress": [
                955
            ],
            "online": [
                85
            ],
            "port": [
                357
            ],
            "serviceUrl": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "AtmConnection": {
            "edges": [
                59
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "AtmEdge": {
            "cursor": [
                955
            ],
            "node": [
                57
            ],
            "__typename": [
                955
            ]
        },
        "Attachable": {
            "attachableId": [
                955
            ],
            "files": [
                847
            ],
            "__typename": [
                955
            ]
        },
        "AuditLog": {
            "auditLogId": [
                955
            ],
            "auditableId": [
                955
            ],
            "auditableTable": [
                955
            ],
            "centralizedCompanyId": [
                955
            ],
            "entityIdentifierForUser": [
                955
            ],
            "event": [
                955
            ],
            "newValues": [
                446
            ],
            "oldValues": [
                446
            ],
            "platform": [
                955
            ],
            "requestId": [
                955
            ],
            "timestamp": [
                955
            ],
            "updaterId": [
                955
            ],
            "updaterName": [
                955
            ],
            "updaterType": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "AuditLogConnection": {
            "edges": [
                63
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "AuditLogEdge": {
            "cursor": [
                955
            ],
            "node": [
                61
            ],
            "__typename": [
                955
            ]
        },
        "BalanceSheet": {
            "accountingPeriod": [
                23
            ],
            "date": [
                198
            ],
            "lines": [
                829
            ],
            "__typename": [
                955
            ]
        },
        "BalanceSheetError": {
            "message": [
                955
            ],
            "name": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "BalanceSheetResult": {
            "on_BalanceSheet": [
                64
            ],
            "on_BalanceSheetError": [
                65
            ],
            "__typename": [
                955
            ]
        },
        "BankAccount": {
            "accountNumber": [
                955
            ],
            "accountType": [
                70
            ],
            "bankAccountId": [
                955
            ],
            "bankName": [
                955
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "financialAccount": [
                275
            ],
            "routingNumber": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "BankAccountConnection": {
            "edges": [
                69
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "BankAccountEdge": {
            "cursor": [
                955
            ],
            "node": [
                67
            ],
            "__typename": [
                955
            ]
        },
        "BankAccountType": {},
        "BillingInfo": {
            "amount": [
                286
            ],
            "bankAccount": [
                955
            ],
            "bankName": [
                955
            ],
            "billingInfoId": [
                955
            ],
            "nextDueDate": [
                194
            ],
            "plan": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "BlankTicketIdentifierField": {},
        "BlankTicketInfo": {
            "licensePlateNumber": [
                955
            ],
            "truckNumber": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "Booking": {
            "attachments": [
                75
            ],
            "centralizedCompanyId": [
                955
            ],
            "containerTypes": [
                138
            ],
            "createdAt": [
                198
            ],
            "createdBy": [
                869
            ],
            "createdById": [
                345
            ],
            "cutOffDate": [
                198
            ],
            "departureDate": [
                198
            ],
            "destinationCountry": [
                955
            ],
            "destinationPort": [
                674
            ],
            "earlyReturnDate": [
                198
            ],
            "externalNotes": [
                955
            ],
            "facility": [
                849
            ],
            "facilityId": [
                345
            ],
            "freightForwarder": [
                288
            ],
            "freightLine": [
                300
            ],
            "freightPerContainer": [
                286
            ],
            "id": [
                345
            ],
            "internalNotes": [
                955
            ],
            "invoiceDate": [
                198
            ],
            "invoiceDueDate": [
                198
            ],
            "invoiceNumber": [
                955
            ],
            "loadsStatus": [
                79
            ],
            "number": [
                955
            ],
            "originPort": [
                674
            ],
            "photoRequirements": [
                650
            ],
            "salesOrder": [
                80
            ],
            "salesOrderId": [
                345
            ],
            "shippingCarrier": [
                81
            ],
            "status": [
                84
            ],
            "totalInvoiceAmount": [
                286
            ],
            "updatedAt": [
                198
            ],
            "updatedBy": [
                869
            ],
            "updatedById": [
                345
            ],
            "vesselArrivalDate": [
                198
            ],
            "vesselName": [
                955
            ],
            "voidedById": [
                345
            ],
            "__typename": [
                955
            ]
        },
        "BookingAttachment": {
            "bookingId": [
                345
            ],
            "createdAt": [
                198
            ],
            "creatorId": [
                345
            ],
            "downloadUrl": [
                955
            ],
            "id": [
                345
            ],
            "name": [
                955
            ],
            "s3Key": [
                955
            ],
            "size": [
                286
            ],
            "type": [
                955
            ],
            "updatedAt": [
                198
            ],
            "uploadConfirmed": [
                85
            ],
            "url": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "BookingConnection": {
            "edges": [
                77
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "BookingEdge": {
            "node": [
                74
            ],
            "__typename": [
                955
            ]
        },
        "BookingLoadsStatus": {},
        "BookingLoadsStatusObject": {
            "count": [
                357
            ],
            "status": [
                78
            ],
            "__typename": [
                955
            ]
        },
        "BookingSalesOrder": {
            "centralizedCompanyId": [
                345
            ],
            "counterpartyPurchaseOrderNumber": [
                955
            ],
            "customerId": [
                955
            ],
            "customerName": [
                955
            ],
            "id": [
                345
            ],
            "locationId": [
                955
            ],
            "salesOrderNumber": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "BookingShippingCarrier": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                198
            ],
            "id": [
                345
            ],
            "name": [
                955
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "BookingShippingCarrierConnection": {
            "edges": [
                83
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "BookingShippingCarrierEdge": {
            "node": [
                81
            ],
            "__typename": [
                955
            ]
        },
        "BookingStatus": {},
        "Boolean": {},
        "CarrierType": {},
        "CashFlowStatement": {
            "accountingPeriod": [
                23
            ],
            "date": [
                198
            ],
            "lines": [
                829
            ],
            "__typename": [
                955
            ]
        },
        "CashFlowStatementError": {
            "message": [
                955
            ],
            "name": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "CashFlowStatementResult": {
            "on_CashFlowStatement": [
                87
            ],
            "on_CashFlowStatementError": [
                88
            ],
            "__typename": [
                955
            ]
        },
        "CashPayment": {
            "amount": [
                286
            ],
            "financialAccountId": [
                345
            ],
            "id": [
                345
            ],
            "legalHold": [
                85
            ],
            "paymentSchedule": [
                785
            ],
            "purchaseId": [
                345
            ],
            "type": [
                637
            ],
            "__typename": [
                955
            ]
        },
        "CashTransactionType": {},
        "CatalyticConverter": {
            "averageAcquisitionCost": [
                286
            ],
            "catalyticConverterId": [
                955
            ],
            "inventoryState": [
                371
            ],
            "inventoryValuation": [
                434,
                {
                    "facilityId": [
                        955
                    ],
                    "valuationAt": [
                        198
                    ]
                }
            ],
            "materialGroup": [
                541
            ],
            "materialGroupId": [
                955
            ],
            "materialName": [
                955
            ],
            "materialNotes": [
                955
            ],
            "materials": [
                536
            ],
            "skuNumber": [
                955
            ],
            "wipInventory": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "CatalyticConverterConnection": {
            "edges": [
                94
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "CatalyticConverterEdge": {
            "cursor": [
                955
            ],
            "node": [
                92
            ],
            "__typename": [
                955
            ]
        },
        "CatalyticConverterSize": {},
        "CentralizedCompany": {
            "activatedAt": [
                194
            ],
            "centralizedCompanyId": [
                955
            ],
            "companyName": [
                955
            ],
            "companyPerspectives": [
                130
            ],
            "createdAt": [
                194
            ],
            "credentialledCentralizedCompanyId": [
                955
            ],
            "defaultCurrency": [
                173
            ],
            "drivers": [
                223
            ],
            "enableTaxRates": [
                85
            ],
            "equipmentAccountManagers": [
                1037
            ],
            "ezCashEndpoint": [
                955
            ],
            "ezCashToken": [
                955
            ],
            "facilities": [
                524
            ],
            "featureFlags": [
                446
            ],
            "groups": [
                338
            ],
            "hasEquipmentIntegration": [
                85
            ],
            "hasEquipmentPortalAccess": [
                85
            ],
            "hasFacilitiesInKansas": [
                85
            ],
            "hasFacilitiesInOhio": [
                85
            ],
            "hasFacilitiesInPuertoRico": [
                85
            ],
            "hasFacilitiesInTexas": [
                85
            ],
            "hasFacilitiesOutOfTheUS": [
                85
            ],
            "hasHaulerPortalAccess": [
                85
            ],
            "hasRecyclerConsoleAccess": [
                85
            ],
            "hasSupplierPortalAccess": [
                85
            ],
            "numAssets": [
                357
            ],
            "numFacilities": [
                357
            ],
            "numOfEquipmentChecklists": [
                357
            ],
            "numOfEquipmentUnit": [
                357
            ],
            "onboarded": [
                85
            ],
            "options": [
                583
            ],
            "recyclerCompanies": [
                130
            ],
            "ssoLoginDomain": [
                955
            ],
            "subscriptionType": [
                960
            ],
            "thirdPartyHauler": [
                1004
            ],
            "timezone": [
                955
            ],
            "users": [
                1037
            ],
            "__typename": [
                955
            ]
        },
        "CentralizedCompanyConnection": {
            "edges": [
                98
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "CentralizedCompanyEdge": {
            "cursor": [
                955
            ],
            "node": [
                96
            ],
            "__typename": [
                955
            ]
        },
        "CentralizedCompanyId": {},
        "CentralizedCompanyIntegration": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyIntegrationId": [
                955
            ],
            "createdAt": [
                194
            ],
            "integratedCentralizedCompany": [
                96
            ],
            "integratedCentralizedCompanyId": [
                955
            ],
            "integratedCompanyName": [
                955
            ],
            "integrationType": [
                103
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "CentralizedCompanyIntegrationConnection": {
            "edges": [
                102
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "CentralizedCompanyIntegrationEdge": {
            "cursor": [
                955
            ],
            "node": [
                100
            ],
            "__typename": [
                955
            ]
        },
        "CentralizedCompanyIntegrationType": {},
        "CertificationType": {},
        "Chart": {
            "chartConfig": [
                111
            ],
            "chartType": [
                955
            ],
            "createdAt": [
                198
            ],
            "dateRange": [
                196
            ],
            "description": [
                955
            ],
            "dimensions": [
                955
            ],
            "filters": [
                273
            ],
            "granularity": [
                955
            ],
            "id": [
                345
            ],
            "measures": [
                955
            ],
            "name": [
                955
            ],
            "pivotConfig": [
                671
            ],
            "reportType": [
                955
            ],
            "sorts": [
                948
            ],
            "timeDimension": [
                955
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "ChartAccount": {
            "accountSubType": [
                8
            ],
            "accountType": [
                14
            ],
            "author": [
                955
            ],
            "centralizedCompanyId": [
                955
            ],
            "chartAccountId": [
                955
            ],
            "chartAccountUnit": [
                110
            ],
            "code": [
                955
            ],
            "createdAt": [
                194
            ],
            "cumulative": [
                85
            ],
            "deletedAt": [
                194
            ],
            "description": [
                955
            ],
            "facilityId": [
                955
            ],
            "financialAccountId": [
                955
            ],
            "isDebit": [
                85
            ],
            "materialId": [
                955
            ],
            "name": [
                955
            ],
            "productDescriptionId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ChartAccountConnection": {
            "edges": [
                108
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ChartAccountEdge": {
            "cursor": [
                955
            ],
            "node": [
                106
            ],
            "__typename": [
                955
            ]
        },
        "ChartAccountTag": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "chartAccount": [
                106
            ],
            "chartAccountId": [
                955
            ],
            "chartAccountTagId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "from": [
                194
            ],
            "income": [
                357
            ],
            "loss": [
                357
            ],
            "previousChartAccountTag": [
                109
            ],
            "previousChartAccountTagId": [
                955
            ],
            "to": [
                194
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ChartAccountUnit": {},
        "ChartConfig": {
            "columns": [
                127
            ],
            "showColumnSubtotals": [
                85
            ],
            "showColumnTotals": [
                85
            ],
            "__typename": [
                955
            ]
        },
        "ChartConfigInput": {
            "columns": [
                128
            ],
            "showColumnSubtotals": [
                85
            ],
            "showColumnTotals": [
                85
            ],
            "__typename": [
                955
            ]
        },
        "ChartConnection": {
            "edges": [
                114
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ChartEdge": {
            "node": [
                105
            ],
            "__typename": [
                955
            ]
        },
        "ChartSortField": {},
        "ChartSortInput": {
            "field": [
                115
            ],
            "order": [
                950
            ],
            "__typename": [
                955
            ]
        },
        "CheckFont": {},
        "CheckGovernmentReportingServiceCredentialsOutput": {
            "errorMessage": [
                955
            ],
            "success": [
                85
            ],
            "__typename": [
                955
            ]
        },
        "CheckLayout": {},
        "CheckPayment": {
            "amount": [
                286
            ],
            "attnValue": [
                955
            ],
            "checkMemo": [
                955
            ],
            "checkNumber": [
                955
            ],
            "financialAccountId": [
                345
            ],
            "id": [
                345
            ],
            "legalHold": [
                85
            ],
            "paymentSchedule": [
                785
            ],
            "purchaseId": [
                345
            ],
            "supplierMailToAddress": [
                524
            ],
            "supplierMailToAddressId": [
                345
            ],
            "type": [
                637
            ],
            "__typename": [
                955
            ]
        },
        "CheckTemplate": {
            "checkElementsPosition": [
                446
            ],
            "checkFont": [
                955
            ],
            "checkFontSize": [
                357
            ],
            "checkLayout": [
                955
            ],
            "checkTemplateId": [
                955
            ],
            "checkType": [
                955
            ],
            "displayAttn": [
                85
            ],
            "displayBankName": [
                85
            ],
            "displayCheckNumber": [
                85
            ],
            "displayCutLine": [
                85
            ],
            "displayMemo": [
                85
            ],
            "displayMicr": [
                85
            ],
            "displayPayeeAddress": [
                85
            ],
            "displayPayeeName": [
                85
            ],
            "displayPayeeNameDuplicate": [
                85
            ],
            "displayPhoneNumber": [
                85
            ],
            "displayRecyclerAddress": [
                85
            ],
            "displayRecyclerLogo": [
                85
            ],
            "displayRecyclerName": [
                85
            ],
            "displayScaleTicketNumbers": [
                85
            ],
            "displaySecondSignature": [
                85
            ],
            "displaySignature": [
                85
            ],
            "micrSettings": [
                446
            ],
            "minAmountSecondSignature": [
                357
            ],
            "minAmountSignature": [
                357
            ],
            "secondSignature": [
                847
            ],
            "secondSignatureId": [
                955
            ],
            "signature": [
                847
            ],
            "signatureId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "CheckTemplateConnection": {
            "edges": [
                123
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "CheckTemplateEdge": {
            "cursor": [
                955
            ],
            "node": [
                121
            ],
            "__typename": [
                955
            ]
        },
        "CheckTypes": {},
        "CloneReportTemplateInput": {
            "name": [
                955
            ],
            "relativePeriod": [
                955
            ],
            "reportTemplateId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "CloseInventoryPeriodInput": {
            "notes": [
                955
            ],
            "periodId": [
                345
            ],
            "__typename": [
                955
            ]
        },
        "Column": {
            "alias": [
                955
            ],
            "name": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ColumnInput": {
            "alias": [
                955
            ],
            "name": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "CommercialSupplier": {
            "centralizedCompanyId": [
                345
            ],
            "commercialSupplierId": [
                345
            ],
            "companyName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "Company": {
            "accountManagers": [
                1037
            ],
            "businessLicenseNumber": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "companyId": [
                345
            ],
            "companyJobHistory": [
                447,
                {
                    "locationId": [
                        955
                    ]
                }
            ],
            "companyName": [
                955
            ],
            "companyTransactionHistory": [
                877,
                {
                    "locationId": [
                        955
                    ]
                }
            ],
            "currentAssets": [
                40
            ],
            "customAttributes": [
                446
            ],
            "customCompanyId": [
                955
            ],
            "defaultPaymentSchedule": [
                624
            ],
            "defaultPaymentTerm": [
                627
            ],
            "defaultPaymentTermId": [
                955
            ],
            "defaultPaymentType": [
                637
            ],
            "defaultShipToLocation": [
                524
            ],
            "defaultShipToLocationId": [
                955
            ],
            "files": [
                847
            ],
            "inboundTaxRate": [
                980
            ],
            "inboundTaxRateId": [
                955
            ],
            "inboundTaxRates": [
                980
            ],
            "isCustomer": [
                85
            ],
            "isServiceProvider": [
                85
            ],
            "isSupplier": [
                85
            ],
            "locationManualAssetHistory": [
                50,
                {
                    "locationId": [
                        955
                    ]
                }
            ],
            "locations": [
                524
            ],
            "notes": [
                955
            ],
            "numCurrentAssets": [
                357
            ],
            "numLocations": [
                357
            ],
            "numberOfLocations": [
                357
            ],
            "outboundTaxRate": [
                980
            ],
            "outboundTaxRateId": [
                955
            ],
            "outboundTaxRates": [
                980
            ],
            "payeeName": [
                955
            ],
            "paymentAddress": [
                524
            ],
            "paymentAddressId": [
                955
            ],
            "pendingReceivablePaymentBalance": [
                286
            ],
            "pendingReceivablePaymentInvoices": [
                802
            ],
            "priceListGroups": [
                691
            ],
            "privilegedFacilities": [
                524
            ],
            "privilegedGroups": [
                338
            ],
            "supplierDrivers": [
                134
            ],
            "trailers": [
                1013
            ],
            "vehicles": [
                1013
            ],
            "__typename": [
                955
            ]
        },
        "CompanyConnection": {
            "edges": [
                132
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "CompanyEdge": {
            "cursor": [
                955
            ],
            "node": [
                130
            ],
            "__typename": [
                955
            ]
        },
        "CompatibleTransportationType": {
            "transportationType": [
                955
            ],
            "transportationTypeId": [
                955
            ],
            "transportationTypeValue": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "Contact": {
            "acceptsPayment": [
                85
            ],
            "cellNumber": [
                955
            ],
            "company": [
                130
            ],
            "contactAddress": [
                955
            ],
            "contactId": [
                955
            ],
            "dateOfBirth": [
                194
            ],
            "email": [
                955
            ],
            "eyeColor": [
                955
            ],
            "fingerprint": [
                847
            ],
            "firstName": [
                955
            ],
            "hairColor": [
                955
            ],
            "height": [
                286
            ],
            "identificationBack": [
                847
            ],
            "identificationExpiresDate": [
                194
            ],
            "identificationFront": [
                847
            ],
            "identificationIssuedDate": [
                194
            ],
            "identificationNumber": [
                955
            ],
            "identificationState": [
                955
            ],
            "identificationType": [
                955
            ],
            "isDefault": [
                85
            ],
            "isDisabled": [
                85
            ],
            "isPriceListContact": [
                85
            ],
            "lastInvitedAt": [
                194
            ],
            "lastName": [
                955
            ],
            "location": [
                524
            ],
            "middleName": [
                955
            ],
            "notes": [
                955
            ],
            "phoneNumber": [
                955
            ],
            "portalAccountStatus": [
                955
            ],
            "race": [
                955
            ],
            "role": [
                955
            ],
            "sex": [
                955
            ],
            "suffix": [
                955
            ],
            "thirdPartyHauler": [
                1004
            ],
            "user": [
                1037,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "weight": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "ContactConnection": {
            "edges": [
                136
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ContactEdge": {
            "cursor": [
                955
            ],
            "node": [
                134
            ],
            "__typename": [
                955
            ]
        },
        "ContactRoles": {},
        "ContainerType": {
            "amount": [
                286
            ],
            "assetTypeId": [
                955
            ],
            "assetTypeValue": [
                955
            ],
            "bookingId": [
                345
            ],
            "centralizedCompanyId": [
                955
            ],
            "id": [
                345
            ],
            "__typename": [
                955
            ]
        },
        "ContainerTypeInput": {
            "amount": [
                286
            ],
            "assetTypeId": [
                955
            ],
            "assetTypeValue": [
                955
            ],
            "id": [
                345
            ],
            "__typename": [
                955
            ]
        },
        "CopyFromDefaultPriceListInput": {
            "currency": [
                702
            ],
            "facilityId": [
                268
            ],
            "operationType": [
                582
            ],
            "__typename": [
                955
            ]
        },
        "CounterpartiesInGroups": {
            "counterpartyIds": [
                147
            ],
            "__typename": [
                955
            ]
        },
        "CounterpartyGroup": {
            "centralizedCompanyId": [
                99
            ],
            "counterpartiesCount": [
                357
            ],
            "createdAt": [
                198
            ],
            "deletedAt": [
                198
            ],
            "firstTwoCounterparties": [
                148
            ],
            "id": [
                143
            ],
            "name": [
                955
            ],
            "operationType": [
                582
            ],
            "updatedAt": [
                198
            ],
            "updatedBy": [
                1037
            ],
            "__typename": [
                955
            ]
        },
        "CounterpartyGroupId": {},
        "CounterpartyGroupMember": {
            "addedAt": [
                198
            ],
            "addedBy": [
                1037
            ],
            "company": [
                130
            ],
            "counterpartyType": [
                955
            ],
            "publicSupplier": [
                757
            ],
            "__typename": [
                955
            ]
        },
        "CounterpartyGroupMembers": {
            "items": [
                144
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "CounterpartyGroups": {
            "items": [
                142
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "CounterpartyId": {},
        "CounterpartyUnion": {
            "on_Company": [
                130
            ],
            "on_PublicSupplier": [
                757
            ],
            "__typename": [
                955
            ]
        },
        "CreateAccountError": {
            "message": [
                955
            ],
            "name": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "CreateAccountResult": {
            "on_Account": [
                2
            ],
            "on_CreateAccountError": [
                149
            ],
            "__typename": [
                955
            ]
        },
        "CreateAllPhysicalCountUntaggedEntryDto": {
            "createdCount": [
                357
            ],
            "id": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "CreateAllPhysicalCountUntaggedEntryError": {
            "error": [
                33
            ],
            "__typename": [
                955
            ]
        },
        "CreateAllPhysicalCountUntaggedEntryInput": {
            "journalId": [
                955
            ],
            "materialGroupId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "CreateAllPhysicalCountUntaggedEntryResult": {
            "on_CreateAllPhysicalCountUntaggedEntryError": [
                152
            ],
            "on_CreateAllPhysicalCountUntaggedEntrySuccess": [
                155
            ],
            "__typename": [
                955
            ]
        },
        "CreateAllPhysicalCountUntaggedEntrySuccess": {
            "value": [
                151
            ],
            "__typename": [
                955
            ]
        },
        "CreateChartInput": {
            "chartConfig": [
                112
            ],
            "chartType": [
                955
            ],
            "dateRange": [
                197
            ],
            "description": [
                955
            ],
            "dimensions": [
                955
            ],
            "filters": [
                274
            ],
            "granularity": [
                955
            ],
            "measures": [
                955
            ],
            "name": [
                955
            ],
            "pivotConfig": [
                672
            ],
            "reportType": [
                955
            ],
            "sorts": [
                949
            ],
            "timeDimension": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "CreateInventoryProcessInput": {
            "costs": [
                713
            ],
            "facilityIds": [
                345
            ],
            "name": [
                955
            ],
            "transformations": [
                741
            ],
            "__typename": [
                955
            ]
        },
        "CreatePhysicalCountJournalInput": {
            "facilityId": [
                955
            ],
            "occurredAt": [
                198
            ],
            "type": [
                661
            ],
            "__typename": [
                955
            ]
        },
        "CreatePhysicalCountTaggedEntryInput": {
            "inventoryTagId": [
                955
            ],
            "journalId": [
                955
            ],
            "newGrossWeight": [
                286
            ],
            "newTareWeight": [
                286
            ],
            "type": [
                666
            ],
            "__typename": [
                955
            ]
        },
        "CreatePhysicalCountUntaggedEntryInput": {
            "itemId": [
                955
            ],
            "journalId": [
                955
            ],
            "newQuantity": [
                286
            ],
            "newWac": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "Creator": {
            "firstName": [
                955
            ],
            "lastName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "CreatorPlatform": {},
        "CrvBatch": {
            "amount": [
                286
            ],
            "createdAt": [
                194
            ],
            "crvBatchId": [
                955
            ],
            "crvBatchNumber": [
                357
            ],
            "crvMaterial": [
                167,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "crvMaterialId": [
                955
            ],
            "crvRate": [
                170
            ],
            "crvRateId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "endDate": [
                194
            ],
            "endScaleTicketNumber": [
                357
            ],
            "facility": [
                524,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "facilityId": [
                955
            ],
            "largeContainerQuantity": [
                286
            ],
            "largeContainerWeight": [
                286
            ],
            "outboundScaleTicket": [
                584
            ],
            "outboundScaleTicketId": [
                955
            ],
            "primaryQuantity": [
                286
            ],
            "primaryWeight": [
                286
            ],
            "scaleTicketRawMaterials": [
                903
            ],
            "smallContainerQuantity": [
                286
            ],
            "smallContainerWeight": [
                286
            ],
            "startDate": [
                194
            ],
            "startScaleTicketNumber": [
                357
            ],
            "status": [
                166
            ],
            "totalScrapValue": [
                286
            ],
            "totalWeight": [
                286
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "CrvBatchConnection": {
            "edges": [
                165
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "CrvBatchEdge": {
            "cursor": [
                955
            ],
            "node": [
                163
            ],
            "__typename": [
                955
            ]
        },
        "CrvBatchStatus": {},
        "CrvMaterial": {
            "createdAt": [
                194
            ],
            "crvMaterialId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "largeContainerMaterial": [
                536,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "largeContainerMaterialId": [
                955
            ],
            "materialName": [
                955
            ],
            "materialSkuNumber": [
                955
            ],
            "primaryMaterial": [
                536,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "primaryMaterialId": [
                955
            ],
            "smallContainerMaterial": [
                536,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "smallContainerMaterialId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "CrvMaterialConnection": {
            "edges": [
                169
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "CrvMaterialEdge": {
            "cursor": [
                955
            ],
            "node": [
                167
            ],
            "__typename": [
                955
            ]
        },
        "CrvRate": {
            "containersPerSegregatedPound": [
                286
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "creatorId": [
                955
            ],
            "crvMaterial": [
                167,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "crvMaterialId": [
                955
            ],
            "crvRateId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "endDate": [
                194
            ],
            "refundValuePerLargeContainer": [
                286
            ],
            "refundValuePerSegregatedPound": [
                286
            ],
            "refundValuePerSmallContainer": [
                286
            ],
            "refundValuePerWineAndDistilledSpirits": [
                286
            ],
            "scrapValue": [
                286
            ],
            "startDate": [
                194
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "CrvRateConnection": {
            "edges": [
                172
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "CrvRateEdge": {
            "cursor": [
                955
            ],
            "node": [
                170
            ],
            "__typename": [
                955
            ]
        },
        "CurrencyCode": {},
        "CurrentRole": {},
        "CustomAttribute": {
            "createdAt": [
                194
            ],
            "customAttributeId": [
                955
            ],
            "customAttributeName": [
                955
            ],
            "customAttributeType": [
                183
            ],
            "deletedAt": [
                194
            ],
            "entityType": [
                178
            ],
            "maxLength": [
                357
            ],
            "maxNumber": [
                286
            ],
            "minLength": [
                357
            ],
            "minNumber": [
                286
            ],
            "options": [
                179
            ],
            "required": [
                85
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "CustomAttributeConnection": {
            "edges": [
                177
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "CustomAttributeEdge": {
            "cursor": [
                955
            ],
            "node": [
                175
            ],
            "__typename": [
                955
            ]
        },
        "CustomAttributeEntityType": {},
        "CustomAttributeOption": {
            "createdAt": [
                194
            ],
            "customAttributeOptionId": [
                955
            ],
            "customAttributeOptionName": [
                955
            ],
            "deletedAt": [
                194
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "CustomAttributeOptionConnection": {
            "edges": [
                181
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "CustomAttributeOptionEdge": {
            "cursor": [
                955
            ],
            "node": [
                179
            ],
            "__typename": [
                955
            ]
        },
        "CustomAttributeSelectionType": {},
        "CustomAttributeType": {},
        "CustomPriceList": {
            "archivedAt": [
                198
            ],
            "centralizedCompanyId": [
                99
            ],
            "counterpartyGroup": [
                142
            ],
            "counterpartyGroupId": [
                143
            ],
            "createdAt": [
                198
            ],
            "currency": [
                702
            ],
            "endDate": [
                198
            ],
            "facilityId": [
                268
            ],
            "id": [
                185
            ],
            "isPublished": [
                85
            ],
            "name": [
                955
            ],
            "notes": [
                955
            ],
            "operationType": [
                582
            ],
            "productPricings": [
                752
            ],
            "startDate": [
                198
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "CustomPriceListId": {},
        "CustomScheduledPayment": {
            "amount": [
                286
            ],
            "id": [
                345
            ],
            "legalHold": [
                85
            ],
            "paymentSchedule": [
                785
            ],
            "purchaseId": [
                345
            ],
            "scheduledDate": [
                198
            ],
            "type": [
                637
            ],
            "__typename": [
                955
            ]
        },
        "CustomerType": {},
        "DataOwnerType": {},
        "DataWarehouseRun": {
            "endTime": [
                198
            ],
            "jobName": [
                955
            ],
            "runId": [
                345
            ],
            "startTime": [
                198
            ],
            "status": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "DataWarehouseRunConnection": {
            "edges": [
                191
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "DataWarehouseRunEdge": {
            "node": [
                189
            ],
            "__typename": [
                955
            ]
        },
        "DataWarehouseUser": {
            "host": [
                955
            ],
            "port": [
                286
            ],
            "userId": [
                345
            ],
            "username": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "DataWarehouseUserCreationResponse": {
            "host": [
                955
            ],
            "password": [
                955
            ],
            "userId": [
                345
            ],
            "username": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "Date": {},
        "DateFormatType": {},
        "DateRange": {
            "from": [
                198
            ],
            "relative": [
                955
            ],
            "to": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "DateRangeInput": {
            "from": [
                198
            ],
            "relative": [
                955
            ],
            "to": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "DateTime": {},
        "Deduction": {
            "amount": [
                286
            ],
            "centralizedCompanyId": [
                345
            ],
            "createdAt": [
                198
            ],
            "creatorId": [
                345
            ],
            "deductionType": [
                794
            ],
            "description": [
                955
            ],
            "id": [
                345
            ],
            "itemId": [
                345
            ],
            "purchaseId": [
                345
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "DeductionCategory": {},
        "DeductionId": {},
        "DeductionInput": {
            "amount": [
                286
            ],
            "createdAt": [
                198
            ],
            "deductionId": [
                345
            ],
            "deductionTypeId": [
                345
            ],
            "description": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "DeductionMethod": {},
        "DeductionScope": {},
        "DeductionType": {
            "createdAt": [
                194
            ],
            "creator": [
                1037
            ],
            "deductionTypeCategory": [
                200
            ],
            "deductionTypeId": [
                955
            ],
            "deductionTypeMethod": [
                203
            ],
            "deductionTypeName": [
                955
            ],
            "deletedAt": [
                194
            ],
            "hasDeductionsUsage": [
                85
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "DeductionTypeConnection": {
            "edges": [
                207
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "DeductionTypeEdge": {
            "cursor": [
                955
            ],
            "node": [
                205
            ],
            "__typename": [
                955
            ]
        },
        "DeductionTypeId": {},
        "DeductionUnit": {},
        "DefaultPhotoRequirement": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                198
            ],
            "createdById": [
                345
            ],
            "id": [
                345
            ],
            "isRequired": [
                85
            ],
            "name": [
                955
            ],
            "order": [
                286
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "DefaultPriceList": {
            "centralizedCompanyId": [
                99
            ],
            "createdAt": [
                198
            ],
            "currency": [
                702
            ],
            "id": [
                212
            ],
            "notes": [
                955
            ],
            "operationType": [
                582
            ],
            "productPricings": [
                752
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "DefaultPriceListId": {},
        "DefaultTransactionDateType": {},
        "DeletePhysicalCountTaggedEntryInput": {
            "id": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "DeletePhysicalCountUntaggedEntryInput": {
            "id": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "Detention": {
            "carrierId": [
                955
            ],
            "carrierName": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "company": [
                130
            ],
            "companyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "detentionId": [
                955
            ],
            "detentionIncidence": [
                357
            ],
            "detentionValue": [
                286
            ],
            "endDate": [
                194
            ],
            "startDate": [
                194
            ],
            "thirdPartyHauler": [
                1004
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "DetentionConnection": {
            "edges": [
                218
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "DetentionEdge": {
            "cursor": [
                955
            ],
            "node": [
                216
            ],
            "__typename": [
                955
            ]
        },
        "DispatchJobScheduleAnalytics": {
            "date": [
                955
            ],
            "numJobsCreated": [
                357
            ],
            "numJobsFailed": [
                357
            ],
            "numJobsFound": [
                357
            ],
            "numJobsNotAlreadyExecuted": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "DisplayProductDescription": {},
        "DoNotBuyOriginType": {},
        "DocumentGenerationParams": {
            "args": [
                446
            ],
            "fetchPdfType": [
                271
            ],
            "idToken": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "Driver": {
            "activeJob": [
                447
            ],
            "address": [
                524
            ],
            "allowReInvite": [
                85
            ],
            "appVersion": [
                955
            ],
            "cdlExpirationDate": [
                194
            ],
            "cdlNumber": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "currentTruck": [
                1021
            ],
            "customAttributes": [
                446
            ],
            "customDriverId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "driverId": [
                955
            ],
            "driverJobHistory": [
                447
            ],
            "driverOrder": [
                357
            ],
            "driverStatus": [
                955
            ],
            "email": [
                955
            ],
            "firstName": [
                955
            ],
            "idleTime": [
                286
            ],
            "invitationSentAt": [
                194
            ],
            "isAssignableToJobs": [
                85
            ],
            "isInternalUser": [
                85
            ],
            "languagePreference": [
                955
            ],
            "lastActivity": [
                194
            ],
            "lastLogin": [
                194
            ],
            "lastName": [
                955
            ],
            "latitude": [
                286
            ],
            "locationUpdated": [
                194
            ],
            "longitude": [
                286
            ],
            "mostRecentlySeenPlatform": [
                955
            ],
            "numJobs": [
                357,
                {
                    "afterDate": [
                        194
                    ],
                    "beforeDate": [
                        194
                    ],
                    "jobTypes": [
                        955,
                        "[String!]"
                    ],
                    "statuses": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "numQueuedJobs": [
                357
            ],
            "percentSuccessfulJobs": [
                286
            ],
            "phoneNumber": [
                955
            ],
            "primaryFacility": [
                524
            ],
            "primaryFacilityId": [
                955
            ],
            "privilegedFacilities": [
                524
            ],
            "privilegedGroups": [
                338
            ],
            "totalMiles": [
                286
            ],
            "totalTime": [
                286
            ],
            "updatedAt": [
                194
            ],
            "userSub": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "DriverConnection": {
            "edges": [
                225
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "DriverEdge": {
            "cursor": [
                955
            ],
            "node": [
                223
            ],
            "__typename": [
                955
            ]
        },
        "Email": {
            "id": [
                345
            ],
            "__typename": [
                955
            ]
        },
        "EmailBookingLoad": {
            "documentTypes": [
                955
            ],
            "outboundScaleTicketId": [
                345
            ],
            "__typename": [
                955
            ]
        },
        "EmailDocumentEntity": {},
        "EmailDocumentVariant": {},
        "Equipment": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "equipmentId": [
                955
            ],
            "equipmentName": [
                955
            ],
            "equipmentType": [
                252
            ],
            "equipmentTypeId": [
                955
            ],
            "installDate": [
                194
            ],
            "lastEquipmentChecklist": [
                231
            ],
            "lastEquipmentChecklistId": [
                955
            ],
            "location": [
                524
            ],
            "locationId": [
                955
            ],
            "manufacturerCentralizedCompany": [
                96
            ],
            "manufacturerCentralizedCompanyId": [
                955
            ],
            "notes": [
                955
            ],
            "numberOfReports": [
                357
            ],
            "serialNumber": [
                955
            ],
            "status": [
                251
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentChecklist": {
            "answers": [
                232
            ],
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "checklistNotes": [
                955
            ],
            "checklistNumber": [
                357
            ],
            "closer": [
                1037
            ],
            "closerId": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "equipment": [
                230
            ],
            "equipmentChecklistId": [
                955
            ],
            "equipmentChecklistTemplate": [
                242
            ],
            "equipmentChecklistTemplateId": [
                955
            ],
            "equipmentHours": [
                286
            ],
            "equipmentId": [
                955
            ],
            "numberOfFlaggedItems": [
                357
            ],
            "photos": [
                239
            ],
            "resolutionDate": [
                194
            ],
            "status": [
                241
            ],
            "timeline": [
                245
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentChecklistAnswer": {
            "answer": [
                233
            ],
            "answerNotes": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "equipmentChecklist": [
                231
            ],
            "equipmentChecklistAnswerId": [
                955
            ],
            "equipmentChecklistId": [
                955
            ],
            "equipmentChecklistItem": [
                237
            ],
            "equipmentChecklistItemId": [
                955
            ],
            "photos": [
                239
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentChecklistAnswerType": {},
        "EquipmentChecklistConnection": {
            "edges": [
                235
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentChecklistEdge": {
            "cursor": [
                955
            ],
            "node": [
                231
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentChecklistFrequency": {},
        "EquipmentChecklistItem": {
            "centralizedCompany": [
                96
            ],
            "checklistItemType": [
                238
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "description": [
                955
            ],
            "equipmentChecklistItemId": [
                955
            ],
            "equipmentChecklistTemplate": [
                242
            ],
            "equipmentChecklistTemplateId": [
                955
            ],
            "photoRequired": [
                240
            ],
            "positionNumber": [
                357
            ],
            "title": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentChecklistItemType": {},
        "EquipmentChecklistPhoto": {
            "centralizedCompany": [
                96
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "equipmentChecklist": [
                231
            ],
            "equipmentChecklistAnswer": [
                231
            ],
            "equipmentChecklistAnswerId": [
                955
            ],
            "equipmentChecklistId": [
                955
            ],
            "equipmentChecklistPhotoId": [
                955
            ],
            "photo": [
                847
            ],
            "photoId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentChecklistPhotoRequiredOption": {},
        "EquipmentChecklistStatus": {},
        "EquipmentChecklistTemplate": {
            "centralizedCompany": [
                96
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "equipmentChecklistTemplateId": [
                955
            ],
            "equipmentChecklistTemplateName": [
                955
            ],
            "equipmentType": [
                252
            ],
            "equipmentTypeId": [
                955
            ],
            "items": [
                237
            ],
            "numberOfReports": [
                357
            ],
            "repeatFrequency": [
                236
            ],
            "repeatInterval": [
                357
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentChecklistTemplateConnection": {
            "edges": [
                244
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentChecklistTemplateEdge": {
            "cursor": [
                955
            ],
            "node": [
                242
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentChecklistUpdate": {
            "createdAt": [
                194
            ],
            "equipmentChecklistUpdateId": [
                955
            ],
            "notes": [
                955
            ],
            "status": [
                241
            ],
            "updatedAt": [
                194
            ],
            "user": [
                1037
            ],
            "userId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentConnection": {
            "edges": [
                247
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentEdge": {
            "cursor": [
                955
            ],
            "node": [
                230
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentGroup": {
            "centralizedCompany": [
                96
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "equipmentGroupId": [
                955
            ],
            "equipmentGroupName": [
                955
            ],
            "equipmentGroupNotes": [
                955
            ],
            "numOfUnits": [
                357
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentGroupConnection": {
            "edges": [
                250
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentGroupEdge": {
            "cursor": [
                955
            ],
            "node": [
                248
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentStatus": {},
        "EquipmentType": {
            "centralizedCompany": [
                96
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "equipmentGroup": [
                248
            ],
            "equipmentGroupId": [
                955
            ],
            "equipmentPhoto": [
                847
            ],
            "equipmentPhotoId": [
                955
            ],
            "equipmentTypeId": [
                955
            ],
            "equipmentTypeName": [
                955
            ],
            "equipmentTypeNotes": [
                955
            ],
            "numOfUnits": [
                357
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentTypeConnection": {
            "edges": [
                254
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "EquipmentTypeEdge": {
            "cursor": [
                955
            ],
            "node": [
                252
            ],
            "__typename": [
                955
            ]
        },
        "Error": {
            "code": [
                955
            ],
            "field": [
                955
            ],
            "message": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "EvaluatedFormula": {
            "error": [
                955
            ],
            "value": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "EvaluatedProductPricing": {
            "centralizedCompanyId": [
                99
            ],
            "createdAt": [
                198
            ],
            "customPriceList": [
                184
            ],
            "id": [
                753
            ],
            "priceListId": [
                696
            ],
            "pricingUnit": [
                703
            ],
            "product": [
                704
            ],
            "tiers": [
                258
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "EvaluatedProductPricingTier": {
            "maxAmount": [
                286
            ],
            "maxUnitPrice": [
                259
            ],
            "minUnitPrice": [
                259
            ],
            "targetUnitPrice": [
                259
            ],
            "__typename": [
                955
            ]
        },
        "EvaluatedUnitPriceFormula": {
            "evaluation": [
                286
            ],
            "formula": [
                955
            ],
            "variableIds": [
                1054
            ],
            "__typename": [
                955
            ]
        },
        "ExecuteProcessInput": {
            "executedAt": [
                198
            ],
            "facilityId": [
                345
            ],
            "inputs": [
                261
            ],
            "processId": [
                345
            ],
            "__typename": [
                955
            ]
        },
        "ExecuteProcessInputInput": {
            "itemId": [
                345
            ],
            "quantity": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "ExpandedComputedPermissions": {
            "facilities": [
                524
            ],
            "groups": [
                338
            ],
            "__typename": [
                955
            ]
        },
        "ExplainableError1": {
            "devExplain": [
                955
            ],
            "errorType": [
                955
            ],
            "explain": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ExtraLocationData": {
            "defaultStartFacility": [
                524
            ],
            "defaultStartFacilityId": [
                345
            ],
            "driverNotes": [
                955
            ],
            "endTime": [
                194
            ],
            "estimatedJobDistance": [
                286
            ],
            "estimatedJobTime": [
                286
            ],
            "extraLocationDataId": [
                955
            ],
            "locationId": [
                955
            ],
            "locationNotes": [
                955
            ],
            "serviceDays": [
                955
            ],
            "startTime": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "FacilityAtm": {
            "atmFacilityId": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "FacilityAtmConnection": {
            "edges": [
                267
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "FacilityAtmEdge": {
            "cursor": [
                955
            ],
            "node": [
                265
            ],
            "__typename": [
                955
            ]
        },
        "FacilityId": {},
        "FacilitySettingName": {},
        "FacilitySettings": {
            "alertFailedJob": [
                85
            ],
            "alertTimeOnSite": [
                85
            ],
            "alertTimeOnSiteDays": [
                357
            ],
            "allowAssetsToBeAssignedToSpecificCompanies": [
                85
            ],
            "allowCarryOverNotes": [
                85
            ],
            "allowDriverJobCreation": [
                85
            ],
            "allowDuplicateObjectNames": [
                85
            ],
            "allowEditingActiveJobs": [
                85
            ],
            "billOfLadingLiabilityNotice": [
                955
            ],
            "billOfLadingNumberPostfix": [
                955
            ],
            "billOfLadingNumberPrefix": [
                955
            ],
            "billOfSalesDisclaimer": [
                955
            ],
            "blankScaleTicketIdentifier": [
                72
            ],
            "blankScaleTicketInternalNoteFieldStatus": [
                272
            ],
            "blankScaleTicketLicensePlateNumberFieldStatus": [
                272
            ],
            "blankScaleTicketTruckNumberFieldStatus": [
                272
            ],
            "canHaveMultipleActiveJobs": [
                85
            ],
            "canStartJobsOutOfOrder": [
                85
            ],
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "clearDriverTruckTrailerAssignment": [
                955
            ],
            "clearSuccessfulJobs": [
                85
            ],
            "dateFormatType": [
                195
            ],
            "deadlineDays": [
                357
            ],
            "defaultTransactionDateType": [
                213
            ],
            "dismantlerNumber": [
                357
            ],
            "displayCheckNumber": [
                85
            ],
            "displayDeadlineDate": [
                85
            ],
            "displayExternalNotes": [
                85
            ],
            "displayHundredweight": [
                85
            ],
            "displayInventoryTagPrimaryWeight": [
                430
            ],
            "displayMaterialAssetName": [
                85
            ],
            "displayMaterialAssetSelector": [
                85
            ],
            "displayPreviousJobAssetsSelectionInDriverApp": [
                85
            ],
            "displayProductDescription": [
                220
            ],
            "displayReturnFacility": [
                85
            ],
            "displaySupplierDriversLicense": [
                85
            ],
            "displaySupplierVehiclePlate": [
                85
            ],
            "displayWeighedByName": [
                85
            ],
            "displayWeightCaptureMethod": [
                85
            ],
            "displayWeightCaptureMethodLegend": [
                85
            ],
            "documentLogo": [
                847
            ],
            "documentLogoId": [
                955
            ],
            "driverAppRequiresAssetPhotos": [
                843
            ],
            "driverAppRequiresLocationPhotos": [
                844
            ],
            "enforceAssetTransportationCompatibility": [
                85
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "floridaDerelictLicenseNumber": [
                955
            ],
            "invoiceDisclaimer": [
                955
            ],
            "isBillOfLadingLiabilityNoticeActive": [
                85
            ],
            "isBillOfSalesActive": [
                85
            ],
            "isCrvActive": [
                85
            ],
            "isInvoiceDisclaimerActive": [
                85
            ],
            "isLiabilityWaiverActive": [
                85
            ],
            "isPurchaseOrderDisclaimerActive": [
                85
            ],
            "isSalesOrderDisclaimerActive": [
                85
            ],
            "isWeightMasterCertificateActive": [
                85
            ],
            "jobCompletedPastDeadline": [
                85
            ],
            "jobEstimates": [
                85
            ],
            "liabilityWaiverDisclaimer": [
                955
            ],
            "measurementSystem": [
                560
            ],
            "minimumAge": [
                357
            ],
            "printPublicFingerprint": [
                85
            ],
            "promptDriverToConfirmTruckTrailer": [
                955
            ],
            "promptForMaterialEntry": [
                85
            ],
            "purchaseOrderDisclaimer": [
                955
            ],
            "requireAllVehicleDetails": [
                85
            ],
            "requireBusinessLicenseNumber": [
                85
            ],
            "requireConverterVehicleIdentificationNumber": [
                85
            ],
            "requireConverterVehicleLicensePlate": [
                85
            ],
            "requireConverterVehicleMake": [
                85
            ],
            "requireConverterVehicleModel": [
                85
            ],
            "requireConverterVehicleTitle": [
                85
            ],
            "requireConverterVehicleYear": [
                85
            ],
            "requireDefaultSignature": [
                85
            ],
            "requireDriverCameraPhotos": [
                85
            ],
            "requireDriverLicenseBack": [
                85
            ],
            "requireDriverLicenseFront": [
                85
            ],
            "requireDriverNotes": [
                85
            ],
            "requireMaterialPhoto": [
                85
            ],
            "requireMinimumAge": [
                85
            ],
            "requireSupplierAddress": [
                85
            ],
            "requireSupplierDateOfBirth": [
                85
            ],
            "requireSupplierEmployerName": [
                85
            ],
            "requireSupplierHeight": [
                85
            ],
            "requireSupplierIdentificationIssuingState": [
                85
            ],
            "requireSupplierIdentificationNumber": [
                85
            ],
            "requireSupplierIdentificationType": [
                85
            ],
            "requireSupplierPhoto": [
                85
            ],
            "requireSupplierSex": [
                85
            ],
            "requireSupplierWeight": [
                85
            ],
            "requireThumbprint": [
                85
            ],
            "requireValidDateLicense": [
                85
            ],
            "requireVehicleColor": [
                85
            ],
            "requireVehicleLicense": [
                85
            ],
            "requireVehicleLicenseExpiration": [
                85
            ],
            "requireVehicleLicenseState": [
                85
            ],
            "requireVehicleMake": [
                85
            ],
            "requireVehicleModel": [
                85
            ],
            "requireVehicleScalePhoto": [
                85
            ],
            "requireVehicleType": [
                85
            ],
            "requireVehicleYear": [
                85
            ],
            "salesMeasurementSystem": [
                560
            ],
            "salesOrderDisclaimer": [
                955
            ],
            "salesOrderLoadMaterialSlippage": [
                286
            ],
            "savePublicSupplierSignature": [
                85
            ],
            "scaleTicketDocumentThermalMarginOffset": [
                357
            ],
            "scaleTicketDocumentsBodyFontSize": [
                357
            ],
            "scaleTicketDocumentsDisclaimerFontSize": [
                357
            ],
            "scaleTicketEmail": [
                955
            ],
            "scaleTicketPhoneNumber": [
                955
            ],
            "scaleTicketReceiptType": [
                906
            ],
            "scaleTicketRequiresSignature": [
                845
            ],
            "scaleTicketTableFormat": [
                913
            ],
            "scaleTicketThermalReceiptWidthInches": [
                914
            ],
            "scaleTicketThumbnailDisplayOption": [
                915
            ],
            "scaleTicketWebsite": [
                955
            ],
            "showDeductionReason": [
                85
            ],
            "supplierPhotoOnPayment": [
                85
            ],
            "taxRatesAffectsWACCalculation": [
                85
            ],
            "useDoubleScaleSplitWeight": [
                85
            ],
            "usePresetPricing": [
                85
            ],
            "weightConversion": [
                85
            ],
            "weightConversionBOL": [
                85
            ],
            "weightConversionInvoice": [
                85
            ],
            "weightConversionOST": [
                85
            ],
            "weightConversionPackingList": [
                85
            ],
            "weightMasterCertificateDisclaimer": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "FetchPdfType": {},
        "FieldDisplayStatus": {},
        "Filter": {
            "feature": [
                955
            ],
            "operator": [
                955
            ],
            "value": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "FilterInput": {
            "feature": [
                955
            ],
            "operator": [
                955
            ],
            "value": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "FinancialAccount": {
            "allowRepeatedCheckNumbers": [
                85
            ],
            "balanceLastModified": [
                194
            ],
            "bankAccount": [
                67
            ],
            "cashAccountId": [
                955
            ],
            "cashAccountName": [
                955
            ],
            "currentBalance": [
                286
            ],
            "customAttributes": [
                446
            ],
            "facilities": [
                524
            ],
            "financialAccountId": [
                955
            ],
            "financialAccountName": [
                955
            ],
            "financialAccountType": [
                282
            ],
            "recycler": [
                96
            ],
            "scaleTicketRoundingMethod": [
                907
            ],
            "scaleTicketRoundingPrecision": [
                908
            ],
            "status": [
                955
            ],
            "visibleInPayments": [
                85
            ],
            "warningThreshold": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "FinancialAccountAdjustment": {
            "adjustmentQuantity": [
                286
            ],
            "adjustmentReason": [
                955
            ],
            "adjustmentType": [
                955
            ],
            "creator": [
                1037
            ],
            "date": [
                194
            ],
            "financialAccountAdjustmentId": [
                955
            ],
            "fromAccount": [
                275
            ],
            "recycler": [
                96
            ],
            "toAccount": [
                275
            ],
            "__typename": [
                955
            ]
        },
        "FinancialAccountAdjustmentConnection": {
            "edges": [
                278
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "FinancialAccountAdjustmentEdge": {
            "cursor": [
                955
            ],
            "node": [
                276
            ],
            "__typename": [
                955
            ]
        },
        "FinancialAccountConnection": {
            "edges": [
                280
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "FinancialAccountEdge": {
            "cursor": [
                955
            ],
            "node": [
                275
            ],
            "__typename": [
                955
            ]
        },
        "FinancialAccountStatus": {},
        "FinancialAccountType": {},
        "FinancialTransaction": {
            "adjustmentQuantity": [
                286
            ],
            "adjustmentReason": [
                955
            ],
            "adjustmentType": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "creatorFullName": [
                955
            ],
            "date": [
                194
            ],
            "financialTransactionId": [
                955
            ],
            "fromAccount": [
                275
            ],
            "fromAccountId": [
                955
            ],
            "toAccount": [
                275
            ],
            "toAccountId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "FinancialTransactionConnection": {
            "edges": [
                285
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "FinancialTransactionEdge": {
            "cursor": [
                955
            ],
            "node": [
                283
            ],
            "__typename": [
                955
            ]
        },
        "Float": {},
        "FreightAdjustmentType": {},
        "FreightForwarder": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                198
            ],
            "id": [
                345
            ],
            "name": [
                955
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "FreightForwarderConnection": {
            "edges": [
                290
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "FreightForwarderEdge": {
            "node": [
                288
            ],
            "__typename": [
                955
            ]
        },
        "FreightLane": {
            "carrierId": [
                955
            ],
            "carrierName": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "createdAt": [
                194
            ],
            "currentCost": [
                292
            ],
            "currentFuelSurcharge": [
                306
            ],
            "currentTotalCost": [
                286
            ],
            "freightLaneId": [
                955
            ],
            "freightLaneRoute": [
                297
            ],
            "thirdPartyHauler": [
                1004
            ],
            "transportationTypes": [
                1017
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "FreightLaneCost": {
            "centralizedCompany": [
                96
            ],
            "costType": [
                295
            ],
            "createdAt": [
                194
            ],
            "endDate": [
                194
            ],
            "freightLane": [
                291
            ],
            "freightLaneCostId": [
                955
            ],
            "freightLaneId": [
                955
            ],
            "roundTripCost": [
                286
            ],
            "startDate": [
                194
            ],
            "updatedAt": [
                194
            ],
            "weightUnit": [
                534
            ],
            "__typename": [
                955
            ]
        },
        "FreightLaneCostConnection": {
            "edges": [
                294
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "FreightLaneCostEdge": {
            "cursor": [
                955
            ],
            "node": [
                292
            ],
            "__typename": [
                955
            ]
        },
        "FreightLaneCostType": {},
        "FreightLaneId": {},
        "FreightLaneRoute": {
            "centralizedCompany": [
                96
            ],
            "createdAt": [
                194
            ],
            "customRouteId": [
                955
            ],
            "distance": [
                286
            ],
            "freightLaneRouteId": [
                955
            ],
            "freightLanes": [
                291
            ],
            "locationA": [
                524
            ],
            "locationAName": [
                955
            ],
            "locationB": [
                524
            ],
            "locationBName": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "FreightLaneRouteConnection": {
            "edges": [
                299
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "FreightLaneRouteEdge": {
            "cursor": [
                955
            ],
            "node": [
                297
            ],
            "__typename": [
                955
            ]
        },
        "FreightLine": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                198
            ],
            "id": [
                345
            ],
            "name": [
                955
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "FreightLineConnection": {
            "edges": [
                302
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "FreightLineEdge": {
            "node": [
                300
            ],
            "__typename": [
                955
            ]
        },
        "FreightTermOptions": {},
        "FreightTermOptionsLabelMap": {},
        "FreightType": {},
        "FuelSurcharge": {
            "carrierId": [
                955
            ],
            "carrierName": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "company": [
                130
            ],
            "companyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "endDate": [
                194
            ],
            "fuelSurchargeId": [
                955
            ],
            "startDate": [
                194
            ],
            "surchargeType": [
                309
            ],
            "surchargeValue": [
                286
            ],
            "thirdPartyHauler": [
                1004
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "FuelSurchargeConnection": {
            "edges": [
                308
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "FuelSurchargeEdge": {
            "cursor": [
                955
            ],
            "node": [
                306
            ],
            "__typename": [
                955
            ]
        },
        "FuelSurchargeType": {},
        "GOVERNMENT_REPORTING_IMAGE_FIELDS": {},
        "GPSIdentifier": {
            "identifier": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "GPSIdentifierConnection": {
            "edges": [
                313
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "GPSIdentifierEdge": {
            "node": [
                311
            ],
            "__typename": [
                955
            ]
        },
        "GPSLocation": {
            "lastUpdate": [
                198
            ],
            "lat": [
                286
            ],
            "lon": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingBatch": {
            "batchEndTime": [
                194
            ],
            "batchStartTime": [
                194
            ],
            "batchStatus": [
                318
            ],
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "governmentReportingBatchId": [
                955
            ],
            "governmentReportingConfigurationId": [
                955
            ],
            "numberOfFailedTickets": [
                357
            ],
            "numberOfImages": [
                357
            ],
            "numberOfMaterials": [
                357
            ],
            "numberOfTickets": [
                357
            ],
            "updatedAt": [
                194
            ],
            "uploadType": [
                336
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingBatchConnection": {
            "edges": [
                317
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingBatchEdge": {
            "cursor": [
                955
            ],
            "node": [
                315
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingBatchStatus": {},
        "GovernmentReportingConfiguration": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                955
            ],
            "daysOfWeek": [
                955
            ],
            "deletedAt": [
                194
            ],
            "facilities": [
                322
            ],
            "fields": [
                955
            ],
            "governmentReportingConfigurationId": [
                955
            ],
            "loginEmail": [
                955
            ],
            "recyclerId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "uploadService": [
                324
            ],
            "uploadState": [
                955
            ],
            "uploadTimezone": [
                955
            ],
            "uploadType": [
                336
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingConfigurationConnection": {
            "edges": [
                321
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingConfigurationEdge": {
            "cursor": [
                955
            ],
            "node": [
                319
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingFacility": {
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "governmentReportingConfiguration": [
                319
            ],
            "governmentReportingConfigurationId": [
                955
            ],
            "governmentReportingFacilityId": [
                955
            ],
            "mlid": [
                955
            ],
            "reportingFacilityId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingNotEnqueuedTicket": {
            "companyName": [
                955
            ],
            "errorMessage": [
                955
            ],
            "governmentReportingTicketId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingService": {},
        "GovernmentReportingTicket": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "completedAt": [
                194
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "errorMessage": [
                955
            ],
            "governmentReportingBatch": [
                315
            ],
            "governmentReportingBatchId": [
                955
            ],
            "governmentReportingTicketId": [
                955
            ],
            "numberOfFailedImages": [
                357
            ],
            "numberOfImages": [
                357
            ],
            "numberOfMaterials": [
                357
            ],
            "numberOfNotReportedMaterials": [
                357
            ],
            "queuedAt": [
                194
            ],
            "retryCount": [
                357
            ],
            "scaleTicket": [
                877
            ],
            "scaleTicketId": [
                955
            ],
            "status": [
                333
            ],
            "transactionId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingTicketConnection": {
            "edges": [
                327
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingTicketEdge": {
            "cursor": [
                955
            ],
            "node": [
                325
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingTicketEnqueueingResult": {
            "notEnqueuedTickets": [
                323
            ],
            "numberOfEnqueuedTickets": [
                357
            ],
            "numberOfEnqueueingErrors": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingTicketImageSourceType": {},
        "GovernmentReportingTicketImageStatus": {},
        "GovernmentReportingTicketImageType": {},
        "GovernmentReportingTicketImageUploadInput": {
            "externalId": [
                955
            ],
            "governmentReportingTicketImageId": [
                955
            ],
            "status": [
                330
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingTicketStatus": {},
        "GovernmentReportingTicketStatusInput": {
            "errorMessage": [
                955
            ],
            "governmentReportingTicketId": [
                955
            ],
            "imageUploads": [
                332
            ],
            "retriable": [
                85
            ],
            "status": [
                333
            ],
            "transactionId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingTicketsFileData": {
            "content": [
                955
            ],
            "fileType": [
                955
            ],
            "filename": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "GovernmentReportingUploadType": {},
        "Grade": {},
        "Group": {
            "areFacilitySettingsLocked": [
                85
            ],
            "createdAt": [
                194
            ],
            "customGroupId": [
                955
            ],
            "defaultFacility": [
                524
            ],
            "defaultFacilityId": [
                955
            ],
            "facilities": [
                524
            ],
            "groupId": [
                955
            ],
            "groupName": [
                955
            ],
            "privilegedUsers": [
                1037
            ],
            "recycler": [
                96
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "GroupConnection": {
            "edges": [
                340
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "GroupEdge": {
            "cursor": [
                955
            ],
            "node": [
                338
            ],
            "__typename": [
                955
            ]
        },
        "GroupSettings": {
            "allowAssetsToBeAssignedToSpecificCompanies": [
                85
            ],
            "allowCarryOverNotes": [
                85
            ],
            "allowDriverJobCreation": [
                85
            ],
            "allowDuplicateObjectNames": [
                85
            ],
            "allowEditingActiveJobs": [
                85
            ],
            "billOfLadingLiabilityNotice": [
                955
            ],
            "billOfLadingNumberPostfix": [
                955
            ],
            "billOfLadingNumberPrefix": [
                955
            ],
            "billOfSalesDisclaimer": [
                955
            ],
            "canHaveMultipleActiveJobs": [
                85
            ],
            "canStartJobsOutOfOrder": [
                85
            ],
            "clearDriverTruckTrailerAssignment": [
                955
            ],
            "dateFormatType": [
                195
            ],
            "deadlineDays": [
                357
            ],
            "displayCheckNumber": [
                85
            ],
            "displayDeadlineDate": [
                85
            ],
            "displayExternalNotes": [
                85
            ],
            "displayMaterialAssetName": [
                85
            ],
            "displayMaterialAssetSelector": [
                85
            ],
            "displayPreviousJobAssetsSelectionInDriverApp": [
                85
            ],
            "displayReturnFacility": [
                85
            ],
            "displaySupplierDriversLicense": [
                85
            ],
            "displaySupplierVehiclePlate": [
                85
            ],
            "displayWeighedByName": [
                85
            ],
            "displayWeightCaptureMethod": [
                85
            ],
            "displayWeightCaptureMethodLegend": [
                85
            ],
            "driverAppRequiresAssetPhotos": [
                843
            ],
            "driverAppRequiresLocationPhotos": [
                844
            ],
            "enforceAssetTransportationCompatibility": [
                85
            ],
            "invoiceDisclaimer": [
                955
            ],
            "isBillOfLadingLiabilityNoticeActive": [
                85
            ],
            "isBillOfSalesActive": [
                85
            ],
            "isInvoiceDisclaimerActive": [
                85
            ],
            "isLiabilityWaiverActive": [
                85
            ],
            "isPurchaseOrderDisclaimerActive": [
                85
            ],
            "isSalesOrderDisclaimerActive": [
                85
            ],
            "isWeightMasterCertificateActive": [
                85
            ],
            "jobEstimates": [
                85
            ],
            "liabilityWaiverDisclaimer": [
                955
            ],
            "measurementSystem": [
                560
            ],
            "printPublicFingerprint": [
                85
            ],
            "promptDriverToConfirmTruckTrailer": [
                955
            ],
            "promptForMaterialEntry": [
                85
            ],
            "purchaseOrderDisclaimer": [
                955
            ],
            "requireDefaultSignature": [
                85
            ],
            "requireDriverCameraPhotos": [
                85
            ],
            "requireDriverNotes": [
                85
            ],
            "salesMeasurementSystem": [
                560
            ],
            "salesOrderDisclaimer": [
                955
            ],
            "savePublicSupplierSignature": [
                85
            ],
            "scaleTicketReceiptType": [
                906
            ],
            "scaleTicketRequiresSignature": [
                845
            ],
            "scaleTicketTableFormat": [
                913
            ],
            "scaleTicketThermalReceiptWidthInches": [
                914
            ],
            "scaleTicketThumbnailDisplayOption": [
                915
            ],
            "showDeductionReason": [
                85
            ],
            "useDoubleScaleSplitWeight": [
                85
            ],
            "weightConversion": [
                85
            ],
            "weightConversionBOL": [
                85
            ],
            "weightConversionInvoice": [
                85
            ],
            "weightConversionOST": [
                85
            ],
            "weightConversionPackingList": [
                85
            ],
            "weightMasterCertificateDisclaimer": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "HelpkitArticle": {
            "description": [
                955
            ],
            "id": [
                955
            ],
            "title": [
                955
            ],
            "url": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "HistoricalData": {
            "date": [
                955
            ],
            "id": [
                955
            ],
            "type": [
                955
            ],
            "value": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "HistoryEntry": {
            "author": [
                1037
            ],
            "body": [
                446
            ],
            "eventType": [
                955
            ],
            "occurredOn": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "ID": {},
        "IdentifiableType": {},
        "IdentificationTitle": {},
        "IdentificationType": {},
        "ImperialMassUnit": {},
        "InboundOutboundScaleTicketAttachable": {
            "file": [
                847
            ],
            "inboundOutboundScaleTicketAttachableId": [
                955
            ],
            "objectType": [
                878
            ],
            "ticketId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "IncomeStatement": {
            "accountingPeriod": [
                23
            ],
            "date": [
                198
            ],
            "lines": [
                829
            ],
            "__typename": [
                955
            ]
        },
        "IncomeStatementError": {
            "message": [
                955
            ],
            "name": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "IncomeStatementResult": {
            "on_IncomeStatement": [
                351
            ],
            "on_IncomeStatementError": [
                352
            ],
            "__typename": [
                955
            ]
        },
        "InfoForCrvBatch": {
            "amount": [
                286
            ],
            "endDate": [
                194
            ],
            "endScaleTicketNumber": [
                357
            ],
            "largeContainerQuantity": [
                286
            ],
            "primaryWeight": [
                286
            ],
            "scaleTicketsCount": [
                357
            ],
            "smallContainerQuantity": [
                286
            ],
            "startDate": [
                194
            ],
            "startScaleTicketNumber": [
                357
            ],
            "totalScrapValue": [
                286
            ],
            "totalWeight": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "InitialAmountType": {},
        "InitializeRecyclerTruckInput": {
            "truckNumber": [
                955
            ],
            "truckType": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "Int": {},
        "IntegrationInvitation": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "companyDomain": [
                955
            ],
            "companyName": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                955
            ],
            "hashCode": [
                955
            ],
            "integrationInvitationId": [
                955
            ],
            "integrationType": [
                103
            ],
            "invitationEmail": [
                955
            ],
            "invitationStatus": [
                362
            ],
            "inviteeCentralizedCompany": [
                96
            ],
            "inviteeCentralizedCompanyId": [
                955
            ],
            "inviteeFirstName": [
                955
            ],
            "inviteeLastName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "IntegrationInvitationConnection": {
            "edges": [
                361
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "IntegrationInvitationDirection": {},
        "IntegrationInvitationEdge": {
            "cursor": [
                955
            ],
            "node": [
                358
            ],
            "__typename": [
                955
            ]
        },
        "IntegrationInvitationStatus": {},
        "InventoryAccount": {
            "facilityId": [
                345
            ],
            "id": [
                345
            ],
            "name": [
                955
            ],
            "taggingType": [
                364
            ],
            "type": [
                365
            ],
            "__typename": [
                955
            ]
        },
        "InventoryAccountTaggingType": {},
        "InventoryAccountType": {},
        "InventoryAdjustmentType": {},
        "InventoryFacilityBreakdownDetail": {
            "facility": [
                524
            ],
            "facilityId": [
                345
            ],
            "inventoryState": [
                371
            ],
            "inventoryValuation": [
                434
            ],
            "__typename": [
                955
            ]
        },
        "InventoryFacilityBreakdownResult": {
            "details": [
                367
            ],
            "itemId": [
                345
            ],
            "totals": [
                369
            ],
            "__typename": [
                955
            ]
        },
        "InventoryFacilityBreakdownTotals": {
            "inventoryState": [
                371
            ],
            "inventoryValuation": [
                434
            ],
            "__typename": [
                955
            ]
        },
        "InventoryItem": {
            "inventoryState": [
                371
            ],
            "inventoryValuation": [
                434,
                {
                    "facilityId": [
                        955
                    ],
                    "valuationAt": [
                        198
                    ]
                }
            ],
            "on_CatalyticConverter": [
                92
            ],
            "on_Material": [
                536
            ],
            "on_MaterialGroup": [
                541
            ],
            "__typename": [
                955
            ]
        },
        "InventoryItemState": {
            "availableQuantity": [
                421
            ],
            "inTransitQuantity": [
                421
            ],
            "incomingQuantity": [
                421
            ],
            "item": [
                370
            ],
            "itemId": [
                345
            ],
            "onHandQuantity": [
                421
            ],
            "outgoingQuantity": [
                421
            ],
            "__typename": [
                955
            ]
        },
        "InventoryItemType": {},
        "InventoryMovement": {
            "facilityId": [
                345
            ],
            "fromAccount": [
                363
            ],
            "fromAccountId": [
                345
            ],
            "id": [
                345
            ],
            "inventoryItem": [
                370
            ],
            "itemId": [
                345
            ],
            "metadata": [
                446
            ],
            "movementType": [
                377
            ],
            "occurredAt": [
                198
            ],
            "originTransactionItemId": [
                955
            ],
            "originTransactionType": [
                433
            ],
            "quantity": [
                286
            ],
            "status": [
                376
            ],
            "toAccount": [
                363
            ],
            "toAccountId": [
                345
            ],
            "totalCost": [
                286
            ],
            "valuation": [
                434
            ],
            "__typename": [
                955
            ]
        },
        "InventoryMovementConnection": {
            "edges": [
                375
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "InventoryMovementDtoEdge": {
            "node": [
                373
            ],
            "__typename": [
                955
            ]
        },
        "InventoryMovementStatus": {},
        "InventoryMovementType": {},
        "InventoryPeriod": {
            "endDate": [
                198
            ],
            "events": [
                643
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "id": [
                955
            ],
            "lastEvent": [
                643
            ],
            "options": [
                392
            ],
            "periodNumber": [
                286
            ],
            "startDate": [
                198
            ],
            "status": [
                649
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodClosingRules": {
            "noNegativeInventory": [
                85
            ],
            "noPendingTickets": [
                85
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodClosingRulesInput": {
            "noNegativeInventory": [
                85
            ],
            "noPendingTickets": [
                85
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodConfiguration": {
            "facilityIds": [
                345
            ],
            "options": [
                392
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodConfigurationError": {
            "error": [
                33
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodConfigurationInput": {
            "facilityIds": [
                955
            ],
            "options": [
                393
            ],
            "startDate": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodConfigurationResult": {
            "on_InventoryPeriodConfigurationError": [
                382
            ],
            "on_InventoryPeriodConfigurationSuccess": [
                385
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodConfigurationSuccess": {
            "value": [
                381
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodConnection": {
            "edges": [
                387
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodEdge": {
            "node": [
                378
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodError": {
            "error": [
                33
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodEventTransactionsError": {
            "error": [
                255
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodEventTransactionsResult": {
            "on_InventoryPeriodEventTransactionsError": [
                389
            ],
            "on_InventoryPeriodEventTransactionsSuccess": [
                391
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodEventTransactionsSuccess": {
            "value": [
                645
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodOptions": {
            "closingRules": [
                379
            ],
            "frequency": [
                646
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodOptionsInput": {
            "closingRules": [
                380
            ],
            "frequency": [
                646
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodResult": {
            "on_InventoryPeriodError": [
                388
            ],
            "on_InventoryPeriodSuccess": [
                395
            ],
            "__typename": [
                955
            ]
        },
        "InventoryPeriodSuccess": {
            "value": [
                378
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcess": {
            "costs": [
                399
            ],
            "facilities": [
                524
            ],
            "facilityIds": [
                345
            ],
            "id": [
                345
            ],
            "lastExecution": [
                402
            ],
            "name": [
                955
            ],
            "status": [
                418
            ],
            "transformations": [
                420
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessAggregateError": {
            "errors": [
                255
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessConnection": {
            "edges": [
                400
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessCost": {
            "amount": [
                286
            ],
            "id": [
                345
            ],
            "name": [
                955
            ],
            "type": [
                714
            ],
            "unit": [
                715
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessEdge": {
            "node": [
                396
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessError": {
            "error": [
                397
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessExecution": {
            "executedAt": [
                198
            ],
            "executedBy": [
                1037
            ],
            "executionNumber": [
                357
            ],
            "executionType": [
                728
            ],
            "executorId": [
                955
            ],
            "facility": [
                524
            ],
            "facilityId": [
                345
            ],
            "failedReason": [
                955
            ],
            "id": [
                345
            ],
            "process": [
                396
            ],
            "processId": [
                345
            ],
            "status": [
                727
            ],
            "totalCost": [
                286
            ],
            "transformations": [
                414
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessExecutionConnection": {
            "edges": [
                405
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessExecutionCost": {
            "amount": [
                286
            ],
            "id": [
                345
            ],
            "name": [
                955
            ],
            "totalAmount": [
                286
            ],
            "type": [
                714
            ],
            "unit": [
                715
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessExecutionEdge": {
            "node": [
                402
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessExecutionError": {
            "error": [
                397
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessExecutionInput": {
            "id": [
                345
            ],
            "inventoryItem": [
                370
            ],
            "itemId": [
                345
            ],
            "quantity": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessExecutionOutcomeError": {
            "error": [
                397
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessExecutionOutcomeResult": {
            "on_InventoryProcessExecutionOutcomeError": [
                408
            ],
            "on_InventoryProcessExecutionOutcomeSuccess": [
                410
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessExecutionOutcomeSuccess": {
            "value": [
                721
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessExecutionOutput": {
            "costs": [
                404
            ],
            "id": [
                345
            ],
            "inventoryItem": [
                370
            ],
            "itemId": [
                345
            ],
            "quantity": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessExecutionResult": {
            "on_InventoryProcessExecutionError": [
                406
            ],
            "on_InventoryProcessExecutionSuccess": [
                413
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessExecutionSuccess": {
            "value": [
                402
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessExecutionTransformation": {
            "id": [
                345
            ],
            "input": [
                407
            ],
            "outputs": [
                411
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessInput": {
            "id": [
                345
            ],
            "inventoryItem": [
                370
            ],
            "itemId": [
                345
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessOutput": {
            "costs": [
                399
            ],
            "id": [
                345
            ],
            "inventoryItem": [
                370
            ],
            "itemId": [
                345
            ],
            "percentage": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessResult": {
            "on_InventoryProcessError": [
                401
            ],
            "on_InventoryProcessSuccess": [
                419
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessStatus": {},
        "InventoryProcessSuccess": {
            "value": [
                396
            ],
            "__typename": [
                955
            ]
        },
        "InventoryProcessTransformation": {
            "id": [
                345
            ],
            "input": [
                415
            ],
            "outputs": [
                416
            ],
            "__typename": [
                955
            ]
        },
        "InventoryQuantity": {
            "fg": [
                286
            ],
            "total": [
                286
            ],
            "wip": [
                286
            ],
            "wipTagged": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "InventoryReportType": {},
        "InventoryTag": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                955
            ],
            "creatorPlatform": [
                162
            ],
            "grossWeight": [
                286
            ],
            "grossWeightCaptureMethod": [
                1064
            ],
            "inventoryTagId": [
                955
            ],
            "inventoryTagNumber": [
                357
            ],
            "isRevised": [
                85
            ],
            "location": [
                524
            ],
            "locationId": [
                955
            ],
            "material": [
                536
            ],
            "materialId": [
                955
            ],
            "netWeight": [
                286
            ],
            "notes": [
                955
            ],
            "outboundScaleTicketInventoryTags": [
                597
            ],
            "photos": [
                847
            ],
            "printedAt": [
                194
            ],
            "productDescription": [
                742
            ],
            "productDescriptionId": [
                955
            ],
            "quantity": [
                286
            ],
            "salesOrderLoadMaterial": [
                856
            ],
            "scale": [
                871
            ],
            "scaleId": [
                955
            ],
            "scaleTicketInventoryTags": [
                891
            ],
            "status": [
                431
            ],
            "tagType": [
                432
            ],
            "tareType": [
                976
            ],
            "tareTypeId": [
                955
            ],
            "tareWeight": [
                286
            ],
            "tareWeightCaptureMethod": [
                1064
            ],
            "updatedAt": [
                194
            ],
            "visibleMaterialName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "InventoryTagAdjustmentType": {},
        "InventoryTagConnection": {
            "edges": [
                426
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "InventoryTagEdge": {
            "cursor": [
                955
            ],
            "node": [
                423
            ],
            "__typename": [
                955
            ]
        },
        "InventoryTagPhoto": {
            "centralizedCompany": [
                96
            ],
            "inventoryTag": [
                423
            ],
            "inventoryTagPhotoId": [
                955
            ],
            "photo": [
                847
            ],
            "__typename": [
                955
            ]
        },
        "InventoryTagPhotoConnection": {
            "edges": [
                429
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "InventoryTagPhotoEdge": {
            "cursor": [
                955
            ],
            "node": [
                427
            ],
            "__typename": [
                955
            ]
        },
        "InventoryTagPrimaryWeightType": {},
        "InventoryTagStatus": {},
        "InventoryTagType": {},
        "InventoryTransactionType": {},
        "InventoryValuation": {
            "isInterrupted": [
                85
            ],
            "itemId": [
                345
            ],
            "movementId": [
                345
            ],
            "originTransactionItemId": [
                345
            ],
            "totalCost": [
                286
            ],
            "totalQuantity": [
                286
            ],
            "valuationAt": [
                198
            ],
            "wacInterruptionQuantity": [
                286
            ],
            "wacInterruptionTimestamp": [
                198
            ],
            "weightedAverageCost": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "InviteStatus": {},
        "InvoiceStatus": {},
        "InvoiceType": {},
        "IpCamera": {
            "centralizedCompany": [
                96
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "ipCameraId": [
                955
            ],
            "ipCameraName": [
                955
            ],
            "ipCameraUrl": [
                955
            ],
            "isStillImage": [
                85
            ],
            "scales": [
                871
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "IpCameraConnection": {
            "edges": [
                440
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "IpCameraEdge": {
            "cursor": [
                955
            ],
            "node": [
                438
            ],
            "__typename": [
                955
            ]
        },
        "Item": {
            "centralizedCompanyId": [
                345
            ],
            "createdAt": [
                198
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                345
            ],
            "deductions": [
                199
            ],
            "deletedAt": [
                198
            ],
            "deletedById": [
                955
            ],
            "deletedDeductions": [
                199
            ],
            "grossWeight": [
                286
            ],
            "grossWeightInputMethod": [
                1065
            ],
            "id": [
                345
            ],
            "inventoryTag": [
                769
            ],
            "material": [
                536
            ],
            "netWeight": [
                286
            ],
            "notes": [
                955
            ],
            "pictures": [
                528
            ],
            "pricingUnit": [
                707
            ],
            "product": [
                786
            ],
            "purchaseId": [
                345
            ],
            "quantityAmount": [
                286
            ],
            "quantityUnit": [
                795
            ],
            "scrapVehicles": [
                937
            ],
            "subTotal": [
                286
            ],
            "tareOnTruck": [
                85
            ],
            "tareWeight": [
                286
            ],
            "tareWeightInputMethod": [
                1065
            ],
            "total": [
                286
            ],
            "unitPrice": [
                286
            ],
            "updatedAt": [
                198
            ],
            "weightUnit": [
                1066
            ],
            "__typename": [
                955
            ]
        },
        "ItemId": {},
        "ItemMonetaryDeductionTotals": {
            "id": [
                201
            ],
            "monetaryAmountImpact": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "ItemTotals": {
            "id": [
                345
            ],
            "monetaryDeductionsTotals": [
                443
            ],
            "netPrice": [
                286
            ],
            "nominalPrice": [
                286
            ],
            "weightDeductionsTotals": [
                445
            ],
            "__typename": [
                955
            ]
        },
        "ItemWeightDeductionTotals": {
            "deductedWeight": [
                286
            ],
            "id": [
                201
            ],
            "monetaryAmount": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "JSON": {},
        "Job": {
            "centralizedCompanyId": [
                955
            ],
            "closer": [
                1037,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "contact": [
                134,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "createdAt": [
                194
            ],
            "creatorId": [
                955
            ],
            "creatorName": [
                955
            ],
            "creatorPlatform": [
                162
            ],
            "creatorType": [
                955
            ],
            "deadlineChangeNotes": [
                955
            ],
            "deadlineDate": [
                194
            ],
            "defaultStartFacilityName": [
                955
            ],
            "dispatcherAcceptTime": [
                194
            ],
            "dispatcherNotes": [
                955
            ],
            "dispatcherReviewDate": [
                194
            ],
            "driver": [
                223,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "driverCanStartJob": [
                85
            ],
            "driverEndTime": [
                194
            ],
            "driverFailTime": [
                194
            ],
            "driverNotes": [
                955
            ],
            "driverOrder": [
                955
            ],
            "driverStartTime": [
                194
            ],
            "driverTotalTime": [
                286
            ],
            "estimatedEndTime": [
                955
            ],
            "estimatedJobDistance": [
                357
            ],
            "estimatedJobTime": [
                357
            ],
            "estimatedStartTime": [
                955
            ],
            "failedJobNotes": [
                955
            ],
            "failedJobReason": [
                955
            ],
            "files": [
                847
            ],
            "group": [
                338
            ],
            "groupId": [
                955
            ],
            "hasAttachments": [
                85
            ],
            "haulerCompletionConfirmed": [
                194
            ],
            "haulerJobAccepted": [
                194
            ],
            "highPriority": [
                85
            ],
            "isNonDefaultTrailer": [
                85
            ],
            "isNonDefaultTruck": [
                85
            ],
            "isServiceRequest": [
                85
            ],
            "jobCompletionNotes": [
                955
            ],
            "jobFreight": [
                450
            ],
            "jobId": [
                955
            ],
            "jobLocations": [
                452
            ],
            "jobNumber": [
                357
            ],
            "jobPauseLog": [
                462,
                {
                    "scope": [
                        955
                    ]
                }
            ],
            "jobSchedule": [
                471,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "jobTemplate": [
                480
            ],
            "jobTemplateId": [
                955
            ],
            "jobType": [
                492
            ],
            "miles": [
                286
            ],
            "notes": [
                955
            ],
            "numberOfAssets": [
                357
            ],
            "originalScheduledDate": [
                194
            ],
            "postJobNotes": [
                955
            ],
            "previouslyFailedJobId": [
                955
            ],
            "recycler": [
                96
            ],
            "requestingCentralizedCompanyId": [
                955
            ],
            "scaleTickets": [
                877
            ],
            "scheduledDate": [
                194
            ],
            "serviceDate": [
                194
            ],
            "serviceRequestNotes": [
                955
            ],
            "shareLocationNotesWithDriver": [
                85
            ],
            "shareServiceRequestNotesWithDriver": [
                85
            ],
            "status": [
                955
            ],
            "thirdPartyHauler": [
                1004,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "timeAssigned": [
                194
            ],
            "trailer": [
                1009,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "truck": [
                1021,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "truckStateDistances": [
                1025
            ],
            "updatedAt": [
                194
            ],
            "voidTime": [
                194
            ],
            "wasManuallyCompleted": [
                85
            ],
            "__typename": [
                955
            ]
        },
        "JobConnection": {
            "edges": [
                449,
                {
                    "recursiveParanoid": [
                        85
                    ]
                }
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "JobEdge": {
            "cursor": [
                955
            ],
            "node": [
                447
            ],
            "__typename": [
                955
            ]
        },
        "JobFreight": {
            "adjustmentsCost": [
                286
            ],
            "centralizedCompanyId": [
                955
            ],
            "distance": [
                286
            ],
            "freightAdjustments": [
                451
            ],
            "freightLaneId": [
                955
            ],
            "jobFreightId": [
                955
            ],
            "roundTripCost": [
                286
            ],
            "totalFreightCost": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "JobFreightAdjustment": {
            "adjustmentCost": [
                286
            ],
            "adjustmentType": [
                287
            ],
            "jobFreightAdjustmentId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "JobLocation": {
            "centralizedCompanyId": [
                955
            ],
            "collectSignature": [
                85
            ],
            "dispatcherNotes": [
                955
            ],
            "driverArriveTime": [
                194
            ],
            "driverDepartTime": [
                194
            ],
            "driverStatus": [
                955
            ],
            "externalNotes": [
                955
            ],
            "heavyWeight": [
                286
            ],
            "job": [
                447
            ],
            "jobId": [
                955
            ],
            "jobLocationId": [
                955
            ],
            "jobLocationMaterials": [
                453
            ],
            "jobLocationOrder": [
                357
            ],
            "jobLocationPayloadActions": [
                456
            ],
            "jobLocationPhotos": [
                459
            ],
            "lightWeight": [
                286
            ],
            "location": [
                524,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "locationId": [
                955
            ],
            "locationName": [
                955
            ],
            "milesTravelled": [
                286
            ],
            "payloads": [
                619
            ],
            "requireMaterialEntry": [
                85
            ],
            "signature": [
                847
            ],
            "signatureId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "JobLocationMaterial": {
            "centralizedCompany": [
                96
            ],
            "createdAt": [
                194
            ],
            "creator": [
                223
            ],
            "deletedAt": [
                194
            ],
            "files": [
                847
            ],
            "grossWeight": [
                286
            ],
            "jobLocation": [
                452
            ],
            "jobLocationMaterialId": [
                955
            ],
            "material": [
                536
            ],
            "tareWeight": [
                286
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "JobLocationMaterialConnection": {
            "edges": [
                455
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "JobLocationMaterialEdge": {
            "cursor": [
                955
            ],
            "node": [
                453
            ],
            "__typename": [
                955
            ]
        },
        "JobLocationPayloadAction": {
            "action": [
                458
            ],
            "jobLocation": [
                452
            ],
            "jobLocationId": [
                955
            ],
            "jobLocationPayloadActionId": [
                955
            ],
            "jobLocationPayloadActionPhotos": [
                457
            ],
            "payload": [
                619
            ],
            "payloadId": [
                955
            ],
            "photos": [
                847
            ],
            "__typename": [
                955
            ]
        },
        "JobLocationPayloadActionPhoto": {
            "assetImageType": [
                955
            ],
            "jobLocationPayloadAction": [
                456
            ],
            "jobLocationPayloadActionId": [
                955
            ],
            "jobLocationPayloadActionPhotoId": [
                955
            ],
            "photo": [
                847
            ],
            "photoId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "JobLocationPayloadActionType": {},
        "JobLocationPhoto": {
            "jobLocation": [
                452
            ],
            "jobLocationId": [
                955
            ],
            "jobLocationPhotoId": [
                955
            ],
            "payloadAction": [
                458
            ],
            "photo": [
                847
            ],
            "photoId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "JobMetric": {
            "date": [
                194
            ],
            "numJobsCompletedAfterDeadlineDate": [
                357
            ],
            "numJobsCompletedAfterExpectedDate": [
                357
            ],
            "numJobsCompletedOnTime": [
                357
            ],
            "totalJobs": [
                357
            ],
            "totalJobsSuccessful": [
                357
            ],
            "totalsByJobType": [
                494
            ],
            "__typename": [
                955
            ]
        },
        "JobPauseInput": {
            "jobId": [
                955
            ],
            "jobPauseReasonId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "JobPauseLogEntry": {
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "jobId": [
                955
            ],
            "jobPauseLogEntryId": [
                955
            ],
            "jobPauseReason": [
                465
            ],
            "jobPauseReasonId": [
                955
            ],
            "pausedAt": [
                194
            ],
            "pausedById": [
                955
            ],
            "pausedByType": [
                955
            ],
            "resumedAt": [
                194
            ],
            "resumedById": [
                955
            ],
            "resumedByType": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "JobPauseLogEntryConnection": {
            "edges": [
                464
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "JobPauseLogEntryEdge": {
            "cursor": [
                955
            ],
            "node": [
                462
            ],
            "__typename": [
                955
            ]
        },
        "JobPauseReason": {
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "description": [
                955
            ],
            "jobPauseReasonId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "JobPauseReasonConnection": {
            "edges": [
                467
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "JobPauseReasonEdge": {
            "cursor": [
                955
            ],
            "node": [
                465
            ],
            "__typename": [
                955
            ]
        },
        "JobPrintType": {},
        "JobRequestType": {},
        "JobResumeInput": {
            "jobId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "JobSchedule": {
            "assetTypesFromFacility": [
                472
            ],
            "assetTypesToFacility": [
                472
            ],
            "companyLocation": [
                524
            ],
            "destinationLocationName": [
                955
            ],
            "dispatcherNotes": [
                955
            ],
            "driver": [
                223
            ],
            "dropoffFacility": [
                524
            ],
            "endDate": [
                194
            ],
            "externalNotes": [
                955
            ],
            "facility": [
                524
            ],
            "group": [
                338
            ],
            "groupId": [
                955
            ],
            "jobScheduleId": [
                955
            ],
            "jobType": [
                955
            ],
            "numberOfInstancesToCreate": [
                357
            ],
            "repeatFrequency": [
                357
            ],
            "repeatMagnitude": [
                476
            ],
            "repeatedDateOfMonth": [
                357
            ],
            "repeatedDaysOfWeek": [
                357
            ],
            "repeatedWeekOfMonth": [
                357
            ],
            "shareLocationNotesWithDriver": [
                85
            ],
            "startDate": [
                194
            ],
            "thirdPartyHauler": [
                1004,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "__typename": [
                955
            ]
        },
        "JobScheduleAssetType": {
            "assetDescriptionId": [
                955
            ],
            "assetType": [
                52
            ],
            "assetTypeId": [
                345
            ],
            "jobScheduleId": [
                345
            ],
            "quantity": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "JobScheduleConnection": {
            "edges": [
                474
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "JobScheduleEdge": {
            "cursor": [
                955
            ],
            "node": [
                471
            ],
            "__typename": [
                955
            ]
        },
        "JobScheduleMonthlyRepeatMode": {},
        "JobScheduleRepeatMagnitude": {},
        "JobSegment": {
            "jobLocations": [
                452
            ],
            "milesTravelled": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "JobStatus": {},
        "JobStatusFilterOptionTypes": {},
        "JobTemplate": {
            "createdAt": [
                194
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                955
            ],
            "endLocation": [
                955
            ],
            "group": [
                338
            ],
            "groupId": [
                955
            ],
            "jobLegsCount": [
                357
            ],
            "jobTemplateId": [
                955
            ],
            "jobTemplateLocations": [
                483
            ],
            "jobType": [
                492
            ],
            "startLocation": [
                955
            ],
            "templateName": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "JobTemplateConnection": {
            "edges": [
                482
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "JobTemplateEdge": {
            "cursor": [
                955
            ],
            "node": [
                480
            ],
            "__typename": [
                955
            ]
        },
        "JobTemplateLocation": {
            "collectSignature": [
                85
            ],
            "jobLocationOrder": [
                357
            ],
            "jobTemplateLocationId": [
                955
            ],
            "jobTemplatePayloadActions": [
                487
            ],
            "location": [
                524
            ],
            "locationId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "JobTemplateLocationConnection": {
            "edges": [
                485
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "JobTemplateLocationEdge": {
            "cursor": [
                955
            ],
            "node": [
                483
            ],
            "__typename": [
                955
            ]
        },
        "JobTemplatePayload": {
            "assetDescription": [
                42
            ],
            "assetDescriptionId": [
                955
            ],
            "assetType": [
                52
            ],
            "assetTypeId": [
                955
            ],
            "jobTemplatePayloadId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "JobTemplatePayloadAction": {
            "action": [
                458
            ],
            "jobTemplatePayload": [
                486
            ],
            "jobTemplatePayloadActionId": [
                955
            ],
            "jobTemplatePayloadId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "JobTemplatePayloadActionConnection": {
            "edges": [
                489
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "JobTemplatePayloadActionEdge": {
            "cursor": [
                955
            ],
            "node": [
                487
            ],
            "__typename": [
                955
            ]
        },
        "JobTemplatePayloadConnection": {
            "edges": [
                491
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "JobTemplatePayloadEdge": {
            "cursor": [
                955
            ],
            "node": [
                486
            ],
            "__typename": [
                955
            ]
        },
        "JobType": {},
        "JobTypeGroup": {},
        "JobTypeTotal": {
            "jobType": [
                492
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "JournalEntry": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                198
            ],
            "date": [
                198
            ],
            "journalEntryId": [
                345
            ],
            "journalEntryLines": [
                499
            ],
            "journalEntrySequence": [
                286
            ],
            "memo": [
                955
            ],
            "postedAt": [
                198
            ],
            "status": [
                953
            ],
            "total": [
                286
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "JournalEntryConnection": {
            "edges": [
                497
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "JournalEntryEdge": {
            "node": [
                495
            ],
            "__typename": [
                955
            ]
        },
        "JournalEntryImpactSummary": {
            "accountImpactSummary": [
                7
            ],
            "journalEntryId": [
                345
            ],
            "__typename": [
                955
            ]
        },
        "JournalEntryLine": {
            "account": [
                2
            ],
            "accountId": [
                955
            ],
            "amount": [
                286
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                198
            ],
            "description": [
                955
            ],
            "journalEntryLineId": [
                345
            ],
            "normality": [
                573
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "JournalEntryLineConnection": {
            "edges": [
                501
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "JournalEntryLineEdge": {
            "node": [
                499
            ],
            "__typename": [
                955
            ]
        },
        "JournalEntryLineInput": {
            "accountId": [
                955
            ],
            "amount": [
                286
            ],
            "description": [
                955
            ],
            "normality": [
                573
            ],
            "__typename": [
                955
            ]
        },
        "KansasScrapMetalMaterialForm": {
            "materialFormId": [
                955
            ],
            "materialFormName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "KansasScrapMetalMaterialType": {
            "materialForms": [
                503
            ],
            "materialTypeId": [
                955
            ],
            "materialTypeName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "KansasScrapMetalVehicleMake": {
            "vehicleMakeCode": [
                955
            ],
            "vehicleMakeId": [
                955
            ],
            "vehicleMakeName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "KansasScrapMetalVehicleModel": {
            "vehicleModelCode": [
                955
            ],
            "vehicleModelName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "KeyAndOptions": {
            "options": [
                1140
            ],
            "s3Key": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "LanguagesSupported": {},
        "LatestAppData": {
            "androidDriver": [
                38
            ],
            "androidOperator": [
                38
            ],
            "iOSDriver": [
                38
            ],
            "iOSOperator": [
                38
            ],
            "__typename": [
                955
            ]
        },
        "Lead": {
            "companyName": [
                955
            ],
            "contacts": [
                134
            ],
            "isCustomer": [
                85
            ],
            "isServiceProvider": [
                85
            ],
            "isSupplier": [
                85
            ],
            "leadId": [
                955
            ],
            "locations": [
                524
            ],
            "notes": [
                955
            ],
            "priority": [
                513
            ],
            "status": [
                514
            ],
            "__typename": [
                955
            ]
        },
        "LeadConnection": {
            "edges": [
                512
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "LeadEdge": {
            "cursor": [
                955
            ],
            "node": [
                510
            ],
            "__typename": [
                955
            ]
        },
        "LeadPriority": {},
        "LeadStatus": {},
        "LedgerEntry": {
            "account": [
                2
            ],
            "accountId": [
                345
            ],
            "amount": [
                286
            ],
            "balance": [
                286
            ],
            "createdAt": [
                198
            ],
            "journalEntryLine": [
                499
            ],
            "journalEntryLineId": [
                345
            ],
            "ledgerEntryId": [
                345
            ],
            "postedAt": [
                198
            ],
            "transactionDate": [
                198
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "LedgerEntryConnection": {
            "edges": [
                517
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "LedgerEntryEdge": {
            "node": [
                515
            ],
            "__typename": [
                955
            ]
        },
        "Load": {
            "bookingId": [
                345
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                198
            ],
            "createdBy": [
                869
            ],
            "createdById": [
                345
            ],
            "deletedAt": [
                198
            ],
            "facility": [
                849
            ],
            "facilityId": [
                345
            ],
            "id": [
                345
            ],
            "number": [
                955
            ],
            "outboundScaleTicketId": [
                345
            ],
            "photos": [
                522
            ],
            "receivableInvoiceId": [
                345
            ],
            "salesOrderId": [
                345
            ],
            "status": [
                523
            ],
            "updatedAt": [
                198
            ],
            "updatedBy": [
                869
            ],
            "updatedById": [
                345
            ],
            "__typename": [
                955
            ]
        },
        "LoadBoardAssignableType": {},
        "LoadConnection": {
            "edges": [
                521
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "LoadEdge": {
            "node": [
                518
            ],
            "__typename": [
                955
            ]
        },
        "LoadPhoto": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                198
            ],
            "creatorId": [
                345
            ],
            "deletedAt": [
                198
            ],
            "downloadUrl": [
                955
            ],
            "id": [
                345
            ],
            "loadId": [
                345
            ],
            "name": [
                955
            ],
            "notes": [
                955
            ],
            "order": [
                357
            ],
            "photoRequirement": [
                650
            ],
            "photoRequirementId": [
                345
            ],
            "s3Key": [
                955
            ],
            "size": [
                286
            ],
            "type": [
                955
            ],
            "updatedAt": [
                198
            ],
            "uploadConfirmed": [
                85
            ],
            "url": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "LoadStatus": {},
        "Location": {
            "addressInputType": [
                29
            ],
            "availableAssetTypes": [
                54,
                {
                    "selectedCompanyId": [
                        955
                    ]
                }
            ],
            "city": [
                955
            ],
            "company": [
                130,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "contacts": [
                134
            ],
            "country": [
                955
            ],
            "county": [
                955
            ],
            "currentAssets": [
                40,
                {
                    "assetTypeId": [
                        955
                    ],
                    "includeOutOfService": [
                        85
                    ],
                    "selectedCompanyId": [
                        955
                    ],
                    "status": [
                        955
                    ]
                }
            ],
            "customAttributes": [
                446
            ],
            "customLocationId": [
                955
            ],
            "equipments": [
                230
            ],
            "extraLocationData": [
                264
            ],
            "facilitySettings": [
                270
            ],
            "facilityType": [
                955
            ],
            "governmentReportingFacilities": [
                322
            ],
            "group": [
                338
            ],
            "jobLocations": [
                452
            ],
            "latitude": [
                286
            ],
            "locatableId": [
                955
            ],
            "locatableType": [
                955
            ],
            "locationId": [
                955
            ],
            "locationName": [
                955
            ],
            "longitude": [
                286
            ],
            "mailingAddress": [
                85
            ],
            "numAssets": [
                357
            ],
            "numOfEquipmentChecklists": [
                357
            ],
            "permissionedCompanies": [
                130
            ],
            "privilegedUsers": [
                1037
            ],
            "recycler": [
                96
            ],
            "sidecarHosts": [
                947
            ],
            "state": [
                955
            ],
            "streetAddress": [
                955
            ],
            "timezone": [
                955
            ],
            "zipcode": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "LocationAddress": {
            "city": [
                955
            ],
            "country": [
                955
            ],
            "latitude": [
                286
            ],
            "longitude": [
                286
            ],
            "state": [
                955
            ],
            "streetAddress": [
                955
            ],
            "timezone": [
                955
            ],
            "unstable": [
                85
            ],
            "zipcode": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "LocationConnection": {
            "edges": [
                527
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "LocationEdge": {
            "cursor": [
                955
            ],
            "node": [
                524
            ],
            "__typename": [
                955
            ]
        },
        "ManagedFile": {
            "centralizedCompanyId": [
                99
            ],
            "createdAt": [
                198
            ],
            "creatorId": [
                345
            ],
            "deletedAt": [
                198
            ],
            "deletedById": [
                345
            ],
            "entityId": [
                955
            ],
            "id": [
                529
            ],
            "metadata": [
                530
            ],
            "reason": [
                532
            ],
            "updatedAt": [
                198
            ],
            "uploadConfirmed": [
                85
            ],
            "url": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ManagedFileId": {},
        "ManagedFileMetadata": {
            "mimeType": [
                955
            ],
            "name": [
                955
            ],
            "sizeInBytes": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "ManagedFileMetadataInput": {
            "mimeType": [
                955
            ],
            "name": [
                955
            ],
            "sizeInBytes": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "ManagedFileReason": {},
        "ManagedFileResult": {
            "managedFile": [
                528
            ],
            "uploadUrl": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "MassUnit": {},
        "MassUnitGroup": {},
        "Material": {
            "assets": [
                40
            ],
            "averageAcquisitionCost": [
                286
            ],
            "catalyticConverter": [
                92
            ],
            "catalyticConverterId": [
                955
            ],
            "catalyticConverterSize": [
                95
            ],
            "createdAt": [
                194
            ],
            "customAttributes": [
                446
            ],
            "darkColor": [
                955
            ],
            "darkTextColor": [
                955
            ],
            "defaultPricingUnitGroup": [
                535
            ],
            "defaultSalesPricingUnitGroup": [
                535
            ],
            "defaultUnitPriceToNegative": [
                85
            ],
            "deletedAt": [
                85
            ],
            "fgInventory": [
                286
            ],
            "inventoryState": [
                371
            ],
            "inventoryTags": [
                423
            ],
            "inventoryValuation": [
                434,
                {
                    "facilityId": [
                        955
                    ],
                    "valuationAt": [
                        198
                    ]
                }
            ],
            "kansasScrapMetalMaterialFormId": [
                955
            ],
            "kansasScrapMetalMaterialTypeId": [
                955
            ],
            "lightColor": [
                955
            ],
            "lightTextColor": [
                955
            ],
            "materialGroup": [
                541
            ],
            "materialGroupId": [
                955
            ],
            "materialGroupType": [
                559
            ],
            "materialId": [
                345
            ],
            "materialIntegrations": [
                546
            ],
            "materialLocations": [
                551,
                {
                    "locationId": [
                        955
                    ]
                }
            ],
            "materialName": [
                955
            ],
            "materialNotes": [
                955
            ],
            "numberOfInInventoryFgInventoryTags": [
                357
            ],
            "numberOfInInventoryWipInventoryTags": [
                357
            ],
            "ohioDpsMaterialCode": [
                955
            ],
            "pendingShipmentInventory": [
                286
            ],
            "pricingUnitGroup": [
                535
            ],
            "recycler": [
                96
            ],
            "skuNumber": [
                955
            ],
            "texasOnlineMetalsMaterialCode": [
                995
            ],
            "texasOnlineMetalsMaterialCodeId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "wipInventory": [
                286
            ],
            "wipTagInventory": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "MaterialAdjustment": {
            "adjustmentQuantity": [
                286
            ],
            "adjustmentQuantityEntryType": [
                30
            ],
            "adjustmentReason": [
                955
            ],
            "adjustmentType": [
                366
            ],
            "adjustmentWacEntryType": [
                32
            ],
            "createdAt": [
                194
            ],
            "creatorId": [
                955
            ],
            "fromMaterialLocation": [
                551
            ],
            "inventoryTag": [
                423
            ],
            "materialAdjustmentId": [
                955
            ],
            "postedAt": [
                194
            ],
            "recycler": [
                96
            ],
            "toMaterialLocation": [
                551
            ],
            "totalQuantity": [
                286
            ],
            "weightedAverageCost": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "MaterialConnection": {
            "edges": [
                539
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "MaterialEdge": {
            "cursor": [
                955
            ],
            "node": [
                536
            ],
            "__typename": [
                955
            ]
        },
        "MaterialForMassScaleTicketReviseInput": {
            "materialId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescriptionId": [
                955
            ],
            "unitPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "MaterialGroup": {
            "averageAcquisitionCost": [
                286
            ],
            "centralizedCompanyId": [
                96
            ],
            "createdAt": [
                194
            ],
            "darkColor": [
                955
            ],
            "darkTextColor": [
                955
            ],
            "defaultPricingUnitGroup": [
                535
            ],
            "defaultSalesPricingUnitGroup": [
                535
            ],
            "deletedAt": [
                194
            ],
            "fgInventory": [
                286
            ],
            "inventoryState": [
                371
            ],
            "inventoryValuation": [
                434,
                {
                    "facilityId": [
                        955
                    ],
                    "valuationAt": [
                        198
                    ]
                }
            ],
            "lightColor": [
                955
            ],
            "lightTextColor": [
                955
            ],
            "materialGroupId": [
                955
            ],
            "materialGroupName": [
                955
            ],
            "materialGroupNumber": [
                955
            ],
            "materialGroupType": [
                559
            ],
            "materials": [
                536
            ],
            "numberOfInInventoryFgInventoryTags": [
                357
            ],
            "numberOfInInventoryWipInventoryTags": [
                357
            ],
            "numberOfMaterials": [
                357
            ],
            "pendingShipmentInventory": [
                286
            ],
            "readOnly": [
                85
            ],
            "wipInventory": [
                286
            ],
            "wipTagInventory": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "MaterialGroupConnection": {
            "edges": [
                543
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "MaterialGroupEdge": {
            "cursor": [
                955
            ],
            "node": [
                541
            ],
            "__typename": [
                955
            ]
        },
        "MaterialGroupInventoryByLocation": {
            "nodes": [
                545
            ],
            "__typename": [
                955
            ]
        },
        "MaterialGroupInventoryByLocationNode": {
            "averageAcquisitionCost": [
                286
            ],
            "defaultPricingUnitGroup": [
                535
            ],
            "defaultSalesPricingUnitGroup": [
                535
            ],
            "fgInventory": [
                286
            ],
            "key": [
                955
            ],
            "locationName": [
                955
            ],
            "pendingShipmentInventory": [
                286
            ],
            "wipInventory": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "MaterialIntegration": {
            "centralizedCompanyId": [
                955
            ],
            "integrationData": [
                446
            ],
            "integrationType": [
                549
            ],
            "material": [
                536
            ],
            "materialId": [
                955
            ],
            "materialIntegrationId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "MaterialIntegrationConnection": {
            "edges": [
                548
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "MaterialIntegrationEdge": {
            "cursor": [
                955
            ],
            "node": [
                546
            ],
            "__typename": [
                955
            ]
        },
        "MaterialIntegrationType": {},
        "MaterialItemForMassScaleTicketRevise": {
            "material": [
                536
            ],
            "pricingUnits": [
                534
            ],
            "productDescription": [
                742
            ],
            "totalDeductions": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "MaterialLocation": {
            "averageAcquisitionCost": [
                286
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                85
            ],
            "fgInventory": [
                286
            ],
            "inboundPrice": [
                286
            ],
            "location": [
                524
            ],
            "locationId": [
                955
            ],
            "material": [
                536
            ],
            "materialId": [
                955
            ],
            "materialLocationId": [
                955
            ],
            "outboundPrice": [
                286
            ],
            "pendingShipmentInventory": [
                286
            ],
            "priceUpdatedDate": [
                194
            ],
            "recycler": [
                96
            ],
            "wipInventory": [
                286
            ],
            "wipTaggedInventory": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "MaterialLocationInput": {
            "inboundPrice": [
                286
            ],
            "materialLocationId": [
                955
            ],
            "outboundPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "MaterialPurchasesResult": {
            "material": [
                955
            ],
            "materialGroup": [
                955
            ],
            "purchasedQuantity": [
                286
            ],
            "purchasedValue": [
                286
            ],
            "purchasedWeight": [
                286
            ],
            "totalTickets": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "MaterialPurchasesTotalResult": {
            "monetaryValueTotalPurchases": [
                286
            ],
            "totalMaterialsPurchases": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "MaterialTransaction": {
            "accountName": [
                955
            ],
            "catalyticConverterSize": [
                95
            ],
            "entityId": [
                955
            ],
            "entityNumber": [
                955
            ],
            "facilityLocation": [
                524
            ],
            "facilityLocationId": [
                955
            ],
            "grossWeight": [
                286
            ],
            "material": [
                536
            ],
            "materialId": [
                955
            ],
            "materialTransactionId": [
                955
            ],
            "netWeight": [
                286
            ],
            "pricingUnit": [
                534
            ],
            "quantity": [
                286
            ],
            "tareWeight": [
                286
            ],
            "totalPrice": [
                286
            ],
            "transactionDate": [
                194
            ],
            "transactionSubType": [
                955
            ],
            "transactionType": [
                955
            ],
            "unitPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "MaterialTransactionConnection": {
            "edges": [
                557
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "MaterialTransactionEdge": {
            "cursor": [
                955
            ],
            "node": [
                555
            ],
            "__typename": [
                955
            ]
        },
        "MaterialTransactionType": {},
        "MaterialType": {},
        "MeasurementSystem": {},
        "Message": {
            "message": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "MetricByDate": {
            "count": [
                357
            ],
            "date": [
                194
            ],
            "status": [
                955
            ],
            "type": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "MetricMassUnit": {},
        "MetricWithStatusAndType": {
            "objectDays": [
                357
            ],
            "status": [
                955
            ],
            "type": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "MixedMaterial": {
            "createdAt": [
                198
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                345
            ],
            "deletedItems": [
                441
            ],
            "grossWeight": [
                286
            ],
            "grossWeightInputMethod": [
                1065
            ],
            "id": [
                566
            ],
            "items": [
                441
            ],
            "material": [
                536
            ],
            "netWeight": [
                286
            ],
            "notes": [
                955
            ],
            "pictures": [
                528
            ],
            "product": [
                786
            ],
            "purchaseId": [
                768
            ],
            "tareWeight": [
                286
            ],
            "tareWeightInputMethod": [
                1065
            ],
            "updatedAt": [
                198
            ],
            "weightUnit": [
                1066
            ],
            "__typename": [
                955
            ]
        },
        "MixedMaterialId": {},
        "MobilePlatform": {},
        "MonetaryValuePurchasesResult": {
            "achAmount": [
                286
            ],
            "atmAmount": [
                286
            ],
            "cashAmount": [
                286
            ],
            "checkAmount": [
                286
            ],
            "paymentDate": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "Mutation": {
            "acceptIntegrationInvitation": [
                358,
                {
                    "integrationInvitationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "activateInventoryPeriod": [
                394,
                {
                    "input": [
                        26,
                        "ActivateInventoryPeriodInput!"
                    ]
                }
            ],
            "activatePriceList": [
                688,
                {
                    "priceListId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "addCounterpartiesToGroup": [
                142,
                {
                    "counterpartyGroupId": [
                        143,
                        "CounterpartyGroupId!"
                    ],
                    "counterpartyIds": [
                        147,
                        "[CounterpartyId!]!"
                    ],
                    "counterpartyType": [
                        955,
                        "String!"
                    ]
                }
            ],
            "addDeductionToPurchase": [
                28,
                {
                    "deduction": [
                        202,
                        "DeductionInput!"
                    ],
                    "purchaseId": [
                        345,
                        "ID!"
                    ]
                }
            ],
            "addDeductionToPurchaseItem": [
                27,
                {
                    "deduction": [
                        202,
                        "DeductionInput!"
                    ],
                    "itemId": [
                        345,
                        "ID!"
                    ],
                    "purchaseId": [
                        345,
                        "ID!"
                    ]
                }
            ],
            "addFileToItemVehicle": [
                533,
                {
                    "itemId": [
                        442,
                        "ItemId!"
                    ],
                    "metadata": [
                        531
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ],
                    "scrapVehicleId": [
                        938,
                        "ScrapVehicleId!"
                    ]
                }
            ],
            "addInventoryTagToSalesOrderLoad": [
                423,
                {
                    "inventoryTagId": [
                        955,
                        "String!"
                    ],
                    "salesOrderLoadMaterialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "addItemToPurchase": [
                763,
                {
                    "createdAt": [
                        198,
                        "DateTime!"
                    ],
                    "inventoryTag": [
                        770
                    ],
                    "itemId": [
                        345,
                        "ID!"
                    ],
                    "mixedMaterialId": [
                        566
                    ],
                    "notes": [
                        955
                    ],
                    "product": [
                        787
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ],
                    "tareOnTruck": [
                        85
                    ]
                }
            ],
            "addMaterialToJobLocation": [
                452,
                {
                    "grossWeight": [
                        286
                    ],
                    "jobLocationId": [
                        955,
                        "String!"
                    ],
                    "materialId": [
                        955,
                        "String!"
                    ],
                    "tareWeight": [
                        286
                    ]
                }
            ],
            "addMixedMaterialToPurchase": [
                763,
                {
                    "mixedMaterialId": [
                        566
                    ],
                    "notes": [
                        955
                    ],
                    "product": [
                        787
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ],
                    "weight": [
                        774
                    ]
                }
            ],
            "addPictureToMixedMaterial": [
                533,
                {
                    "metadata": [
                        531,
                        "ManagedFileMetadataInput!"
                    ],
                    "mixedMaterialId": [
                        345,
                        "ID!"
                    ],
                    "purchaseId": [
                        345,
                        "ID!"
                    ],
                    "reason": [
                        532
                    ]
                }
            ],
            "addPictureToPurchaseItem": [
                533,
                {
                    "itemId": [
                        345,
                        "ID!"
                    ],
                    "metadata": [
                        531
                    ],
                    "purchaseId": [
                        345,
                        "ID!"
                    ],
                    "reason": [
                        532
                    ]
                }
            ],
            "addProductPricingToCustomPriceList": [
                184,
                {
                    "customPriceListId": [
                        185,
                        "CustomPriceListId!"
                    ],
                    "pricingUnit": [
                        703,
                        "PricingPricingUnit!"
                    ],
                    "product": [
                        705,
                        "PricingProductInput!"
                    ],
                    "tiers": [
                        755,
                        "[ProductPricingTierInput!]!"
                    ],
                    "tiersEffectiveAt": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "addProductPricingToDefaultPriceList": [
                211,
                {
                    "currency": [
                        702,
                        "PricingCurrency!"
                    ],
                    "facilityId": [
                        268,
                        "FacilityId!"
                    ],
                    "operationType": [
                        582,
                        "OperationType!"
                    ],
                    "pricingUnit": [
                        703,
                        "PricingPricingUnit!"
                    ],
                    "product": [
                        705,
                        "PricingProductInput!"
                    ],
                    "tiers": [
                        755,
                        "[ProductPricingTierInput!]!"
                    ],
                    "tiersEffectiveAt": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "addPurchaseACHPayment": [
                0,
                {
                    "amount": [
                        286,
                        "Float!"
                    ],
                    "bankId": [
                        345,
                        "ID!"
                    ],
                    "id": [
                        345,
                        "ID!"
                    ],
                    "legalHold": [
                        85,
                        "Boolean!"
                    ],
                    "paymentSchedule": [
                        785
                    ],
                    "purchaseId": [
                        345,
                        "ID!"
                    ],
                    "scheduledDate": [
                        198
                    ]
                }
            ],
            "addPurchaseATMPayment": [
                1,
                {
                    "amount": [
                        286,
                        "Float!"
                    ],
                    "atmId": [
                        345,
                        "ID!"
                    ],
                    "financialAccountId": [
                        345,
                        "ID!"
                    ],
                    "id": [
                        345,
                        "ID!"
                    ],
                    "legalHold": [
                        85,
                        "Boolean!"
                    ],
                    "paymentSchedule": [
                        785
                    ],
                    "purchaseId": [
                        345,
                        "ID!"
                    ],
                    "scheduledDate": [
                        198
                    ]
                }
            ],
            "addPurchaseCashPayment": [
                90,
                {
                    "amount": [
                        286,
                        "Float!"
                    ],
                    "financialAccountId": [
                        345,
                        "ID!"
                    ],
                    "id": [
                        345,
                        "ID!"
                    ],
                    "legalHold": [
                        85,
                        "Boolean!"
                    ],
                    "paymentSchedule": [
                        785
                    ],
                    "purchaseId": [
                        345,
                        "ID!"
                    ],
                    "scheduledDate": [
                        198
                    ]
                }
            ],
            "addPurchaseCheckPayment": [
                120,
                {
                    "amount": [
                        286,
                        "Float!"
                    ],
                    "checkMemo": [
                        955
                    ],
                    "checkNumber": [
                        955
                    ],
                    "financialAccountId": [
                        345,
                        "ID!"
                    ],
                    "id": [
                        345,
                        "ID!"
                    ],
                    "legalHold": [
                        85,
                        "Boolean!"
                    ],
                    "paymentSchedule": [
                        785
                    ],
                    "purchaseId": [
                        345,
                        "ID!"
                    ],
                    "scheduledDate": [
                        198
                    ]
                }
            ],
            "addScrapVehicle": [
                937,
                {
                    "itemId": [
                        442,
                        "ItemId!"
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ],
                    "scrapVehicle": [
                        939
                    ],
                    "scrapVehicleId": [
                        938,
                        "ScrapVehicleId!"
                    ]
                }
            ],
            "addSupplierPhotoToPurchase": [
                533,
                {
                    "metadata": [
                        531
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ]
                }
            ],
            "addSupplierSignatureToPurchase": [
                533,
                {
                    "metadata": [
                        531
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ]
                }
            ],
            "addTeamMember": [
                1037,
                {
                    "clonePermissions": [
                        85
                    ],
                    "skipWelcomeEmail": [
                        85
                    ],
                    "user": [
                        1276
                    ]
                }
            ],
            "archiveCustomPriceList": [
                184,
                {
                    "archive": [
                        85,
                        "Boolean!"
                    ],
                    "archivedAt": [
                        198
                    ],
                    "id": [
                        185,
                        "CustomPriceListId!"
                    ],
                    "tiersEffectiveAt": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "archiveInventoryProcess": [
                417,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "arriveAtJobLocation": [
                452,
                {
                    "driverArriveTime": [
                        194
                    ],
                    "jobLocationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "assignSalesOrderLoadToSalesOrder": [
                853,
                {
                    "finishDraft": [
                        85
                    ],
                    "salesOrderId": [
                        955,
                        "String!"
                    ],
                    "salesOrderLoadId": [
                        955,
                        "String!"
                    ],
                    "salesOrderMaterials": [
                        1209,
                        "[salesOrderMaterialInput!]"
                    ]
                }
            ],
            "assignSalesOrderToOutboundScaleTicket": [
                584,
                {
                    "finishDraft": [
                        85
                    ],
                    "outboundScaleTicketId": [
                        955,
                        "String!"
                    ],
                    "salesOrderId": [
                        955,
                        "String!"
                    ],
                    "salesOrderMaterials": [
                        1209,
                        "[salesOrderMaterialInput!]"
                    ]
                }
            ],
            "assignSupplierToPurchase": [
                763,
                {
                    "purchaseId": [
                        345,
                        "ID!"
                    ],
                    "supplier": [
                        963,
                        "SupplierInput!"
                    ]
                }
            ],
            "assignTruckToDriver": [
                223,
                {
                    "driverId": [
                        955,
                        "String!"
                    ],
                    "truckId": [
                        955
                    ]
                }
            ],
            "batchScaleTicketsMaterialPricesRevise": [
                877,
                {
                    "companyId": [
                        955
                    ],
                    "materials": [
                        540,
                        "[MaterialForMassScaleTicketReviseInput!]!"
                    ],
                    "publicSupplierId": [
                        955
                    ],
                    "transactionDatePeriod": [
                        955,
                        "[String!]!"
                    ],
                    "updateDeductions": [
                        85,
                        "Boolean!"
                    ]
                }
            ],
            "cancelIntegrationInvitation": [
                358,
                {
                    "integrationInvitationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "clearDriverTruckTrailerAssignment": [
                357
            ],
            "clearSuccessfulJobs": [
                447,
                {
                    "driverId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "cloneJob": [
                447,
                {
                    "input": [
                        1078,
                        "cloneJobInput!"
                    ]
                }
            ],
            "clonePriceList": [
                688,
                {
                    "priceListId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "clonePurchaseOrder": [
                776,
                {
                    "purchaseOrderId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "cloneReportTemplate": [
                838,
                {
                    "cloneReportTemplateInput": [
                        125,
                        "CloneReportTemplateInput!"
                    ]
                }
            ],
            "cloneSalesOrder": [
                850,
                {
                    "salesOrderId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "closeInventoryPeriod": [
                394,
                {
                    "input": [
                        126,
                        "CloseInventoryPeriodInput!"
                    ]
                }
            ],
            "closePurchaseOrder": [
                776,
                {
                    "endDate": [
                        194,
                        "Date!"
                    ],
                    "pdfId": [
                        955,
                        "String!"
                    ],
                    "purchaseOrderId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "closeSalesOrder": [
                850,
                {
                    "endDate": [
                        194,
                        "Date!"
                    ],
                    "pdfId": [
                        955,
                        "String!"
                    ],
                    "salesOrderId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "completeBooking": [
                74,
                {
                    "dueDate": [
                        198
                    ],
                    "id": [
                        345,
                        "ID!"
                    ],
                    "invoiceDate": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "completeEquipmentChecklist": [
                231,
                {
                    "equipmentChecklistId": [
                        955,
                        "String!"
                    ],
                    "equipmentHours": [
                        286,
                        "Float!"
                    ],
                    "notes": [
                        955
                    ],
                    "photos": [
                        1205,
                        "[s3ObjectMetadataInput!]"
                    ]
                }
            ],
            "completeIdScanningSession": [
                933,
                {
                    "idScanningSession": [
                        1143
                    ]
                }
            ],
            "completePurchaseTask": [
                763,
                {
                    "purchaseId": [
                        345,
                        "ID!"
                    ],
                    "task": [
                        790,
                        "PurchaseTask!"
                    ]
                }
            ],
            "confirmBookingAttachmentUpload": [
                75,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "confirmInventoryTag": [
                423,
                {
                    "inventoryTagId": [
                        955,
                        "String!"
                    ],
                    "outboundScaleTicketMaterialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "confirmJobCompletion": [
                447,
                {
                    "assetAdjustments": [
                        1069,
                        "[assetAdjustmentInput!]"
                    ],
                    "completionDate": [
                        194
                    ],
                    "files": [
                        1205,
                        "[s3ObjectMetadataInput!]"
                    ],
                    "jobCompletionNotes": [
                        955
                    ],
                    "jobId": [
                        955,
                        "String!"
                    ],
                    "jobLocationNotes": [
                        1150,
                        "[jobLocationInput!]"
                    ],
                    "role": [
                        174
                    ],
                    "startDate": [
                        194
                    ],
                    "wasManuallyCompleted": [
                        85
                    ]
                }
            ],
            "confirmJobFailure": [
                447,
                {
                    "jobCompletionNotes": [
                        955
                    ],
                    "jobId": [
                        955,
                        "String!"
                    ],
                    "role": [
                        174
                    ]
                }
            ],
            "confirmLoadPhotoUpload": [
                522,
                {
                    "photoId": [
                        345,
                        "ID!"
                    ]
                }
            ],
            "confirmManagedFileUpload": [
                528,
                {
                    "managedFileId": [
                        529,
                        "ManagedFileId!"
                    ]
                }
            ],
            "confirmPayments": [
                632,
                {
                    "confirmPaymentsInput": [
                        1080,
                        "confirmPaymentsInput!"
                    ]
                }
            ],
            "convertInventoryTag": [
                423,
                {
                    "inventoryTagId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "createAccount": [
                150,
                {
                    "accountSubtype": [
                        9
                    ],
                    "accountType": [
                        14,
                        "AccountType!"
                    ],
                    "activityType": [
                        3
                    ],
                    "code": [
                        955,
                        "String!"
                    ],
                    "currencyCode": [
                        173
                    ],
                    "isCash": [
                        85,
                        "Boolean!"
                    ],
                    "name": [
                        955,
                        "String!"
                    ],
                    "parentAccountId": [
                        955
                    ]
                }
            ],
            "createAccountingAgingCategory": [
                16,
                {
                    "accountingAgingCategory": [
                        1082,
                        "createAccountingAgingCategoryInput!"
                    ]
                }
            ],
            "createAllPhysicalCountUntaggedEntry": [
                154,
                {
                    "input": [
                        153,
                        "CreateAllPhysicalCountUntaggedEntryInput!"
                    ]
                }
            ],
            "createAndInviteContact": [
                134,
                {
                    "contact": [
                        1081,
                        "contactInput!"
                    ],
                    "portal": [
                        955
                    ]
                }
            ],
            "createAsset": [
                40,
                {
                    "asset": [
                        1071,
                        "assetInput!"
                    ]
                }
            ],
            "createAssetDescription": [
                42,
                {
                    "assetDescription": [
                        1083,
                        "createAssetDescriptionInput!"
                    ]
                }
            ],
            "createAssetType": [
                52,
                {
                    "assetType": [
                        1072,
                        "assetTypeInput!"
                    ]
                }
            ],
            "createBankAccount": [
                67,
                {
                    "bankAccount": [
                        1084,
                        "createBankAccountInput!"
                    ]
                }
            ],
            "createBillingInfo": [
                71,
                {
                    "accountId": [
                        955
                    ],
                    "bankAccount": [
                        955
                    ],
                    "bankName": [
                        955
                    ],
                    "plaidBankToken": [
                        955
                    ],
                    "plan": [
                        955
                    ]
                }
            ],
            "createBooking": [
                74,
                {
                    "containerTypes": [
                        139,
                        "[ContainerTypeInput!]"
                    ],
                    "cutOffDate": [
                        198
                    ],
                    "departureDate": [
                        198
                    ],
                    "destinationCountry": [
                        955
                    ],
                    "destinationPortId": [
                        955
                    ],
                    "earlyReturnDate": [
                        198
                    ],
                    "externalNotes": [
                        955
                    ],
                    "facilityId": [
                        345
                    ],
                    "freightForwarderId": [
                        955
                    ],
                    "freightLineId": [
                        955
                    ],
                    "freightPerContainer": [
                        286
                    ],
                    "internalNotes": [
                        955
                    ],
                    "number": [
                        955
                    ],
                    "originPortId": [
                        955
                    ],
                    "photoRequirements": [
                        651,
                        "[PhotoRequirementInput!]"
                    ],
                    "salesOrderId": [
                        345
                    ],
                    "shippingCarrierId": [
                        955
                    ],
                    "unlinkedAttachmentIds": [
                        955,
                        "[String!]"
                    ],
                    "vesselArrivalDate": [
                        198
                    ],
                    "vesselName": [
                        955
                    ]
                }
            ],
            "createBookingAttachment": [
                75,
                {
                    "bookingId": [
                        345
                    ],
                    "name": [
                        955,
                        "String!"
                    ],
                    "size": [
                        286,
                        "Float!"
                    ],
                    "type": [
                        955,
                        "String!"
                    ]
                }
            ],
            "createBookingShippingCarrier": [
                81,
                {
                    "name": [
                        955,
                        "String!"
                    ]
                }
            ],
            "createCatalyticConverter": [
                92,
                {
                    "catalyticConverter": [
                        1075,
                        "catalyticConverterInput!"
                    ]
                }
            ],
            "createChart": [
                105,
                {
                    "chart": [
                        156,
                        "CreateChartInput!"
                    ]
                }
            ],
            "createCheckTemplate": [
                121,
                {
                    "checkTemplate": [
                        1077,
                        "checkTemplateInput!"
                    ]
                }
            ],
            "createCompany": [
                130,
                {
                    "company": [
                        1079,
                        "companyInput!"
                    ]
                }
            ],
            "createContact": [
                134,
                {
                    "contact": [
                        1081,
                        "contactInput!"
                    ]
                }
            ],
            "createCounterpartyGroup": [
                142,
                {
                    "name": [
                        955,
                        "String!"
                    ],
                    "operationType": [
                        582,
                        "OperationType!"
                    ]
                }
            ],
            "createCrvBatch": [
                163,
                {
                    "crvBatch": [
                        1085,
                        "createCrvBatchInput!"
                    ]
                }
            ],
            "createCustomAttribute": [
                175,
                {
                    "customAttribute": [
                        1086,
                        "createCustomAttributeInput!"
                    ]
                }
            ],
            "createDataWarehouseUser": [
                193
            ],
            "createDeductionType": [
                205,
                {
                    "deductionType": [
                        1087,
                        "createDeductionTypeInput!"
                    ]
                }
            ],
            "createDetention": [
                216,
                {
                    "detention": [
                        1125,
                        "detentionInput!"
                    ]
                }
            ],
            "createDriver": [
                223,
                {
                    "driver": [
                        1126,
                        "driverInput!"
                    ]
                }
            ],
            "createEmail": [
                226,
                {
                    "body": [
                        955,
                        "String!"
                    ],
                    "contactIds": [
                        955,
                        "[String!]"
                    ],
                    "documentVariants": [
                        229,
                        "[EmailDocumentVariant!]!"
                    ],
                    "entityId": [
                        955,
                        "String!"
                    ],
                    "entityType": [
                        228,
                        "EmailDocumentEntity!"
                    ],
                    "publicSupplierId": [
                        955
                    ],
                    "sentByEmailAddress": [
                        955,
                        "String!"
                    ],
                    "sentByName": [
                        955,
                        "String!"
                    ],
                    "subject": [
                        955,
                        "String!"
                    ]
                }
            ],
            "createEquipment": [
                230,
                {
                    "equipment": [
                        1091,
                        "createEquipmentInput!"
                    ]
                }
            ],
            "createEquipmentChecklist": [
                231,
                {
                    "equipmentChecklist": [
                        1088,
                        "createEquipmentChecklistInput!"
                    ]
                }
            ],
            "createEquipmentChecklistTemplate": [
                242,
                {
                    "equipmentChecklistTemplate": [
                        1089,
                        "createEquipmentChecklistTemplateInput!"
                    ]
                }
            ],
            "createEquipmentGroup": [
                248,
                {
                    "equipmentGroup": [
                        1090,
                        "createEquipmentGroupInput!"
                    ]
                }
            ],
            "createEquipmentType": [
                252,
                {
                    "equipmentType": [
                        1092,
                        "createEquipmentTypeInput!"
                    ]
                }
            ],
            "createFinancialAccount": [
                275,
                {
                    "financialAccount": [
                        1133,
                        "financialAccountInput!"
                    ]
                }
            ],
            "createFinancialAccountAdjustment": [
                276,
                {
                    "financialAccountAdjustment": [
                        1132,
                        "financialAccountAdjustmentInput!"
                    ]
                }
            ],
            "createFreightForwarder": [
                288,
                {
                    "name": [
                        955,
                        "String!"
                    ]
                }
            ],
            "createFreightLane": [
                291,
                {
                    "freightLane": [
                        1137,
                        "freightLaneInput!"
                    ]
                }
            ],
            "createFreightLaneCost": [
                292,
                {
                    "freightLaneCost": [
                        1136,
                        "freightLaneCostInput!"
                    ]
                }
            ],
            "createFreightLine": [
                300,
                {
                    "name": [
                        955,
                        "String!"
                    ]
                }
            ],
            "createFuelSurcharge": [
                306,
                {
                    "fuelSurcharge": [
                        1138,
                        "fuelSurchargeInput!"
                    ]
                }
            ],
            "createGovernmentReportingConfiguration": [
                319,
                {
                    "governmentReportingConfiguration": [
                        1094,
                        "createGovernmentReportingConfigurationInput!"
                    ]
                }
            ],
            "createGroup": [
                338,
                {
                    "group": [
                        1142,
                        "groupInput!"
                    ]
                }
            ],
            "createInitialAmount": [
                19,
                {
                    "initialAmountInput": [
                        1145,
                        "initialAmountInput!"
                    ]
                }
            ],
            "createIntegrationInvitation": [
                358,
                {
                    "integrationInvitation": [
                        1095,
                        "createIntegrationInvitationInput!"
                    ]
                }
            ],
            "createInventoryProcess": [
                417,
                {
                    "input": [
                        157,
                        "CreateInventoryProcessInput!"
                    ]
                }
            ],
            "createInventoryTag": [
                423,
                {
                    "locationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "createInventoryTagWithValues": [
                423,
                {
                    "inventoryTag": [
                        1146,
                        "inventoryTagInput!"
                    ]
                }
            ],
            "createIpCamera": [
                438,
                {
                    "ipCamera": [
                        1148,
                        "ipCameraInput!"
                    ]
                }
            ],
            "createJob": [
                447,
                {
                    "job": [
                        1149,
                        "jobInput!"
                    ],
                    "numInstances": [
                        357
                    ],
                    "role": [
                        174
                    ]
                }
            ],
            "createJobPauseReason": [
                465,
                {
                    "jobPauseReason": [
                        1096,
                        "createJobPauseReasonInput!"
                    ]
                }
            ],
            "createJobSchedule": [
                471,
                {
                    "jobSchedule": [
                        1156,
                        "jobScheduleInput!"
                    ]
                }
            ],
            "createJobTemplate": [
                480,
                {
                    "jobTemplate": [
                        1157,
                        "jobTemplateInput!"
                    ]
                }
            ],
            "createJournalEntry": [
                495,
                {
                    "date": [
                        198,
                        "DateTime!"
                    ],
                    "journalEntryLines": [
                        502,
                        "[JournalEntryLineInput!]!"
                    ],
                    "memo": [
                        955,
                        "String!"
                    ]
                }
            ],
            "createLead": [
                510,
                {
                    "lead": [
                        1162,
                        "leadInput!"
                    ]
                }
            ],
            "createLoad": [
                518,
                {
                    "bookingId": [
                        345
                    ],
                    "facilityId": [
                        345,
                        "ID!"
                    ],
                    "number": [
                        955,
                        "String!"
                    ],
                    "outboundScaleTicketId": [
                        345,
                        "ID!"
                    ],
                    "salesOrderId": [
                        345
                    ],
                    "unlinkedLoadPhotoIds": [
                        345,
                        "[ID!]"
                    ]
                }
            ],
            "createLoadPhoto": [
                522,
                {
                    "loadId": [
                        345
                    ],
                    "name": [
                        955,
                        "String!"
                    ],
                    "size": [
                        357,
                        "Int!"
                    ],
                    "type": [
                        955,
                        "String!"
                    ]
                }
            ],
            "createLocation": [
                524,
                {
                    "location": [
                        1167,
                        "locationInput!"
                    ]
                }
            ],
            "createMaterial": [
                536,
                {
                    "material": [
                        1170,
                        "materialInput!"
                    ]
                }
            ],
            "createMaterialAdjustment": [
                537,
                {
                    "materialAdjustment": [
                        1168,
                        "materialAdjustmentInput!"
                    ]
                }
            ],
            "createMaterialGroup": [
                541,
                {
                    "materialGroup": [
                        1169,
                        "materialGroupInput!"
                    ]
                }
            ],
            "createOutboundScaleTicket": [
                584,
                {
                    "outboundScaleTicket": [
                        1178,
                        "outboundScaleTicketInput!"
                    ]
                }
            ],
            "createOutboundScaleTicketAttachables": [
                584,
                {
                    "attachables": [
                        1144,
                        "[inboundOutboundScaleTicketAttachableInput!]!"
                    ],
                    "ticketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "createOutboundScaleTicketFile": [
                595,
                {
                    "outboundScaleTicketFile": [
                        1176,
                        "outboundScaleTicketFileInput!"
                    ]
                }
            ],
            "createOutboundScaleTicketFreight": [
                596,
                {
                    "outboundScaleTicketFreight": [
                        1098,
                        "createOutboundScaleTicketFreightInput!"
                    ]
                }
            ],
            "createOutboundScaleTicketFromCrvBatch": [
                584,
                {
                    "companyId": [
                        955
                    ],
                    "companyLocationId": [
                        955
                    ],
                    "creatorPlatform": [
                        607,
                        "OutboundScaleTicketsCreatorPlatform!"
                    ],
                    "crvBatchId": [
                        955,
                        "String!"
                    ],
                    "receivingFacilityLocationId": [
                        955
                    ]
                }
            ],
            "createOutboundScaleTicketFromPackingList": [
                584,
                {
                    "outboundScaleTicketFromLoadInput": [
                        1177,
                        "outboundScaleTicketFromLoadInput!"
                    ]
                }
            ],
            "createOutboundScaleTicketFromSalesOrder": [
                584,
                {
                    "creatorPlatform": [
                        607,
                        "OutboundScaleTicketsCreatorPlatform!"
                    ],
                    "facilityLocationId": [
                        955
                    ],
                    "salesOrderId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "createOutboundScaleTicketMaterial": [
                600,
                {
                    "outboundScaleTicketMaterial": [
                        1182,
                        "outboundScaleTicketMaterialInput!"
                    ]
                }
            ],
            "createPastJob": [
                447,
                {
                    "assetAdjustments": [
                        1069,
                        "[assetAdjustmentInput!]"
                    ],
                    "completionDate": [
                        194
                    ],
                    "job": [
                        1149,
                        "jobInput!"
                    ],
                    "jobCompletionNotes": [
                        955
                    ],
                    "role": [
                        174
                    ],
                    "startDate": [
                        194
                    ]
                }
            ],
            "createPayableNote": [
                608,
                {
                    "amount": [
                        286,
                        "Float!"
                    ],
                    "legalHold": [
                        85
                    ],
                    "payableNoteEligibleDate": [
                        194,
                        "Date!"
                    ],
                    "payableNoteNotes": [
                        955
                    ],
                    "preferredPaymentType": [
                        618
                    ],
                    "scaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "createPaymentSettings": [
                625,
                {
                    "paymentSettings": [
                        1189,
                        "paymentSettingsInput!"
                    ]
                }
            ],
            "createPaymentTerm": [
                627,
                {
                    "paymentTerm": [
                        1099,
                        "createPaymentTermInput!"
                    ]
                }
            ],
            "createPhysicalCountJournal": [
                656,
                {
                    "input": [
                        158,
                        "CreatePhysicalCountJournalInput!"
                    ]
                }
            ],
            "createPhysicalCountTaggedEntry": [
                664,
                {
                    "input": [
                        159,
                        "CreatePhysicalCountTaggedEntryInput!"
                    ]
                }
            ],
            "createPhysicalCountUntaggedEntry": [
                669,
                {
                    "input": [
                        160,
                        "CreatePhysicalCountUntaggedEntryInput!"
                    ]
                }
            ],
            "createPlaidLinkToken": [
                955
            ],
            "createPort": [
                674,
                {
                    "name": [
                        955,
                        "String!"
                    ],
                    "type": [
                        677,
                        "PortType!"
                    ]
                }
            ],
            "createPriceList": [
                688,
                {
                    "priceList": [
                        1102,
                        "createPriceListInput!"
                    ]
                }
            ],
            "createPriceListGroup": [
                691,
                {
                    "priceListGroup": [
                        1101,
                        "createPriceListGroupInput!"
                    ]
                }
            ],
            "createPriceListMaterial": [
                697,
                {
                    "priceListMaterial": [
                        1103,
                        "createPriceListMaterialInput!"
                    ]
                }
            ],
            "createPricingVariable": [
                708,
                {
                    "description": [
                        955
                    ],
                    "name": [
                        955,
                        "String!"
                    ],
                    "value": [
                        286,
                        "Float!"
                    ]
                }
            ],
            "createProcess": [
                711,
                {
                    "process": [
                        1105,
                        "createProcessInput!"
                    ]
                }
            ],
            "createProcessExecution": [
                717,
                {
                    "processExecution": [
                        1104,
                        "createProcessExecutionInput!"
                    ]
                }
            ],
            "createProcessLineBurden": [
                730,
                {
                    "processLineBurden": [
                        1106,
                        "createProcessLineBurdenInput!"
                    ]
                }
            ],
            "createProcessMapping": [
                734,
                {
                    "processMapping": [
                        1107,
                        "createProcessMappingInput!"
                    ]
                }
            ],
            "createProductDescription": [
                742,
                {
                    "productDescription": [
                        1108,
                        "createProductDescriptionInput!"
                    ]
                }
            ],
            "createPublicSupplier": [
                757,
                {
                    "ignoreDuplicates": [
                        85
                    ],
                    "publicSupplier": [
                        1193,
                        "publicSupplierInput!"
                    ]
                }
            ],
            "createPuertoRicoPoliceFormConfiguration": [
                760,
                {
                    "puertoRicoPoliceFormConfiguration": [
                        1109,
                        "createPuertoRicoPoliceFormConfigurationInput!"
                    ]
                }
            ],
            "createPurchase": [
                763,
                {
                    "facilityId": [
                        955,
                        "String!"
                    ],
                    "heavyWeight": [
                        286
                    ],
                    "heavyWeightInputMethod": [
                        1065
                    ],
                    "id": [
                        955
                    ],
                    "lightWeight": [
                        286
                    ],
                    "lightWeightInputMethod": [
                        1065
                    ],
                    "supplier": [
                        963
                    ],
                    "weightUnit": [
                        1066
                    ]
                }
            ],
            "createPurchaseFreight": [
                766,
                {
                    "createdAt": [
                        198,
                        "DateTime!"
                    ],
                    "freight": [
                        767,
                        "PurchaseFreightInput!"
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ]
                }
            ],
            "createPurchaseOrder": [
                776,
                {
                    "purchaseOrder": [
                        1194,
                        "purchaseOrderInput!"
                    ]
                }
            ],
            "createPurchaseOrderMaterial": [
                779,
                {
                    "purchaseOrderMaterial": [
                        1195,
                        "purchaseOrderMaterialInput!"
                    ]
                }
            ],
            "createPurchasesDeductionType": [
                794,
                {
                    "deductionScope": [
                        204,
                        "DeductionScope!"
                    ],
                    "deductionUnit": [
                        209,
                        "DeductionUnit!"
                    ],
                    "description": [
                        955,
                        "String!"
                    ],
                    "facilityId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "createQueryCustomField": [
                797,
                {
                    "fieldType": [
                        955,
                        "String!"
                    ],
                    "name": [
                        955,
                        "String!"
                    ],
                    "querySql": [
                        955,
                        "String!"
                    ],
                    "resultType": [
                        955,
                        "String!"
                    ],
                    "tableName": [
                        955,
                        "String!"
                    ]
                }
            ],
            "createReceivedOutboundScaleTicketDeduction": [
                811,
                {
                    "receivedOutboundScaleTicketDeduction": [
                        1110,
                        "createReceivedOutboundScaleTicketDeductionInput!"
                    ]
                }
            ],
            "createReceivedOutboundScaleTicketFreight": [
                814,
                {
                    "receivedOutboundScaleTicketFreight": [
                        1111,
                        "createReceivedOutboundScaleTicketFreightInput!"
                    ]
                }
            ],
            "createReceivedOutboundScaleTicketMaterial": [
                817,
                {
                    "receivedOutboundScaleTicketMaterial": [
                        1112,
                        "createReceivedOutboundScaleTicketMaterialInput!"
                    ]
                }
            ],
            "createReportSchedule": [
                833,
                {
                    "reportSchedule": [
                        1113,
                        "createReportScheduleInput!"
                    ]
                }
            ],
            "createReportTemplate": [
                838,
                {
                    "reportTemplate": [
                        1114,
                        "createReportTemplateInput!"
                    ]
                }
            ],
            "createS3ObjectMetadata": [
                847,
                {
                    "s3ObjectMetadata": [
                        1205,
                        "s3ObjectMetadataInput!"
                    ]
                }
            ],
            "createS3ObjectsMetadata": [
                847,
                {
                    "s3ObjectsMetadata": [
                        1205,
                        "[s3ObjectMetadataInput!]!"
                    ]
                }
            ],
            "createSalesOrder": [
                850,
                {
                    "salesOrder": [
                        1206,
                        "salesOrderInput!"
                    ]
                }
            ],
            "createSalesOrderLoad": [
                853,
                {
                    "numInstances": [
                        357
                    ],
                    "salesOrderLoad": [
                        1207,
                        "salesOrderLoadInput!"
                    ]
                }
            ],
            "createSalesOrderLoadMaterial": [
                856,
                {
                    "salesOrderLoadMaterial": [
                        1208,
                        "salesOrderLoadMaterialInput!"
                    ]
                }
            ],
            "createSalesOrderLoadReceivingTicket": [
                859,
                {
                    "salesOrderLoadReceivingTicket": [
                        1115,
                        "createSalesOrderLoadReceivingTicketInput!"
                    ]
                }
            ],
            "createSalesOrderMaterial": [
                863,
                {
                    "salesOrderMaterial": [
                        1209,
                        "salesOrderMaterialInput!"
                    ]
                }
            ],
            "createScale": [
                871,
                {
                    "scale": [
                        1210,
                        "scaleInput!"
                    ]
                }
            ],
            "createScaleTicket": [
                877,
                {
                    "scaleTicket": [
                        1214,
                        "scaleTicketInput!"
                    ],
                    "skipBlankTicketValidation": [
                        85
                    ]
                }
            ],
            "createScaleTicketDeduction": [
                884,
                {
                    "scaleTicketDeduction": [
                        1213,
                        "scaleTicketDeductionInput!"
                    ]
                }
            ],
            "createScaleTicketFreight": [
                890,
                {
                    "scaleTicketFreight": [
                        1116,
                        "createScaleTicketFreightInput!"
                    ]
                }
            ],
            "createScaleTicketMaterial": [
                892,
                {
                    "scaleTicketMaterial": [
                        1217
                    ]
                }
            ],
            "createScaleTicketPdf": [
                877,
                {
                    "scaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "createScaleTicketVehicleItem": [
                924,
                {
                    "scaleTicketVehicleItem": [
                        1117,
                        "createScaleTicketVehicleItemInput!"
                    ]
                }
            ],
            "createScanningSession": [
                933,
                {
                    "scanningSession": [
                        1223
                    ]
                }
            ],
            "createShippingCarrier": [
                944,
                {
                    "shippingCarrier": [
                        1224,
                        "shippingCarrierInput!"
                    ]
                }
            ],
            "createSsoConfiguration": [
                952,
                {
                    "input": [
                        1225,
                        "ssoConfigurationInput!"
                    ]
                }
            ],
            "createSupplierSignature": [
                967,
                {
                    "supplierSignature": [
                        1118,
                        "createSupplierSignatureInput!"
                    ]
                }
            ],
            "createTareType": [
                976,
                {
                    "tareType": [
                        1226,
                        "tareTypeInput!"
                    ]
                }
            ],
            "createTaxRate": [
                980,
                {
                    "taxRate": [
                        1119,
                        "createTaxRateInput!"
                    ]
                }
            ],
            "createTexasCashCard": [
                985,
                {
                    "texasCashCard": [
                        1121,
                        "createTexasCashCardInput!"
                    ]
                }
            ],
            "createTexasCashCardConfiguration": [
                987,
                {
                    "texasCashCardConfiguration": [
                        1120,
                        "createTexasCashCardConfigurationInput!"
                    ]
                }
            ],
            "createThirdPartyHauler": [
                1004,
                {
                    "thirdPartyHauler": [
                        1227,
                        "thirdPartyHaulerInput!"
                    ]
                }
            ],
            "createThirdPartyHaulerContact": [
                134,
                {
                    "contact": [
                        1081,
                        "contactInput!"
                    ]
                }
            ],
            "createThirdPartyHaulerLocation": [
                524,
                {
                    "location": [
                        1167,
                        "locationInput!"
                    ]
                }
            ],
            "createTrailer": [
                1009,
                {
                    "trailer": [
                        1228,
                        "trailerInput!"
                    ]
                }
            ],
            "createTransport": [
                1013,
                {
                    "transport": [
                        1229,
                        "transportInput!"
                    ]
                }
            ],
            "createTransportationType": [
                1017,
                {
                    "transportationType": [
                        1230,
                        "transportationTypeInput!"
                    ]
                }
            ],
            "createTruck": [
                1021,
                {
                    "truck": [
                        1231,
                        "truckInput!"
                    ]
                }
            ],
            "createUserPolicy": [
                1040,
                {
                    "userPolicy": [
                        1278,
                        "userPolicyInput!"
                    ]
                }
            ],
            "createUserRoleTemplate": [
                1042,
                {
                    "userRoleTemplate": [
                        1122,
                        "createUserRoleTemplateInput!"
                    ]
                }
            ],
            "createVariable": [
                1051,
                {
                    "variable": [
                        1123,
                        "createVariableInput!"
                    ]
                }
            ],
            "createWarehouseCredential": [
                1063
            ],
            "deleteAccountingAgingCategory": [
                955,
                {
                    "accountingAgingCategoryId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteAsset": [
                40,
                {
                    "assetId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteAssetTypes": [
                955,
                {
                    "assetTypeIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteAssets": [
                357,
                {
                    "assetIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteBankAccount": [
                955,
                {
                    "bankAccountId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteBankAccounts": [
                955,
                {
                    "bankAccountIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteBookingAttachment": [
                75,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteCatalyticConverters": [
                357,
                {
                    "catalyticConverterIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteCentralizedCompanyIntegration": [
                955,
                {
                    "centralizedCompanyIntegrationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteChart": [
                85,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteCharts": [
                85,
                {
                    "ids": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteCompanies": [
                955,
                {
                    "companyIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteContact": [
                955,
                {
                    "contactId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteCounterpartyGroup": [
                142,
                {
                    "id": [
                        143,
                        "CounterpartyGroupId!"
                    ]
                }
            ],
            "deleteCustomAttributes": [
                955,
                {
                    "customAttributeIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteCustomPriceListProductPricing": [
                184,
                {
                    "customPriceListId": [
                        185,
                        "CustomPriceListId!"
                    ],
                    "productPricingId": [
                        753,
                        "ProductPricingId!"
                    ],
                    "tiersEffectiveAt": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "deleteDataWarehouseUser": [
                85
            ],
            "deleteDeductionTypes": [
                955,
                {
                    "deductionTypeIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteDefaultPriceListProductPricing": [
                211,
                {
                    "currency": [
                        702,
                        "PricingCurrency!"
                    ],
                    "facilityId": [
                        268,
                        "FacilityId!"
                    ],
                    "operationType": [
                        582,
                        "OperationType!"
                    ],
                    "productPricingId": [
                        753,
                        "ProductPricingId!"
                    ],
                    "tiersEffectiveAt": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "deleteDetentions": [
                955,
                {
                    "detentionIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteDrivers": [
                955,
                {
                    "driverIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteEquipmentChecklistTemplate": [
                955,
                {
                    "equipmentChecklistTemplateId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteEquipmentChecklistTemplates": [
                955,
                {
                    "equipmentChecklistTemplateIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteEquipmentGroup": [
                955,
                {
                    "equipmentGroupId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteEquipmentGroups": [
                955,
                {
                    "equipmentGroupIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteEquipmentType": [
                955,
                {
                    "equipmentTypeId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteEquipmentTypes": [
                955,
                {
                    "equipmentTypeIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteEquipments": [
                955,
                {
                    "equipmentIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteFinancialAccounts": [
                357,
                {
                    "financialAccountIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteFreightLaneCosts": [
                955,
                {
                    "freightLaneCostIds": [
                        955,
                        "[String!]!"
                    ],
                    "freightLaneId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteFreightLanes": [
                955,
                {
                    "freightLaneIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteFreightLanesAndRoutes": [
                955,
                {
                    "freightLaneIds": [
                        955,
                        "[String!]!"
                    ],
                    "freightLaneRouteIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "deleteFuelSurcharges": [
                955,
                {
                    "fuelSurchargeIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteGovernmentReportingConfiguration": [
                955,
                {
                    "governmentReportingConfigurationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteGovernmentReportingConfigurations": [
                955,
                {
                    "governmentReportingConfigurationIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteGroup": [
                357,
                {
                    "groupId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteGroups": [
                357,
                {
                    "groupIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteIpCamera": [
                85,
                {
                    "ipCameraId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteIpCameras": [
                85,
                {
                    "ipCameraIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteJobPauseReason": [
                955,
                {
                    "jobPauseReasonId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteJobPauseReasons": [
                955,
                {
                    "jobPauseReasonIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteJobSchedule": [
                471,
                {
                    "jobScheduleId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteJobSchedules": [
                471,
                {
                    "jobScheduleIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteJobTemplates": [
                357,
                {
                    "jobTemplateIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteJournalEntries": [
                85,
                {
                    "journalEntryIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteLead": [
                510,
                {
                    "lead": [
                        1161,
                        "leadDeleteInput!"
                    ]
                }
            ],
            "deleteLeadContact": [
                134,
                {
                    "contact": [
                        1081,
                        "contactInput!"
                    ]
                }
            ],
            "deleteLeadLocation": [
                524,
                {
                    "location": [
                        1167,
                        "locationInput!"
                    ]
                }
            ],
            "deleteLeads": [
                510,
                {
                    "leadIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteLoadPhoto": [
                522,
                {
                    "photoId": [
                        345,
                        "ID!"
                    ]
                }
            ],
            "deleteLocation": [
                524,
                {
                    "locationId": [
                        955
                    ]
                }
            ],
            "deleteLocations": [
                524,
                {
                    "locationIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteManagedFile": [
                528,
                {
                    "managedFileId": [
                        529,
                        "ManagedFileId!"
                    ]
                }
            ],
            "deleteMaterial": [
                357,
                {
                    "materialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteMaterialGroups": [
                357,
                {
                    "materialGroupIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteMaterials": [
                357,
                {
                    "materialIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteNotification": [
                574,
                {
                    "notificationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteOutboundScaleTicketAttachables": [
                357,
                {
                    "attachableIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteOutboundScaleTicketDeduction": [
                955,
                {
                    "outboundScaleTicketDeductionId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteOutboundScaleTicketFiles": [
                357,
                {
                    "outboundScaleTicketFileIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteOutboundScaleTicketFreight": [
                955,
                {
                    "outboundScaleTicketFreightId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteOutboundScaleTicketMaterials": [
                357,
                {
                    "convertInventoryTagToRaw": [
                        85
                    ],
                    "outboundScaleTicketMaterialIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deletePaymentTerm": [
                955,
                {
                    "paymentTermId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deletePhysicalCountTaggedEntry": [
                664,
                {
                    "input": [
                        214,
                        "DeletePhysicalCountTaggedEntryInput!"
                    ]
                }
            ],
            "deletePhysicalCountUntaggedEntry": [
                669,
                {
                    "input": [
                        215,
                        "DeletePhysicalCountUntaggedEntryInput!"
                    ]
                }
            ],
            "deletePositivePayTemplate": [
                955,
                {
                    "positivePayTemplateId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deletePositivePayTemplates": [
                955,
                {
                    "positivePayTemplateIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deletePriceList": [
                955,
                {
                    "priceListId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deletePriceListGroup": [
                955,
                {
                    "priceListGroupId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deletePriceListGroups": [
                955,
                {
                    "priceListGroupIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deletePriceListMaterial": [
                955,
                {
                    "priceListMaterialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deletePriceListMaterials": [
                955,
                {
                    "priceListMaterialIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deletePriceLists": [
                955,
                {
                    "priceListIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deletePricingVariable": [
                708,
                {
                    "id": [
                        1054,
                        "VariableId!"
                    ]
                }
            ],
            "deleteProcess": [
                955,
                {
                    "processId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteProcessExecution": [
                955,
                {
                    "processExecutionId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteProcessExecutions": [
                955,
                {
                    "processExecutionIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteProcessLineBurden": [
                955,
                {
                    "processLineBurdenId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteProcessLineBurdens": [
                955,
                {
                    "processLineBurdenIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteProcessMapping": [
                955,
                {
                    "processMappingId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteProcessMappings": [
                955,
                {
                    "processMappingIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteProcesses": [
                955,
                {
                    "processIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteProductDescription": [
                955,
                {
                    "productDescriptionId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteProductDescriptions": [
                955,
                {
                    "productDescriptionIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deletePublicSupplier": [
                357,
                {
                    "publicSupplierId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deletePublicSuppliers": [
                357,
                {
                    "publicSupplierIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "deletePurchaseDeduction": [
                763,
                {
                    "deductionId": [
                        345,
                        "ID!"
                    ],
                    "purchaseId": [
                        345,
                        "ID!"
                    ]
                }
            ],
            "deletePurchaseFreight": [
                763,
                {
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ]
                }
            ],
            "deletePurchaseItem": [
                763,
                {
                    "itemId": [
                        345,
                        "ID!"
                    ],
                    "purchaseId": [
                        345,
                        "ID!"
                    ]
                }
            ],
            "deletePurchaseItemDeduction": [
                763,
                {
                    "deductionId": [
                        345,
                        "ID!"
                    ],
                    "itemId": [
                        345,
                        "ID!"
                    ],
                    "purchaseId": [
                        345,
                        "ID!"
                    ]
                }
            ],
            "deletePurchaseMixedMaterial": [
                763,
                {
                    "mixedMaterialId": [
                        566,
                        "MixedMaterialId!"
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ]
                }
            ],
            "deletePurchaseOrderMaterials": [
                357,
                {
                    "purchaseOrderMaterialIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "deletePurchasePayment": [
                763,
                {
                    "paymentId": [
                        345,
                        "ID!"
                    ],
                    "purchaseId": [
                        345,
                        "ID!"
                    ]
                }
            ],
            "deleteQueryCustomField": [
                85,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteReceivedOutboundScaleTicketDeduction": [
                955,
                {
                    "receivedOutboundScaleTicketDeductionId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteReceivedOutboundScaleTicketDeductions": [
                955,
                {
                    "receivedOutboundScaleTicketDeductionIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteReceivedOutboundScaleTicketFreight": [
                955,
                {
                    "receivedOutboundScaleTicketFreightId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteReceivedOutboundScaleTicketMaterial": [
                955,
                {
                    "receivedOutboundScaleTicketMaterialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteReceivedOutboundScaleTicketMaterials": [
                955,
                {
                    "receivedOutboundScaleTicketMaterialIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteReportSchedule": [
                955,
                {
                    "reportScheduleId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteReportSchedules": [
                955,
                {
                    "reportScheduleIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteReportTemplate": [
                955,
                {
                    "reportTemplateId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteReportTemplates": [
                955,
                {
                    "reportTemplateIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteS3Object": [
                85,
                {
                    "key": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteS3ObjectMetadata": [
                847,
                {
                    "s3ObjectMetadata": [
                        1205,
                        "s3ObjectMetadataInput!"
                    ]
                }
            ],
            "deleteS3ObjectsMetadata": [
                847,
                {
                    "s3ObjectMetadataIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteSalesOrderLoadMaterials": [
                357,
                {
                    "salesOrderLoadMaterialIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "deleteSalesOrderMaterials": [
                357,
                {
                    "salesOrderMaterialIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "deleteScaleTicketDeductions": [
                357,
                {
                    "scaleTicketDeductionIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteScaleTicketFreight": [
                955,
                {
                    "scaleTicketFreightId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteScaleTicketMaterial": [
                892,
                {
                    "scaleTicketMaterialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteScaleTicketMaterials": [
                357,
                {
                    "scaleTicketMaterialIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteScales": [
                357,
                {
                    "scaleIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteScrapVehicle": [
                441,
                {
                    "itemId": [
                        442,
                        "ItemId!"
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ],
                    "scrapVehicleId": [
                        938,
                        "ScrapVehicleId!"
                    ]
                }
            ],
            "deleteShippingCarrier": [
                944,
                {
                    "shippingCarrier": [
                        1224,
                        "shippingCarrierInput!"
                    ]
                }
            ],
            "deleteShippingCarrierContact": [
                134,
                {
                    "contact": [
                        1081,
                        "contactInput!"
                    ]
                }
            ],
            "deleteShippingCarrierLocation": [
                524,
                {
                    "location": [
                        1167,
                        "locationInput!"
                    ]
                }
            ],
            "deleteShippingCarriers": [
                944,
                {
                    "shippingCarrierIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteSsoConfiguration": [
                85
            ],
            "deleteTareType": [
                357,
                {
                    "tareTypeId": [
                        955
                    ]
                }
            ],
            "deleteTareTypes": [
                357,
                {
                    "tareTypeIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteTaxRate": [
                955,
                {
                    "taxRateId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteTaxRates": [
                955,
                {
                    "taxRateIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteTexasCashCard": [
                955,
                {
                    "texasCashCardId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteTexasCashCardConfigurations": [
                955,
                {
                    "texasCashCardConfigurationIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteTexasCashCards": [
                955,
                {
                    "texasCashCardIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteThirdPartyHauler": [
                1004,
                {
                    "thirdPartyHaulerId": [
                        955
                    ]
                }
            ],
            "deleteThirdPartyHaulers": [
                1004,
                {
                    "thirdPartyHaulerIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteTrailer": [
                1009,
                {
                    "trailerId": [
                        955
                    ]
                }
            ],
            "deleteTrailers": [
                1009,
                {
                    "trailerIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteTransport": [
                1013,
                {
                    "transportId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteTransportationType": [
                1017,
                {
                    "transportationTypeId": [
                        955
                    ]
                }
            ],
            "deleteTransportationTypes": [
                1017,
                {
                    "transportationTypeIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteTruck": [
                1021,
                {
                    "truckId": [
                        955
                    ]
                }
            ],
            "deleteTruckModel": [
                1024,
                {
                    "truckModelId": [
                        955
                    ]
                }
            ],
            "deleteTruckModels": [
                1024,
                {
                    "truckModelIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteTrucks": [
                1021,
                {
                    "truckIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteUser": [
                1037,
                {
                    "userId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteUserPolicies": [
                1040,
                {
                    "userPolicyIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteUserPolicy": [
                1040,
                {
                    "userPolicyId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteUserRoleTemplate": [
                955,
                {
                    "userRoleTemplateId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteUserRoleTemplates": [
                955,
                {
                    "userRoleTemplateIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteUsers": [
                1037,
                {
                    "userIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteVariable": [
                955,
                {
                    "variableId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deleteVariables": [
                955,
                {
                    "variableIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "deleteWarehouseCredential": [
                85
            ],
            "departFromJobLocation": [
                452,
                {
                    "driverDepartTime": [
                        194
                    ],
                    "jobLocationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "dequeueJob": [
                447,
                {
                    "jobId": [
                        955,
                        "String!"
                    ],
                    "role": [
                        174
                    ]
                }
            ],
            "deregisterDeviceToken": [
                955,
                {
                    "deviceToken": [
                        955,
                        "String!"
                    ],
                    "environment": [
                        955,
                        "String!"
                    ],
                    "os": [
                        955,
                        "String!"
                    ]
                }
            ],
            "disableCompanyIdentityProvider": [
                85
            ],
            "disableExternalUserAccount": [
                1037,
                {
                    "userId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "dispatchJobSchedules": [
                219
            ],
            "dispatcherAcceptJob": [
                447,
                {
                    "jobId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "dispatcherRejectJob": [
                447,
                {
                    "jobCompletionNotes": [
                        955
                    ],
                    "jobId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "downloadChart": [
                955,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "draftCustomPriceList": [
                184,
                {
                    "copyPricesFrom": [
                        185
                    ],
                    "copyPricesFromDefaultPriceList": [
                        140
                    ],
                    "counterpartyGroupId": [
                        143,
                        "CounterpartyGroupId!"
                    ],
                    "currency": [
                        702,
                        "PricingCurrency!"
                    ],
                    "endDate": [
                        198
                    ],
                    "facilityId": [
                        268,
                        "FacilityId!"
                    ],
                    "name": [
                        955,
                        "String!"
                    ],
                    "notes": [
                        955
                    ],
                    "operationType": [
                        582,
                        "OperationType!"
                    ],
                    "startDate": [
                        198
                    ],
                    "tiersEffectiveAt": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "driverCompleteJob": [
                447,
                {
                    "completedAt": [
                        194
                    ],
                    "jobId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "editPaymentCheckNumber": [
                632,
                {
                    "editPaymentCheckNumberInput": [
                        1127,
                        "editPaymentCheckNumberInput!"
                    ]
                }
            ],
            "emailFreightBill": [
                955,
                {
                    "emailSubject": [
                        955
                    ],
                    "freightBillId": [
                        955,
                        "String!"
                    ],
                    "notificationEmails": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "emailPriceList": [
                955,
                {
                    "emailSubject": [
                        955
                    ],
                    "notificationEmails": [
                        955,
                        "[String!]"
                    ],
                    "priceListId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "enableCompanyIdentityProvider": [
                85
            ],
            "enableExternalUserAccount": [
                1037,
                {
                    "userId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "enqueueGovernmentReportingTickets": [
                328
            ],
            "enqueueReport": [
                832,
                {
                    "definition": [
                        1202,
                        "reportInput!"
                    ],
                    "fileName": [
                        955,
                        "String!"
                    ],
                    "fileType": [
                        824,
                        "ReportFileType!"
                    ],
                    "groupByColumns": [
                        357,
                        "Int!"
                    ],
                    "reportName": [
                        955,
                        "String!"
                    ],
                    "reportPeriod": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "executeInventoryProcess": [
                412,
                {
                    "input": [
                        260,
                        "ExecuteProcessInput!"
                    ]
                }
            ],
            "expirePriceList": [
                688,
                {
                    "priceListId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "expireScanningSession": [
                85,
                {
                    "scanningSessionId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "expireScanningSessions": [
                357
            ],
            "failJob": [
                447,
                {
                    "failedAt": [
                        194
                    ],
                    "failedJobNotes": [
                        955
                    ],
                    "failedJobReason": [
                        955
                    ],
                    "jobId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "finishDraftOutboundScaleTicket": [
                584,
                {
                    "outboundScaleTicketId": [
                        955,
                        "String!"
                    ],
                    "salesOrderMaterials": [
                        1209,
                        "[salesOrderMaterialInput!]"
                    ]
                }
            ],
            "finishDraftSalesOrderLoad": [
                853,
                {
                    "salesOrderLoadId": [
                        955,
                        "String!"
                    ],
                    "salesOrderMaterials": [
                        1209,
                        "[salesOrderMaterialInput!]"
                    ]
                }
            ],
            "finishOutboundScaleTicket": [
                584,
                {
                    "dueDate": [
                        194
                    ],
                    "emailAttachedDocuments": [
                        593,
                        "[OutboundScaleTicketDocuments!]"
                    ],
                    "emailSubject": [
                        955
                    ],
                    "notificationEmails": [
                        955,
                        "[String!]"
                    ],
                    "outboundScaleTicket": [
                        1134,
                        "finishOutboundScaleTicketInput!"
                    ],
                    "receivableInvoiceDate": [
                        194
                    ]
                }
            ],
            "finishPurchase": [
                763,
                {
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ]
                }
            ],
            "finishScaleTicket": [
                877,
                {
                    "dueDate": [
                        194
                    ],
                    "emailAttachedDocuments": [
                        888,
                        "[ScaleTicketDocuments!]"
                    ],
                    "emailSubject": [
                        955
                    ],
                    "notificationEmails": [
                        955,
                        "[String!]"
                    ],
                    "receivableInvoiceDate": [
                        194
                    ],
                    "scaleTicket": [
                        1135,
                        "finishScaleTicketInput!"
                    ]
                }
            ],
            "generateNewPositivePayTemplate": [
                681,
                {
                    "templateName": [
                        955,
                        "String!"
                    ]
                }
            ],
            "gradePayload": [
                619,
                {
                    "jobLocationPayloadActionId": [
                        955,
                        "String!"
                    ],
                    "payload": [
                        1187,
                        "payloadInput!"
                    ]
                }
            ],
            "haulerAcceptJob": [
                447,
                {
                    "jobId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "haulerRejectJob": [
                447,
                {
                    "jobCompletionNotes": [
                        955
                    ],
                    "jobId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "holdPurchase": [
                763,
                {
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ]
                }
            ],
            "holdScaleTicket": [
                877,
                {
                    "emailSubject": [
                        955
                    ],
                    "externalNotes": [
                        955
                    ],
                    "internalNotes": [
                        955
                    ],
                    "notificationEmails": [
                        955,
                        "[String!]"
                    ],
                    "scaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "includeInventoryTagInSalesOrderLoad": [
                856,
                {
                    "inventoryTagId": [
                        955,
                        "String!"
                    ],
                    "salesOrderLoadId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "initializeNewInventory": [
                571,
                {
                    "centralizedCompanyId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "initializeRecycler": [
                96,
                {
                    "city": [
                        955,
                        "String!"
                    ],
                    "companyName": [
                        955,
                        "String!"
                    ],
                    "country": [
                        955,
                        "String!"
                    ],
                    "facilityLocationName": [
                        955,
                        "String!"
                    ],
                    "facilitySettings": [
                        1131,
                        "facilitySettingInput!"
                    ],
                    "latitude": [
                        286,
                        "Float!"
                    ],
                    "longitude": [
                        286,
                        "Float!"
                    ],
                    "serviceUserPassword": [
                        955,
                        "String!"
                    ],
                    "state": [
                        955,
                        "String!"
                    ],
                    "streetAddress": [
                        955,
                        "String!"
                    ],
                    "subscriptionType": [
                        960,
                        "SubscriptionType!"
                    ],
                    "transportationTypeList": [
                        1230,
                        "[transportationTypeInput!]!"
                    ],
                    "truckList": [
                        356,
                        "[InitializeRecyclerTruckInput!]!"
                    ],
                    "zipcode": [
                        955,
                        "String!"
                    ]
                }
            ],
            "inviteContact": [
                134,
                {
                    "contactId": [
                        955
                    ],
                    "email": [
                        955
                    ],
                    "portal": [
                        955
                    ]
                }
            ],
            "issueApiKey": [
                35,
                {
                    "apiKey": [
                        1068,
                        "apiKeyInput!"
                    ]
                }
            ],
            "launchDataWarehouseRun": [
                189
            ],
            "loadMetricData": [
                955
            ],
            "lockUserAccount": [
                1037,
                {
                    "userId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "logExternalServiceRequests": [
                85,
                {
                    "logs": [
                        1093,
                        "[createExternalServiceLogInput!]!"
                    ]
                }
            ],
            "loginDriver": [
                357
            ],
            "markAllNotificationSeen": [
                357
            ],
            "markNotificationSeen": [
                574,
                {
                    "notificationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "mergeScaleTickets": [
                877,
                {
                    "dstScaleTicketId": [
                        955,
                        "String!"
                    ],
                    "srcScaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "metricDataRectification": [
                955
            ],
            "moveAssets": [
                40,
                {
                    "assetBulkMove": [
                        1070,
                        "assetBulkMoveInput!"
                    ]
                }
            ],
            "netPayForSupplier": [
                632,
                {
                    "netPayForSupplierInput": [
                        1172,
                        "netPayForSupplierInput!"
                    ]
                }
            ],
            "netPaySelectedTransactions": [
                632,
                {
                    "netPaySelectedTransactionsInput": [
                        1173,
                        "netPaySelectedTransactionsInput!"
                    ]
                }
            ],
            "pauseJob": [
                447,
                {
                    "input": [
                        461,
                        "JobPauseInput!"
                    ]
                }
            ],
            "paySupplier": [
                632,
                {
                    "paySupplierInput": [
                        1185,
                        "paySupplierInput!"
                    ]
                }
            ],
            "postJournalEntryToLedger": [
                495,
                {
                    "journalEntryId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "printDocumentWithSidecar": [
                85,
                {
                    "args": [
                        446,
                        "JSON!"
                    ],
                    "documentType": [
                        271,
                        "FetchPdfType!"
                    ],
                    "printerId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "publishCustomPriceList": [
                184,
                {
                    "id": [
                        185,
                        "CustomPriceListId!"
                    ],
                    "tiersEffectiveAt": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "queueJob": [
                447,
                {
                    "jobId": [
                        955,
                        "String!"
                    ],
                    "role": [
                        174
                    ]
                }
            ],
            "reassignSalesOrderToOutboundScaleTicket": [
                584,
                {
                    "outboundScaleTicketId": [
                        955,
                        "String!"
                    ],
                    "salesOrderId": [
                        955,
                        "String!"
                    ],
                    "updateUnitPrice": [
                        85
                    ]
                }
            ],
            "rebalanceJobsDriverOrder": [
                85
            ],
            "receiveOutboundScaleTicket": [
                584,
                {
                    "dateReceived": [
                        194
                    ],
                    "dueDate": [
                        194
                    ],
                    "externalNotes": [
                        955
                    ],
                    "internalNotes": [
                        955
                    ],
                    "outboundScaleTicketId": [
                        955,
                        "String!"
                    ],
                    "receivableInvoiceType": [
                        437
                    ]
                }
            ],
            "receivePaymentForInvoices": [
                632,
                {
                    "receivePaymentForInvoicesInput": [
                        1197,
                        "receivePaymentForInvoicesInput!"
                    ]
                }
            ],
            "receiveSalesOrderLoad": [
                853,
                {
                    "dateReceived": [
                        194
                    ],
                    "dueDate": [
                        194
                    ],
                    "externalNotes": [
                        955
                    ],
                    "internalNotes": [
                        955
                    ],
                    "receivableInvoiceType": [
                        437
                    ],
                    "salesOrderLoadId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "recreateFailedJob": [
                447,
                {
                    "jobCompletionNotes": [
                        955
                    ],
                    "jobId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "registerDeviceToken": [
                955,
                {
                    "deviceToken": [
                        955,
                        "String!"
                    ],
                    "environment": [
                        955,
                        "String!"
                    ],
                    "os": [
                        955,
                        "String!"
                    ]
                }
            ],
            "registerPrinters": [
                85,
                {
                    "facilityId": [
                        955,
                        "String!"
                    ],
                    "printers": [
                        955,
                        "[String]!"
                    ],
                    "sidecarHostId": [
                        955,
                        "String!"
                    ],
                    "sidecarHostName": [
                        955,
                        "String!"
                    ],
                    "sidecarVersion": [
                        955,
                        "String!"
                    ]
                }
            ],
            "rejectIntegrationInvitation": [
                358,
                {
                    "integrationInvitationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "removeCounterpartiesFromGroup": [
                142,
                {
                    "counterpartyGroupId": [
                        143,
                        "CounterpartyGroupId!"
                    ],
                    "counterpartyIds": [
                        147,
                        "[CounterpartyId!]!"
                    ]
                }
            ],
            "removeInventoryTagsFromSalesOrderLoad": [
                423,
                {
                    "inventoryTagIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "removeMaterialFromJobLocation": [
                452,
                {
                    "jobLocationMaterialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "reopenBooking": [
                74,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "reopenInventoryPeriod": [
                394,
                {
                    "input": [
                        821,
                        "ReopenInventoryPeriodInput!"
                    ]
                }
            ],
            "reopenInventoryTag": [
                423,
                {
                    "inventoryTag": [
                        1146,
                        "inventoryTagInput!"
                    ]
                }
            ],
            "reopenOutboundScaleTicket": [
                584,
                {
                    "outboundScaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "reopenPhysicalCountJournal": [
                656,
                {
                    "input": [
                        822,
                        "ReopenPhysicalCountJournalInput!"
                    ]
                }
            ],
            "reopenSalesOrder": [
                850,
                {
                    "salesOrderId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "reopenScaleTicketForRevision": [
                877,
                {
                    "scaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "replacePurchaseDeductionForItem": [
                763,
                {
                    "itemId": [
                        442,
                        "ItemId!"
                    ],
                    "product": [
                        787,
                        "PurchaseProductInput!"
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ],
                    "replacedDeductionId": [
                        201,
                        "DeductionId!"
                    ]
                }
            ],
            "replacePurchaseItemForDeduction": [
                763,
                {
                    "deductionId": [
                        201,
                        "DeductionId!"
                    ],
                    "deductionTypeId": [
                        208,
                        "DeductionTypeId!"
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ],
                    "replacedItemId": [
                        442,
                        "ItemId!"
                    ]
                }
            ],
            "resendDriverInvitation": [
                223,
                {
                    "driverId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "resendTeamMemberInvitation": [
                1037,
                {
                    "userId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "reserveNextInventoryTagNumber": [
                357
            ],
            "restoreInventoryProcess": [
                417,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "resumeJob": [
                447,
                {
                    "input": [
                        470,
                        "JobResumeInput!"
                    ]
                }
            ],
            "retryAllFailedGovernmentReportingTicketsInBatch": [
                357,
                {
                    "governmentReportingBatchId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "retryFailedGovernmentReportingTicket": [
                357,
                {
                    "governmentReportingTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "reviseReceivedLoad": [
                584,
                {
                    "outboundScaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "revokeApiKey": [
                35,
                {
                    "apiKey": [
                        955,
                        "String!"
                    ]
                }
            ],
            "revokeApiKeys": [
                35,
                {
                    "apiKeys": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "runReportSchedules": [
                955
            ],
            "savePhysicalCountJournalAsDraft": [
                656,
                {
                    "input": [
                        870,
                        "SavePhysicalCountJournalAsDraftInput!"
                    ]
                }
            ],
            "savePlaidConnection": [
                673,
                {
                    "publicToken": [
                        955,
                        "String!"
                    ]
                }
            ],
            "scaleOutboundScaleTicket": [
                584,
                {
                    "outboundScaleTicket": [
                        1178,
                        "outboundScaleTicketInput!"
                    ]
                }
            ],
            "semaphorAccessToken": [
                941
            ],
            "sendBookingNotification": [
                85,
                {
                    "emailAddresses": [
                        955,
                        "[String!]!"
                    ],
                    "id": [
                        345,
                        "ID!"
                    ],
                    "includeBookingInvoice": [
                        85,
                        "Boolean!"
                    ],
                    "loads": [
                        227,
                        "[EmailBookingLoad!]!"
                    ]
                }
            ],
            "sendCustomPriceListNotification": [
                85,
                {
                    "emailAddresses": [
                        955,
                        "[String!]!"
                    ],
                    "id": [
                        345,
                        "ID!"
                    ],
                    "pdfContent": [
                        955,
                        "String!"
                    ]
                }
            ],
            "sendDefaultPriceListNotification": [
                85,
                {
                    "currency": [
                        702,
                        "PricingCurrency!"
                    ],
                    "emailAddresses": [
                        955,
                        "[String!]!"
                    ],
                    "facilityId": [
                        268,
                        "FacilityId!"
                    ],
                    "operationType": [
                        582,
                        "OperationType!"
                    ],
                    "pdfContent": [
                        955,
                        "String!"
                    ]
                }
            ],
            "sendReportByEmail": [
                85,
                {
                    "sendReportByEmailInput": [
                        942,
                        "SendReportByEmailInput!"
                    ]
                }
            ],
            "setDefaultPhotoRequirements": [
                210,
                {
                    "photoRequirements": [
                        651,
                        "[PhotoRequirementInput!]!"
                    ]
                }
            ],
            "setExtraLocationData": [
                264,
                {
                    "extraLocationData": [
                        1130
                    ]
                }
            ],
            "setEzCashToken": [
                96,
                {
                    "ezCashToken": [
                        955
                    ]
                }
            ],
            "setProductGroupPriceConfiguration": [
                749,
                {
                    "currency": [
                        702,
                        "PricingCurrency!"
                    ],
                    "operationType": [
                        582,
                        "OperationType!"
                    ],
                    "pricingUnits": [
                        703,
                        "[PricingPricingUnit!]!"
                    ],
                    "productGroupId": [
                        746,
                        "ProductGroupId!"
                    ],
                    "productType": [
                        706,
                        "PricingProductType!"
                    ]
                }
            ],
            "setStationaryAssetsNotifications": [
                955
            ],
            "shipBooking": [
                74,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "shipSalesOrderLoad": [
                853,
                {
                    "dateShipped": [
                        194
                    ],
                    "files": [
                        1144,
                        "[inboundOutboundScaleTicketAttachableInput!]"
                    ],
                    "salesOrderLoadId": [
                        955,
                        "String!"
                    ],
                    "vehicleHeavyWeight": [
                        286
                    ],
                    "vehicleLightWeight": [
                        286
                    ]
                }
            ],
            "startJob": [
                447,
                {
                    "jobId": [
                        955,
                        "String!"
                    ],
                    "startedAt": [
                        194
                    ]
                }
            ],
            "storeTruckLocation": [
                357,
                {
                    "latitude": [
                        286,
                        "Float!"
                    ],
                    "longitude": [
                        286,
                        "Float!"
                    ]
                }
            ],
            "submitPhysicalCountJournal": [
                656,
                {
                    "input": [
                        957,
                        "SubmitPhysicalCountJournalInput!"
                    ]
                }
            ],
            "syncAssetsFromBlackBerry": [
                970
            ],
            "syncLocationsFromEvents": [
                973
            ],
            "unassignSalesOrderFromOutboundScaleTicket": [
                584,
                {
                    "outboundScaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "unassignSalesOrderLoadFromSalesOrder": [
                853,
                {
                    "salesOrderLoadId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "unholdPurchase": [
                763,
                {
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ]
                }
            ],
            "unlockUserAccount": [
                1037,
                {
                    "userId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "updateAccount": [
                2,
                {
                    "accountId": [
                        345,
                        "ID!"
                    ],
                    "code": [
                        955
                    ],
                    "name": [
                        955
                    ]
                }
            ],
            "updateAccountingAgingCategory": [
                16,
                {
                    "accountingAgingCategory": [
                        1233,
                        "updateAccountingAgingCategoryInput!"
                    ]
                }
            ],
            "updateApiKeyAccessMetadata": [
                955
            ],
            "updateAsset": [
                40,
                {
                    "asset": [
                        1071,
                        "assetInput!"
                    ]
                }
            ],
            "updateAssetType": [
                52,
                {
                    "assetType": [
                        1072,
                        "assetTypeInput!"
                    ]
                }
            ],
            "updateAtm": [
                57,
                {
                    "atm": [
                        1073,
                        "atmInput!"
                    ]
                }
            ],
            "updateAtmPaymentsStatuses": [
                955
            ],
            "updateBankAccount": [
                67,
                {
                    "bankAccount": [
                        1235,
                        "updateBankAccountInput!"
                    ]
                }
            ],
            "updateBooking": [
                74,
                {
                    "containerTypes": [
                        139,
                        "[ContainerTypeInput!]"
                    ],
                    "cutOffDate": [
                        198
                    ],
                    "departureDate": [
                        198
                    ],
                    "destinationCountry": [
                        955
                    ],
                    "destinationPortId": [
                        955
                    ],
                    "earlyReturnDate": [
                        198
                    ],
                    "externalNotes": [
                        955
                    ],
                    "facilityId": [
                        345
                    ],
                    "freightForwarderId": [
                        955
                    ],
                    "freightLineId": [
                        955
                    ],
                    "freightPerContainer": [
                        286
                    ],
                    "id": [
                        345,
                        "ID!"
                    ],
                    "internalNotes": [
                        955
                    ],
                    "number": [
                        955
                    ],
                    "originPortId": [
                        955
                    ],
                    "photoRequirements": [
                        651,
                        "[PhotoRequirementInput!]"
                    ],
                    "salesOrderId": [
                        345
                    ],
                    "shippingCarrierId": [
                        955
                    ],
                    "unlinkedAttachmentIds": [
                        955,
                        "[String!]"
                    ],
                    "vesselArrivalDate": [
                        198
                    ],
                    "vesselName": [
                        955
                    ]
                }
            ],
            "updateCatalyticConverter": [
                92,
                {
                    "catalyticConverter": [
                        1075,
                        "catalyticConverterInput!"
                    ]
                }
            ],
            "updateCentralizedCompany": [
                96,
                {
                    "centralizedCompany": [
                        1076,
                        "centralizedCompanyInput!"
                    ]
                }
            ],
            "updateCentralizedCompanyEquipmentAccountManagers": [
                96,
                {
                    "centralizedCompany": [
                        1076,
                        "centralizedCompanyInput!"
                    ]
                }
            ],
            "updateCentralizedCompanyOnboarding": [
                96,
                {
                    "centralizedCompanyId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "updateCentralizedCompanyOption": [
                583,
                {
                    "option": [
                        1174,
                        "optionInput!"
                    ]
                }
            ],
            "updateChart": [
                105,
                {
                    "chart": [
                        1030,
                        "UpdateChartInput!"
                    ]
                }
            ],
            "updateCheckTemplate": [
                121,
                {
                    "checkTemplate": [
                        1077,
                        "checkTemplateInput!"
                    ]
                }
            ],
            "updateCompany": [
                130,
                {
                    "company": [
                        1079,
                        "companyInput!"
                    ]
                }
            ],
            "updateContact": [
                134,
                {
                    "contact": [
                        1081,
                        "contactInput!"
                    ]
                }
            ],
            "updateCounterpartyGroup": [
                142,
                {
                    "counterpartyGroupId": [
                        143,
                        "CounterpartyGroupId!"
                    ],
                    "name": [
                        955
                    ]
                }
            ],
            "updateCrvRate": [
                170,
                {
                    "crvRate": [
                        1237,
                        "updateCrvRateInput!"
                    ]
                }
            ],
            "updateCustomAttribute": [
                175,
                {
                    "customAttribute": [
                        1238,
                        "updateCustomAttributeInput!"
                    ]
                }
            ],
            "updateCustomPriceList": [
                184,
                {
                    "counterpartyGroupId": [
                        143
                    ],
                    "currency": [
                        702
                    ],
                    "endDate": [
                        198
                    ],
                    "facilityId": [
                        268
                    ],
                    "id": [
                        185,
                        "CustomPriceListId!"
                    ],
                    "name": [
                        955
                    ],
                    "notes": [
                        955
                    ],
                    "operationType": [
                        582
                    ],
                    "startDate": [
                        198
                    ],
                    "tiersEffectiveAt": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "updateCustomPriceListProductPricing": [
                184,
                {
                    "customPriceListId": [
                        185,
                        "CustomPriceListId!"
                    ],
                    "pricingUnit": [
                        703
                    ],
                    "product": [
                        705
                    ],
                    "productPricingId": [
                        753,
                        "ProductPricingId!"
                    ],
                    "tiers": [
                        755,
                        "[ProductPricingTierInput!]"
                    ],
                    "tiersEffectiveAt": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "updateCustomPriceListProductPricingOrder": [
                85,
                {
                    "customPriceListId": [
                        185,
                        "CustomPriceListId!"
                    ],
                    "productPricingIds": [
                        753,
                        "[ProductPricingId!]!"
                    ]
                }
            ],
            "updateDeductionType": [
                205,
                {
                    "deductionType": [
                        1239,
                        "updateDeductionTypeInput!"
                    ]
                }
            ],
            "updateDefaultPriceListNotes": [
                85,
                {
                    "currency": [
                        702,
                        "PricingCurrency!"
                    ],
                    "facilityId": [
                        268,
                        "FacilityId!"
                    ],
                    "notes": [
                        955
                    ],
                    "operationType": [
                        582,
                        "OperationType!"
                    ]
                }
            ],
            "updateDefaultPriceListProductPricing": [
                211,
                {
                    "currency": [
                        702,
                        "PricingCurrency!"
                    ],
                    "facilityId": [
                        268,
                        "FacilityId!"
                    ],
                    "operationType": [
                        582,
                        "OperationType!"
                    ],
                    "pricingUnit": [
                        703
                    ],
                    "product": [
                        705
                    ],
                    "productPricingId": [
                        753,
                        "ProductPricingId!"
                    ],
                    "tiers": [
                        755,
                        "[ProductPricingTierInput!]"
                    ],
                    "tiersEffectiveAt": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "updateDefaultPriceListProductPricingOrder": [
                85,
                {
                    "currency": [
                        702,
                        "PricingCurrency!"
                    ],
                    "facilityId": [
                        268,
                        "FacilityId!"
                    ],
                    "operationType": [
                        582,
                        "OperationType!"
                    ],
                    "productPricingIds": [
                        753,
                        "[ProductPricingId!]!"
                    ]
                }
            ],
            "updateDetention": [
                216,
                {
                    "detention": [
                        1125,
                        "detentionInput!"
                    ]
                }
            ],
            "updateDeviceInfo": [
                85,
                {
                    "mostRecentlySeenDeviceModel": [
                        955
                    ],
                    "mostRecentlySeenDeviceOSVersion": [
                        955
                    ]
                }
            ],
            "updateDocumentsFacilitySettings": [
                270,
                {
                    "facilityId": [
                        955,
                        "String!"
                    ],
                    "facilitySetting": [
                        1131,
                        "facilitySettingInput!"
                    ]
                }
            ],
            "updateDriver": [
                223,
                {
                    "driver": [
                        1126,
                        "driverInput!"
                    ]
                }
            ],
            "updateDriverAppVersion": [
                223,
                {
                    "mostRecentlySeenBinaryAppVersion": [
                        955
                    ],
                    "mostRecentlySeenCodePushLabel": [
                        955
                    ],
                    "mostRecentlySeenPlatform": [
                        955
                    ]
                }
            ],
            "updateDriverOrder": [
                223,
                {
                    "driverIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "updateEquipment": [
                230,
                {
                    "equipment": [
                        1244,
                        "updateEquipmentInput!"
                    ]
                }
            ],
            "updateEquipmentChecklist": [
                231,
                {
                    "equipmentChecklist": [
                        1241,
                        "updateEquipmentChecklistInput!"
                    ]
                }
            ],
            "updateEquipmentChecklistAnswer": [
                232,
                {
                    "equipmentChecklistAnswer": [
                        1240,
                        "updateEquipmentChecklistAnswerInput!"
                    ]
                }
            ],
            "updateEquipmentChecklistStatus": [
                231,
                {
                    "equipmentChecklistId": [
                        955,
                        "String!"
                    ],
                    "notes": [
                        955
                    ],
                    "recyclerCentralizedCompanyId": [
                        955
                    ],
                    "resolutionDate": [
                        194
                    ],
                    "status": [
                        241,
                        "EquipmentChecklistStatus!"
                    ]
                }
            ],
            "updateEquipmentChecklistTemplate": [
                242,
                {
                    "equipmentChecklistTemplate": [
                        1242,
                        "updateEquipmentChecklistTemplateInput!"
                    ]
                }
            ],
            "updateEquipmentGroup": [
                248,
                {
                    "equipmentGroup": [
                        1243,
                        "updateEquipmentGroupInput!"
                    ]
                }
            ],
            "updateEquipmentType": [
                252,
                {
                    "equipmentType": [
                        1245,
                        "updateEquipmentTypeInput!"
                    ]
                }
            ],
            "updateFacilitySettings": [
                524,
                {
                    "resourceSetting": [
                        1204,
                        "resourceSettingInput!"
                    ]
                }
            ],
            "updateFinancialAccount": [
                275,
                {
                    "financialAccount": [
                        1133,
                        "financialAccountInput!"
                    ]
                }
            ],
            "updateFreightLane": [
                291,
                {
                    "freightLane": [
                        1137,
                        "freightLaneInput!"
                    ]
                }
            ],
            "updateFreightLaneCost": [
                292,
                {
                    "freightLaneCost": [
                        1136,
                        "freightLaneCostInput!"
                    ]
                }
            ],
            "updateFuelSurcharge": [
                306,
                {
                    "fuelSurcharge": [
                        1138,
                        "fuelSurchargeInput!"
                    ]
                }
            ],
            "updateGovernmentReportingConfiguration": [
                319,
                {
                    "governmentReportingConfiguration": [
                        1246,
                        "updateGovernmentReportingConfigurationInput!"
                    ]
                }
            ],
            "updateGovernmentReportingTicketsStatus": [
                357,
                {
                    "results": [
                        334,
                        "[GovernmentReportingTicketStatusInput!]!"
                    ]
                }
            ],
            "updateGroup": [
                338,
                {
                    "group": [
                        1142,
                        "groupInput!"
                    ]
                }
            ],
            "updateInventoryPeriodConfigurations": [
                384,
                {
                    "input": [
                        1031,
                        "UpdateInventoryPeriodConfigurationsInput!"
                    ]
                }
            ],
            "updateInventoryProcess": [
                417,
                {
                    "input": [
                        1032,
                        "UpdateInventoryProcessInput!"
                    ]
                }
            ],
            "updateInventoryTag": [
                423,
                {
                    "inventoryTag": [
                        1146,
                        "inventoryTagInput!"
                    ]
                }
            ],
            "updateIpCamera": [
                438,
                {
                    "ipCamera": [
                        1148,
                        "ipCameraInput!"
                    ]
                }
            ],
            "updateJob": [
                447,
                {
                    "autoAssign": [
                        85
                    ],
                    "job": [
                        1149,
                        "jobInput!"
                    ],
                    "role": [
                        174
                    ]
                }
            ],
            "updateJobLocation": [
                452,
                {
                    "jobLocation": [
                        1150,
                        "jobLocationInput!"
                    ]
                }
            ],
            "updateJobLocationMaterial": [
                453,
                {
                    "jobLocationMaterial": [
                        1247,
                        "updateJobLocationMaterialInput!"
                    ]
                }
            ],
            "updateJobLocationSignature": [
                452,
                {
                    "jobLocation": [
                        1150,
                        "jobLocationInput!"
                    ]
                }
            ],
            "updateJobLocationWeights": [
                452,
                {
                    "heavyWeight": [
                        286
                    ],
                    "jobLocationId": [
                        955,
                        "String!"
                    ],
                    "lightWeight": [
                        286
                    ]
                }
            ],
            "updateJobLocationsDispatcherNotes": [
                452,
                {
                    "jobLocations": [
                        1150,
                        "[jobLocationInput!]!"
                    ]
                }
            ],
            "updateJobPauseReason": [
                465,
                {
                    "jobPauseReason": [
                        1248,
                        "updateJobPauseReasonInput!"
                    ]
                }
            ],
            "updateJobSchedule": [
                471,
                {
                    "jobSchedule": [
                        1156,
                        "jobScheduleInput!"
                    ]
                }
            ],
            "updateJobTemplate": [
                480,
                {
                    "jobTemplate": [
                        1157,
                        "jobTemplateInput!"
                    ]
                }
            ],
            "updateJournalEntry": [
                495,
                {
                    "action": [
                        25
                    ],
                    "date": [
                        198
                    ],
                    "journalEntryId": [
                        955,
                        "String!"
                    ],
                    "memo": [
                        955
                    ]
                }
            ],
            "updateLead": [
                510,
                {
                    "lead": [
                        1163,
                        "leadUpdateInput!"
                    ]
                }
            ],
            "updateLeadNotes": [
                510,
                {
                    "lead": [
                        1164,
                        "leadUpdateNotesInput!"
                    ]
                }
            ],
            "updateLeadPriority": [
                510,
                {
                    "lead": [
                        1165,
                        "leadUpdatePriorityInput!"
                    ]
                }
            ],
            "updateLeadStatus": [
                510,
                {
                    "lead": [
                        1166,
                        "leadUpdateStatusInput!"
                    ]
                }
            ],
            "updateLoadPhoto": [
                522,
                {
                    "id": [
                        345,
                        "ID!"
                    ],
                    "notes": [
                        955
                    ],
                    "photoRequirementId": [
                        345
                    ]
                }
            ],
            "updateLocation": [
                524,
                {
                    "location": [
                        1167,
                        "locationInput!"
                    ]
                }
            ],
            "updateMaterial": [
                536,
                {
                    "material": [
                        1170,
                        "materialInput!"
                    ]
                }
            ],
            "updateMaterialGroup": [
                541,
                {
                    "materialGroup": [
                        1169,
                        "materialGroupInput!"
                    ]
                }
            ],
            "updateMaterialLocation": [
                551,
                {
                    "input": [
                        552,
                        "MaterialLocationInput!"
                    ]
                }
            ],
            "updateNotifications": [
                574,
                {
                    "markAsCleared": [
                        85
                    ],
                    "markAsSeen": [
                        85
                    ],
                    "notificationIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "updateOperatorAppVersion": [
                1037,
                {
                    "mostRecentlySeenBinaryAppVersion": [
                        955
                    ],
                    "mostRecentlySeenCodePushLabel": [
                        955
                    ],
                    "mostRecentlySeenPlatform": [
                        955
                    ]
                }
            ],
            "updateOutboundScaleTicket": [
                584,
                {
                    "outboundScaleTicket": [
                        1178,
                        "outboundScaleTicketInput!"
                    ]
                }
            ],
            "updateOutboundScaleTicketFreight": [
                596,
                {
                    "outboundScaleTicketFreight": [
                        1250,
                        "updateOutboundScaleTicketFreightInput!"
                    ]
                }
            ],
            "updateOutboundScaleTicketFromLoad": [
                584,
                {
                    "outboundScaleTicketFromLoadInput": [
                        1177,
                        "outboundScaleTicketFromLoadInput!"
                    ]
                }
            ],
            "updateOutboundScaleTicketMaterial": [
                600,
                {
                    "outboundScaleTicketMaterial": [
                        1182,
                        "outboundScaleTicketMaterialInput!"
                    ]
                }
            ],
            "updateOutboundScaleTicketVehicleWeights": [
                584,
                {
                    "outboundScaleTicketId": [
                        955,
                        "String!"
                    ],
                    "vehicleHeavyWeight": [
                        286
                    ],
                    "vehicleHeavyWeightCaptureMethod": [
                        1064
                    ],
                    "vehicleLightWeight": [
                        286
                    ],
                    "vehicleLightWeightCaptureMethod": [
                        1064
                    ]
                }
            ],
            "updatePayload": [
                619,
                {
                    "payload": [
                        1187,
                        "payloadInput!"
                    ]
                }
            ],
            "updatePayloads": [
                619,
                {
                    "payloads": [
                        1187,
                        "[payloadInput]!"
                    ]
                }
            ],
            "updatePaymentInfo": [
                71,
                {
                    "accountId": [
                        955
                    ],
                    "bankAccount": [
                        955
                    ],
                    "bankName": [
                        955
                    ],
                    "plaidBankToken": [
                        955
                    ]
                }
            ],
            "updatePaymentSettings": [
                625,
                {
                    "paymentSettings": [
                        1189,
                        "paymentSettingsInput!"
                    ]
                }
            ],
            "updatePaymentTerm": [
                627,
                {
                    "paymentTerm": [
                        1251,
                        "updatePaymentTermInput!"
                    ]
                }
            ],
            "updatePhysicalCountTaggedEntry": [
                664,
                {
                    "input": [
                        1034,
                        "UpdatePhysicalCountTaggedEntryInput!"
                    ]
                }
            ],
            "updatePhysicalCountUntaggedEntry": [
                669,
                {
                    "input": [
                        1035,
                        "UpdatePhysicalCountUntaggedEntryInput!"
                    ]
                }
            ],
            "updatePositivePayTemplate": [
                681,
                {
                    "positivePayTemplate": [
                        1252,
                        "updatePositivePayTemplateInput!"
                    ]
                }
            ],
            "updatePostJobNotes": [
                447,
                {
                    "jobId": [
                        955,
                        "String!"
                    ],
                    "postJobNotes": [
                        955
                    ],
                    "role": [
                        174
                    ]
                }
            ],
            "updatePriceList": [
                688,
                {
                    "priceList": [
                        1254,
                        "updatePriceListInput!"
                    ]
                }
            ],
            "updatePriceListGroup": [
                691,
                {
                    "priceListGroup": [
                        1253,
                        "updatePriceListGroupInput!"
                    ]
                }
            ],
            "updatePriceListMaterial": [
                697,
                {
                    "priceListMaterial": [
                        1255,
                        "updatePriceListMaterialInput!"
                    ]
                }
            ],
            "updatePricingVariable": [
                708,
                {
                    "description": [
                        955
                    ],
                    "value": [
                        286
                    ],
                    "variableId": [
                        1054,
                        "VariableId!"
                    ]
                }
            ],
            "updateProcess": [
                711,
                {
                    "process": [
                        1257,
                        "updateProcessInput!"
                    ]
                }
            ],
            "updateProcessExecution": [
                717,
                {
                    "processExecution": [
                        1256,
                        "updateProcessExecutionInput!"
                    ]
                }
            ],
            "updateProcessLineBurden": [
                730,
                {
                    "processLineBurden": [
                        1258,
                        "updateProcessLineBurdenInput!"
                    ]
                }
            ],
            "updateProcessMapping": [
                734,
                {
                    "processMapping": [
                        1259,
                        "updateProcessMappingInput!"
                    ]
                }
            ],
            "updateProductDescription": [
                742,
                {
                    "productDescription": [
                        1260,
                        "updateProductDescriptionInput!"
                    ]
                }
            ],
            "updatePublicSupplier": [
                757,
                {
                    "publicSupplier": [
                        1193,
                        "publicSupplierInput!"
                    ]
                }
            ],
            "updatePublicSupplierFiles": [
                757,
                {
                    "publicSupplier": [
                        1192,
                        "publicSupplierFilesInput!"
                    ]
                }
            ],
            "updatePuertoRicoPoliceFormConfiguration": [
                760,
                {
                    "puertoRicoPoliceFormConfiguration": [
                        1261,
                        "updatePuertoRicoPoliceFormConfigurationInput!"
                    ]
                }
            ],
            "updatePurchase": [
                763,
                {
                    "driverId": [
                        345
                    ],
                    "externalNotes": [
                        955
                    ],
                    "extras": [
                        446
                    ],
                    "internalNotes": [
                        955
                    ],
                    "paymentFacilityId": [
                        268
                    ],
                    "purchaseId": [
                        345,
                        "ID!"
                    ],
                    "supplierId": [
                        345
                    ],
                    "supplierLocationId": [
                        345
                    ],
                    "supplierType": [
                        345
                    ],
                    "tempIdentification": [
                        345
                    ],
                    "ticketDate": [
                        198
                    ],
                    "trailerId": [
                        345
                    ],
                    "truckWeight": [
                        792
                    ],
                    "vehicleId": [
                        345
                    ]
                }
            ],
            "updatePurchaseDeduction": [
                763,
                {
                    "amount": [
                        286
                    ],
                    "deductionId": [
                        201,
                        "DeductionId!"
                    ],
                    "deductionTypeId": [
                        208
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ]
                }
            ],
            "updatePurchaseFreight": [
                766,
                {
                    "freight": [
                        767,
                        "PurchaseFreightInput!"
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ]
                }
            ],
            "updatePurchaseItem": [
                763,
                {
                    "input": [
                        1036,
                        "UpdatePurchaseItemInput!"
                    ],
                    "itemId": [
                        442,
                        "ItemId!"
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ]
                }
            ],
            "updatePurchaseItemDeduction": [
                763,
                {
                    "amount": [
                        286
                    ],
                    "deductionId": [
                        201,
                        "DeductionId!"
                    ],
                    "deductionTypeId": [
                        208
                    ],
                    "itemId": [
                        442,
                        "ItemId!"
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ]
                }
            ],
            "updatePurchaseMixedMaterial": [
                763,
                {
                    "mixedMaterialId": [
                        566,
                        "MixedMaterialId!"
                    ],
                    "notes": [
                        955
                    ],
                    "product": [
                        787
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ],
                    "weight": [
                        774
                    ]
                }
            ],
            "updatePurchaseOrder": [
                776,
                {
                    "notificationEmails": [
                        955,
                        "[String!]"
                    ],
                    "purchaseOrder": [
                        1194,
                        "purchaseOrderInput!"
                    ]
                }
            ],
            "updatePurchaseOrderMaterial": [
                779,
                {
                    "purchaseOrderMaterial": [
                        1195,
                        "purchaseOrderMaterialInput!"
                    ]
                }
            ],
            "updatePurchasePayment": [
                620,
                {
                    "achNumber": [
                        955
                    ],
                    "amount": [
                        286
                    ],
                    "atmId": [
                        345
                    ],
                    "attnValue": [
                        955
                    ],
                    "bankId": [
                        345
                    ],
                    "checkMemo": [
                        955
                    ],
                    "checkNumber": [
                        955
                    ],
                    "financialAccountId": [
                        345
                    ],
                    "legalHold": [
                        85
                    ],
                    "paymentId": [
                        345,
                        "ID!"
                    ],
                    "paymentSchedule": [
                        785
                    ],
                    "purchaseId": [
                        345,
                        "ID!"
                    ],
                    "scheduledDate": [
                        198
                    ],
                    "supplierMailToAddressId": [
                        345
                    ],
                    "type": [
                        637
                    ]
                }
            ],
            "updatePurchasesDeductionType": [
                794,
                {
                    "deductionTypeId": [
                        955,
                        "String!"
                    ],
                    "description": [
                        955,
                        "String!"
                    ]
                }
            ],
            "updateQueryCustomField": [
                797,
                {
                    "fieldType": [
                        955,
                        "String!"
                    ],
                    "id": [
                        955,
                        "String!"
                    ],
                    "name": [
                        955,
                        "String!"
                    ],
                    "querySql": [
                        955,
                        "String!"
                    ],
                    "resultType": [
                        955,
                        "String!"
                    ],
                    "tableName": [
                        955,
                        "String!"
                    ]
                }
            ],
            "updateReceivedOutboundScaleTicketDeduction": [
                811,
                {
                    "receivedOutboundScaleTicketDeduction": [
                        1262,
                        "updateReceivedOutboundScaleTicketDeductionInput!"
                    ]
                }
            ],
            "updateReceivedOutboundScaleTicketEntities": [
                85,
                {
                    "outboundScaleTicketId": [
                        955,
                        "String!"
                    ],
                    "receivedDeductions": [
                        1262,
                        "[updateReceivedOutboundScaleTicketDeductionInput!]!"
                    ],
                    "receivedFreights": [
                        1263,
                        "[updateReceivedOutboundScaleTicketFreightInput!]!"
                    ],
                    "receivedMaterials": [
                        1264,
                        "[updateReceivedOutboundScaleTicketMaterialInput!]!"
                    ]
                }
            ],
            "updateReceivedOutboundScaleTicketFreight": [
                814,
                {
                    "receivedOutboundScaleTicketFreight": [
                        1263,
                        "updateReceivedOutboundScaleTicketFreightInput!"
                    ]
                }
            ],
            "updateReceivedOutboundScaleTicketMaterial": [
                817,
                {
                    "receivedOutboundScaleTicketMaterial": [
                        1264,
                        "updateReceivedOutboundScaleTicketMaterialInput!"
                    ]
                }
            ],
            "updateReportSchedule": [
                833,
                {
                    "reportSchedule": [
                        1265,
                        "updateReportScheduleInput!"
                    ]
                }
            ],
            "updateReportTemplate": [
                838,
                {
                    "reportTemplate": [
                        1266,
                        "updateReportTemplateInput!"
                    ]
                }
            ],
            "updateReportTemplateRelativePeriod": [
                838,
                {
                    "reportTemplateRelativePeriodInput": [
                        842,
                        "ReportTemplateRelativePeriodInput!"
                    ]
                }
            ],
            "updateS3ObjectMetadata": [
                847,
                {
                    "s3ObjectMetadata": [
                        1205,
                        "s3ObjectMetadataInput!"
                    ]
                }
            ],
            "updateSalesOrder": [
                850,
                {
                    "emailSubject": [
                        955
                    ],
                    "notificationEmails": [
                        955,
                        "[String]"
                    ],
                    "salesOrder": [
                        1206,
                        "salesOrderInput!"
                    ]
                }
            ],
            "updateSalesOrderLoad": [
                853,
                {
                    "salesOrderLoad": [
                        1207,
                        "salesOrderLoadInput!"
                    ]
                }
            ],
            "updateSalesOrderLoadMaterial": [
                856,
                {
                    "salesOrderLoadMaterial": [
                        1208,
                        "salesOrderLoadMaterialInput!"
                    ]
                }
            ],
            "updateSalesOrderLoadReceivingTicket": [
                859,
                {
                    "salesOrderLoadReceivingTicket": [
                        1267,
                        "updateSalesOrderLoadReceivingTicketInput!"
                    ]
                }
            ],
            "updateSalesOrderMaterial": [
                863,
                {
                    "salesOrderMaterial": [
                        1209,
                        "salesOrderMaterialInput!"
                    ]
                }
            ],
            "updateScale": [
                871,
                {
                    "scale": [
                        1210,
                        "scaleInput!"
                    ]
                }
            ],
            "updateScaleTicket": [
                877,
                {
                    "autoUpdateMaterialPricing": [
                        85
                    ],
                    "emailSubject": [
                        955
                    ],
                    "enforceContractMaterials": [
                        85
                    ],
                    "newPriceList": [
                        85
                    ],
                    "notificationEmails": [
                        955,
                        "[String!]"
                    ],
                    "scaleTicket": [
                        1214,
                        "scaleTicketInput!"
                    ]
                }
            ],
            "updateScaleTicketDeduction": [
                884,
                {
                    "scaleTicketDeduction": [
                        1213,
                        "scaleTicketDeductionInput!"
                    ]
                }
            ],
            "updateScaleTicketFacility": [
                877,
                {
                    "scaleTicket": [
                        1214,
                        "scaleTicketInput!"
                    ]
                }
            ],
            "updateScaleTicketFreight": [
                890,
                {
                    "scaleTicketFreight": [
                        1268,
                        "updateScaleTicketFreightInput!"
                    ]
                }
            ],
            "updateScaleTicketMaterial": [
                892,
                {
                    "scaleTicketMaterial": [
                        1217,
                        "scaleTicketMaterialInput!"
                    ]
                }
            ],
            "updateScaleTicketVehicleItem": [
                924,
                {
                    "scaleTicketVehicleItem": [
                        1269,
                        "updateScaleTicketVehicleItemInput!"
                    ]
                }
            ],
            "updateScaleTicketVehicleWeights": [
                877,
                {
                    "scaleTicketId": [
                        955,
                        "String!"
                    ],
                    "vehicleHeavyWeight": [
                        286
                    ],
                    "vehicleHeavyWeightCaptureMethod": [
                        1064
                    ],
                    "vehicleLightWeight": [
                        286
                    ],
                    "vehicleLightWeightCaptureMethod": [
                        1064
                    ]
                }
            ],
            "updateScaleTickets": [
                877,
                {
                    "scaleTicketIds": [
                        955,
                        "[String!]!"
                    ],
                    "values": [
                        1214,
                        "scaleTicketInput!"
                    ]
                }
            ],
            "updateScaleWeights": [
                85,
                {
                    "grossWeight": [
                        286
                    ],
                    "netWeight": [
                        286
                    ],
                    "scaleId": [
                        955,
                        "String!"
                    ],
                    "tareWeight": [
                        286
                    ],
                    "timestamp": [
                        194
                    ],
                    "unitOfMeasurement": [
                        929
                    ]
                }
            ],
            "updateScrapVehicle": [
                937,
                {
                    "itemId": [
                        442,
                        "ItemId!"
                    ],
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ],
                    "scrapVehicle": [
                        939,
                        "ScrapVehicleInput!"
                    ],
                    "scrapVehicleId": [
                        938,
                        "ScrapVehicleId!"
                    ]
                }
            ],
            "updateShippingCarrier": [
                944,
                {
                    "shippingCarrier": [
                        1224,
                        "shippingCarrierInput!"
                    ]
                }
            ],
            "updateShippingCarrierContact": [
                134,
                {
                    "contact": [
                        1081,
                        "contactInput!"
                    ]
                }
            ],
            "updateShippingCarrierLocation": [
                524,
                {
                    "location": [
                        1167,
                        "locationInput!"
                    ]
                }
            ],
            "updateSsoConfiguration": [
                952,
                {
                    "input": [
                        1225,
                        "ssoConfigurationInput!"
                    ]
                }
            ],
            "updateTareType": [
                976,
                {
                    "tareType": [
                        1226,
                        "tareTypeInput!"
                    ]
                }
            ],
            "updateTaxRate": [
                980,
                {
                    "taxRate": [
                        1271,
                        "updateTaxRateInput!"
                    ]
                }
            ],
            "updateTexasCashCard": [
                985,
                {
                    "texasCashCard": [
                        1273,
                        "updateTexasCashCardInput!"
                    ]
                }
            ],
            "updateTexasCashCardConfiguration": [
                987,
                {
                    "texasCashCardConfiguration": [
                        1272,
                        "updateTexasCashCardConfigurationInput!"
                    ]
                }
            ],
            "updateThirdPartyHauler": [
                1004,
                {
                    "thirdPartyHauler": [
                        1227,
                        "thirdPartyHaulerInput!"
                    ]
                }
            ],
            "updateThirdPartyHaulerOrder": [
                1004,
                {
                    "haulerIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "updateTrailer": [
                1009,
                {
                    "trailer": [
                        1228,
                        "trailerInput!"
                    ]
                }
            ],
            "updateTransport": [
                1013,
                {
                    "transport": [
                        1229,
                        "transportInput!"
                    ]
                }
            ],
            "updateTransportationType": [
                1017,
                {
                    "transportationType": [
                        1230,
                        "transportationTypeInput!"
                    ]
                }
            ],
            "updateTruck": [
                1021,
                {
                    "truck": [
                        1231,
                        "truckInput!"
                    ]
                }
            ],
            "updateUser": [
                1037,
                {
                    "user": [
                        1276,
                        "userInput!"
                    ]
                }
            ],
            "updateUserPolicy": [
                1040,
                {
                    "userPolicy": [
                        1278,
                        "userPolicyInput!"
                    ]
                }
            ],
            "updateUserPolicyAttribute": [
                1040,
                {
                    "userPolicyAttribute": [
                        1277,
                        "userPolicyAttributeInput!"
                    ]
                }
            ],
            "updateUserRoleTemplate": [
                1042,
                {
                    "userRoleTemplate": [
                        1274,
                        "updateUserRoleTemplateInput!"
                    ]
                }
            ],
            "updateUserSetting": [
                1049,
                {
                    "option": [
                        1280,
                        "userSettingInput!"
                    ]
                }
            ],
            "updateVariable": [
                1051,
                {
                    "variable": [
                        1275,
                        "updateVariableInput!"
                    ]
                }
            ],
            "updateVoucherTemplate": [
                1060,
                {
                    "voucherTemplate": [
                        1285,
                        "voucherTemplateInput!"
                    ]
                }
            ],
            "upsertSalesOrderLoadReceivingTicket": [
                859,
                {
                    "salesOrderLoadReceivingTicket": [
                        1115,
                        "createSalesOrderLoadReceivingTicketInput!"
                    ]
                }
            ],
            "verifyPublicSupplierIsInDoNotBuyList": [
                757,
                {
                    "publicSupplierId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "voidBookings": [
                76,
                {
                    "ids": [
                        345,
                        "[ID!]!"
                    ]
                }
            ],
            "voidInventoryTag": [
                423,
                {
                    "inventoryTagId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "voidJob": [
                447,
                {
                    "jobCompletionNotes": [
                        955
                    ],
                    "jobId": [
                        955,
                        "String!"
                    ],
                    "role": [
                        174
                    ]
                }
            ],
            "voidOutboundScaleTicket": [
                584,
                {
                    "outboundScaleTicket": [
                        1281,
                        "voidOutboundScaleTicketInput!"
                    ]
                }
            ],
            "voidOutboundScaleTickets": [
                584,
                {
                    "input": [
                        1282,
                        "voidOutboundScaleTicketsInput!"
                    ]
                }
            ],
            "voidPayments": [
                632,
                {
                    "voidPaymentsInput": [
                        1283,
                        "voidPaymentsInput!"
                    ]
                }
            ],
            "voidPhysicalCountJournal": [
                656,
                {
                    "input": [
                        1059,
                        "VoidPhysicalCountJournalInput!"
                    ]
                }
            ],
            "voidPurchase": [
                763,
                {
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ],
                    "voidReason": [
                        955,
                        "String!"
                    ]
                }
            ],
            "voidReceivedPayments": [
                632,
                {
                    "voidReceivedPaymentsInput": [
                        1284,
                        "voidReceivedPaymentsInput!"
                    ]
                }
            ],
            "voidSalesOrder": [
                850,
                {
                    "completionNotes": [
                        955
                    ],
                    "endDate": [
                        194,
                        "Date!"
                    ],
                    "salesOrderId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "voidSalesOrderLoad": [
                853,
                {
                    "salesOrderLoadId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "voidSalesOrderLoads": [
                853,
                {
                    "salesOrderLoadIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "voidSalesOrders": [
                850,
                {
                    "completionNotes": [
                        955
                    ],
                    "endDate": [
                        194,
                        "Date!"
                    ],
                    "salesOrderIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "voidScaleTickets": [
                877,
                {
                    "reason": [
                        955,
                        "String!"
                    ],
                    "scaleTicketIds": [
                        955,
                        "[String!]!"
                    ],
                    "transactionDate": [
                        194,
                        "Date!"
                    ]
                }
            ],
            "__typename": [
                955
            ]
        },
        "NetPaymentsDocuments": {},
        "NewInventoryInitializationResult": {
            "message": [
                955
            ],
            "success": [
                85
            ],
            "__typename": [
                955
            ]
        },
        "NextPaymentCheckNumber": {
            "checkNumber": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "Normality": {},
        "Notification": {
            "createdAt": [
                194
            ],
            "isCleared": [
                85
            ],
            "isSeen": [
                85
            ],
            "notificationId": [
                955
            ],
            "notificationObjectId": [
                955
            ],
            "notificationText": [
                955
            ],
            "notificationTitle": [
                955
            ],
            "notificationType": [
                577
            ],
            "severity": [
                576
            ],
            "__typename": [
                955
            ]
        },
        "NotificationSettings": {},
        "NotificationSeverity": {},
        "NotificationType": {},
        "OatfiBusiness": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "creditLimit": [
                357
            ],
            "deletedAt": [
                194
            ],
            "externalId": [
                955
            ],
            "oatfiBusinessId": [
                955
            ],
            "onboardStatus": [
                580
            ],
            "onboardedAt": [
                194
            ],
            "status": [
                955
            ],
            "underwriteStatus": [
                1028
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "OldAccountType": {},
        "OnboardStatus": {},
        "OpenFinishedPurchasesResult": {
            "finishedPurchasesCount": [
                357
            ],
            "openPurchasesCount": [
                357
            ],
            "purchaseDate": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "OperationType": {},
        "Option": {
            "alertFailedJob": [
                955
            ],
            "alertTimeOnSite": [
                955
            ],
            "alertTimeOnSiteDays": [
                955
            ],
            "allowAssetsToBeAssignedToSpecificCompanies": [
                955
            ],
            "allowDriverJobCreation": [
                955
            ],
            "allowDuplicateObjectNames": [
                955
            ],
            "allowEditingActiveJobs": [
                955
            ],
            "applyDiscount": [
                955
            ],
            "canHaveMultipleActiveJobs": [
                955
            ],
            "canStartJobsOutOfOrder": [
                955
            ],
            "clearDriverTruckTrailerAssignment": [
                955
            ],
            "deadlineDays": [
                955
            ],
            "displayDeadlineDate": [
                955
            ],
            "displayReturnFacility": [
                955
            ],
            "driverAppRequiresAssetPhotos": [
                955
            ],
            "enforceAssetTransportationCompatibility": [
                955
            ],
            "hideLoadBoardJobNumbers": [
                955
            ],
            "jobCompletedPastDeadline": [
                955
            ],
            "promptDriverToConfirmTruckTrailer": [
                955
            ],
            "shouldApplyDiscounts": [
                955
            ],
            "supplierPortalJobRequests": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicket": {
            "activeScale": [
                871
            ],
            "activeScaleId": [
                955
            ],
            "allInventoryTagsAreReserved": [
                85
            ],
            "averageGradingConfidence": [
                286
            ],
            "bookingId": [
                955
            ],
            "carrierDriverName": [
                955
            ],
            "carrierScac": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "closedById": [
                955
            ],
            "closer": [
                1037
            ],
            "company": [
                130
            ],
            "companyId": [
                955
            ],
            "companyLocation": [
                524
            ],
            "companyLocationId": [
                955
            ],
            "completionNotes": [
                955
            ],
            "createdAt": [
                194
            ],
            "creationType": [
                589
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                955
            ],
            "creatorPlatform": [
                607
            ],
            "customerName": [
                955
            ],
            "customerType": [
                187
            ],
            "dateShipped": [
                194
            ],
            "deductions": [
                590
            ],
            "expectedShipDate": [
                194
            ],
            "externalNotes": [
                955
            ],
            "facilityLocation": [
                524
            ],
            "facilityLocationId": [
                955
            ],
            "files": [
                847,
                {
                    "scope": [
                        955
                    ]
                }
            ],
            "fob": [
                955
            ],
            "frontendUrl": [
                955
            ],
            "grossWeight": [
                286
            ],
            "inboundScaleTicketId": [
                955
            ],
            "internalNotes": [
                955
            ],
            "inventoryTags": [
                597
            ],
            "lastNonReceivedSalesOrderLoad": [
                85
            ],
            "loadBookingNumber": [
                955
            ],
            "loadContainerNumber": [
                955
            ],
            "loadDeliveryNumber": [
                955
            ],
            "loadMillNumber": [
                955
            ],
            "loadMillOrderNumber": [
                955
            ],
            "loadRailCar": [
                955
            ],
            "loadReceivedDate": [
                194
            ],
            "loadReleaseNumber": [
                955
            ],
            "loadSealNumber": [
                955
            ],
            "loadTrailerNumber": [
                955
            ],
            "loadTruckNumber": [
                955
            ],
            "materials": [
                600
            ],
            "numberOfDistinctMaterials": [
                357
            ],
            "numberOfMaterials": [
                357
            ],
            "outboundScaleTicketFreights": [
                596
            ],
            "outboundScaleTicketId": [
                955
            ],
            "outboundScaleTicketNumber": [
                955
            ],
            "pdf": [
                847
            ],
            "receivableInvoice": [
                802
            ],
            "receivedDeductions": [
                811
            ],
            "receivedOutboundScaleTicketFreights": [
                814
            ],
            "receivingFacilityLocation": [
                524
            ],
            "receivingFacilityLocationId": [
                955
            ],
            "requestedQuantity": [
                286
            ],
            "requestedWeight": [
                286
            ],
            "salesOrder": [
                850
            ],
            "salesOrderId": [
                955
            ],
            "salesOrderLoad": [
                853
            ],
            "salesOrderLoadId": [
                955
            ],
            "salesOrderLoadReceivingTicket": [
                859
            ],
            "salesOrderNumber": [
                955
            ],
            "shippedWeight": [
                286
            ],
            "shippingCarrierName": [
                955
            ],
            "status": [
                606
            ],
            "tareWeight": [
                286
            ],
            "totalPrice": [
                286
            ],
            "totalReceivedPrice": [
                286
            ],
            "totalReceivedQuantity": [
                286
            ],
            "totalReceivedWeight": [
                286
            ],
            "totalWeight": [
                286
            ],
            "transactionDate": [
                194
            ],
            "updatedAt": [
                194
            ],
            "vehicleHeavyWeight": [
                286
            ],
            "vehicleHeavyWeightCaptureMethod": [
                1064
            ],
            "vehicleLightWeight": [
                286
            ],
            "vehicleLightWeightCaptureMethod": [
                1064
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketCatalyticConverter": {
            "catalyticConverter": [
                92
            ],
            "catalyticConverterId": [
                955
            ],
            "catalyticConverterSize": [
                95
            ],
            "centralizedCompany": [
                96
            ],
            "converterNotes": [
                955
            ],
            "converterVehicleIdentificationNumber": [
                955
            ],
            "converterVehicleLicensePlate": [
                955
            ],
            "converterVehicleMake": [
                955
            ],
            "converterVehicleModel": [
                955
            ],
            "converterVehicleYear": [
                194
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "files": [
                847
            ],
            "material": [
                536
            ],
            "nominalTotalPrice": [
                286
            ],
            "outboundScaleTicketCatalyticConverterId": [
                955
            ],
            "outboundScaleTicketMaterial": [
                600
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "priceOrigin": [
                701
            ],
            "quantity": [
                286
            ],
            "realTotalPrice": [
                286
            ],
            "realUnitPrice": [
                286
            ],
            "totalPrice": [
                286
            ],
            "totalPriceDeduction": [
                286
            ],
            "unitPrice": [
                286
            ],
            "updatedAt": [
                194
            ],
            "vehicleTitle": [
                847
            ],
            "vehicleTitleId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketCatalyticConverterConnection": {
            "edges": [
                587
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketCatalyticConverterEdge": {
            "cursor": [
                955
            ],
            "node": [
                585
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketConnection": {
            "edges": [
                594
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketCreationType": {},
        "OutboundScaleTicketDeduction": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deductionCategory": [
                200
            ],
            "deductionMethod": [
                203
            ],
            "deductionReason": [
                955
            ],
            "deductionType": [
                205
            ],
            "deductionTypeId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "notes": [
                955
            ],
            "outboundScaleTicket": [
                584
            ],
            "outboundScaleTicketDeductionId": [
                955
            ],
            "outboundScaleTicketId": [
                955
            ],
            "outboundScaleTicketMaterial": [
                600
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "percentageDeduction": [
                286
            ],
            "priceDeduction": [
                286
            ],
            "scale": [
                871
            ],
            "scaleId": [
                955
            ],
            "taxRate": [
                980
            ],
            "taxRateId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "weightDeduction": [
                286
            ],
            "weightDeductionCaptureMethod": [
                1064
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketDeductionConnection": {
            "edges": [
                592
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketDeductionEdge": {
            "cursor": [
                955
            ],
            "node": [
                590
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketDocuments": {},
        "OutboundScaleTicketEdge": {
            "cursor": [
                955
            ],
            "node": [
                584
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketFile": {
            "file": [
                847
            ],
            "outboundScaleTicketFileId": [
                955
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketFreight": {
            "carrierName": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "creatorId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "deliveryNumber": [
                955
            ],
            "freightAccrualAmount": [
                286
            ],
            "freightDeductionAmount": [
                286
            ],
            "freightLaneCost": [
                292,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "freightLaneCostId": [
                955
            ],
            "freightTotalAmount": [
                286
            ],
            "notes": [
                955
            ],
            "outboundScaleTicketFreightId": [
                955
            ],
            "outboundScaleTicketId": [
                955
            ],
            "paymentDueDate": [
                955
            ],
            "scaleTicket": [
                877,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "shouldCreateFreightBill": [
                85
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketInventoryTag": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "grossWeight": [
                286
            ],
            "inventoryTag": [
                423
            ],
            "inventoryTagId": [
                955
            ],
            "netWeight": [
                286
            ],
            "outboundScaleTicketInventoryTagId": [
                955
            ],
            "outboundScaleTicketMaterial": [
                600
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "priceList": [
                688
            ],
            "priceListId": [
                955
            ],
            "priceOrigin": [
                701
            ],
            "pricingUnit": [
                534
            ],
            "quantity": [
                286
            ],
            "requestedWeight": [
                286
            ],
            "salesOrder": [
                850
            ],
            "salesOrderId": [
                955
            ],
            "tareWeight": [
                286
            ],
            "totalPrice": [
                286
            ],
            "totalRequestedWeight": [
                286
            ],
            "unitPrice": [
                286
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketInventoryTagConnection": {
            "edges": [
                599
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketInventoryTagEdge": {
            "cursor": [
                955
            ],
            "node": [
                597
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketMaterial": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "files": [
                595
            ],
            "outboundScaleTicket": [
                584
            ],
            "outboundScaleTicketCatalyticConverter": [
                585
            ],
            "outboundScaleTicketDeductions": [
                590
            ],
            "outboundScaleTicketId": [
                955
            ],
            "outboundScaleTicketInventoryTag": [
                597
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "outboundScaleTicketRawMaterial": [
                603
            ],
            "receivedMaterials": [
                817
            ],
            "salesOrderMaterial": [
                863
            ],
            "salesOrderMaterialId": [
                955
            ],
            "salesOrderMaterialRemainingWeight": [
                286
            ],
            "salesOrderMaterialRequestedWeight": [
                286
            ],
            "scale": [
                871
            ],
            "scaleId": [
                955
            ],
            "secondaryScale": [
                871
            ],
            "secondaryScaleId": [
                955
            ],
            "shippedInventoryTagsNetWeight": [
                286
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketMaterialConnection": {
            "edges": [
                602
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketMaterialEdge": {
            "cursor": [
                955
            ],
            "node": [
                600
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketRawMaterial": {
            "centralizedCompanyId": [
                955
            ],
            "confidencePrompt": [
                955
            ],
            "confidenceResponse": [
                955
            ],
            "createdAt": [
                194
            ],
            "gradingConfidence": [
                357
            ],
            "grossWeight": [
                286
            ],
            "grossWeightCaptureMethod": [
                1064
            ],
            "material": [
                536
            ],
            "materialId": [
                955
            ],
            "netWeight": [
                286
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "outboundScaleTicketRawMaterialId": [
                955
            ],
            "priceList": [
                688
            ],
            "priceListId": [
                955
            ],
            "priceOrigin": [
                701
            ],
            "pricingUnit": [
                534
            ],
            "productDescription": [
                742,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "productDescriptionId": [
                955
            ],
            "quantity": [
                286
            ],
            "requestedQuantity": [
                286
            ],
            "requestedWeight": [
                286
            ],
            "salesOrder": [
                850
            ],
            "salesOrderId": [
                955
            ],
            "salesOrderMaterialRemainingQuantity": [
                286
            ],
            "salesOrderMaterialRemainingWeight": [
                286
            ],
            "salesOrderMaterialRequestedQuantity": [
                286
            ],
            "salesOrderMaterialRequestedWeight": [
                286
            ],
            "scrapValue": [
                286
            ],
            "shippedInventoryTagsGrossWeight": [
                286
            ],
            "shippedInventoryTagsTareWeight": [
                286
            ],
            "shippedPrice": [
                286
            ],
            "shippedQuantity": [
                286
            ],
            "shippedWeight": [
                286
            ],
            "shippedWipInventoryQuantity": [
                286
            ],
            "shippedWipInventoryWeight": [
                286
            ],
            "splitGrossWeight1": [
                286
            ],
            "splitGrossWeight1CaptureMethod": [
                1064
            ],
            "splitGrossWeight2": [
                286
            ],
            "splitGrossWeight2CaptureMethod": [
                1064
            ],
            "splitTareWeight1": [
                286
            ],
            "splitTareWeight1CaptureMethod": [
                1064
            ],
            "splitTareWeight2": [
                286
            ],
            "splitTareWeight2CaptureMethod": [
                1064
            ],
            "tareWeight": [
                286
            ],
            "tareWeightCaptureMethod": [
                1064
            ],
            "totalPrice": [
                286
            ],
            "unitPrice": [
                286
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketRawMaterialConnection": {
            "edges": [
                605
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketRawMaterialEdge": {
            "cursor": [
                955
            ],
            "node": [
                603
            ],
            "__typename": [
                955
            ]
        },
        "OutboundScaleTicketStatus": {},
        "OutboundScaleTicketsCreatorPlatform": {},
        "PayableNote": {
            "amount": [
                286
            ],
            "centralizedCompany": [
                96
            ],
            "company": [
                130
            ],
            "contact": [
                134
            ],
            "contactId": [
                955
            ],
            "createdAt": [
                194
            ],
            "defaultPaymentTerm": [
                627
            ],
            "defaultPaymentTermId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "facilityId": [
                955
            ],
            "isFreightBill": [
                85
            ],
            "legalHold": [
                85
            ],
            "outboundScaleTicket": [
                584
            ],
            "outboundScaleTicketFreight": [
                596
            ],
            "outboundScaleTicketId": [
                955
            ],
            "payableNoteEligibleDate": [
                194
            ],
            "payableNoteId": [
                955
            ],
            "payableNoteNotes": [
                955
            ],
            "payableNoteNumber": [
                357
            ],
            "paymentTransaction": [
                632
            ],
            "preferredPaymentType": [
                618
            ],
            "publicSupplier": [
                757
            ],
            "scaleTicket": [
                877
            ],
            "scaleTicketFreight": [
                890
            ],
            "scaleTicketId": [
                955
            ],
            "status": [
                611
            ],
            "supplierId": [
                955
            ],
            "thirdPartyHauler": [
                1004
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "PayableNoteConnection": {
            "edges": [
                610
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PayableNoteEdge": {
            "cursor": [
                955
            ],
            "node": [
                608
            ],
            "__typename": [
                955
            ]
        },
        "PayableNoteStatus": {},
        "PayableNoteStatusObject": {},
        "PayableNotesType": {},
        "PayablePayment": {
            "atmId": [
                955
            ],
            "barcode": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "checkMemo": [
                955
            ],
            "checkNumber": [
                357
            ],
            "company": [
                130
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "financialAccount": [
                275
            ],
            "financialAccountId": [
                955
            ],
            "payablePaymentAmount": [
                286
            ],
            "payablePaymentCurrency": [
                173
            ],
            "payablePaymentDate": [
                194
            ],
            "payablePaymentId": [
                955
            ],
            "payablePaymentType": [
                618
            ],
            "publicSupplier": [
                757
            ],
            "status": [
                617
            ],
            "supplierId": [
                955
            ],
            "supplierLocation": [
                524
            ],
            "supplierLocationId": [
                955
            ],
            "supplierName": [
                955
            ],
            "supplierPhoto": [
                847
            ],
            "supplierType": [
                968
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "PayablePaymentConnection": {
            "edges": [
                616
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PayablePaymentEdge": {
            "cursor": [
                955
            ],
            "node": [
                614
            ],
            "__typename": [
                955
            ]
        },
        "PayablePaymentStatus": {},
        "PayablePaymentType": {},
        "Payload": {
            "asset": [
                40,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "assetId": [
                955
            ],
            "assetName": [
                955
            ],
            "assetType": [
                52,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "assetTypeId": [
                955
            ],
            "binNotes": [
                955
            ],
            "grade": [
                337
            ],
            "isWrongBin": [
                85
            ],
            "jobLocationPayloadActions": [
                456,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "payloadId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "Payment": {
            "on_ACHPayment": [
                0
            ],
            "on_ATMPayment": [
                1
            ],
            "on_CashPayment": [
                90
            ],
            "on_CheckPayment": [
                120
            ],
            "on_CustomScheduledPayment": [
                186
            ],
            "on_PresetScheduledPayment": [
                686
            ],
            "__typename": [
                955
            ]
        },
        "PaymentDeduction": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deductionCategory": [
                955
            ],
            "deductionMethod": [
                955
            ],
            "deductionReason": [
                955
            ],
            "deductionTypeId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "notes": [
                955
            ],
            "paymentDeductionId": [
                955
            ],
            "percentageDeduction": [
                286
            ],
            "priceDeduction": [
                286
            ],
            "reversedDeductionId": [
                955
            ],
            "taxRateId": [
                955
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "PaymentDeductionConnection": {
            "edges": [
                623
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PaymentDeductionEdge": {
            "cursor": [
                955
            ],
            "node": [
                621
            ],
            "__typename": [
                955
            ]
        },
        "PaymentSchedule": {},
        "PaymentSettings": {
            "accountNumber": [
                955
            ],
            "bank": [
                955
            ],
            "businessName": [
                955
            ],
            "checkNumberGeneration": [
                85
            ],
            "lastCheckNumber": [
                357
            ],
            "logo": [
                955
            ],
            "mailingAddress": [
                955
            ],
            "paymentSettingsId": [
                955
            ],
            "phoneNumber": [
                955
            ],
            "routingNumber": [
                955
            ],
            "signature": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "PaymentStatus": {},
        "PaymentTerm": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "creatorId": [
                955
            ],
            "dateDrivenDiscountPercentage": [
                286
            ],
            "deletedAt": [
                194
            ],
            "discountDueBeforeDayOfMonth": [
                357
            ],
            "discountIfPaidWithin": [
                357
            ],
            "discountPercentage": [
                286
            ],
            "netDueBeforeDayOfMonth": [
                357
            ],
            "netDueInDays": [
                357
            ],
            "nextMonthDueIfIssuedWithinDays": [
                357
            ],
            "paymentTermId": [
                955
            ],
            "paymentTermName": [
                955
            ],
            "paymentTermType": [
                631
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "PaymentTermConnection": {
            "edges": [
                629
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PaymentTermEdge": {
            "cursor": [
                955
            ],
            "node": [
                627
            ],
            "__typename": [
                955
            ]
        },
        "PaymentTermOptions": {},
        "PaymentTermType": {},
        "PaymentTransaction": {
            "achNumber": [
                955
            ],
            "atmId": [
                955
            ],
            "barcode": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "checkAttn": [
                955
            ],
            "checkLocation": [
                524
            ],
            "checkLocationId": [
                955
            ],
            "checkMemo": [
                955
            ],
            "checkNumber": [
                955
            ],
            "company": [
                130
            ],
            "companyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                955
            ],
            "creatorPlatform": [
                162
            ],
            "deletedAt": [
                194
            ],
            "effectiveAmount": [
                286
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "facilityName": [
                955
            ],
            "financialAccount": [
                275
            ],
            "financialAccountId": [
                955
            ],
            "numberOfPendingInvoices": [
                357
            ],
            "payableNotes": [
                608
            ],
            "paymentTransactionAmount": [
                286
            ],
            "paymentTransactionCurrency": [
                173
            ],
            "paymentTransactionDate": [
                194
            ],
            "paymentTransactionId": [
                955
            ],
            "paymentTransactionType": [
                636
            ],
            "paymentType": [
                618
            ],
            "publicSupplier": [
                757
            ],
            "publicSupplierId": [
                955
            ],
            "receivableInvoices": [
                802
            ],
            "status": [
                635
            ],
            "supplierName": [
                955
            ],
            "supplierPhoto": [
                847
            ],
            "supplierPhotoId": [
                955
            ],
            "thirdPartyHauler": [
                1004
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "ticketCount": [
                357
            ],
            "totalBalanceInvoices": [
                286
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "PaymentTransactionConnection": {
            "edges": [
                634
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PaymentTransactionEdge": {
            "cursor": [
                955
            ],
            "node": [
                632
            ],
            "__typename": [
                955
            ]
        },
        "PaymentTransactionStatus": {},
        "PaymentTransactionType": {},
        "PaymentType": {},
        "PaymentTypeValues": {},
        "PendingBalance": {
            "balance": [
                286
            ],
            "date": [
                194
            ],
            "invoiceId": [
                955
            ],
            "invoiceNumber": [
                357
            ],
            "payableNoteId": [
                955
            ],
            "scaleTicketId": [
                955
            ],
            "scaleTicketNumber": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PendingTransactionInfo": {
            "pendingBalance": [
                286
            ],
            "pendingTransactions": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PeriodEventAdjustmentItem": {
            "id": [
                955
            ],
            "item": [
                370
            ],
            "movementType": [
                377
            ],
            "quantity": [
                286
            ],
            "transactionType": [
                433
            ],
            "__typename": [
                955
            ]
        },
        "PeriodEventDateRange": {
            "endDate": [
                198
            ],
            "startDate": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "PeriodEventDto": {
            "id": [
                955
            ],
            "notes": [
                955
            ],
            "occurredAt": [
                198
            ],
            "type": [
                955
            ],
            "user": [
                1037
            ],
            "userId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "PeriodEventScaleTicketItem": {
            "scaleTicketId": [
                955
            ],
            "scaleTicketNumber": [
                357
            ],
            "status": [
                955
            ],
            "supplierLocationAddress": [
                955
            ],
            "supplierName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "PeriodEventTransactions": {
            "adjustments": [
                641
            ],
            "dateRange": [
                642
            ],
            "scaleTickets": [
                644
            ],
            "__typename": [
                955
            ]
        },
        "PeriodFrequency": {},
        "PeriodSortField": {},
        "PeriodSortInput": {
            "field": [
                647
            ],
            "order": [
                950
            ],
            "__typename": [
                955
            ]
        },
        "PeriodStatus": {},
        "PhotoRequirement": {
            "bookingId": [
                345
            ],
            "centralizedCompanyId": [
                955
            ],
            "id": [
                345
            ],
            "isRequired": [
                85
            ],
            "name": [
                955
            ],
            "order": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "PhotoRequirementInput": {
            "id": [
                345
            ],
            "isRequired": [
                85
            ],
            "name": [
                955
            ],
            "order": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "PhysicalCountJournal": {
            "facility": [
                524
            ],
            "id": [
                955
            ],
            "journalNumber": [
                357
            ],
            "lastUpdatedBy": [
                1037
            ],
            "numberOfEntries": [
                357
            ],
            "occurredAt": [
                198
            ],
            "status": [
                659
            ],
            "type": [
                661
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "PhysicalCountJournalConnection": {
            "edges": [
                654
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PhysicalCountJournalDtoEdge": {
            "node": [
                652
            ],
            "__typename": [
                955
            ]
        },
        "PhysicalCountJournalError": {
            "error": [
                33
            ],
            "__typename": [
                955
            ]
        },
        "PhysicalCountJournalResult": {
            "on_PhysicalCountJournalError": [
                655
            ],
            "on_PhysicalCountJournalSuccess": [
                660
            ],
            "__typename": [
                955
            ]
        },
        "PhysicalCountJournalSortField": {},
        "PhysicalCountJournalSortInput": {
            "field": [
                657
            ],
            "order": [
                950
            ],
            "__typename": [
                955
            ]
        },
        "PhysicalCountJournalStatus": {},
        "PhysicalCountJournalSuccess": {
            "value": [
                652
            ],
            "__typename": [
                955
            ]
        },
        "PhysicalCountJournalType": {},
        "PhysicalCountTaggedEntryDto": {
            "createdAt": [
                198
            ],
            "id": [
                345
            ],
            "inventoryTagId": [
                345
            ],
            "isPrinted": [
                85
            ],
            "item": [
                536
            ],
            "itemId": [
                345
            ],
            "journalId": [
                345
            ],
            "newGrossWeight": [
                286
            ],
            "newTareWeight": [
                286
            ],
            "originalGrossWeight": [
                286
            ],
            "originalTareWeight": [
                286
            ],
            "type": [
                666
            ],
            "updatedAt": [
                198
            ],
            "user": [
                1037
            ],
            "userId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "PhysicalCountTaggedEntryError": {
            "error": [
                33
            ],
            "__typename": [
                955
            ]
        },
        "PhysicalCountTaggedEntryResult": {
            "on_PhysicalCountTaggedEntryError": [
                663
            ],
            "on_PhysicalCountTaggedEntrySuccess": [
                665
            ],
            "__typename": [
                955
            ]
        },
        "PhysicalCountTaggedEntrySuccess": {
            "value": [
                662
            ],
            "__typename": [
                955
            ]
        },
        "PhysicalCountTaggedEntryType": {},
        "PhysicalCountUntaggedEntry": {
            "id": [
                955
            ],
            "item": [
                370
            ],
            "journalId": [
                955
            ],
            "newQuantity": [
                286
            ],
            "newWac": [
                286
            ],
            "updatedAt": [
                198
            ],
            "user": [
                1037
            ],
            "__typename": [
                955
            ]
        },
        "PhysicalCountUntaggedEntryError": {
            "error": [
                33
            ],
            "__typename": [
                955
            ]
        },
        "PhysicalCountUntaggedEntryResult": {
            "on_PhysicalCountUntaggedEntryError": [
                668
            ],
            "on_PhysicalCountUntaggedEntrySuccess": [
                670
            ],
            "__typename": [
                955
            ]
        },
        "PhysicalCountUntaggedEntrySuccess": {
            "value": [
                667
            ],
            "__typename": [
                955
            ]
        },
        "PivotConfig": {
            "fillMissingDates": [
                85
            ],
            "joinDateRange": [
                85
            ],
            "x": [
                955
            ],
            "y": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "PivotConfigInput": {
            "fillMissingDates": [
                85
            ],
            "joinDateRange": [
                85
            ],
            "x": [
                955
            ],
            "y": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "PlaidConnection": {
            "accessToken": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "institutionId": [
                955
            ],
            "institutionName": [
                955
            ],
            "itemId": [
                955
            ],
            "plaidConnectionId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "Port": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                198
            ],
            "id": [
                345
            ],
            "name": [
                955
            ],
            "type": [
                677
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "PortConnection": {
            "edges": [
                676
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PortEdge": {
            "node": [
                674
            ],
            "__typename": [
                955
            ]
        },
        "PortType": {},
        "PortalType": {},
        "PositivePayFileQueryResults": {
            "content": [
                955
            ],
            "fileType": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "PositivePayFileType": {},
        "PositivePayTemplate": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "definition": [
                446
            ],
            "deletedAt": [
                194
            ],
            "fileType": [
                680
            ],
            "positivePayTemplateId": [
                955
            ],
            "templateName": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "PositivePayTemplateConnection": {
            "edges": [
                683
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PositivePayTemplateEdge": {
            "cursor": [
                955
            ],
            "node": [
                681
            ],
            "__typename": [
                955
            ]
        },
        "PositivePayTemplateFieldFormattingOperationOrder": {},
        "PositivePayTemplateFieldType": {},
        "PresetScheduledPayment": {
            "amount": [
                286
            ],
            "id": [
                345
            ],
            "legalHold": [
                85
            ],
            "paymentSchedule": [
                785
            ],
            "purchaseId": [
                345
            ],
            "scheduledDate": [
                198
            ],
            "type": [
                637
            ],
            "__typename": [
                955
            ]
        },
        "PresignedURL": {
            "fields": [
                34
            ],
            "url": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "PriceList": {
            "createdAt": [
                194
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "endDate": [
                194
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "isDefault": [
                85
            ],
            "name": [
                955
            ],
            "priceListGroup": [
                691,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "priceListGroupId": [
                955
            ],
            "priceListGroupMembers": [
                694
            ],
            "priceListId": [
                955
            ],
            "priceListMaterials": [
                697
            ],
            "startDate": [
                194
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "PriceListConnection": {
            "edges": [
                690
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PriceListEdge": {
            "cursor": [
                955
            ],
            "node": [
                688
            ],
            "__typename": [
                955
            ]
        },
        "PriceListGroup": {
            "companies": [
                130
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "isDefaultGroup": [
                85
            ],
            "members": [
                694
            ],
            "name": [
                955
            ],
            "priceListGroupId": [
                955
            ],
            "priceLists": [
                688
            ],
            "publicSuppliers": [
                757
            ],
            "type": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "PriceListGroupConnection": {
            "edges": [
                693
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PriceListGroupEdge": {
            "cursor": [
                955
            ],
            "node": [
                691
            ],
            "__typename": [
                955
            ]
        },
        "PriceListGroupMember": {
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "memberId": [
                955
            ],
            "memberType": [
                955
            ],
            "priceListGroup": [
                691
            ],
            "priceListGroupMemberId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "PriceListGroupType": {},
        "PriceListId": {},
        "PriceListMaterial": {
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "material": [
                536
            ],
            "materialId": [
                955
            ],
            "priceList": [
                688
            ],
            "priceListId": [
                955
            ],
            "priceListMaterialId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescription": [
                742
            ],
            "tiers": [
                700
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "PriceListMaterialConnection": {
            "edges": [
                699
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PriceListMaterialEdge": {
            "cursor": [
                955
            ],
            "node": [
                697
            ],
            "__typename": [
                955
            ]
        },
        "PriceListMaterialTier": {
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "priceListMaterial": [
                697
            ],
            "priceListMaterialId": [
                955
            ],
            "priceListMaterialTierId": [
                955
            ],
            "priceMax": [
                955
            ],
            "priceMin": [
                955
            ],
            "priceTarget": [
                955
            ],
            "updatedAt": [
                194
            ],
            "weightMax": [
                286
            ],
            "weightMin": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "PriceOrigin": {},
        "PricingCurrency": {},
        "PricingPricingUnit": {},
        "PricingProduct": {
            "descriptionId": [
                745
            ],
            "id": [
                747
            ],
            "type": [
                706
            ],
            "__typename": [
                955
            ]
        },
        "PricingProductInput": {
            "descriptionId": [
                745
            ],
            "id": [
                747
            ],
            "type": [
                706
            ],
            "__typename": [
                955
            ]
        },
        "PricingProductType": {},
        "PricingUnit": {},
        "PricingVariable": {
            "centralizedCompanyId": [
                99
            ],
            "createdAt": [
                198
            ],
            "deletedAt": [
                198
            ],
            "description": [
                955
            ],
            "id": [
                1054
            ],
            "name": [
                955
            ],
            "updatedAt": [
                198
            ],
            "value": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "Printer": {
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "name": [
                955
            ],
            "printerId": [
                955
            ],
            "sidecarHost": [
                947
            ],
            "sidecarHostId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "PrintingRequest": {
            "documentGenerationParams": [
                222
            ],
            "printer": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "Process": {
            "centralizedCompany": [
                96,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "creatorId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "name": [
                955
            ],
            "processExecutions": [
                717,
                {
                    "limit": [
                        357
                    ]
                }
            ],
            "processId": [
                955
            ],
            "processLineBurdens": [
                730
            ],
            "processMappings": [
                734
            ],
            "status": [
                740
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ProcessConnection": {
            "edges": [
                716
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ProcessCostInput": {
            "amount": [
                286
            ],
            "name": [
                955
            ],
            "type": [
                714
            ],
            "unit": [
                715
            ],
            "__typename": [
                955
            ]
        },
        "ProcessCostType": {},
        "ProcessCostUnit": {},
        "ProcessEdge": {
            "cursor": [
                955
            ],
            "node": [
                711
            ],
            "__typename": [
                955
            ]
        },
        "ProcessExecution": {
            "centralizedCompany": [
                96,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "creatorId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "materialAdjustments": [
                537
            ],
            "process": [
                711
            ],
            "processExecutionId": [
                955
            ],
            "processId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ProcessExecutionConnection": {
            "edges": [
                719
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ProcessExecutionEdge": {
            "cursor": [
                955
            ],
            "node": [
                717
            ],
            "__typename": [
                955
            ]
        },
        "ProcessExecutionMaterialInput": {
            "amountToProcess": [
                286
            ],
            "materialId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ProcessExecutionOutcome": {
            "outputs": [
                724
            ],
            "__typename": [
                955
            ]
        },
        "ProcessExecutionOutcomeCost": {
            "costDetails": [
                723
            ],
            "inputItem": [
                370
            ],
            "inputItemId": [
                955
            ],
            "totalAmount": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "ProcessExecutionOutcomeCostDetail": {
            "amount": [
                286
            ],
            "name": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ProcessExecutionOutcomeOutput": {
            "costs": [
                722
            ],
            "finalQuantity": [
                286
            ],
            "finalTotalCost": [
                286
            ],
            "finalWac": [
                286
            ],
            "initialQuantity": [
                286
            ],
            "initialTotalCost": [
                286
            ],
            "initialWac": [
                286
            ],
            "item": [
                370
            ],
            "itemId": [
                345
            ],
            "quantity": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "ProcessExecutionSortField": {},
        "ProcessExecutionSortInput": {
            "field": [
                725
            ],
            "order": [
                950
            ],
            "__typename": [
                955
            ]
        },
        "ProcessExecutionStatus": {},
        "ProcessExecutionType": {},
        "ProcessInputInput": {
            "itemId": [
                345
            ],
            "__typename": [
                955
            ]
        },
        "ProcessLineBurden": {
            "centralizedCompany": [
                96,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "centralizedCompanyId": [
                955
            ],
            "cost": [
                286
            ],
            "costUnit": [
                732
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "name": [
                955
            ],
            "process": [
                711
            ],
            "processId": [
                955
            ],
            "processLineBurdenId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ProcessLineBurdenConnection": {
            "edges": [
                733
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ProcessLineBurdenCostUnit": {},
        "ProcessLineBurdenEdge": {
            "cursor": [
                955
            ],
            "node": [
                730
            ],
            "__typename": [
                955
            ]
        },
        "ProcessMapping": {
            "centralizedCompany": [
                96,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "centralizedCompanyId": [
                955
            ],
            "cost": [
                286
            ],
            "costUnit": [
                732
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "inputMaterial": [
                536,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "inputMaterialId": [
                955
            ],
            "outputMaterial": [
                536,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "outputMaterialId": [
                955
            ],
            "percentage": [
                286
            ],
            "process": [
                711
            ],
            "processId": [
                955
            ],
            "processMappingId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ProcessMappingConnection": {
            "edges": [
                736
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ProcessMappingEdge": {
            "cursor": [
                955
            ],
            "node": [
                734
            ],
            "__typename": [
                955
            ]
        },
        "ProcessOutputInput": {
            "costs": [
                713
            ],
            "itemId": [
                345
            ],
            "percentage": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "ProcessSortField": {},
        "ProcessSortInput": {
            "field": [
                738
            ],
            "order": [
                950
            ],
            "__typename": [
                955
            ]
        },
        "ProcessStatus": {},
        "ProcessTransformationInput": {
            "input": [
                729
            ],
            "outputs": [
                737
            ],
            "__typename": [
                955
            ]
        },
        "ProductDescription": {
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "material": [
                536,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "materialId": [
                955
            ],
            "productDescriptionId": [
                955
            ],
            "productDescriptionName": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ProductDescriptionConnection": {
            "edges": [
                744
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ProductDescriptionEdge": {
            "cursor": [
                955
            ],
            "node": [
                742
            ],
            "__typename": [
                955
            ]
        },
        "ProductDescriptionId": {},
        "ProductGroupId": {},
        "ProductId": {},
        "ProductPrice": {
            "centralizedCompanyId": [
                99
            ],
            "currency": [
                702
            ],
            "facilityId": [
                268
            ],
            "operationType": [
                582
            ],
            "pricingUnits": [
                703
            ],
            "product": [
                704
            ],
            "productPricings": [
                257
            ],
            "__typename": [
                955
            ]
        },
        "ProductPriceConfiguration": {
            "centralizedCompanyId": [
                99
            ],
            "createdAt": [
                198
            ],
            "currency": [
                702
            ],
            "facilityId": [
                268
            ],
            "id": [
                750
            ],
            "operationType": [
                582
            ],
            "pricingUnits": [
                703
            ],
            "product": [
                704
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "ProductPriceConfigurationId": {},
        "ProductPriceHistoryEntry": {
            "netWeight": [
                286
            ],
            "pricingUnit": [
                707
            ],
            "productId": [
                747
            ],
            "purchaseDate": [
                198
            ],
            "unitPrice": [
                286
            ],
            "weightUnit": [
                1066
            ],
            "__typename": [
                955
            ]
        },
        "ProductPricing": {
            "centralizedCompanyId": [
                99
            ],
            "createdAt": [
                198
            ],
            "id": [
                753
            ],
            "priceListId": [
                696
            ],
            "pricingUnit": [
                703
            ],
            "product": [
                704
            ],
            "tiers": [
                754
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "ProductPricingId": {},
        "ProductPricingTier": {
            "maxAmount": [
                286
            ],
            "maxUnitPrice": [
                1029
            ],
            "minUnitPrice": [
                1029
            ],
            "targetUnitPrice": [
                1029
            ],
            "__typename": [
                955
            ]
        },
        "ProductPricingTierInput": {
            "maxAmount": [
                286
            ],
            "maxUnitPriceFormula": [
                955
            ],
            "minUnitPriceFormula": [
                955
            ],
            "targetUnitPriceFormula": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ProductType": {},
        "PublicSupplier": {
            "businessLicenseNumber": [
                955
            ],
            "centralizedCompanyId": [
                345
            ],
            "customAttributes": [
                446
            ],
            "dateOfBirth": [
                194
            ],
            "doNotBuy": [
                85
            ],
            "doNotBuyOriginType": [
                221
            ],
            "email": [
                955
            ],
            "employerName": [
                955
            ],
            "eyeColor": [
                955
            ],
            "files": [
                847
            ],
            "fingerprint": [
                847
            ],
            "firstName": [
                955
            ],
            "fullName": [
                955
            ],
            "hairColor": [
                955
            ],
            "height": [
                286
            ],
            "identificationBack": [
                847
            ],
            "identificationExpiresDate": [
                194
            ],
            "identificationFront": [
                847
            ],
            "identificationIssuedDate": [
                194
            ],
            "identificationNumber": [
                955
            ],
            "identificationState": [
                955
            ],
            "identificationType": [
                955
            ],
            "inboundTaxRates": [
                980
            ],
            "lastName": [
                955
            ],
            "lastTransactionDate": [
                194
            ],
            "latestTexasCashCardNumber": [
                357
            ],
            "location": [
                524
            ],
            "middleName": [
                955
            ],
            "notes": [
                955
            ],
            "paymentDatePreference": [
                194
            ],
            "paymentHoldDays": [
                286
            ],
            "paymentSchedulePreference": [
                624
            ],
            "paymentTypePreference": [
                955
            ],
            "phoneNumber": [
                955
            ],
            "priceListGroups": [
                691
            ],
            "profilePhoto": [
                847
            ],
            "publicSupplierId": [
                345
            ],
            "race": [
                955
            ],
            "sex": [
                955
            ],
            "suffix": [
                955
            ],
            "supplierSignature": [
                967
            ],
            "supplierSignatureId": [
                955
            ],
            "texasCashCards": [
                985
            ],
            "totalBusiness": [
                286
            ],
            "totalTransactions": [
                357
            ],
            "trailers": [
                1013
            ],
            "vehicles": [
                1013
            ],
            "weight": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "PublicSupplierConnection": {
            "edges": [
                759
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PublicSupplierEdge": {
            "cursor": [
                955
            ],
            "node": [
                757
            ],
            "__typename": [
                955
            ]
        },
        "PuertoRicoPoliceFormConfiguration": {
            "buyerFullName": [
                955
            ],
            "buyerMobileNumber": [
                955
            ],
            "buyerPhoneNumber": [
                955
            ],
            "buyerPostalAddress": [
                955
            ],
            "centralizedCompany": [
                96,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "facilityLocation": [
                524,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "facilityLocationId": [
                955
            ],
            "puertoRicoPoliceFormConfigurationId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "PuertoRicoPoliceFormConfigurationConnection": {
            "edges": [
                762
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PuertoRicoPoliceFormConfigurationEdge": {
            "cursor": [
                955
            ],
            "node": [
                760
            ],
            "__typename": [
                955
            ]
        },
        "Purchase": {
            "activeTasks": [
                790
            ],
            "centralizedCompanyId": [
                345
            ],
            "commercialSupplier": [
                130
            ],
            "completedTasks": [
                790
            ],
            "createdAt": [
                198
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                345
            ],
            "currencyCode": [
                173
            ],
            "deductions": [
                199
            ],
            "deletedDeductions": [
                199
            ],
            "deletedItems": [
                441
            ],
            "deletedMixedMaterials": [
                565
            ],
            "driverId": [
                345
            ],
            "externalNotes": [
                955
            ],
            "extras": [
                446
            ],
            "facilityId": [
                345
            ],
            "freight": [
                766
            ],
            "id": [
                345
            ],
            "internalNotes": [
                955
            ],
            "items": [
                441
            ],
            "mixedMaterials": [
                565
            ],
            "number": [
                357
            ],
            "paymentFacilityId": [
                345
            ],
            "payments": [
                620
            ],
            "publicSupplier": [
                757
            ],
            "status": [
                789
            ],
            "supplierId": [
                345
            ],
            "supplierLocationId": [
                345
            ],
            "supplierName": [
                955
            ],
            "supplierPhoto": [
                528
            ],
            "supplierSignature": [
                528
            ],
            "supplierType": [
                968
            ],
            "tempIdentification": [
                955
            ],
            "ticketDate": [
                198
            ],
            "totals": [
                791
            ],
            "trailerId": [
                345
            ],
            "truckHeavyWeight": [
                286
            ],
            "truckHeavyWeightInputMethod": [
                1065
            ],
            "truckLightWeight": [
                286
            ],
            "truckLightWeightInputMethod": [
                1065
            ],
            "truckNetWeight": [
                286
            ],
            "truckWeightDifferentialGross": [
                286
            ],
            "truckWeightDifferentialTare": [
                286
            ],
            "truckWeightUnit": [
                1066
            ],
            "updatedAt": [
                198
            ],
            "vehicleId": [
                345
            ],
            "voidReason": [
                955
            ],
            "voidedAt": [
                198
            ],
            "voidedById": [
                345
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseConnection": {
            "edges": [
                765
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseEdge": {
            "node": [
                763
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseFreight": {
            "accruedAmount": [
                286
            ],
            "chargebackAmount": [
                286
            ],
            "createdAt": [
                198
            ],
            "deliveryNumber": [
                955
            ],
            "freightBillDueDate": [
                198
            ],
            "freightLaneId": [
                296
            ],
            "notes": [
                955
            ],
            "thirdPartyHaulerId": [
                1007
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseFreightInput": {
            "accruedAmount": [
                286
            ],
            "chargebackAmount": [
                286
            ],
            "deliveryNumber": [
                955
            ],
            "freightBillDueDate": [
                198
            ],
            "freightLaneId": [
                296
            ],
            "notes": [
                955
            ],
            "thirdPartyHaulerId": [
                1007
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseId": {},
        "PurchaseInventoryTag": {
            "number": [
                286
            ],
            "tareTypeId": [
                979
            ],
            "type": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseInventoryTagInput": {
            "number": [
                357
            ],
            "tareTypeId": [
                979
            ],
            "type": [
                771
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseInventoryTagType": {},
        "PurchaseItemQuantityInput": {
            "amount": [
                286
            ],
            "unit": [
                795
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseItemUnitPriceInput": {
            "amount": [
                286
            ],
            "unit": [
                707
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseItemWeightInput": {
            "gross": [
                286
            ],
            "grossWeightInputMethod": [
                1065
            ],
            "tare": [
                286
            ],
            "tareWeightInputMethod": [
                1065
            ],
            "unit": [
                1066
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseMonetaryDeductionTotals": {
            "id": [
                201
            ],
            "monetaryAmount": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseOrder": {
            "accountRepresentative": [
                1037
            ],
            "completionNotes": [
                955
            ],
            "contact": [
                134
            ],
            "counterpartySalesOrderNumber": [
                955
            ],
            "creator": [
                1037
            ],
            "defaultPaymentTerm": [
                627
            ],
            "defaultPaymentTermId": [
                955
            ],
            "endDate": [
                194
            ],
            "facilityLocation": [
                524
            ],
            "facilityLocationId": [
                955
            ],
            "files": [
                847
            ],
            "freightTerm": [
                303
            ],
            "location": [
                524
            ],
            "netWeight": [
                286
            ],
            "notes": [
                955
            ],
            "paymentCurrency": [
                173
            ],
            "paymentTerm": [
                630
            ],
            "pdf": [
                847
            ],
            "purchaseOrderId": [
                955
            ],
            "purchaseOrderMaterials": [
                779
            ],
            "purchaseOrderNumber": [
                357
            ],
            "purchasedWeight": [
                286
            ],
            "recycler": [
                96
            ],
            "scaleTicketsCount": [
                357
            ],
            "startDate": [
                194
            ],
            "status": [
                782
            ],
            "supplier": [
                130
            ],
            "totalPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseOrderConnection": {
            "edges": [
                778
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseOrderEdge": {
            "cursor": [
                955
            ],
            "node": [
                776
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseOrderMaterial": {
            "centralizedCompanyId": [
                955
            ],
            "material": [
                536
            ],
            "materialId": [
                955
            ],
            "netWeight": [
                286
            ],
            "priceList": [
                688
            ],
            "priceListId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescription": [
                742
            ],
            "productDescriptionId": [
                955
            ],
            "purchaseOrder": [
                776
            ],
            "purchaseOrderId": [
                955
            ],
            "purchaseOrderMaterialId": [
                955
            ],
            "quantity": [
                286
            ],
            "recycler": [
                96
            ],
            "totalPrice": [
                286
            ],
            "unitPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseOrderMaterialConnection": {
            "edges": [
                781
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseOrderMaterialEdge": {
            "cursor": [
                955
            ],
            "node": [
                779
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseOrderStatus": {},
        "PurchaseOrderStatusToTags": {},
        "PurchaseOwnership": {},
        "PurchasePaymentSchedule": {},
        "PurchaseProduct": {
            "descriptionId": [
                745
            ],
            "id": [
                747
            ],
            "type": [
                756
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseProductInput": {
            "descriptionId": [
                745
            ],
            "id": [
                747
            ],
            "type": [
                756
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseSimplifiedStatus": {},
        "PurchaseStatus": {},
        "PurchaseTask": {},
        "PurchaseTotals": {
            "itemsTotals": [
                444
            ],
            "monetaryDeductionsTotals": [
                775
            ],
            "netMonetaryAmount": [
                286
            ],
            "nominalPrice": [
                286
            ],
            "weightDeductionsTotals": [
                793
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseTruckWeightInput": {
            "heavy": [
                286
            ],
            "heavyWeightInputMethod": [
                1065
            ],
            "light": [
                286
            ],
            "lightWeightInputMethod": [
                1065
            ],
            "unit": [
                1066
            ],
            "__typename": [
                955
            ]
        },
        "PurchaseWeightDeductionTotals": {
            "amount": [
                286
            ],
            "id": [
                201
            ],
            "monetaryAmount": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "PurchasesDeductionType": {
            "centralizedCompanyId": [
                345
            ],
            "deductionScope": [
                204
            ],
            "deductionUnit": [
                209
            ],
            "description": [
                955
            ],
            "facilityId": [
                345
            ],
            "id": [
                345
            ],
            "legacyDeductionTypeId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "QuantityUnit": {},
        "Query": {
            "accountTypesToSubtypesMap": [
                15
            ],
            "accountingAgingCategories": [
                17,
                {
                    "accountingAgingCategoryIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "accountingAgingCategory": [
                16,
                {
                    "accountingAgingCategoryId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "accountingEntry": [
                19,
                {
                    "accountingEntryId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "accounts": [
                4,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ]
                }
            ],
            "accountsTotalAmounts": [
                11,
                {
                    "afterDate": [
                        198
                    ],
                    "beforeDate": [
                        198
                    ],
                    "period": [
                        955,
                        "String!"
                    ]
                }
            ],
            "allSalesOrdersForCentralizedCompanyId": [
                851,
                {
                    "companyIds": [
                        955,
                        "[String!]"
                    ],
                    "hasNotExpired": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "locationIds": [
                        955,
                        "[String!]"
                    ],
                    "offset": [
                        357
                    ],
                    "salesOrderIds": [
                        955,
                        "[String]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "shippingStatus": [
                        866,
                        "[SalesOrderShippingStatus!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        867,
                        "[SalesOrderStatus!]"
                    ],
                    "withWeightOwed": [
                        85
                    ]
                }
            ],
            "apiKeys": [
                36,
                {
                    "apiKeyIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "asset": [
                40,
                {
                    "assetId": [
                        955
                    ]
                }
            ],
            "assetDescription": [
                42,
                {
                    "assetDescriptionId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "assetDescriptions": [
                43,
                {
                    "assetDescriptionIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "assetHistories": [
                47,
                {
                    "afterDate": [
                        194
                    ],
                    "assetHistoryIds": [
                        955,
                        "[String!]"
                    ],
                    "assetId": [
                        955,
                        "String!"
                    ],
                    "beforeDate": [
                        194
                    ],
                    "companyIds": [
                        955,
                        "[String!]"
                    ],
                    "jobTypes": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "assetTypes": [
                53,
                {
                    "excludeTemporary": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "assets": [
                41,
                {
                    "assetIds": [
                        955,
                        "[String!]"
                    ],
                    "assetTypeIds": [
                        955,
                        "[String!]"
                    ],
                    "centralizedCompanyId": [
                        955
                    ],
                    "companyIds": [
                        955,
                        "[String!]"
                    ],
                    "excludeTemporary": [
                        85
                    ],
                    "grades": [
                        337,
                        "[Grade!]"
                    ],
                    "limit": [
                        357
                    ],
                    "locationIds": [
                        955,
                        "[String!]"
                    ],
                    "movedBeforeDate": [
                        194
                    ],
                    "offset": [
                        357
                    ],
                    "role": [
                        174
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "atms": [
                58,
                {
                    "facilityId": [
                        955
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "auditAuditableTables": [
                955,
                {
                    "includeExtraneousTables": [
                        85
                    ]
                }
            ],
            "auditLogs": [
                62,
                {
                    "date": [
                        194
                    ],
                    "filter": [
                        446
                    ],
                    "includeExtraneousTables": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "bankAccount": [
                67,
                {
                    "bankAccountId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "bankAccounts": [
                68,
                {
                    "accountType": [
                        955,
                        "[String]"
                    ],
                    "bankAccountIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "booking": [
                74,
                {
                    "bookingId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "bookings": [
                76,
                {
                    "assetTypeIds": [
                        955,
                        "[String!]"
                    ],
                    "destinationPortIds": [
                        955,
                        "[String!]"
                    ],
                    "endDate": [
                        955
                    ],
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "originPortIds": [
                        955,
                        "[String!]"
                    ],
                    "salesOrderIds": [
                        955,
                        "[String!]"
                    ],
                    "searchTerm": [
                        955
                    ],
                    "shippingCarrierIds": [
                        955,
                        "[String!]"
                    ],
                    "sort": [
                        955
                    ],
                    "startDate": [
                        955
                    ],
                    "status": [
                        84
                    ]
                }
            ],
            "calculateInfoForCrvBatch": [
                354,
                {
                    "afterDate": [
                        194
                    ],
                    "beforeDate": [
                        194
                    ],
                    "crvMaterialId": [
                        955,
                        "String!"
                    ],
                    "facilityId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "calculateStartDateForDraftCrvBatch": [
                194,
                {
                    "crvMaterialId": [
                        955,
                        "String!"
                    ],
                    "facilityId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "cashAccount": [
                275,
                {
                    "cashAccountId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "cashAccounts": [
                279,
                {
                    "cashAccountIds": [
                        955,
                        "[String!]"
                    ],
                    "cashAccountTypes": [
                        955,
                        "[String!]"
                    ],
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "catalyticConverter": [
                92,
                {
                    "catalyticConverterId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "catalyticConverters": [
                93,
                {
                    "catalyticConverterIds": [
                        955,
                        "[String!]"
                    ],
                    "catalyticConverterSizes": [
                        95,
                        "[CatalyticConverterSize!]"
                    ],
                    "limit": [
                        357
                    ],
                    "materialGroupIds": [
                        955,
                        "[String!]"
                    ],
                    "offset": [
                        357
                    ],
                    "purchaseOrderIds": [
                        955,
                        "[String!]"
                    ],
                    "salesOrderLoadIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "catalyticConvertersForInventoryExport": [
                955,
                {
                    "catalyticConverterIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "centralizedCompanies": [
                97,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "centralizedCompany": [
                96,
                {
                    "centralizedCompanyId": [
                        955
                    ]
                }
            ],
            "centralizedCompanyIntegrations": [
                101,
                {
                    "centralizedCompanyIntegrationIds": [
                        955,
                        "[String!]"
                    ],
                    "integrationTypes": [
                        103,
                        "[CentralizedCompanyIntegrationType!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "chart": [
                105,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "chartAccount": [
                106,
                {
                    "chartAccountId": [
                        955
                    ]
                }
            ],
            "chartAccounts": [
                107,
                {
                    "accountSubTypes": [
                        955,
                        "[String!]"
                    ],
                    "accountTypes": [
                        955,
                        "[String!]"
                    ],
                    "chartAccountUnits": [
                        955,
                        "[String!]"
                    ],
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "materialIds": [
                        955,
                        "[String!]"
                    ],
                    "names": [
                        955,
                        "[String!]"
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "charts": [
                113,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "search": [
                        955
                    ],
                    "sorter": [
                        116
                    ]
                }
            ],
            "checkCounterpartiesInGroups": [
                141,
                {
                    "counterpartyIds": [
                        147,
                        "[CounterpartyId!]!"
                    ],
                    "operationType": [
                        955
                    ]
                }
            ],
            "checkGovernmentReportingServiceCredentials": [
                118,
                {
                    "password": [
                        955,
                        "String!"
                    ],
                    "storeIds": [
                        955,
                        "[String!]"
                    ],
                    "username": [
                        955,
                        "String!"
                    ]
                }
            ],
            "checkTemplate": [
                121
            ],
            "companies": [
                131,
                {
                    "accountManagerIds": [
                        955,
                        "[String!]"
                    ],
                    "afterDate": [
                        194
                    ],
                    "companyIds": [
                        955,
                        "[String!]"
                    ],
                    "companyTypes": [
                        955,
                        "[String!]"
                    ],
                    "groupId": [
                        955
                    ],
                    "hasAssets": [
                        85
                    ],
                    "hasDetentions": [
                        85
                    ],
                    "hasFuelSurcharges": [
                        85
                    ],
                    "hasPendingReceivablePaymentInvoices": [
                        85
                    ],
                    "hasScaleTicketsWithStatus": [
                        909
                    ],
                    "hasSupplierPortalAccess": [
                        85
                    ],
                    "hasSupplierPortalContacts": [
                        85
                    ],
                    "isCustomer": [
                        85
                    ],
                    "isServiceProvider": [
                        85
                    ],
                    "isSupplier": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "privilegedFacilityId": [
                        955
                    ],
                    "role": [
                        174
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "company": [
                130,
                {
                    "companyId": [
                        955
                    ],
                    "role": [
                        174
                    ]
                }
            ],
            "contact": [
                134,
                {
                    "contactId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "contacts": [
                135,
                {
                    "companyId": [
                        955
                    ],
                    "contactIds": [
                        955,
                        "[String!]"
                    ],
                    "hasSupplierPortalAccess": [
                        85
                    ],
                    "hasSupplierPortalContacts": [
                        85
                    ],
                    "hideNonInvitedContacts": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "onlyPriceListContact": [
                        85
                    ],
                    "priceListGroupId": [
                        955
                    ],
                    "priceListGroupMemberIds": [
                        955,
                        "[String]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "counterpartyGroup": [
                142,
                {
                    "id": [
                        143,
                        "CounterpartyGroupId!"
                    ]
                }
            ],
            "counterpartyGroupMembers": [
                145,
                {
                    "counterpartyGroupId": [
                        143,
                        "CounterpartyGroupId!"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "search": [
                        955
                    ]
                }
            ],
            "counterpartyGroupMembersCompanyIds": [
                955,
                {
                    "counterpartyGroupId": [
                        143,
                        "CounterpartyGroupId!"
                    ]
                }
            ],
            "counterpartyGroups": [
                146,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "search": [
                        955
                    ]
                }
            ],
            "crvBatch": [
                163,
                {
                    "crvBatchId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "crvBatches": [
                164,
                {
                    "crvBatchIds": [
                        955,
                        "[String!]"
                    ],
                    "crvMaterialIds": [
                        955,
                        "[String!]"
                    ],
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "status": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "crvMaterials": [
                168,
                {
                    "crvMaterialIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "crvRate": [
                170,
                {
                    "crvRateId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "crvRates": [
                171,
                {
                    "crvMaterialId": [
                        955
                    ],
                    "crvRateIds": [
                        955,
                        "[String!]"
                    ],
                    "includeExpired": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "materialId": [
                        955
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "customAttribute": [
                175,
                {
                    "customAttributeId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "customAttributes": [
                176,
                {
                    "customAttributeIds": [
                        955,
                        "[String!]"
                    ],
                    "customAttributeTypes": [
                        183,
                        "[CustomAttributeType!]"
                    ],
                    "entityTypes": [
                        178,
                        "[CustomAttributeEntityType!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "customPriceList": [
                184,
                {
                    "id": [
                        185,
                        "CustomPriceListId!"
                    ],
                    "tiersEffectiveAt": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "customPriceListHistory": [
                344,
                {
                    "id": [
                        185,
                        "CustomPriceListId!"
                    ]
                }
            ],
            "customPriceLists": [
                184,
                {
                    "facilityId": [
                        268,
                        "FacilityId!"
                    ],
                    "tiersEffectiveAt": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "dataWarehouseRun": [
                189,
                {
                    "runId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "dataWarehouseRuns": [
                190,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ]
                }
            ],
            "dataWarehouseUser": [
                192
            ],
            "datedMaterialLocation": [
                551,
                {
                    "date": [
                        194,
                        "Date!"
                    ],
                    "locationId": [
                        955,
                        "String!"
                    ],
                    "materialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deductionType": [
                205,
                {
                    "deductionTypeId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "deductionTypes": [
                206,
                {
                    "deductionTypeCategories": [
                        200,
                        "[DeductionCategory!]"
                    ],
                    "deductionTypeIds": [
                        955,
                        "[String!]"
                    ],
                    "deductionTypeMethods": [
                        203,
                        "[DeductionMethod!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "defaultPhotoRequirements": [
                210
            ],
            "defaultPriceList": [
                211,
                {
                    "currency": [
                        702,
                        "PricingCurrency!"
                    ],
                    "facilityId": [
                        268,
                        "FacilityId!"
                    ],
                    "operationType": [
                        582,
                        "OperationType!"
                    ],
                    "tiersEffectiveAt": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "defaultPriceListHistory": [
                344,
                {
                    "currency": [
                        702,
                        "PricingCurrency!"
                    ],
                    "facilityId": [
                        268,
                        "FacilityId!"
                    ],
                    "operationType": [
                        582,
                        "OperationType!"
                    ]
                }
            ],
            "detention": [
                216,
                {
                    "detentionId": [
                        955
                    ]
                }
            ],
            "detentions": [
                217,
                {
                    "carrierId": [
                        955
                    ],
                    "companyId": [
                        955
                    ],
                    "currentOnly": [
                        85
                    ],
                    "dateFilter": [
                        194
                    ],
                    "detentionId": [
                        955
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "driver": [
                223,
                {
                    "driverId": [
                        955
                    ]
                }
            ],
            "drivers": [
                224,
                {
                    "appVersionStatuses": [
                        39,
                        "[AppVersionStatus!]"
                    ],
                    "centralizedCompanyIds": [
                        955,
                        "[String!]"
                    ],
                    "dataOwner": [
                        955
                    ],
                    "driverIds": [
                        955,
                        "[String!]"
                    ],
                    "driverStatuses": [
                        955,
                        "[String!]"
                    ],
                    "groupId": [
                        955
                    ],
                    "includeHaulerDrivers": [
                        85
                    ],
                    "isAssignableToJobs": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "thirdPartyHaulerId": [
                        955
                    ]
                }
            ],
            "equipment": [
                230,
                {
                    "equipmentId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "equipmentChecklist": [
                231,
                {
                    "equipmentChecklistId": [
                        955,
                        "String!"
                    ],
                    "role": [
                        174
                    ]
                }
            ],
            "equipmentChecklistAnswer": [
                232,
                {
                    "equipmentChecklistAnswerId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "equipmentChecklistTemplate": [
                242,
                {
                    "equipmentChecklistTemplateId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "equipmentChecklistTemplates": [
                243,
                {
                    "equipmentChecklistTemplateIds": [
                        955,
                        "[String!]"
                    ],
                    "equipmentTypeIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "manufacturerCentralizedCompanyId": [
                        955
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "equipmentChecklists": [
                234,
                {
                    "creatorIds": [
                        955,
                        "[String!]"
                    ],
                    "endDate": [
                        194
                    ],
                    "equipmentChecklistIds": [
                        955,
                        "[String!]"
                    ],
                    "equipmentChecklistTemplateIds": [
                        955,
                        "[String!]"
                    ],
                    "equipmentIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "role": [
                        174
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "startDate": [
                        194
                    ],
                    "statuses": [
                        241,
                        "[EquipmentChecklistStatus!]"
                    ]
                }
            ],
            "equipmentGroup": [
                248,
                {
                    "equipmentGroupId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "equipmentGroups": [
                249,
                {
                    "equipmentGroupIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "manufacturerCentralizedCompanyId": [
                        955
                    ],
                    "offset": [
                        357
                    ],
                    "role": [
                        174
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "equipmentType": [
                252,
                {
                    "equipmentTypeId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "equipmentTypes": [
                253,
                {
                    "equipmentGroupIds": [
                        955,
                        "[String!]"
                    ],
                    "equipmentTypeIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "manufacturerCentralizedCompanyId": [
                        955
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "equipments": [
                246,
                {
                    "equipmentIds": [
                        955,
                        "[String!]"
                    ],
                    "equipmentTypeIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "role": [
                        174
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        251,
                        "[EquipmentStatus!]"
                    ]
                }
            ],
            "evaluatedFormulas": [
                256,
                {
                    "formulas": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "exportGovernmentReportingTicketsFile": [
                335,
                {
                    "governmentReportingBatchId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "financialAccount": [
                275,
                {
                    "financialAccountId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "financialAccountAdjustments": [
                277,
                {
                    "financialAccountAdjustmentIds": [
                        955,
                        "[String!]"
                    ],
                    "financialAccountIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "financialAccounts": [
                279,
                {
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "financialAccountIds": [
                        955,
                        "[String!]"
                    ],
                    "financialAccountTypes": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "financialTransactions": [
                284,
                {
                    "financialAccountIds": [
                        955,
                        "[String!]"
                    ],
                    "financialTransactionIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "findDuplicateCompanies": [
                130,
                {
                    "company": [
                        1079,
                        "companyInput!"
                    ]
                }
            ],
            "findDuplicatePublicSuppliers": [
                757,
                {
                    "publicSupplier": [
                        1193,
                        "publicSupplierInput!"
                    ]
                }
            ],
            "findFuelSurchargeForFreightLane": [
                306,
                {
                    "carrierId": [
                        955,
                        "String!"
                    ],
                    "date": [
                        194,
                        "Date!"
                    ],
                    "locationAId": [
                        955,
                        "String!"
                    ],
                    "locationBId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "findInventoryBreakdownByFacilities": [
                368,
                {
                    "itemId": [
                        955,
                        "String!"
                    ],
                    "type": [
                        372,
                        "InventoryItemType!"
                    ]
                }
            ],
            "findInventoryItemCurrentState": [
                371,
                {
                    "facilityId": [
                        345,
                        "ID!"
                    ],
                    "itemId": [
                        345,
                        "ID!"
                    ]
                }
            ],
            "findInventoryItemStates": [
                371,
                {
                    "facilityIds": [
                        345,
                        "[ID!]"
                    ],
                    "itemIds": [
                        345,
                        "[ID!]"
                    ],
                    "onlyNegativeOnHand": [
                        85
                    ],
                    "stateAt": [
                        198
                    ]
                }
            ],
            "findInventoryValuationAt": [
                434,
                {
                    "facilityId": [
                        345,
                        "ID!"
                    ],
                    "itemId": [
                        345,
                        "ID!"
                    ],
                    "valuationAt": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "findPendingBalancesForSupplier": [
                639,
                {
                    "supplierId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "findPeriodEventTransactions": [
                390,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "freightLaneCost": [
                292,
                {
                    "freightLaneCostId": [
                        955,
                        "String!"
                    ],
                    "freightLaneId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "freightLaneCosts": [
                293,
                {
                    "freightLaneCostIds": [
                        955,
                        "[String!]"
                    ],
                    "freightLaneId": [
                        955,
                        "String!"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "freightLaneRoutes": [
                298,
                {
                    "limit": [
                        357
                    ],
                    "locationAId": [
                        955
                    ],
                    "locationBId": [
                        955
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "thirdPartyHaulerId": [
                        955
                    ]
                }
            ],
            "fuelSurcharge": [
                306,
                {
                    "fuelSurchargeId": [
                        955
                    ]
                }
            ],
            "fuelSurcharges": [
                307,
                {
                    "carrierId": [
                        955
                    ],
                    "companyIds": [
                        955,
                        "[String!]"
                    ],
                    "currentOnly": [
                        85
                    ],
                    "date": [
                        194
                    ],
                    "fuelSurchargeId": [
                        955
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "surchargeTypes": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "generateBalanceSheet": [
                66,
                {
                    "date": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "generateCashFlowStatement": [
                89,
                {
                    "date": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "generateIncomeStatement": [
                353,
                {
                    "date": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "generateInventoryReport": [
                955,
                {
                    "endDate": [
                        194
                    ],
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "reportType": [
                        422,
                        "InventoryReportType!"
                    ],
                    "startDate": [
                        194
                    ]
                }
            ],
            "getAccount": [
                2,
                {
                    "accountId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getAllAssetTypes": [
                52,
                {
                    "excludeTemporary": [
                        85
                    ]
                }
            ],
            "getAllAssets": [
                40,
                {
                    "assetIds": [
                        955,
                        "[String]"
                    ],
                    "assetTypeId": [
                        955
                    ],
                    "centralizedCompanyId": [
                        955
                    ],
                    "excludeTemporary": [
                        85
                    ],
                    "includeOutOfService": [
                        85
                    ],
                    "locationId": [
                        955
                    ],
                    "role": [
                        174
                    ],
                    "statuses": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "getAllCompanies": [
                130,
                {
                    "accountManagerIds": [
                        955,
                        "[String!]"
                    ],
                    "companyIds": [
                        955,
                        "[String!]"
                    ],
                    "companyTypes": [
                        955,
                        "[String!]"
                    ],
                    "groupId": [
                        955
                    ],
                    "hasAssets": [
                        85
                    ],
                    "hasDetentions": [
                        85
                    ],
                    "hasFuelSurcharges": [
                        85
                    ],
                    "hasPendingReceivablePaymentInvoices": [
                        85
                    ],
                    "hasScaleTicketsWithStatus": [
                        909
                    ],
                    "hasSupplierPortalAccess": [
                        85
                    ],
                    "hasSupplierPortalContacts": [
                        85
                    ],
                    "isCustomer": [
                        85
                    ],
                    "isServiceProvider": [
                        85
                    ],
                    "isSupplier": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "role": [
                        174
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "searchTerm": [
                        955
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "getAllContacts": [
                134,
                {
                    "companyId": [
                        955
                    ],
                    "inviteStatus": [
                        955
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "onlyCompany": [
                        85
                    ],
                    "onlyPriceListContact": [
                        85
                    ],
                    "onlyThirdPartyHauler": [
                        85
                    ],
                    "thirdPartyHaulerId": [
                        955
                    ]
                }
            ],
            "getAllDrivers": [
                223,
                {
                    "includeHaulerDrivers": [
                        85
                    ],
                    "isAssignableToJobs": [
                        85
                    ]
                }
            ],
            "getAllEquipmentChecklistCreatorUsers": [
                1038
            ],
            "getAllFacilitiesForCentralizedCompanyId": [
                526
            ],
            "getAllGroups": [
                338,
                {
                    "includeGroupsFromFacilities": [
                        85
                    ]
                }
            ],
            "getAllLocations": [
                524,
                {
                    "companyId": [
                        955
                    ],
                    "hasAssets": [
                        85
                    ],
                    "isSalesOrderDropoff": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "locatableType": [
                        955
                    ],
                    "role": [
                        174
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "state": [
                        955
                    ],
                    "withCoordinates": [
                        85
                    ]
                }
            ],
            "getAllMaterials": [
                536
            ],
            "getAllNotifications": [
                574
            ],
            "getAllPublicSuppliers": [
                757,
                {
                    "searchTerm": [
                        955
                    ]
                }
            ],
            "getAllTareTypes": [
                976
            ],
            "getAllTransportationTypes": [
                1017,
                {
                    "type": [
                        955
                    ]
                }
            ],
            "getAllTruckModels": [
                1024
            ],
            "getAllTrucks": [
                1021,
                {
                    "compatibleWithJobId": [
                        955
                    ],
                    "status": [
                        955
                    ]
                }
            ],
            "getAllUserPolicies": [
                1040,
                {
                    "userId": [
                        955
                    ]
                }
            ],
            "getAllUsers": [
                1037
            ],
            "getAssetType": [
                52,
                {
                    "assetTypeId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getAssetTypeUtilization": [
                52
            ],
            "getAssetsForStiching": [
                40,
                {
                    "assetIds": [
                        49,
                        "[AssetId!]!"
                    ]
                }
            ],
            "getAtmPaymentsThatRequireConfirmationToBeVoided": [
                632,
                {
                    "getAtmPaymentsThatRequireConfirmationToBeVoidedInput": [
                        1139,
                        "getAtmPaymentsThatRequireConfirmationToBeVoidedInput!"
                    ]
                }
            ],
            "getBillingInfo": [
                71
            ],
            "getBookingLoadsPhotosZipFile": [
                955,
                {
                    "includeLoadPhotos": [
                        85
                    ],
                    "includeMaterialPhotos": [
                        85
                    ],
                    "loadIds": [
                        345,
                        "[ID!]!"
                    ]
                }
            ],
            "getCatalyticConvertersByIds": [
                92,
                {
                    "catalyticConverterIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "getCentralizedCompanyOptions": [
                583
            ],
            "getCommercialSupplierById": [
                129,
                {
                    "commercialSupplierId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getCompaniesByIds": [
                130,
                {
                    "companyIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "getCompany": [
                130,
                {
                    "companyId": [
                        955
                    ],
                    "role": [
                        174
                    ]
                }
            ],
            "getCompanyIdentityProviderStatus": [
                85
            ],
            "getDriversRequiringConfirmationBeforeDeletion": [
                223,
                {
                    "driverIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "getEmail": [
                226,
                {
                    "emailId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getFacilitySettings": [
                270
            ],
            "getFreightForwarders": [
                289
            ],
            "getFreightLane": [
                291,
                {
                    "freightLaneId": [
                        955
                    ]
                }
            ],
            "getFreightLines": [
                301
            ],
            "getGroup": [
                338,
                {
                    "groupId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getGroupSettings": [
                341,
                {
                    "groupId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getHistoricalAssetTypeUtilizationRates": [
                343
            ],
            "getInboundJobs": [
                447,
                {
                    "driverCompletedJobsOnly": [
                        85
                    ],
                    "isPartOfCreateScaleTicketFlow": [
                        85
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ]
                }
            ],
            "getLastFinishedDriverJob": [
                447
            ],
            "getLastPurchaseForScaleTicketMaterial": [
                892,
                {
                    "facilityLocationId": [
                        955,
                        "String!"
                    ],
                    "materialId": [
                        955,
                        "String!"
                    ],
                    "productDescriptionId": [
                        955
                    ],
                    "supplierId": [
                        955
                    ]
                }
            ],
            "getLoadPhotosZipFile": [
                955,
                {
                    "id": [
                        345,
                        "ID!"
                    ],
                    "includeLoadPhotos": [
                        85
                    ],
                    "includeMaterialPhotos": [
                        85
                    ]
                }
            ],
            "getLocation": [
                524,
                {
                    "excludeOutOfService": [
                        85
                    ],
                    "locationId": [
                        955,
                        "String!"
                    ],
                    "role": [
                        174
                    ]
                }
            ],
            "getLocationAddressByCoordinates": [
                525,
                {
                    "latitude": [
                        286,
                        "Float!"
                    ],
                    "longitude": [
                        286,
                        "Float!"
                    ]
                }
            ],
            "getLocationCountry": [
                955
            ],
            "getLocationsByIds": [
                524,
                {
                    "locationIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "getMaterialGroupsByIds": [
                541,
                {
                    "materialGroupIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "getMaterialPurchases": [
                892
            ],
            "getMaterialsByIds": [
                536,
                {
                    "materialIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "getMaterialsForMassScaleTicketMaterialRevise": [
                550,
                {
                    "companyId": [
                        955
                    ],
                    "publicSupplierId": [
                        955
                    ],
                    "transactionDatePeriod": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "getMonthlyTurnoverRate": [
                286
            ],
            "getNextPaymentCheckNumber": [
                572,
                {
                    "facilityId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getPaymentAddress": [
                524,
                {
                    "companyId": [
                        955
                    ]
                }
            ],
            "getPaymentSettings": [
                625
            ],
            "getPorts": [
                675,
                {
                    "portTypes": [
                        677,
                        "[PortType!]!"
                    ]
                }
            ],
            "getPresignedURL": [
                687
            ],
            "getPresignedURLForKey": [
                687,
                {
                    "options": [
                        1140
                    ],
                    "s3Key": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getPresignedURLsForKeys": [
                687,
                {
                    "keysAndOptions": [
                        507,
                        "[KeyAndOptions!]!"
                    ]
                }
            ],
            "getProcessExecutionOutcome": [
                409,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getPublicSupplier": [
                757,
                {
                    "paranoid": [
                        85
                    ],
                    "publicSupplierId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getPublicSupplierById": [
                757,
                {
                    "publicSupplierId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getPublicSuppliersByIds": [
                757,
                {
                    "publicSupplierIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "getPurchase": [
                763,
                {
                    "purchaseId": [
                        768,
                        "PurchaseId!"
                    ]
                }
            ],
            "getPurchasesDeductionType": [
                794,
                {
                    "deductionTypeId": [
                        208,
                        "DeductionTypeId!"
                    ]
                }
            ],
            "getPurchasesDeductionTypes": [
                794
            ],
            "getReadonlyFacilitySettings": [
                798,
                {
                    "primaryGroupId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getRecentlyUsedMaterials": [
                538,
                {
                    "facilityLocationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getRevenue": [
                286
            ],
            "getSalesOrderLoadMaterials": [
                856,
                {
                    "materialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getSalesOrderLoadReceivingTicketFromOST": [
                859,
                {
                    "outboundScaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getScaleTicket": [
                877,
                {
                    "asSupplier": [
                        85
                    ],
                    "scaleTicketId": [
                        955
                    ]
                }
            ],
            "getScaleTicketByPurchaseID": [
                877,
                {
                    "purchaseId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getScaleTicketMaterialPhotoThumbnail": [
                847,
                {
                    "scaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getScaleTicketMaterials": [
                892,
                {
                    "materialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getScaleTicketPhotosZipFile": [
                955,
                {
                    "scaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getScaleTickets": [
                877,
                {
                    "status": [
                        955
                    ]
                }
            ],
            "getShippingCarrier": [
                944,
                {
                    "shippingCarrierId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getShippingCarriers": [
                82
            ],
            "getSsoConfiguration": [
                952
            ],
            "getThirdPartyHauler": [
                1004,
                {
                    "thirdPartyHaulerId": [
                        955
                    ]
                }
            ],
            "getTotalBinUtilizationRate": [
                286
            ],
            "getTrailer": [
                1009,
                {
                    "trailerId": [
                        955
                    ]
                }
            ],
            "getTransportationType": [
                1017,
                {
                    "transportationTypeId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getTruck": [
                1021,
                {
                    "truckId": [
                        955
                    ]
                }
            ],
            "getTruckJobHistory": [
                447,
                {
                    "truckId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getTruckModel": [
                1024,
                {
                    "truckModelId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "getUnseenNotificationCount": [
                357
            ],
            "getUser": [
                1037,
                {
                    "email": [
                        955
                    ],
                    "userId": [
                        955
                    ],
                    "userSub": [
                        955
                    ]
                }
            ],
            "getUserPolicy": [
                1040,
                {
                    "userPolicyId": [
                        955
                    ]
                }
            ],
            "getUserSettings": [
                1049
            ],
            "getUsersByIds": [
                1037,
                {
                    "userIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "governmentReportingBatch": [
                315,
                {
                    "governmentReportingBatchId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "governmentReportingBatches": [
                316,
                {
                    "batchStatus": [
                        318,
                        "[GovernmentReportingBatchStatus!]"
                    ],
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "governmentReportingBatchIds": [
                        955,
                        "[String!]"
                    ],
                    "governmentReportingConfigurationId": [
                        955
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "governmentReportingConfiguration": [
                319,
                {
                    "governmentReportingConfigurationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "governmentReportingConfigurations": [
                320,
                {
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "governmentReportingConfigurationIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "uploadServices": [
                        324,
                        "[GovernmentReportingService!]"
                    ],
                    "uploadStates": [
                        955,
                        "[String!]"
                    ],
                    "uploadTypes": [
                        336,
                        "[GovernmentReportingUploadType!]"
                    ]
                }
            ],
            "governmentReportingTicket": [
                325,
                {
                    "governmentReportingTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "governmentReportingTickets": [
                326,
                {
                    "governmentReportingBatchId": [
                        955
                    ],
                    "governmentReportingTicketIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        333,
                        "[GovernmentReportingTicketStatus!]"
                    ]
                }
            ],
            "groups": [
                339,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "helpkitArticles": [
                342,
                {
                    "search": [
                        955
                    ]
                }
            ],
            "initialAmounts": [
                20,
                {
                    "accountingEntryIds": [
                        955,
                        "[String!]"
                    ],
                    "date": [
                        194
                    ],
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "idForInitialAmountType": [
                        955
                    ],
                    "initialAmountType": [
                        355
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ]
                }
            ],
            "integrationInvitation": [
                358,
                {
                    "integrationInvitationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "integrationInvitations": [
                359,
                {
                    "direction": [
                        360,
                        "IntegrationInvitationDirection!"
                    ],
                    "hashCode": [
                        955
                    ],
                    "integrationInvitationIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        362,
                        "[IntegrationInvitationStatus!]"
                    ]
                }
            ],
            "inventoryMovements": [
                374,
                {
                    "itemId": [
                        345,
                        "ID!"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "originTransactionTypes": [
                        433,
                        "[InventoryTransactionType!]"
                    ],
                    "statuses": [
                        376,
                        "[InventoryMovementStatus!]"
                    ]
                }
            ],
            "inventoryPeriod": [
                394,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "inventoryPeriodConfigurations": [
                381
            ],
            "inventoryPeriods": [
                386,
                {
                    "endDate": [
                        198
                    ],
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "lastUpdaterIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "search": [
                        955
                    ],
                    "sorter": [
                        648
                    ],
                    "startDate": [
                        198
                    ],
                    "statuses": [
                        649,
                        "[PeriodStatus!]"
                    ]
                }
            ],
            "inventoryProcess": [
                417,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "inventoryProcessExecution": [
                412,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "inventoryProcessExecutions": [
                403,
                {
                    "endDate": [
                        198
                    ],
                    "executorIds": [
                        955,
                        "[String!]"
                    ],
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "inputItemIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "outputItemIds": [
                        955,
                        "[String!]"
                    ],
                    "processIds": [
                        955,
                        "[String!]"
                    ],
                    "search": [
                        955
                    ],
                    "sorter": [
                        726
                    ],
                    "startDate": [
                        198
                    ],
                    "statuses": [
                        727,
                        "[ProcessExecutionStatus!]"
                    ]
                }
            ],
            "inventoryProcesses": [
                398,
                {
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "inputItemIds": [
                        955,
                        "[String!]"
                    ],
                    "lastExecutorIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "outputItemIds": [
                        955,
                        "[String!]"
                    ],
                    "search": [
                        955
                    ],
                    "sorter": [
                        739
                    ],
                    "statuses": [
                        418,
                        "[InventoryProcessStatus!]"
                    ]
                }
            ],
            "inventoryTag": [
                423,
                {
                    "inventoryTagId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "inventoryTags": [
                425,
                {
                    "createdAt": [
                        194
                    ],
                    "excludeTagsWithQuantity": [
                        85
                    ],
                    "filter": [
                        446
                    ],
                    "inventoryTagIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "locationIds": [
                        955,
                        "[String!]"
                    ],
                    "materialIds": [
                        955,
                        "[String!]"
                    ],
                    "offset": [
                        357
                    ],
                    "productDescriptionIds": [
                        955,
                        "[String!]"
                    ],
                    "salesOrderIds": [
                        955,
                        "[String!]"
                    ],
                    "salesOrderLoadIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        431,
                        "[InventoryTagStatus!]"
                    ],
                    "tagTypes": [
                        432,
                        "[InventoryTagType!]"
                    ]
                }
            ],
            "ipCamera": [
                438,
                {
                    "ipCameraId": [
                        955
                    ]
                }
            ],
            "ipCameras": [
                439,
                {
                    "ipCameraIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "isDriverTransportationCompatibleWithJob": [
                85,
                {
                    "jobId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "isDriverTransportationCompatibleWithJobWithReasons": [
                1016,
                {
                    "jobId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "isTransportationCompatibleWithAssets": [
                85,
                {
                    "assetTypeIds": [
                        955,
                        "[String!]!"
                    ],
                    "facilityId": [
                        955
                    ],
                    "groupId": [
                        955
                    ],
                    "isNonDefaultTruck": [
                        85
                    ],
                    "trailerId": [
                        955
                    ],
                    "truckId": [
                        955
                    ]
                }
            ],
            "job": [
                447,
                {
                    "jobId": [
                        955,
                        "String!"
                    ],
                    "role": [
                        174
                    ]
                }
            ],
            "jobLocation": [
                452,
                {
                    "jobLocationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "jobLocationMaterial": [
                453,
                {
                    "jobLocationMaterialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "jobMetrics": [
                460,
                {
                    "afterDate": [
                        194,
                        "Date!"
                    ],
                    "beforeDate": [
                        194,
                        "Date!"
                    ]
                }
            ],
            "jobPauseReason": [
                465,
                {
                    "jobPauseReasonId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "jobPauseReasons": [
                466,
                {
                    "jobPauseReasonIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "jobSchedules": [
                473,
                {
                    "companyIds": [
                        955,
                        "[String!]"
                    ],
                    "jobScheduleIds": [
                        955,
                        "[String!]"
                    ],
                    "jobTypes": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "role": [
                        174
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "jobTemplate": [
                480,
                {
                    "jobTemplateId": [
                        955
                    ]
                }
            ],
            "jobTemplates": [
                481,
                {
                    "jobTemplateIds": [
                        955,
                        "[String!]"
                    ],
                    "jobTypes": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "jobs": [
                448,
                {
                    "afterDate": [
                        194
                    ],
                    "assetIds": [
                        955,
                        "[String!]"
                    ],
                    "beforeDate": [
                        194
                    ],
                    "companyIds": [
                        955,
                        "[String!]"
                    ],
                    "driverIds": [
                        955,
                        "[String]"
                    ],
                    "extendedStatuses": [
                        955,
                        "[String!]"
                    ],
                    "freightLaneIds": [
                        955,
                        "[String!]"
                    ],
                    "jobIds": [
                        955,
                        "[String!]"
                    ],
                    "jobTypes": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "loadBoardAssignableTypes": [
                        955,
                        "[String!]"
                    ],
                    "locationIds": [
                        955,
                        "[String!]"
                    ],
                    "lookForIntersectionWithScheduledAndDeadlineDate": [
                        85
                    ],
                    "lookForJobsWithDriverAssigned": [
                        85
                    ],
                    "offset": [
                        357
                    ],
                    "onlyRequestedJobs": [
                        85
                    ],
                    "role": [
                        174
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        955,
                        "[String!]"
                    ],
                    "thirdPartyHaulerIds": [
                        955,
                        "[String]"
                    ],
                    "timePeriod": [
                        955
                    ],
                    "trailerIds": [
                        955,
                        "[String!]"
                    ],
                    "truckIds": [
                        955,
                        "[String!]"
                    ],
                    "useExtendedDateForUnassigned": [
                        85
                    ]
                }
            ],
            "jobsExport": [
                955,
                {
                    "afterDate": [
                        194
                    ],
                    "assetIds": [
                        955,
                        "[String!]"
                    ],
                    "beforeDate": [
                        194
                    ],
                    "companyIds": [
                        955,
                        "[String!]"
                    ],
                    "driverIds": [
                        955,
                        "[String]"
                    ],
                    "extendedStatuses": [
                        955,
                        "[String!]"
                    ],
                    "freightLaneIds": [
                        955,
                        "[String!]"
                    ],
                    "jobIds": [
                        955,
                        "[String!]"
                    ],
                    "jobTypes": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "loadBoardAssignableTypes": [
                        955,
                        "[String!]"
                    ],
                    "locationIds": [
                        955,
                        "[String!]"
                    ],
                    "offset": [
                        357
                    ],
                    "role": [
                        174
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        955,
                        "[String!]"
                    ],
                    "thirdPartyHaulerIds": [
                        955,
                        "[String]"
                    ],
                    "timePeriod": [
                        955
                    ],
                    "trailerIds": [
                        955,
                        "[String!]"
                    ],
                    "truckIds": [
                        955,
                        "[String!]"
                    ],
                    "useExtendedDateForUnassigned": [
                        85
                    ]
                }
            ],
            "journalEntries": [
                496,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ]
                }
            ],
            "journalEntry": [
                495,
                {
                    "journalEntryId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "journalEntryImpactSummary": [
                498,
                {
                    "journalEntryId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "journalEntryLines": [
                500,
                {
                    "journalEntryId": [
                        955,
                        "String!"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ]
                }
            ],
            "kansasScrapMetalMaterialTypes": [
                504
            ],
            "kansasScrapMetalVehicleMakes": [
                505
            ],
            "kansasScrapMetalVehicleModels": [
                506,
                {
                    "vehicleMakeId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "latestAppData": [
                509
            ],
            "lead": [
                510,
                {
                    "leadId": [
                        955
                    ]
                }
            ],
            "leads": [
                511,
                {
                    "isCustomer": [
                        85
                    ],
                    "isServiceProvider": [
                        85
                    ],
                    "isSupplier": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "ledgerEntries": [
                516,
                {
                    "accountId": [
                        955,
                        "String!"
                    ],
                    "afterDate": [
                        198
                    ],
                    "beforeDate": [
                        198
                    ],
                    "period": [
                        955,
                        "String!"
                    ]
                }
            ],
            "ledgerEntriesBeforeDateByAccount": [
                515,
                {
                    "date": [
                        198,
                        "DateTime!"
                    ]
                }
            ],
            "listPlaidConnections": [
                673
            ],
            "load": [
                518,
                {
                    "id": [
                        345,
                        "ID!"
                    ]
                }
            ],
            "loads": [
                520,
                {
                    "bookingIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchTerm": [
                        955
                    ],
                    "sort": [
                        955
                    ]
                }
            ],
            "location": [
                524,
                {
                    "excludeOutOfService": [
                        85
                    ],
                    "locationId": [
                        955,
                        "String!"
                    ],
                    "role": [
                        174
                    ]
                }
            ],
            "locations": [
                526,
                {
                    "companyIds": [
                        955,
                        "[String!]"
                    ],
                    "groupIds": [
                        955,
                        "[String!]"
                    ],
                    "hasAssets": [
                        85
                    ],
                    "hasCrvActive": [
                        85
                    ],
                    "isSalesOrderDropoff": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "locatableTypes": [
                        955,
                        "[String!]"
                    ],
                    "locationIds": [
                        955,
                        "[String!]"
                    ],
                    "offset": [
                        357
                    ],
                    "publicSupplierIds": [
                        955,
                        "[String!]"
                    ],
                    "role": [
                        174
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "state": [
                        955
                    ],
                    "thirdPartyHaulerIds": [
                        955,
                        "[String!]"
                    ],
                    "withCoordinates": [
                        85
                    ]
                }
            ],
            "material": [
                536,
                {
                    "materialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "materialGroup": [
                541,
                {
                    "materialGroupId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "materialGroupInventoryByLocation": [
                544,
                {
                    "materialGroupId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "materialGroups": [
                542,
                {
                    "catalyticConverter": [
                        85
                    ],
                    "defaultPricingUnitGroups": [
                        535,
                        "[MassUnitGroup!]"
                    ],
                    "excludeEmptyFgInventory": [
                        85
                    ],
                    "excludeEmptyFgTagQuantity": [
                        85
                    ],
                    "excludeEmptyInventory": [
                        85
                    ],
                    "excludeEmptyWipInventory": [
                        85
                    ],
                    "excludeEmptyWipTagInventory": [
                        85
                    ],
                    "excludeEmptyWipTagQuantity": [
                        85
                    ],
                    "includeCrvGroups": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "materialGroupIds": [
                        955,
                        "[String!]"
                    ],
                    "materialGroupTypes": [
                        559,
                        "[MaterialType!]"
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "materialGroupsByIds": [
                541,
                {
                    "materialGroupIds": [
                        955,
                        "[String!]!"
                    ]
                }
            ],
            "materialInventoryExport": [
                955,
                {
                    "massUnit": [
                        534,
                        "MassUnit!"
                    ],
                    "materialGroupIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "materialLocation": [
                551,
                {
                    "locationId": [
                        955,
                        "String!"
                    ],
                    "materialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "materialLocations": [
                551,
                {
                    "locationId": [
                        955
                    ],
                    "materialId": [
                        955
                    ]
                }
            ],
            "materialPurchases": [
                553,
                {
                    "endDate": [
                        194
                    ],
                    "facilityId": [
                        955
                    ],
                    "materialGroupType": [
                        955
                    ],
                    "startDate": [
                        194
                    ]
                }
            ],
            "materialPurchasesTotal": [
                554,
                {
                    "endDate": [
                        194
                    ],
                    "facilityId": [
                        955
                    ],
                    "materialGroupType": [
                        955
                    ],
                    "startDate": [
                        194
                    ]
                }
            ],
            "materialTransactions": [
                556,
                {
                    "endDate": [
                        194
                    ],
                    "facilityLocationIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "materialIds": [
                        955,
                        "[String!]!"
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "startDate": [
                        194
                    ],
                    "transactionType": [
                        558,
                        "[MaterialTransactionType!]"
                    ]
                }
            ],
            "materials": [
                538,
                {
                    "defaultPricingUnitGroups": [
                        535,
                        "[MassUnitGroup!]"
                    ],
                    "includeCrvMaterials": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "materialGroupIds": [
                        955,
                        "[String!]"
                    ],
                    "materialGroupTypes": [
                        559,
                        "[MaterialType!]"
                    ],
                    "materialIds": [
                        955,
                        "[String!]"
                    ],
                    "offset": [
                        357
                    ],
                    "purchaseOrderIds": [
                        955,
                        "[String!]"
                    ],
                    "salesOrderIds": [
                        955,
                        "[String!]"
                    ],
                    "salesOrderLoadIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "metricsWithDateAndStatusAndType": [
                562,
                {
                    "endDate": [
                        194,
                        "Date!"
                    ],
                    "startDate": [
                        194,
                        "Date!"
                    ],
                    "types": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "monetaryValuePurchases": [
                568,
                {
                    "endDate": [
                        194
                    ],
                    "facilityId": [
                        955
                    ],
                    "startDate": [
                        194
                    ],
                    "timePeriod": [
                        955
                    ]
                }
            ],
            "openFinishedPurchases": [
                581,
                {
                    "endDate": [
                        194
                    ],
                    "facilityId": [
                        955
                    ],
                    "startDate": [
                        194
                    ],
                    "timePeriod": [
                        955
                    ]
                }
            ],
            "outboundScaleTicket": [
                584,
                {
                    "outboundScaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "outboundScaleTicketForOstDocuments": [
                584,
                {
                    "outboundScaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "outboundScaleTicketForReconcileLoad": [
                584,
                {
                    "outboundScaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "outboundScaleTicketFreight": [
                596,
                {
                    "outboundScaleTicketFreightId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "outboundScaleTicketMaterial": [
                600,
                {
                    "outboundScaleTicketMaterialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "outboundScaleTickets": [
                588,
                {
                    "afterDate": [
                        194
                    ],
                    "beforeDate": [
                        194
                    ],
                    "bookingIds": [
                        955,
                        "[String]"
                    ],
                    "companyIds": [
                        955,
                        "[String!]"
                    ],
                    "companyLocationIds": [
                        955,
                        "[String!]"
                    ],
                    "customerTypes": [
                        187,
                        "[CustomerType!]"
                    ],
                    "facilityLocationIds": [
                        955,
                        "[String!]"
                    ],
                    "filter": [
                        446
                    ],
                    "inboundScaleTicketIds": [
                        955,
                        "[String]"
                    ],
                    "isNotInteryardTransfer": [
                        85
                    ],
                    "isSalesTransaction": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "materialId": [
                        955
                    ],
                    "offset": [
                        357
                    ],
                    "outboundScaleTicketIds": [
                        955,
                        "[String!]"
                    ],
                    "receivedOSTTransactionOrExpectedShipDateDate": [
                        194
                    ],
                    "receivingFacilityLocationIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        606,
                        "[OutboundScaleTicketStatus!]"
                    ]
                }
            ],
            "payableNotes": [
                609,
                {
                    "excludeArchived": [
                        85
                    ],
                    "isFreightBill": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "outboundScaleTicketIdsAssociatedToFreightBills": [
                        955,
                        "[String!]"
                    ],
                    "ownedByCentralizedCompanyId": [
                        85
                    ],
                    "payableNoteIds": [
                        955,
                        "[String!]"
                    ],
                    "paymentTransactionId": [
                        955
                    ],
                    "scaleTicketId": [
                        955,
                        "[String!]"
                    ],
                    "scaleTicketIdsAssociatedToFreightBills": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "status": [
                        611
                    ],
                    "statuses": [
                        611,
                        "[PayableNoteStatus!]"
                    ],
                    "supplierId": [
                        955
                    ],
                    "supplierIds": [
                        955,
                        "[String]"
                    ],
                    "type": [
                        613
                    ]
                }
            ],
            "paymentTerm": [
                627,
                {
                    "paymentTermId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "paymentTerms": [
                628,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "paymentTermIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "paymentTransaction": [
                632,
                {
                    "paymentTransactionId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "paymentTransactions": [
                633,
                {
                    "afterDate": [
                        194
                    ],
                    "beforeDate": [
                        194
                    ],
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "paymentTransactionIds": [
                        955,
                        "[String!]"
                    ],
                    "paymentTransactionTypes": [
                        636,
                        "[PaymentTransactionType!]"
                    ],
                    "paymentTypes": [
                        618,
                        "[PayablePaymentType!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        635,
                        "[PaymentTransactionStatus!]"
                    ],
                    "supplierIds": [
                        955,
                        "[String!]"
                    ],
                    "supplierTypes": [
                        968,
                        "[SupplierType!]"
                    ]
                }
            ],
            "physicalCountJournal": [
                656,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "physicalCountJournals": [
                653,
                {
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "lastUpdaterIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "search": [
                        955
                    ],
                    "sorter": [
                        658
                    ],
                    "statuses": [
                        659,
                        "[PhysicalCountJournalStatus!]"
                    ],
                    "type": [
                        661
                    ]
                }
            ],
            "physicalCountTaggedEntries": [
                662,
                {
                    "itemIds": [
                        955,
                        "[String!]"
                    ],
                    "journalId": [
                        955,
                        "String!"
                    ],
                    "userIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "physicalCountUntaggedEntries": [
                667,
                {
                    "itemIds": [
                        955,
                        "[String!]"
                    ],
                    "journalId": [
                        955,
                        "String!"
                    ],
                    "userIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "port": [
                674,
                {
                    "portId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "positivePayFile": [
                679,
                {
                    "definition": [
                        1190,
                        "positivePayFileInput!"
                    ]
                }
            ],
            "positivePayTemplate": [
                681,
                {
                    "positivePayTemplateId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "positivePayTemplates": [
                682,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "positivePayTemplateIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "presignedURL": [
                687,
                {
                    "bucket": [
                        955
                    ],
                    "options": [
                        1140
                    ],
                    "s3Key": [
                        955,
                        "String!"
                    ]
                }
            ],
            "previewProcessExecutionOutcome": [
                409,
                {
                    "input": [
                        260,
                        "ExecuteProcessInput!"
                    ]
                }
            ],
            "priceList": [
                688,
                {
                    "priceListId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "priceListGroup": [
                691,
                {
                    "priceListGroupId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "priceListGroups": [
                692,
                {
                    "limit": [
                        357
                    ],
                    "memberIds": [
                        955,
                        "[String!]"
                    ],
                    "offset": [
                        357
                    ],
                    "priceListGroupIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "showDefault": [
                        85
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "type": [
                        695,
                        "[PriceListGroupType!]"
                    ]
                }
            ],
            "priceListMaterial": [
                697,
                {
                    "priceListMaterialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "priceListMaterials": [
                698,
                {
                    "date": [
                        194
                    ],
                    "facilityId": [
                        955
                    ],
                    "isDefault": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "materialId": [
                        955
                    ],
                    "memberId": [
                        955
                    ],
                    "memberType": [
                        695
                    ],
                    "offset": [
                        357
                    ],
                    "priceListMaterialIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "priceLists": [
                689,
                {
                    "active": [
                        85
                    ],
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "isDraft": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "priceListGroupIds": [
                        955,
                        "[String!]"
                    ],
                    "priceListIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "showDefault": [
                        85
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "pricingVariable": [
                708,
                {
                    "id": [
                        1054,
                        "VariableId!"
                    ]
                }
            ],
            "pricingVariables": [
                708
            ],
            "process": [
                711,
                {
                    "processId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "processExecution": [
                717,
                {
                    "processExecutionId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "processExecutions": [
                718,
                {
                    "facilityId": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "processExecutionIds": [
                        955,
                        "[String!]"
                    ],
                    "processId": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "processLineBurden": [
                730,
                {
                    "processLineBurdenId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "processLineBurdens": [
                731,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "processId": [
                        955,
                        "String!"
                    ],
                    "processLineBurdenIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "processMapping": [
                734,
                {
                    "processMappingId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "processMappings": [
                735,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "processId": [
                        955,
                        "String!"
                    ],
                    "processMappingIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "processes": [
                712,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "processIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "status": [
                        740
                    ]
                }
            ],
            "productDescriptions": [
                743,
                {
                    "limit": [
                        357
                    ],
                    "materialIds": [
                        955,
                        "[String!]"
                    ],
                    "offset": [
                        357
                    ],
                    "productDescriptionIds": [
                        955,
                        "[String!]"
                    ],
                    "salesOrderLoadId": [
                        955
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "productPrice": [
                748,
                {
                    "counterpartyId": [
                        147,
                        "CounterpartyId!"
                    ],
                    "currency": [
                        702,
                        "PricingCurrency!"
                    ],
                    "facilityId": [
                        268,
                        "FacilityId!"
                    ],
                    "operationType": [
                        582,
                        "OperationType!"
                    ],
                    "product": [
                        705,
                        "PricingProductInput!"
                    ]
                }
            ],
            "productPriceConfiguration": [
                749,
                {
                    "currency": [
                        702,
                        "PricingCurrency!"
                    ],
                    "facilityId": [
                        268,
                        "FacilityId!"
                    ],
                    "operationType": [
                        582,
                        "OperationType!"
                    ],
                    "product": [
                        705,
                        "PricingProductInput!"
                    ]
                }
            ],
            "productPriceHistory": [
                751,
                {
                    "facilityId": [
                        268,
                        "FacilityId!"
                    ],
                    "supplierId": [
                        962,
                        "SupplierId!"
                    ],
                    "supplierType": [
                        968,
                        "SupplierType!"
                    ]
                }
            ],
            "publicSupplier": [
                757,
                {
                    "publicSupplierId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "publicSuppliers": [
                758,
                {
                    "afterDate": [
                        194
                    ],
                    "hasScaleTicketsWithStatus": [
                        909
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "paranoid": [
                        85
                    ],
                    "publicSupplierIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "puertoRicoPoliceFormConfiguration": [
                760,
                {
                    "puertoRicoPoliceFormConfigurationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "puertoRicoPoliceFormConfigurations": [
                761,
                {
                    "facilityLocationId": [
                        955
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "puertoRicoPoliceFormConfigurationIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "purchaseOrder": [
                776,
                {
                    "purchaseOrderId": [
                        955
                    ]
                }
            ],
            "purchaseOrderMaterial": [
                779,
                {
                    "purchaseOrderMaterialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "purchaseOrderMaterials": [
                780,
                {
                    "facilityId": [
                        955
                    ],
                    "limit": [
                        357
                    ],
                    "materialId": [
                        955
                    ],
                    "offset": [
                        357
                    ],
                    "productDescriptionId": [
                        955
                    ],
                    "purchaseOrderId": [
                        955
                    ],
                    "purchaseOrderMaterialIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "supplierId": [
                        955
                    ]
                }
            ],
            "purchaseOrders": [
                777,
                {
                    "companyIds": [
                        955,
                        "[String!]"
                    ],
                    "facilityLocationIds": [
                        955,
                        "[String!]"
                    ],
                    "isNotExpired": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "locationIds": [
                        955,
                        "[String!]"
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "purchases": [
                764,
                {
                    "activeTasks": [
                        790,
                        "[PurchaseTask!]"
                    ],
                    "completedTasks": [
                        790,
                        "[PurchaseTask!]"
                    ],
                    "facilityId": [
                        955
                    ],
                    "limit": [
                        357,
                        "Int!"
                    ],
                    "offset": [
                        357
                    ],
                    "ownership": [
                        784
                    ],
                    "searchTerm": [
                        955
                    ],
                    "status": [
                        788,
                        "[PurchaseSimplifiedStatus!]"
                    ]
                }
            ],
            "queryCustomField": [
                797,
                {
                    "id": [
                        955,
                        "String!"
                    ]
                }
            ],
            "queryCustomFields": [
                797,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ]
                }
            ],
            "receivableAccounts": [
                800,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "receivableAccountIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "receivableInvoice": [
                802,
                {
                    "receivableInvoiceId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "receivableInvoices": [
                803,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "readyToReceivePayment": [
                        85
                    ],
                    "receivableAccountIds": [
                        955,
                        "[String!]"
                    ],
                    "receivableInvoiceIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "status": [
                        805
                    ]
                }
            ],
            "receivedOutboundScaleTicketDeduction": [
                811,
                {
                    "receivedOutboundScaleTicketDeductionId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "receivedOutboundScaleTicketDeductions": [
                812,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "onlyTicketLevelDeduction": [
                        85
                    ],
                    "outboundScaleTicketId": [
                        955
                    ],
                    "receivedOutboundScaleTicketDeductionIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "receivedOutboundScaleTicketFreight": [
                814,
                {
                    "receivedOutboundScaleTicketFreightId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "receivedOutboundScaleTicketFreights": [
                815,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "outboundScaleTicketId": [
                        955
                    ],
                    "receivedOutboundScaleTicketFreightIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "receivedOutboundScaleTicketMaterial": [
                817,
                {
                    "receivedOutboundScaleTicketMaterialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "receivedOutboundScaleTicketMaterials": [
                818,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "outboundScaleTicketMaterialIds": [
                        955,
                        "[String!]"
                    ],
                    "receivedOutboundScaleTicketMaterialIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "report": [
                955,
                {
                    "definition": [
                        1202,
                        "reportInput!"
                    ],
                    "preview": [
                        85
                    ]
                }
            ],
            "reportSchedule": [
                833,
                {
                    "reportScheduleId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "reportSchedules": [
                834,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "reportScheduleIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "reportTemplate": [
                838,
                {
                    "reportTemplateId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "reportTemplateTypeByReportId": [
                446,
                {
                    "reportId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "reportTemplateTypePeriod": [
                831,
                {
                    "reportId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "reportTemplateTypes": [
                446
            ],
            "reportTemplates": [
                839,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "reportId": [
                        955,
                        "[String!]"
                    ],
                    "reportTemplateIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "salesOrder": [
                850,
                {
                    "salesOrderId": [
                        955
                    ]
                }
            ],
            "salesOrderLoad": [
                853,
                {
                    "salesOrderLoadId": [
                        955
                    ]
                }
            ],
            "salesOrderLoadMaterial": [
                856,
                {
                    "salesOrderLoadMaterialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "salesOrderLoadReceivingTicket": [
                859,
                {
                    "salesOrderLoadReceivingTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "salesOrderLoads": [
                854,
                {
                    "companyIds": [
                        955,
                        "[String!]"
                    ],
                    "createdAt": [
                        194
                    ],
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "locationIds": [
                        955,
                        "[String!]"
                    ],
                    "offset": [
                        357
                    ],
                    "salesOrderLoadIds": [
                        955,
                        "[String]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "shippingStatus": [
                        866,
                        "[SalesOrderShippingStatus!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        862,
                        "[SalesOrderLoadStatus!]"
                    ]
                }
            ],
            "salesOrderMaterial": [
                863,
                {
                    "salesOrderMaterialId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "salesOrderMaterials": [
                864,
                {
                    "customerId": [
                        955
                    ],
                    "facilityId": [
                        955
                    ],
                    "limit": [
                        357
                    ],
                    "materialId": [
                        955
                    ],
                    "offset": [
                        357
                    ],
                    "productDescriptionId": [
                        955
                    ],
                    "salesOrderId": [
                        955
                    ],
                    "salesOrderMaterialIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "salesOrders": [
                851,
                {
                    "companyIds": [
                        955,
                        "[String!]"
                    ],
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "hasNotExpired": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "locationIds": [
                        955,
                        "[String!]"
                    ],
                    "materialIds": [
                        955,
                        "[String!]"
                    ],
                    "offset": [
                        357
                    ],
                    "salesOrderIds": [
                        955,
                        "[String]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "shippingStatus": [
                        866,
                        "[SalesOrderShippingStatus!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        867,
                        "[SalesOrderStatus!]"
                    ],
                    "withWeightOwed": [
                        85
                    ]
                }
            ],
            "scale": [
                871,
                {
                    "scaleId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "scaleTicket": [
                877,
                {
                    "asSupplier": [
                        85
                    ],
                    "scaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "scaleTicketDeductions": [
                885,
                {
                    "asSupplier": [
                        85
                    ],
                    "filter": [
                        446
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "scaleTicketFreight": [
                890,
                {
                    "scaleTicketFreightId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "scaleTicketMaterial": [
                892,
                {
                    "scaleTicketMaterialId": [
                        955
                    ]
                }
            ],
            "scaleTicketMaterials": [
                893,
                {
                    "asSupplier": [
                        85
                    ],
                    "filter": [
                        1216
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "scaleTicketSuppliers": [
                911,
                {
                    "accountManagerIds": [
                        955,
                        "[String!]"
                    ],
                    "hasPendingCurrentPayableNotes": [
                        85
                    ],
                    "hasPendingFuturePayableNotes": [
                        85
                    ],
                    "hasPendingPayableNotes": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "scaleTicketSupplierIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "supplierIds": [
                        955,
                        "[String!]"
                    ],
                    "supplierTypes": [
                        968,
                        "[SupplierType!]"
                    ]
                }
            ],
            "scaleTicketVehicleItem": [
                924,
                {
                    "scaleTicketVehicleItemId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "scaleTickets": [
                883,
                {
                    "accountManagerIds": [
                        955,
                        "[String!]"
                    ],
                    "afterDate": [
                        194
                    ],
                    "beforeDate": [
                        194
                    ],
                    "createdAfter": [
                        194
                    ],
                    "createdBefore": [
                        194
                    ],
                    "facilityLocationIds": [
                        955,
                        "[String!]"
                    ],
                    "filter": [
                        446
                    ],
                    "includeBlankTickets": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "purchaseOrderIds": [
                        955,
                        "[String!]"
                    ],
                    "role": [
                        174
                    ],
                    "scaleTicketIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        955,
                        "[String!]"
                    ],
                    "supplierIds": [
                        955,
                        "[String!]"
                    ],
                    "supplierLocationIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "scaleWeightsUpdated": [
                955,
                {
                    "scaleId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "scales": [
                872,
                {
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "scaleIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "scanningSession": [
                933,
                {
                    "scanningSessionId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "scanningSessions": [
                934,
                {
                    "isOpen": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "shippingCarriers": [
                945,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "sidecarDownloadLink": [
                955
            ],
            "stateNames": [
                1026,
                {
                    "endDate": [
                        194
                    ],
                    "startDate": [
                        194
                    ]
                }
            ],
            "summaryMetrics": [
                961,
                {
                    "endDate": [
                        194,
                        "Date!"
                    ],
                    "startDate": [
                        194,
                        "Date!"
                    ]
                }
            ],
            "supplierPendingTransactions": [
                965,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "tareTypes": [
                977,
                {
                    "filter": [
                        446
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ]
                }
            ],
            "taxRate": [
                980,
                {
                    "taxRateId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "taxRates": [
                982,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "taxRateIds": [
                        955,
                        "[String!]"
                    ],
                    "taxRateType": [
                        955
                    ]
                }
            ],
            "texasCashCard": [
                985,
                {
                    "texasCashCardId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "texasCashCardConfiguration": [
                987,
                {
                    "texasCashCardConfigurationId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "texasCashCardConfigurations": [
                988,
                {
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "texasCashCardConfigurationIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "texasCashCards": [
                990,
                {
                    "applicationTypes": [
                        986,
                        "[TexasCashCardApplicationType!]"
                    ],
                    "facilityIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "publicSupplierIds": [
                        955,
                        "[String!]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "texasCashCardIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "texasOnlineMetalsMaterialCodes": [
                996,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "texasOnlineMetalsMaterialCodeIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "texasOnlineMetalsVehicleCodeMakeModelMappings": [
                1002,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "texasOnlineMetalsVehicleCodeMakeModelMappingIds": [
                        955,
                        "[String!]"
                    ],
                    "vehicleMake": [
                        955
                    ],
                    "vehicleModel": [
                        955
                    ]
                }
            ],
            "texasOnlineMetalsVehicleCodes": [
                999,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "texasOnlineMetalsVehicleCodeIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "thirdPartyHaulers": [
                1005,
                {
                    "groupId": [
                        955
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "thirdPartyHaulerIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "trailers": [
                1010,
                {
                    "compatibleWithJobId": [
                        955
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        955,
                        "[String!]"
                    ],
                    "trailerIds": [
                        955,
                        "[String!]"
                    ],
                    "trailerTypeIds": [
                        955,
                        "[String!]"
                    ],
                    "transportationType": [
                        955
                    ],
                    "truckIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "transportationTypes": [
                1018,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "transportationTypes": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "truckStateDistances": [
                1026,
                {
                    "endDate": [
                        194
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "startDate": [
                        194
                    ],
                    "stateIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "truckStateDistancesDetail": [
                1026,
                {
                    "endDate": [
                        194
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "startDate": [
                        194
                    ],
                    "state": [
                        955,
                        "String!"
                    ]
                }
            ],
            "truckStateDistancesForExport": [
                1026,
                {
                    "endDate": [
                        194
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "startDate": [
                        194
                    ],
                    "stateIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "trucks": [
                1022,
                {
                    "compatibleWithJobId": [
                        955
                    ],
                    "groupId": [
                        955
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "statuses": [
                        955,
                        "[String!]"
                    ],
                    "truckIds": [
                        955,
                        "[String!]"
                    ],
                    "truckTypeIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "unconnectedGPSIdentifiers": [
                312,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression]"
                    ]
                }
            ],
            "user": [
                1037,
                {
                    "email": [
                        955
                    ],
                    "userId": [
                        955
                    ],
                    "userSub": [
                        955
                    ]
                }
            ],
            "userRoleTemplate": [
                1042,
                {
                    "userRoleTemplateId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "userRoleTemplates": [
                1046,
                {
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "userRoleTemplateIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "users": [
                1038,
                {
                    "appVersionStatuses": [
                        39,
                        "[AppVersionStatus!]"
                    ],
                    "currentUserOnly": [
                        85
                    ],
                    "emails": [
                        955,
                        "[String!]"
                    ],
                    "groupIds": [
                        955,
                        "[String!]"
                    ],
                    "limit": [
                        357
                    ],
                    "offset": [
                        357
                    ],
                    "onlyAccountManagers": [
                        85
                    ],
                    "preferredUserId": [
                        955
                    ],
                    "roles": [
                        955,
                        "[String]"
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "userIds": [
                        955,
                        "[String!]"
                    ],
                    "userSubs": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "variable": [
                1051,
                {
                    "variableId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "variables": [
                1052,
                {
                    "includeExpired": [
                        85
                    ],
                    "limit": [
                        357
                    ],
                    "name": [
                        955
                    ],
                    "offset": [
                        357
                    ],
                    "searchExpressions": [
                        940,
                        "[SearchExpression!]"
                    ],
                    "sorters": [
                        951,
                        "[Sorter!]"
                    ],
                    "variableIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "voucherTemplate": [
                1060
            ],
            "warehouseCredential": [
                1063
            ],
            "__typename": [
                955
            ]
        },
        "QueryCustomField": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                198
            ],
            "fieldType": [
                955
            ],
            "id": [
                345
            ],
            "name": [
                955
            ],
            "querySql": [
                955
            ],
            "resultType": [
                955
            ],
            "tableName": [
                955
            ],
            "updatedAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "ReadonlyFacilitySettings": {
            "allowDuplicateObjectNames": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ReceivableAccount": {
            "company": [
                130
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "numberOfPendingInvoices": [
                357
            ],
            "publicSupplier": [
                757
            ],
            "receivableAccountId": [
                955
            ],
            "receivableAccountName": [
                955
            ],
            "totalBalance": [
                286
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ReceivableAccountConnection": {
            "edges": [
                801
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ReceivableAccountEdge": {
            "cursor": [
                955
            ],
            "node": [
                799
            ],
            "__typename": [
                955
            ]
        },
        "ReceivableInvoice": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "defaultCurrency": [
                173
            ],
            "deletedAt": [
                194
            ],
            "dueDate": [
                194
            ],
            "facilityLocationId": [
                955
            ],
            "netWeight": [
                286
            ],
            "outboundScaleTicket": [
                584
            ],
            "outboundScaleTicketId": [
                955
            ],
            "paymentTerm": [
                630
            ],
            "paymentTransactions": [
                632
            ],
            "readyToReceivePayment": [
                85
            ],
            "receivableInvoiceDate": [
                194
            ],
            "receivableInvoiceId": [
                955
            ],
            "receivableInvoiceNotes": [
                955
            ],
            "receivableInvoiceNumber": [
                357
            ],
            "receivableInvoiceType": [
                437
            ],
            "scaleTicket": [
                877
            ],
            "scaleTicketId": [
                955
            ],
            "status": [
                805
            ],
            "totalBalance": [
                286
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ReceivableInvoiceConnection": {
            "edges": [
                804
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ReceivableInvoiceEdge": {
            "cursor": [
                955
            ],
            "node": [
                802
            ],
            "__typename": [
                955
            ]
        },
        "ReceivableInvoiceStatus": {},
        "ReceivablePayment": {
            "checkMemo": [
                955
            ],
            "checkNumber": [
                955
            ],
            "companyLocation": [
                524
            ],
            "companyLocationId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "financialAccount": [
                275
            ],
            "financialAccountId": [
                955
            ],
            "receivableAccount": [
                799
            ],
            "receivableAccountId": [
                955
            ],
            "receivableInvoices": [
                802
            ],
            "receivablePaymentAmount": [
                286
            ],
            "receivablePaymentCurrency": [
                173
            ],
            "receivablePaymentDate": [
                194
            ],
            "receivablePaymentId": [
                955
            ],
            "receivablePaymentType": [
                810
            ],
            "status": [
                809
            ],
            "supplierName": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ReceivablePaymentConnection": {
            "edges": [
                808
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ReceivablePaymentEdge": {
            "cursor": [
                955
            ],
            "node": [
                806
            ],
            "__typename": [
                955
            ]
        },
        "ReceivablePaymentStatus": {},
        "ReceivablePaymentType": {},
        "ReceivedOutboundScaleTicketDeduction": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deductionCategory": [
                200
            ],
            "deductionMethod": [
                203
            ],
            "deductionReason": [
                955
            ],
            "deductionType": [
                205
            ],
            "deductionTypeId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "notes": [
                955
            ],
            "outboundScaleTicket": [
                584
            ],
            "outboundScaleTicketId": [
                955
            ],
            "percentageDeduction": [
                286
            ],
            "priceDeduction": [
                286
            ],
            "receivedOutboundScaleTicketDeductionId": [
                955
            ],
            "receivedOutboundScaleTicketMaterial": [
                817
            ],
            "receivedOutboundScaleTicketMaterialId": [
                955
            ],
            "reversedDeduction": [
                811
            ],
            "reversedDeductionId": [
                955
            ],
            "scale": [
                871
            ],
            "scaleId": [
                955
            ],
            "taxRate": [
                980
            ],
            "taxRateId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "weightDeduction": [
                286
            ],
            "weightDeductionCaptureMethod": [
                1064
            ],
            "__typename": [
                955
            ]
        },
        "ReceivedOutboundScaleTicketDeductionConnection": {
            "edges": [
                813
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ReceivedOutboundScaleTicketDeductionEdge": {
            "cursor": [
                955
            ],
            "node": [
                811
            ],
            "__typename": [
                955
            ]
        },
        "ReceivedOutboundScaleTicketFreight": {
            "carrierName": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "creatorId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "deliveryNumber": [
                955
            ],
            "freightAccrualAmount": [
                286
            ],
            "freightDeductionAmount": [
                286
            ],
            "freightLaneCost": [
                292,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "freightLaneCostId": [
                955
            ],
            "freightTotalAmount": [
                286
            ],
            "notes": [
                955
            ],
            "outboundScaleTicket": [
                584,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "outboundScaleTicketId": [
                955
            ],
            "receivedOutboundScaleTicketFreightId": [
                955
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ReceivedOutboundScaleTicketFreightConnection": {
            "edges": [
                816
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ReceivedOutboundScaleTicketFreightEdge": {
            "cursor": [
                955
            ],
            "node": [
                814
            ],
            "__typename": [
                955
            ]
        },
        "ReceivedOutboundScaleTicketMaterial": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deductions": [
                811
            ],
            "deletedAt": [
                194
            ],
            "grossWeight": [
                286
            ],
            "inventoryTag": [
                423
            ],
            "inventoryTagId": [
                955
            ],
            "material": [
                536
            ],
            "materialId": [
                955
            ],
            "netWeight": [
                286
            ],
            "outboundScaleTicketMaterial": [
                600
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescription": [
                742
            ],
            "productDescriptionId": [
                955
            ],
            "quantity": [
                286
            ],
            "receivedOutboundScaleTicketMaterialId": [
                955
            ],
            "tareWeight": [
                286
            ],
            "totalPrice": [
                286
            ],
            "unitPrice": [
                286
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ReceivedOutboundScaleTicketMaterialConnection": {
            "edges": [
                819
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ReceivedOutboundScaleTicketMaterialEdge": {
            "cursor": [
                955
            ],
            "node": [
                817
            ],
            "__typename": [
                955
            ]
        },
        "RegisteredPrintersInfo": {
            "centralizedCompanyId": [
                955
            ],
            "printers": [
                955
            ],
            "sidecarHostId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ReopenInventoryPeriodInput": {
            "notes": [
                955
            ],
            "periodId": [
                345
            ],
            "__typename": [
                955
            ]
        },
        "ReopenPhysicalCountJournalInput": {
            "id": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ReportAggregateMethod": {},
        "ReportFileType": {},
        "ReportFilterDataType": {},
        "ReportFilterOp": {},
        "ReportFilterSelector": {},
        "ReportId": {},
        "ReportLine": {
            "amount": [
                286
            ],
            "childReportLines": [
                829
            ],
            "parentReportLineId": [
                345
            ],
            "reportLineId": [
                345
            ],
            "title": [
                955
            ],
            "type": [
                830
            ],
            "__typename": [
                955
            ]
        },
        "ReportLineType": {},
        "ReportPeriod": {},
        "ReportQueueReturn": {
            "error": [
                955
            ],
            "messageId": [
                955
            ],
            "success": [
                85
            ],
            "__typename": [
                955
            ]
        },
        "ReportSchedule": {
            "centralizedCompany": [
                96,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "creatorId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "endDate": [
                194
            ],
            "fileType": [
                836
            ],
            "hourToBeRunAt": [
                357
            ],
            "isCustomSchedule": [
                85
            ],
            "monthlyRepeatMode": [
                955
            ],
            "notifiableUsers": [
                1037
            ],
            "repeatFrequency": [
                357
            ],
            "repeatMagnitude": [
                955
            ],
            "repeatedDateOfMonth": [
                357
            ],
            "repeatedDaysOfWeek": [
                357
            ],
            "repeatedWeekOfMonth": [
                357
            ],
            "reportScheduleId": [
                955
            ],
            "reportTemplate": [
                838,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "startDate": [
                194
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ReportScheduleConnection": {
            "edges": [
                835
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ReportScheduleEdge": {
            "cursor": [
                955
            ],
            "node": [
                833
            ],
            "__typename": [
                955
            ]
        },
        "ReportScheduleFileType": {},
        "ReportSorterOrder": {},
        "ReportTemplate": {
            "centralizedCompany": [
                96,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "creatorId": [
                955
            ],
            "definition": [
                446
            ],
            "deletedAt": [
                194
            ],
            "description": [
                955
            ],
            "name": [
                955
            ],
            "privilegedFacilities": [
                524
            ],
            "privilegedGroups": [
                338
            ],
            "relativePeriod": [
                955
            ],
            "reportId": [
                828
            ],
            "reportPeriodColumnName": [
                955
            ],
            "reportTemplateId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ReportTemplateConnection": {
            "edges": [
                840
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ReportTemplateEdge": {
            "cursor": [
                955
            ],
            "node": [
                838
            ],
            "__typename": [
                955
            ]
        },
        "ReportTemplateRelativePeriod": {},
        "ReportTemplateRelativePeriodInput": {
            "relativePeriod": [
                841
            ],
            "reportTemplateId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "RequiresAssetPhoto": {},
        "RequiresJobLocationPhoto": {},
        "RequiresScaleTicketSignature": {},
        "RolledJobsType": {},
        "S3ObjectMetadata": {
            "assetImageType": [
                955
            ],
            "attachableId": [
                955
            ],
            "bucket": [
                955
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "fileType": [
                955
            ],
            "humanReadableFilename": [
                955
            ],
            "inboundOutboundScaleTicketAttachable": [
                350
            ],
            "jobLocationPayloadAction": [
                456
            ],
            "key": [
                955
            ],
            "payloadAction": [
                955
            ],
            "s3Key": [
                955
            ],
            "s3ObjectMetadataId": [
                955
            ],
            "scaleTicketAttachableType": [
                879
            ],
            "updatedAt": [
                194
            ],
            "uploadedBy": [
                955
            ],
            "uploadedByType": [
                955
            ],
            "uri": [
                955
            ],
            "url": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "S3SubDirectories": {},
        "SalesFacility": {
            "centralizedCompanyId": [
                955
            ],
            "groupId": [
                345
            ],
            "id": [
                345
            ],
            "locationName": [
                955
            ],
            "timeZone": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrder": {
            "accountRepresentative": [
                1037
            ],
            "accountRepresentativeId": [
                955
            ],
            "billTo": [
                524
            ],
            "billToLocationId": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "completionNotes": [
                955
            ],
            "contact": [
                134
            ],
            "contactId": [
                955
            ],
            "counterpartyPurchaseOrderNumber": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                955
            ],
            "customer": [
                130,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "customerId": [
                955
            ],
            "customerName": [
                955
            ],
            "defaultPaymentTerm": [
                627
            ],
            "defaultPaymentTermId": [
                955
            ],
            "doNotShip": [
                85
            ],
            "endDate": [
                955
            ],
            "facilityLocation": [
                524
            ],
            "facilityLocationId": [
                955
            ],
            "files": [
                847
            ],
            "freightTerm": [
                303
            ],
            "loadMillOrderNumber": [
                955
            ],
            "location": [
                524
            ],
            "locationId": [
                955
            ],
            "netWeight": [
                286
            ],
            "notes": [
                955
            ],
            "outboundScaleTickets": [
                584
            ],
            "paymentCurrency": [
                173
            ],
            "paymentTerm": [
                630
            ],
            "pdf": [
                847
            ],
            "pdfId": [
                955
            ],
            "quantity": [
                286
            ],
            "quantityOwed": [
                286
            ],
            "salesOrderId": [
                955
            ],
            "salesOrderMaterials": [
                863
            ],
            "salesOrderNumber": [
                357
            ],
            "salesOrderType": [
                868
            ],
            "shippedLoadCount": [
                357
            ],
            "startDate": [
                955
            ],
            "status": [
                867
            ],
            "totalPrice": [
                286
            ],
            "weightOwed": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrderConnection": {
            "edges": [
                852
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrderEdge": {
            "cursor": [
                955
            ],
            "node": [
                850
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrderLoad": {
            "allInventoryTagsAreReserved": [
                85
            ],
            "carrierDriverName": [
                955
            ],
            "carrierScac": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                955
            ],
            "dateShipped": [
                194
            ],
            "expectedShipDate": [
                194
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "frontendUrl": [
                955
            ],
            "lastNonReceivedSalesOrderLoad": [
                85
            ],
            "loadContainerNumber": [
                955
            ],
            "loadDeliveryNumber": [
                955
            ],
            "loadReceivedDate": [
                194
            ],
            "loadReleaseNumber": [
                955
            ],
            "loadSealNumber": [
                955
            ],
            "loadTrailerNumber": [
                955
            ],
            "loadTruckNumber": [
                955
            ],
            "materials": [
                536
            ],
            "numberOfMaterials": [
                357
            ],
            "outboundScaleTicket": [
                584
            ],
            "requestedQuantity": [
                286
            ],
            "requestedWeight": [
                286
            ],
            "salesOrder": [
                850
            ],
            "salesOrderId": [
                955
            ],
            "salesOrderLoadId": [
                955
            ],
            "salesOrderLoadMaterials": [
                856
            ],
            "salesOrderLoadNumber": [
                955
            ],
            "shippedPrice": [
                286
            ],
            "shippedWeight": [
                286
            ],
            "shippingCarrierName": [
                955
            ],
            "status": [
                862
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrderLoadConnection": {
            "edges": [
                855
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrderLoadEdge": {
            "cursor": [
                955
            ],
            "node": [
                853
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrderLoadMaterial": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "grossWeight": [
                286
            ],
            "inventoryTags": [
                423
            ],
            "material": [
                536,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "materialId": [
                955
            ],
            "outboundScaleTicketMaterial": [
                600
            ],
            "productDescription": [
                742
            ],
            "productDescriptionId": [
                955
            ],
            "quantity": [
                286
            ],
            "requestedQuantity": [
                286
            ],
            "requestedWeight": [
                286
            ],
            "salesOrderLoad": [
                853
            ],
            "salesOrderLoadId": [
                955
            ],
            "salesOrderLoadMaterialId": [
                955
            ],
            "salesOrderMaterial": [
                863
            ],
            "salesOrderMaterialId": [
                955
            ],
            "salesOrderMaterialRemainingQuantity": [
                286
            ],
            "salesOrderMaterialRemainingWeight": [
                286
            ],
            "salesOrderMaterialRequestedQuantity": [
                286
            ],
            "salesOrderMaterialRequestedWeight": [
                286
            ],
            "shippedInventoryTagsGrossWeight": [
                286
            ],
            "shippedInventoryTagsTareWeight": [
                286
            ],
            "shippedPrice": [
                286
            ],
            "shippedQuantity": [
                286
            ],
            "shippedWeight": [
                286
            ],
            "shippedWipInventoryQuantity": [
                286
            ],
            "shippedWipInventoryWeight": [
                286
            ],
            "tareWeight": [
                286
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrderLoadMaterialConnection": {
            "edges": [
                858
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrderLoadMaterialEdge": {
            "cursor": [
                955
            ],
            "node": [
                856
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrderLoadReceivingTicket": {
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "externalNotes": [
                955
            ],
            "files": [
                847
            ],
            "internalNotes": [
                955
            ],
            "loadReceivedDate": [
                194
            ],
            "millReceivedWeightPostDate": [
                194
            ],
            "outboundScaleTicket": [
                584
            ],
            "outboundScaleTicketId": [
                955
            ],
            "receivingTicketIssueDate": [
                194
            ],
            "receivingTicketNumber": [
                955
            ],
            "salesOrderLoadReceivingTicketId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrderLoadReceivingTicketConnection": {
            "edges": [
                861
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrderLoadReceivingTicketEdge": {
            "cursor": [
                955
            ],
            "node": [
                859
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrderLoadStatus": {},
        "SalesOrderMaterial": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "material": [
                536,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "materialId": [
                955
            ],
            "netWeight": [
                286
            ],
            "priceList": [
                688
            ],
            "priceListId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescription": [
                742
            ],
            "productDescriptionId": [
                955
            ],
            "quantity": [
                357
            ],
            "quantityOwed": [
                286
            ],
            "remainingWeight": [
                286
            ],
            "salesOrder": [
                850
            ],
            "salesOrderId": [
                955
            ],
            "salesOrderMaterialId": [
                955
            ],
            "totalPrice": [
                286
            ],
            "unitPrice": [
                286
            ],
            "updatedAt": [
                194
            ],
            "weightOwed": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrderMaterialConnection": {
            "edges": [
                865
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrderMaterialConnectionEdge": {
            "cursor": [
                955
            ],
            "node": [
                863
            ],
            "__typename": [
                955
            ]
        },
        "SalesOrderShippingStatus": {},
        "SalesOrderStatus": {},
        "SalesOrderType": {},
        "SalesUser": {
            "firstName": [
                955
            ],
            "id": [
                345
            ],
            "lastName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "SavePhysicalCountJournalAsDraftInput": {
            "facilityId": [
                955
            ],
            "id": [
                955
            ],
            "occurredAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "Scale": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "defaultTareToZero": [
                85
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "ipCameras": [
                438
            ],
            "maxWeight": [
                286
            ],
            "measurementIncrement": [
                286
            ],
            "minWeight": [
                286
            ],
            "scaleId": [
                955
            ],
            "scaleModel": [
                955
            ],
            "scaleName": [
                955
            ],
            "scaleType": [
                928
            ],
            "takePhotoOn": [
                876
            ],
            "unitOfMeasurement": [
                929
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ScaleConnection": {
            "edges": [
                873
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ScaleEdge": {
            "cursor": [
                955
            ],
            "node": [
                871
            ],
            "__typename": [
                955
            ]
        },
        "ScaleGeneralModel": {
            "grossWeight": [
                286
            ],
            "netWeight": [
                286
            ],
            "scaleId": [
                955
            ],
            "scaleModel": [
                955
            ],
            "scaleName": [
                955
            ],
            "tareWeight": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "ScalePaymentBehavior": {},
        "ScaleTakePhotoTrigger": {},
        "ScaleTicket": {
            "activeScale": [
                871
            ],
            "activeScaleId": [
                955
            ],
            "averageGradingConfidence": [
                286
            ],
            "blankTicketInfo": [
                73
            ],
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "closedById": [
                955
            ],
            "closer": [
                1037
            ],
            "company": [
                130
            ],
            "companyId": [
                955
            ],
            "companyLocation": [
                524
            ],
            "completionNotes": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                955
            ],
            "creatorPlatform": [
                162
            ],
            "deductions": [
                884
            ],
            "deletedAt": [
                194
            ],
            "externalNotes": [
                955
            ],
            "facilityLocation": [
                524
            ],
            "facilityLocationId": [
                955
            ],
            "files": [
                847,
                {
                    "scope": [
                        955
                    ]
                }
            ],
            "fingerPrintPhoto": [
                847
            ],
            "grossWeight": [
                286
            ],
            "hasPhotos": [
                85
            ],
            "hasVehicles": [
                85
            ],
            "inboundJob": [
                447
            ],
            "inboundJobId": [
                955
            ],
            "internalNotes": [
                955
            ],
            "isCompliant": [
                85
            ],
            "materials": [
                892
            ],
            "materialsHavePhotos": [
                85
            ],
            "materialsVersion": [
                357
            ],
            "outboundScaleTicket": [
                584
            ],
            "outboundScaleTicketId": [
                955
            ],
            "payableNotes": [
                608
            ],
            "paymentStatus": [
                901
            ],
            "pdf": [
                847
            ],
            "publicSupplier": [
                757
            ],
            "publicSupplierId": [
                955
            ],
            "purchaseOrder": [
                776
            ],
            "purchaseOrderId": [
                955
            ],
            "receipt": [
                955
            ],
            "receivableInvoice": [
                802
            ],
            "reversedScaleTicket": [
                877
            ],
            "revisionNumber": [
                357
            ],
            "scaleTicketFreights": [
                890
            ],
            "scaleTicketId": [
                955
            ],
            "scaleTicketNumber": [
                955
            ],
            "signature": [
                446
            ],
            "signatureAsText": [
                955
            ],
            "status": [
                955
            ],
            "supplierDriver": [
                134
            ],
            "supplierDriverId": [
                955
            ],
            "supplierLocationAddress": [
                955
            ],
            "supplierLocationName": [
                955
            ],
            "supplierName": [
                955
            ],
            "supplierSignature": [
                967
            ],
            "supplierType": [
                955
            ],
            "suppliersHavePhotos": [
                85
            ],
            "tareWeight": [
                286
            ],
            "totalPrice": [
                286
            ],
            "totalQuantity": [
                286
            ],
            "totalWeight": [
                286
            ],
            "trailer": [
                1013
            ],
            "transactionDate": [
                194
            ],
            "updatedAt": [
                194
            ],
            "vehicle": [
                1013
            ],
            "vehicleHeavyWeight": [
                286
            ],
            "vehicleHeavyWeightCaptureMethod": [
                1064
            ],
            "vehicleId": [
                955
            ],
            "vehicleIdentificationNumber": [
                955
            ],
            "vehicleLightWeight": [
                286
            ],
            "vehicleLightWeightCaptureMethod": [
                1064
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketAttachableObjectType": {},
        "ScaleTicketAttachableType": {
            "attachableType": [
                878
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "file": [
                847
            ],
            "fileId": [
                955
            ],
            "scaleTicketAttachableTypeId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketCatalyticConverter": {
            "catalyticConverter": [
                92
            ],
            "catalyticConverterId": [
                955
            ],
            "catalyticConverterSize": [
                95
            ],
            "centralizedCompany": [
                96
            ],
            "converterNotes": [
                955
            ],
            "converterVehicleIdentificationNumber": [
                955
            ],
            "converterVehicleLicensePlate": [
                955
            ],
            "converterVehicleMake": [
                955
            ],
            "converterVehicleModel": [
                955
            ],
            "converterVehicleYear": [
                194
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "files": [
                847
            ],
            "material": [
                536
            ],
            "nominalTotalPrice": [
                286
            ],
            "priceOrigin": [
                701
            ],
            "quantity": [
                286
            ],
            "realTotalPrice": [
                286
            ],
            "realUnitPrice": [
                286
            ],
            "scaleTicketCatalyticConverterId": [
                955
            ],
            "scaleTicketMaterial": [
                892
            ],
            "scaleTicketMaterialId": [
                955
            ],
            "texasOnlineMetalsCCID": [
                955
            ],
            "totalPrice": [
                286
            ],
            "totalPriceDeduction": [
                286
            ],
            "unitPrice": [
                286
            ],
            "updatedAt": [
                194
            ],
            "vehicleTitle": [
                847
            ],
            "vehicleTitleId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketCatalyticConverterConnection": {
            "edges": [
                882
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketCatalyticConverterEdge": {
            "cursor": [
                955
            ],
            "node": [
                880
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketConnection": {
            "edges": [
                889
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketDeduction": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deductionCategory": [
                200
            ],
            "deductionMethod": [
                203
            ],
            "deductionReason": [
                955
            ],
            "deductionType": [
                205
            ],
            "deductionTypeId": [
                955
            ],
            "notes": [
                955
            ],
            "percentageDeduction": [
                286
            ],
            "priceDeduction": [
                286
            ],
            "reversedDeductionId": [
                955
            ],
            "scale": [
                871
            ],
            "scaleId": [
                955
            ],
            "scaleTicket": [
                877
            ],
            "scaleTicketDeductionId": [
                955
            ],
            "scaleTicketId": [
                955
            ],
            "scaleTicketMaterial": [
                892
            ],
            "scaleTicketMaterialId": [
                955
            ],
            "taxRate": [
                980
            ],
            "taxRateId": [
                955
            ],
            "weightDeduction": [
                286
            ],
            "weightDeductionCaptureMethod": [
                1064
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketDeductionConnection": {
            "edges": [
                886
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketDeductionEdge": {
            "cursor": [
                955
            ],
            "node": [
                884
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketDocument": {},
        "ScaleTicketDocuments": {},
        "ScaleTicketEdge": {
            "cursor": [
                955
            ],
            "node": [
                877
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketFreight": {
            "carrierId": [
                955
            ],
            "carrierName": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "creatorId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "deliveryNumber": [
                955
            ],
            "freightAccrualAmount": [
                286
            ],
            "freightDeductionAmount": [
                286
            ],
            "freightLaneCost": [
                292,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "freightLaneCostId": [
                955
            ],
            "freightTotalAmount": [
                286
            ],
            "notes": [
                955
            ],
            "paymentDueDate": [
                955
            ],
            "reversedScaleTicketFreight": [
                890,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "reversedScaleTicketFreightId": [
                955
            ],
            "scaleTicket": [
                877,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "scaleTicketFreightId": [
                955
            ],
            "scaleTicketId": [
                955
            ],
            "shouldCreateFreightBill": [
                85
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketInventoryTag": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "grossWeight": [
                286
            ],
            "grossWeightCaptureMethod": [
                1064
            ],
            "inventoryTag": [
                423
            ],
            "inventoryTagId": [
                955
            ],
            "netWeight": [
                286
            ],
            "nominalNetWeight": [
                286
            ],
            "nominalTotalPrice": [
                286
            ],
            "priceList": [
                688
            ],
            "priceListId": [
                955
            ],
            "priceOrigin": [
                701
            ],
            "pricingUnit": [
                534
            ],
            "purchaseOrder": [
                776
            ],
            "purchaseOrderId": [
                955
            ],
            "purchaseOrderMaterial": [
                779
            ],
            "purchaseOrderMaterialId": [
                955
            ],
            "quantity": [
                286
            ],
            "realNetWeight": [
                286
            ],
            "realTotalPrice": [
                286
            ],
            "realUnitPriceInBaseUnit": [
                286
            ],
            "scaleTicketInventoryTagId": [
                955
            ],
            "scaleTicketMaterial": [
                892
            ],
            "scaleTicketMaterialId": [
                955
            ],
            "tareWeight": [
                286
            ],
            "tareWeightCaptureMethod": [
                1064
            ],
            "totalPrice": [
                286
            ],
            "unitPrice": [
                286
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketMaterial": {
            "asset": [
                40
            ],
            "assetId": [
                955
            ],
            "assets": [
                40
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037
            ],
            "files": [
                847
            ],
            "isTareOnTruck": [
                85
            ],
            "materialsVersion": [
                357
            ],
            "reversedScaleTicketMaterialId": [
                955
            ],
            "scale": [
                871
            ],
            "scaleId": [
                955
            ],
            "scaleTicket": [
                877
            ],
            "scaleTicketCatalyticConverter": [
                880
            ],
            "scaleTicketDeductions": [
                884
            ],
            "scaleTicketId": [
                955
            ],
            "scaleTicketInventoryTag": [
                891
            ],
            "scaleTicketMaterialId": [
                955
            ],
            "scaleTicketMixedMaterial": [
                895
            ],
            "scaleTicketRawMaterial": [
                903
            ],
            "scaleTicketVehicle": [
                918
            ],
            "secondaryScale": [
                871
            ],
            "secondaryScaleId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "version": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketMaterialConnection": {
            "edges": [
                894
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketMaterialEdge": {
            "cursor": [
                955
            ],
            "node": [
                892
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketMixedMaterial": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "grossWeight": [
                286
            ],
            "grossWeightCaptureMethod": [
                1064
            ],
            "material": [
                536
            ],
            "materialId": [
                955
            ],
            "netWeight": [
                286
            ],
            "nominalNetWeight": [
                286
            ],
            "nominalTotalPrice": [
                286
            ],
            "productDescription": [
                742,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "productDescriptionId": [
                955
            ],
            "scaleTicketMaterial": [
                892
            ],
            "scaleTicketMaterialId": [
                955
            ],
            "scaleTicketMixedMaterialId": [
                955
            ],
            "scaleTicketMixedMaterialItems": [
                898
            ],
            "splitGrossWeight1": [
                286
            ],
            "splitGrossWeight1CaptureMethod": [
                1064
            ],
            "splitGrossWeight2": [
                286
            ],
            "splitGrossWeight2CaptureMethod": [
                1064
            ],
            "splitTareWeight1": [
                286
            ],
            "splitTareWeight1CaptureMethod": [
                1064
            ],
            "splitTareWeight2": [
                286
            ],
            "splitTareWeight2CaptureMethod": [
                1064
            ],
            "tareWeight": [
                286
            ],
            "tareWeightCaptureMethod": [
                1064
            ],
            "totalPrice": [
                286
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketMixedMaterialConnection": {
            "edges": [
                897
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketMixedMaterialEdge": {
            "cursor": [
                955
            ],
            "node": [
                895
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketMixedMaterialItem": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "material": [
                536
            ],
            "materialId": [
                955
            ],
            "nominalTotalPrice": [
                286
            ],
            "percentage": [
                286
            ],
            "priceList": [
                688
            ],
            "priceListId": [
                955
            ],
            "priceOrigin": [
                701
            ],
            "pricingUnit": [
                534
            ],
            "productDescription": [
                742,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "productDescriptionId": [
                955
            ],
            "purchaseOrder": [
                776
            ],
            "purchaseOrderId": [
                955
            ],
            "purchaseOrderMaterial": [
                779
            ],
            "purchaseOrderMaterialId": [
                955
            ],
            "realTotalPrice": [
                286
            ],
            "scaleTicketMixedMaterial": [
                895
            ],
            "scaleTicketMixedMaterialId": [
                955
            ],
            "scaleTicketMixedMaterialItemId": [
                955
            ],
            "totalPriceDeduction": [
                286
            ],
            "totalWeightDeduction": [
                286
            ],
            "unitPrice": [
                286
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketMixedMaterialItemConnection": {
            "edges": [
                900
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketMixedMaterialItemEdge": {
            "cursor": [
                955
            ],
            "node": [
                898
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketPaymentStatus": {},
        "ScaleTicketPaymentStatusObject": {},
        "ScaleTicketRawMaterial": {
            "centralizedCompanyId": [
                955
            ],
            "confidencePrompt": [
                955
            ],
            "confidenceResponse": [
                955
            ],
            "createdAt": [
                194
            ],
            "gradingConfidence": [
                357
            ],
            "grossWeight": [
                286
            ],
            "grossWeightCaptureMethod": [
                1064
            ],
            "material": [
                536
            ],
            "materialId": [
                955
            ],
            "netWeight": [
                286
            ],
            "nominalNetWeight": [
                286
            ],
            "nominalTotalPrice": [
                286
            ],
            "priceList": [
                688
            ],
            "priceListId": [
                955
            ],
            "priceOrigin": [
                701
            ],
            "pricingUnit": [
                534
            ],
            "productDescription": [
                742,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "productDescriptionId": [
                955
            ],
            "purchaseOrder": [
                776
            ],
            "purchaseOrderId": [
                955
            ],
            "purchaseOrderMaterial": [
                779
            ],
            "purchaseOrderMaterialId": [
                955
            ],
            "quantity": [
                286
            ],
            "realNetWeight": [
                286
            ],
            "realTotalPrice": [
                286
            ],
            "realUnitPriceInBaseUnit": [
                286
            ],
            "scaleTicketMaterial": [
                892
            ],
            "scaleTicketMaterialId": [
                955
            ],
            "scaleTicketRawMaterialId": [
                955
            ],
            "scrapValue": [
                286
            ],
            "splitGrossWeight1": [
                286
            ],
            "splitGrossWeight1CaptureMethod": [
                1064
            ],
            "splitGrossWeight2": [
                286
            ],
            "splitGrossWeight2CaptureMethod": [
                1064
            ],
            "splitTareWeight1": [
                286
            ],
            "splitTareWeight1CaptureMethod": [
                1064
            ],
            "splitTareWeight2": [
                286
            ],
            "splitTareWeight2CaptureMethod": [
                1064
            ],
            "tareWeight": [
                286
            ],
            "tareWeightCaptureMethod": [
                1064
            ],
            "totalPrice": [
                286
            ],
            "totalPriceDeduction": [
                286
            ],
            "totalWeightDeduction": [
                286
            ],
            "unitPrice": [
                286
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketRawMaterialConnection": {
            "edges": [
                905
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketRawMaterialEdge": {
            "cursor": [
                955
            ],
            "node": [
                903
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketReceiptType": {},
        "ScaleTicketRoundingMethod": {},
        "ScaleTicketRoundingPrecision": {},
        "ScaleTicketStatus": {},
        "ScaleTicketSupplier": {
            "company": [
                130
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "pendingCurrentPayableBalance": [
                286
            ],
            "pendingCurrentPayableDate": [
                194
            ],
            "pendingCurrentPayableNotes": [
                608
            ],
            "pendingCurrentPayableNotesQuantity": [
                286
            ],
            "pendingFuturePayableBalance": [
                286
            ],
            "pendingFuturePayableDate": [
                194
            ],
            "pendingFuturePayableNotes": [
                608
            ],
            "pendingFuturePayableNotesQuantity": [
                286
            ],
            "pendingPayableBalance": [
                286
            ],
            "pendingPayableDate": [
                194
            ],
            "pendingPayableNotes": [
                608
            ],
            "pendingPayableNotesQuantity": [
                286
            ],
            "pendingScaleTicketsAndFreightBillsQuantity": [
                357
            ],
            "publicSupplier": [
                757
            ],
            "scaleTicketSupplierId": [
                955
            ],
            "scaleTicketSupplierName": [
                955
            ],
            "scaleTicketSupplierType": [
                968
            ],
            "thirdPartyHauler": [
                1004
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketSupplierConnection": {
            "edges": [
                912
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketSupplierEdge": {
            "cursor": [
                955
            ],
            "node": [
                910
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketTableFormat": {},
        "ScaleTicketThermalReceiptWidthInches": {},
        "ScaleTicketThumbnailDisplayOption": {},
        "ScaleTicketType": {},
        "ScaleTicketUpdated": {
            "originatorClientSessionId": [
                955
            ],
            "originatorWebSocketId": [
                955
            ],
            "scaleTicketId": [
                955
            ],
            "subscribers": [
                958
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketVehicle": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "grossWeight": [
                286
            ],
            "grossWeightCaptureMethod": [
                1064
            ],
            "material": [
                536
            ],
            "materialId": [
                955
            ],
            "nominalNetWeight": [
                286
            ],
            "nominalTotalPrice": [
                286
            ],
            "priceList": [
                688
            ],
            "priceListId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescription": [
                742,
                {
                    "paranoid": [
                        85
                    ]
                }
            ],
            "productDescriptionId": [
                955
            ],
            "purchaseOrder": [
                776
            ],
            "purchaseOrderId": [
                955
            ],
            "purchaseOrderMaterial": [
                779
            ],
            "purchaseOrderMaterialId": [
                955
            ],
            "quantity": [
                286
            ],
            "realNetWeight": [
                286
            ],
            "realTotalPrice": [
                286
            ],
            "realUnitPriceInBaseUnit": [
                286
            ],
            "scaleTicketMaterial": [
                892
            ],
            "scaleTicketMaterialId": [
                955
            ],
            "scaleTicketVehicleId": [
                955
            ],
            "splitGrossWeight1": [
                286
            ],
            "splitGrossWeight1CaptureMethod": [
                1064
            ],
            "splitGrossWeight2": [
                286
            ],
            "splitGrossWeight2CaptureMethod": [
                1064
            ],
            "splitTareWeight1": [
                286
            ],
            "splitTareWeight1CaptureMethod": [
                1064
            ],
            "splitTareWeight2": [
                286
            ],
            "splitTareWeight2CaptureMethod": [
                1064
            ],
            "tareWeight": [
                286
            ],
            "tareWeightCaptureMethod": [
                1064
            ],
            "totalPriceDeduction": [
                286
            ],
            "totalWeightDeduction": [
                286
            ],
            "unitPrice": [
                286
            ],
            "updatedAt": [
                194
            ],
            "vehicles": [
                924
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketVehicleConnection": {
            "edges": [
                920
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketVehicleEdge": {
            "cursor": [
                955
            ],
            "node": [
                918
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketVehicleFileInput": {
            "fileType": [
                955
            ],
            "humanReadableFilename": [
                955
            ],
            "s3Key": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketVehicleFiltersInput": {
            "scaleTicketId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketVehicleInput": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "grossWeight": [
                286
            ],
            "grossWeightCaptureMethod": [
                1064
            ],
            "materialId": [
                955
            ],
            "priceListId": [
                955
            ],
            "pricingUnit": [
                955
            ],
            "productDescriptionId": [
                955
            ],
            "purchaseOrderId": [
                955
            ],
            "quantity": [
                286
            ],
            "scaleTicketMaterialId": [
                955
            ],
            "scaleTicketVehicleId": [
                955
            ],
            "splitGrossWeight1": [
                286
            ],
            "splitGrossWeight1CaptureMethod": [
                1064
            ],
            "splitGrossWeight2": [
                286
            ],
            "splitGrossWeight2CaptureMethod": [
                1064
            ],
            "splitTareWeight1": [
                286
            ],
            "splitTareWeight1CaptureMethod": [
                1064
            ],
            "splitTareWeight2": [
                286
            ],
            "splitTareWeight2CaptureMethod": [
                1064
            ],
            "tareWeight": [
                286
            ],
            "tareWeightCaptureMethod": [
                1064
            ],
            "unitPrice": [
                286
            ],
            "updatedAt": [
                194
            ],
            "vehicles": [
                1117
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketVehicleItem": {
            "attachableId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "files": [
                847
            ],
            "kansasScrapMetalVehicleMakeCode": [
                955
            ],
            "kansasScrapMetalVehicleModelCode": [
                955
            ],
            "loadPercentage": [
                286
            ],
            "reportVehicle": [
                85
            ],
            "scaleTicketVehicleId": [
                955
            ],
            "scaleTicketVehicleItemId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "vehicleBodyStyle": [
                1055
            ],
            "vehicleColor": [
                955
            ],
            "vehicleMake": [
                955
            ],
            "vehicleModel": [
                955
            ],
            "vehicleOrder": [
                357
            ],
            "vehiclePlate": [
                955
            ],
            "vehicleStateOfTitleIssuance": [
                955
            ],
            "vehicleTagState": [
                955
            ],
            "vehicleTitle": [
                955
            ],
            "vehicleType": [
                1057
            ],
            "vehicleVin": [
                955
            ],
            "vehicleYear": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketVehicleItemConnection": {
            "edges": [
                926
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketVehicleItemEdge": {
            "cursor": [
                955
            ],
            "node": [
                924
            ],
            "__typename": [
                955
            ]
        },
        "ScaleTicketVehicleWeightFormat": {},
        "ScaleType": {},
        "ScaleUnitsOfMeasurement": {},
        "ScaleWeights": {
            "grossWeight": [
                286
            ],
            "netWeight": [
                286
            ],
            "scaleId": [
                955
            ],
            "tareWeight": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "ScanDataType": {},
        "ScannableType": {},
        "ScanningSession": {
            "barcodeData": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037
            ],
            "creatorFullName": [
                955
            ],
            "deletedAt": [
                194
            ],
            "identificationBackS3Key": [
                955
            ],
            "identificationFrontS3Key": [
                955
            ],
            "mrzData": [
                955
            ],
            "publicSupplier": [
                757
            ],
            "scanDataType": [
                931
            ],
            "scannedAt": [
                194
            ],
            "scanningSessionId": [
                955
            ],
            "supplierDriver": [
                134
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ScanningSessionConnection": {
            "edges": [
                935
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ScanningSessionEdge": {
            "cursor": [
                955
            ],
            "node": [
                933
            ],
            "__typename": [
                955
            ]
        },
        "ScheduleRepeatMagnitude": {},
        "ScrapVehicle": {
            "bodyStyle": [
                955
            ],
            "centralizedCompanyId": [
                99
            ],
            "color": [
                955
            ],
            "createdAt": [
                198
            ],
            "files": [
                528
            ],
            "id": [
                938
            ],
            "itemId": [
                442
            ],
            "licensePlate": [
                955
            ],
            "make": [
                955
            ],
            "model": [
                955
            ],
            "notes": [
                955
            ],
            "purchaseId": [
                768
            ],
            "tagState": [
                955
            ],
            "updatedAt": [
                198
            ],
            "vin": [
                955
            ],
            "year": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ScrapVehicleId": {},
        "ScrapVehicleInput": {
            "bodyStyle": [
                955
            ],
            "color": [
                955
            ],
            "licensePlate": [
                955
            ],
            "make": [
                955
            ],
            "model": [
                955
            ],
            "notes": [
                955
            ],
            "tagState": [
                955
            ],
            "vin": [
                955
            ],
            "year": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "SearchExpression": {
            "fields": [
                955
            ],
            "searchTerm": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "SemaphorCredential": {
            "accessToken": [
                955
            ],
            "dashboardId": [
                955
            ],
            "refreshToken": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "SendReportByEmailInput": {
            "definition": [
                1202
            ],
            "email": [
                955
            ],
            "fileName": [
                955
            ],
            "fileType": [
                824
            ],
            "groupByColumns": [
                357
            ],
            "reportName": [
                955
            ],
            "reportPeriod": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ShipToGround": {
            "accountingEntry": [
                19
            ],
            "accountingEntryid": [
                955
            ],
            "createdAt": [
                194
            ],
            "date": [
                194
            ],
            "deletedAt": [
                194
            ],
            "material": [
                536
            ],
            "materialId": [
                955
            ],
            "shipToGroundId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "ShippingCarrier": {
            "carrierName": [
                955
            ],
            "carrierType": [
                86
            ],
            "contacts": [
                134
            ],
            "locations": [
                524
            ],
            "notes": [
                955
            ],
            "scacNumber": [
                955
            ],
            "shippingCarrierId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ShippingCarrierConnection": {
            "edges": [
                946
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ShippingCarrierEdge": {
            "cursor": [
                955
            ],
            "node": [
                944
            ],
            "__typename": [
                955
            ]
        },
        "SidecarHost": {
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "location": [
                524
            ],
            "locationId": [
                955
            ],
            "name": [
                955
            ],
            "printers": [
                709
            ],
            "sidecarHostId": [
                955
            ],
            "sidecarVersion": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "Sort": {
            "direction": [
                955
            ],
            "name": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "SortInput": {
            "direction": [
                955
            ],
            "name": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "SortOrder": {},
        "Sorter": {
            "field": [
                955
            ],
            "order": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "SsoConfiguration": {
            "emailAttribute": [
                955
            ],
            "familyNameAttribute": [
                955
            ],
            "givenNameAttribute": [
                955
            ],
            "idpMetadata": [
                955
            ],
            "providerName": [
                955
            ],
            "ssoLoginDomain": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "Status": {},
        "StatusByAccountingEntry": {},
        "String": {},
        "StringChange": {
            "new": [
                955
            ],
            "old": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "SubmitPhysicalCountJournalInput": {
            "facilityId": [
                955
            ],
            "id": [
                955
            ],
            "occurredAt": [
                198
            ],
            "__typename": [
                955
            ]
        },
        "Subscriber": {
            "firstName": [
                955
            ],
            "isSelf": [
                85
            ],
            "lastName": [
                955
            ],
            "userId": [
                955
            ],
            "webSocketId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "Subscription": {
            "printersRegistered": [
                820
            ],
            "printingRequest": [
                710,
                {
                    "sidecarHostId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "scaleTicketUpdated": [
                917,
                {
                    "scaleTicketId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "scaleWeightsUpdated": [
                930,
                {
                    "scaleId": [
                        955,
                        "String!"
                    ]
                }
            ],
            "scalesWeightUpdated": [
                874,
                {
                    "scaleIds": [
                        955,
                        "[String!]"
                    ]
                }
            ],
            "__typename": [
                955
            ]
        },
        "SubscriptionType": {},
        "SummaryMetrics": {
            "assets": [
                564
            ],
            "numAssets": [
                357
            ],
            "numTrailers": [
                357
            ],
            "numTrucks": [
                357
            ],
            "trailers": [
                564
            ],
            "trucks": [
                564
            ],
            "__typename": [
                955
            ]
        },
        "SupplierId": {},
        "SupplierInput": {
            "supplierId": [
                345
            ],
            "type": [
                968
            ],
            "__typename": [
                955
            ]
        },
        "SupplierPendingTransaction": {
            "accountName": [
                955
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "pendingTransactionsInfo": [
                640
            ],
            "supplierPendingTransactionId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "SupplierPendingTransactionConnection": {
            "edges": [
                966
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "SupplierPendingTransactionEdge": {
            "cursor": [
                955
            ],
            "node": [
                964
            ],
            "__typename": [
                955
            ]
        },
        "SupplierSignature": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "signature": [
                446
            ],
            "signatureAsText": [
                955
            ],
            "supplierSignatureId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "uploadedBy": [
                955
            ],
            "uploadedById": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "SupplierType": {},
        "SyncAssetsFromBlackBerryError": {
            "error": [
                263
            ],
            "__typename": [
                955
            ]
        },
        "SyncAssetsFromBlackBerryResult": {
            "on_SyncAssetsFromBlackBerryError": [
                969
            ],
            "on_SyncAssetsFromBlackBerrySuccess": [
                971
            ],
            "__typename": [
                955
            ]
        },
        "SyncAssetsFromBlackBerrySuccess": {
            "value": [
                85
            ],
            "__typename": [
                955
            ]
        },
        "SyncLocationsFromEventsError": {
            "error": [
                263
            ],
            "__typename": [
                955
            ]
        },
        "SyncLocationsFromEventsResult": {
            "on_SyncLocationsFromEventsError": [
                972
            ],
            "on_SyncLocationsFromEventsSuccess": [
                975
            ],
            "__typename": [
                955
            ]
        },
        "SyncLocationsFromEventsStats": {
            "eventsProcessed": [
                286
            ],
            "locationsNotUpdated": [
                286
            ],
            "locationsUpdated": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "SyncLocationsFromEventsSuccess": {
            "value": [
                974
            ],
            "__typename": [
                955
            ]
        },
        "TareType": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "tareTypeId": [
                955
            ],
            "tareTypeMassUnit": [
                534
            ],
            "tareTypeName": [
                955
            ],
            "tareTypeNotes": [
                955
            ],
            "tareTypeWeight": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "TareTypeConnection": {
            "edges": [
                978
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "TareTypeEdge": {
            "cursor": [
                955
            ],
            "node": [
                976
            ],
            "__typename": [
                955
            ]
        },
        "TareTypeId": {},
        "TaxRate": {
            "companies": [
                130
            ],
            "publicSuppliers": [
                757
            ],
            "taxRateAmount": [
                286
            ],
            "taxRateCalculationType": [
                981
            ],
            "taxRateId": [
                955
            ],
            "taxRateName": [
                955
            ],
            "taxRateNotes": [
                955
            ],
            "taxRateType": [
                984
            ],
            "__typename": [
                955
            ]
        },
        "TaxRateCalculationType": {},
        "TaxRateConnection": {
            "edges": [
                983
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "TaxRateEdge": {
            "cursor": [
                955
            ],
            "node": [
                980
            ],
            "__typename": [
                955
            ]
        },
        "TaxRateType": {},
        "TexasCashCard": {
            "applicationType": [
                986
            ],
            "cardExpirationDate": [
                194
            ],
            "cardIssueDate": [
                194
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "fingerprint": [
                847
            ],
            "fingerprintId": [
                955
            ],
            "fingerprintType": [
                993
            ],
            "publicSupplier": [
                757,
                {
                    "required": [
                        85
                    ]
                }
            ],
            "publicSupplierId": [
                955
            ],
            "signature": [
                847
            ],
            "signatureId": [
                955
            ],
            "supplierPhoto": [
                847
            ],
            "supplierPhotoId": [
                955
            ],
            "texasCashCardConfiguration": [
                987
            ],
            "texasCashCardConfigurationId": [
                955
            ],
            "texasCashCardId": [
                955
            ],
            "texasCashCardNumber": [
                357
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "TexasCashCardApplicationType": {},
        "TexasCashCardConfiguration": {
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "expirationNumberOfMonths": [
                357
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "recyclerName": [
                955
            ],
            "recyclerSignature": [
                847
            ],
            "recyclerSignatureId": [
                955
            ],
            "stateRegistrationNumber": [
                955
            ],
            "texasCashCardConfigurationId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "TexasCashCardConfigurationConnection": {
            "edges": [
                989
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "TexasCashCardConfigurationEdge": {
            "cursor": [
                955
            ],
            "node": [
                987
            ],
            "__typename": [
                955
            ]
        },
        "TexasCashCardConnection": {
            "edges": [
                992
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "TexasCashCardDocuments": {},
        "TexasCashCardEdge": {
            "cursor": [
                955
            ],
            "node": [
                985
            ],
            "__typename": [
                955
            ]
        },
        "TexasCashCardFingerprintType": {},
        "TexasOnlineMetalsCcidCounter": {
            "centralizedCompany": [
                96
            ],
            "centralizedCompanyId": [
                955
            ],
            "counter": [
                357
            ],
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "facility": [
                524
            ],
            "facilityId": [
                955
            ],
            "month": [
                357
            ],
            "texasOnlineMetalsCcidCounterId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "year": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "TexasOnlineMetalsMaterialCode": {
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "texasOnlineMetalsMaterialCode": [
                955
            ],
            "texasOnlineMetalsMaterialCodeId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "TexasOnlineMetalsMaterialCodeConnection": {
            "edges": [
                997
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "TexasOnlineMetalsMaterialCodeEdge": {
            "cursor": [
                955
            ],
            "node": [
                995
            ],
            "__typename": [
                955
            ]
        },
        "TexasOnlineMetalsVehicleCode": {
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "texasOnlineMetalsVehicleCode": [
                955
            ],
            "texasOnlineMetalsVehicleCodeId": [
                955
            ],
            "texasOnlineMetalsVehicleDescription": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "TexasOnlineMetalsVehicleCodeConnection": {
            "edges": [
                1000
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "TexasOnlineMetalsVehicleCodeEdge": {
            "cursor": [
                955
            ],
            "node": [
                998
            ],
            "__typename": [
                955
            ]
        },
        "TexasOnlineMetalsVehicleCodeMakeModelMapping": {
            "createdAt": [
                194
            ],
            "deletedAt": [
                194
            ],
            "texasOnlineMetalsVehicleCode": [
                998
            ],
            "texasOnlineMetalsVehicleCodeId": [
                955
            ],
            "texasOnlineMetalsVehicleCodeMakeModelMappingId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "vehicleMake": [
                955
            ],
            "vehicleModel": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "TexasOnlineMetalsVehicleCodeMakeModelMappingConnection": {
            "edges": [
                1003
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "TexasOnlineMetalsVehicleCodeMakeModelMappingEdge": {
            "cursor": [
                955
            ],
            "node": [
                1001
            ],
            "__typename": [
                955
            ]
        },
        "ThirdPartyHauler": {
            "activeJobs": [
                357
            ],
            "centralizedCompany": [
                96
            ],
            "contacts": [
                134
            ],
            "credentialledCentralizedCompanyId": [
                955
            ],
            "customHaulerId": [
                955
            ],
            "drivers": [
                223
            ],
            "loadBoardOrder": [
                357
            ],
            "locations": [
                524
            ],
            "numDrivers": [
                357
            ],
            "onboarded": [
                85
            ],
            "privilegedFacilities": [
                524
            ],
            "privilegedGroups": [
                338
            ],
            "scac": [
                955
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "thirdPartyHaulerJobHistory": [
                447
            ],
            "thirdPartyHaulerName": [
                955
            ],
            "totalJobs": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ThirdPartyHaulerConnection": {
            "edges": [
                1006
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "ThirdPartyHaulerEdge": {
            "cursor": [
                955
            ],
            "node": [
                1004
            ],
            "__typename": [
                955
            ]
        },
        "ThirdPartyHaulerId": {},
        "TimeFormatType": {},
        "Trailer": {
            "compatibleTransportationTypes": [
                1017
            ],
            "currentTruck": [
                1021
            ],
            "files": [
                847
            ],
            "licensePlateNumber": [
                955
            ],
            "notes": [
                955
            ],
            "plateExpiration": [
                194
            ],
            "primaryGroup": [
                338
            ],
            "privilegedFacilities": [
                524
            ],
            "privilegedGroups": [
                338
            ],
            "state": [
                955
            ],
            "status": [
                955
            ],
            "totalJobs": [
                357
            ],
            "trailerId": [
                955
            ],
            "trailerJobHistory": [
                447,
                {
                    "afterDate": [
                        194
                    ],
                    "beforeDate": [
                        194
                    ],
                    "timePeriod": [
                        194
                    ]
                }
            ],
            "trailerNumber": [
                955
            ],
            "trailerTypeId": [
                955
            ],
            "transportationType": [
                1017
            ],
            "__typename": [
                955
            ]
        },
        "TrailerConnection": {
            "edges": [
                1011
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "TrailerEdge": {
            "cursor": [
                955
            ],
            "node": [
                1009
            ],
            "__typename": [
                955
            ]
        },
        "TransactionStepsType": {},
        "Transport": {
            "centralizedCompanyId": [
                955
            ],
            "company": [
                130
            ],
            "createdAt": [
                194
            ],
            "kansasScrapMetalVehicleMakeCode": [
                955
            ],
            "kansasScrapMetalVehicleModelCode": [
                955
            ],
            "licensePlateExpiration": [
                194
            ],
            "licensePlateNumber": [
                955
            ],
            "licensePlateState": [
                955
            ],
            "publicSupplier": [
                757
            ],
            "texasOnlineMetalsVehicleCode": [
                998
            ],
            "texasOnlineMetalsVehicleCodeId": [
                955
            ],
            "transportId": [
                955
            ],
            "transportType": [
                955
            ],
            "transportableType": [
                1015
            ],
            "truckNumber": [
                955
            ],
            "type": [
                955
            ],
            "vehicleColor": [
                955
            ],
            "vehicleMake": [
                955
            ],
            "vehicleModel": [
                955
            ],
            "vehicleYear": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "TransportType": {},
        "TransportableType": {},
        "TransportationCompatibleWithJob": {
            "trailerCompatible": [
                85
            ],
            "trailerCompatibleReason": [
                955
            ],
            "truckCompatible": [
                85
            ],
            "truckCompatibleReason": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "TransportationType": {
            "compatibleTransportationTypes": [
                133
            ],
            "trailers": [
                1009
            ],
            "transportationType": [
                955
            ],
            "transportationTypeId": [
                955
            ],
            "transportationTypeValue": [
                955
            ],
            "trucks": [
                1021
            ],
            "__typename": [
                955
            ]
        },
        "TransportationTypeConnection": {
            "edges": [
                1019
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "TransportationTypeEdge": {
            "cursor": [
                955
            ],
            "node": [
                1017
            ],
            "__typename": [
                955
            ]
        },
        "TransportationTypes": {},
        "Truck": {
            "compatibleTransportationTypes": [
                1017
            ],
            "currentDriver": [
                223
            ],
            "currentTrailer": [
                1009
            ],
            "defaultTrailer": [
                1009
            ],
            "files": [
                847
            ],
            "licensePlateNumber": [
                955
            ],
            "notes": [
                955
            ],
            "plateExpiration": [
                194
            ],
            "primaryGroup": [
                338
            ],
            "privilegedFacilities": [
                524
            ],
            "privilegedGroups": [
                338
            ],
            "state": [
                955
            ],
            "status": [
                955
            ],
            "totalJobs": [
                357
            ],
            "transportationType": [
                1017
            ],
            "truckId": [
                955
            ],
            "truckJobHistory": [
                447,
                {
                    "afterDate": [
                        194
                    ],
                    "beforeDate": [
                        194
                    ],
                    "timePeriod": [
                        194
                    ]
                }
            ],
            "truckModel": [
                1024
            ],
            "truckModelName": [
                955
            ],
            "truckNumber": [
                955
            ],
            "truckTypeId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "TruckConnection": {
            "edges": [
                1023
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "TruckEdge": {
            "cursor": [
                955
            ],
            "node": [
                1021
            ],
            "__typename": [
                955
            ]
        },
        "TruckModel": {
            "name": [
                955
            ],
            "truckModelId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "TruckStateDistance": {
            "job": [
                447
            ],
            "milesTravelled": [
                286
            ],
            "state": [
                955
            ],
            "truckStateDistanceId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "TruckStateDistanceConnection": {
            "edges": [
                1027
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "TruckStateDistanceEdge": {
            "cursor": [
                955
            ],
            "node": [
                1025
            ],
            "__typename": [
                955
            ]
        },
        "UnderwriteStatus": {},
        "UnitPriceFormula": {
            "formula": [
                955
            ],
            "variableIds": [
                1054
            ],
            "__typename": [
                955
            ]
        },
        "UpdateChartInput": {
            "chartConfig": [
                112
            ],
            "chartType": [
                955
            ],
            "dateRange": [
                197
            ],
            "description": [
                955
            ],
            "dimensions": [
                955
            ],
            "filters": [
                274
            ],
            "granularity": [
                955
            ],
            "id": [
                955
            ],
            "measures": [
                955
            ],
            "name": [
                955
            ],
            "pivotConfig": [
                672
            ],
            "reportType": [
                955
            ],
            "sorts": [
                949
            ],
            "timeDimension": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "UpdateInventoryPeriodConfigurationsInput": {
            "configurations": [
                383
            ],
            "__typename": [
                955
            ]
        },
        "UpdateInventoryProcessInput": {
            "costs": [
                713
            ],
            "facilityIds": [
                345
            ],
            "id": [
                345
            ],
            "name": [
                955
            ],
            "transformations": [
                741
            ],
            "__typename": [
                955
            ]
        },
        "UpdateJournalEntryLineInput": {
            "accountId": [
                955
            ],
            "amount": [
                286
            ],
            "description": [
                955
            ],
            "journalEntryLineId": [
                955
            ],
            "normality": [
                573
            ],
            "__typename": [
                955
            ]
        },
        "UpdatePhysicalCountTaggedEntryInput": {
            "id": [
                955
            ],
            "inventoryTagId": [
                955
            ],
            "newGrossWeight": [
                286
            ],
            "newTareWeight": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "UpdatePhysicalCountUntaggedEntryInput": {
            "id": [
                955
            ],
            "itemId": [
                955
            ],
            "newQuantity": [
                286
            ],
            "newWac": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "UpdatePurchaseItemInput": {
            "inventoryTag": [
                770
            ],
            "notes": [
                955
            ],
            "product": [
                787
            ],
            "quantity": [
                772
            ],
            "tareOnTruck": [
                85
            ],
            "unitPrice": [
                773
            ],
            "weight": [
                774
            ],
            "__typename": [
                955
            ]
        },
        "User": {
            "appVersion": [
                955
            ],
            "centralizedCompanyId": [
                955
            ],
            "company": [
                96
            ],
            "computedPermissionedFacilities": [
                524
            ],
            "contacts": [
                134
            ],
            "createdAt": [
                194
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                955
            ],
            "defaultCashDrawer": [
                275
            ],
            "defaultCashDrawerId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "email": [
                955
            ],
            "equipmentChecklists": [
                231,
                {
                    "required": [
                        85
                    ]
                }
            ],
            "expandedComputedPermissions": [
                262
            ],
            "firstName": [
                955
            ],
            "fullName": [
                955
            ],
            "hasAccessToFacilitiesInAlabama": [
                85
            ],
            "hasAccessToFacilitiesInCanada": [
                85
            ],
            "hasAccessToFacilitiesInKansas": [
                85
            ],
            "hasAccessToFacilitiesInOhio": [
                85
            ],
            "hasAccessToFacilitiesInTexas": [
                85
            ],
            "isAdmin": [
                85
            ],
            "isDefaultPrintingEnabled": [
                85
            ],
            "isDisabled": [
                85
            ],
            "lastLogin": [
                194
            ],
            "lastName": [
                955
            ],
            "lockedDate": [
                194
            ],
            "mostRecentlySeenPlatform": [
                955
            ],
            "permissionedFacilities": [
                524
            ],
            "permissionedGroups": [
                338
            ],
            "phoneNumber": [
                955
            ],
            "primaryFacility": [
                524
            ],
            "primaryFacilityId": [
                955
            ],
            "primaryScale": [
                871
            ],
            "primaryScaleId": [
                955
            ],
            "role": [
                955
            ],
            "scalePaymentBehavior": [
                875
            ],
            "scaleTicketTableFormat": [
                913
            ],
            "timezone": [
                955
            ],
            "updatedAt": [
                194
            ],
            "userId": [
                345
            ],
            "userPolicies": [
                1040
            ],
            "userRoleTemplate": [
                1042
            ],
            "userSub": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "UserConnection": {
            "edges": [
                1039
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "UserNode": {
            "cursor": [
                955
            ],
            "node": [
                1037
            ],
            "__typename": [
                955
            ]
        },
        "UserPolicy": {
            "attributes": [
                1041
            ],
            "facility": [
                524
            ],
            "group": [
                338
            ],
            "recycler": [
                96
            ],
            "user": [
                1037
            ],
            "userPolicyId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "UserPolicyAttribute": {
            "action": [
                955
            ],
            "attributeName": [
                955
            ],
            "recycler": [
                96
            ],
            "userPolicy": [
                1040
            ],
            "userPolicyAttributeId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "UserRoleTemplate": {
            "attributes": [
                1043
            ],
            "centralizedCompany": [
                96
            ],
            "createdAt": [
                194
            ],
            "modifiedAt": [
                194
            ],
            "updatedAt": [
                194
            ],
            "userRoleTemplateId": [
                955
            ],
            "userRoleTemplateName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "UserRoleTemplateAttribute": {
            "action": [
                955
            ],
            "attributeName": [
                955
            ],
            "centralizedCompany": [
                96
            ],
            "userRoleTemplate": [
                1042
            ],
            "userRoleTemplateAttributeId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "UserRoleTemplateAttributeConnection": {
            "edges": [
                1045
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "UserRoleTemplateAttributeEdge": {
            "cursor": [
                955
            ],
            "node": [
                1043
            ],
            "__typename": [
                955
            ]
        },
        "UserRoleTemplateConnection": {
            "edges": [
                1047
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "UserRoleTemplateEdge": {
            "cursor": [
                955
            ],
            "node": [
                1042
            ],
            "__typename": [
                955
            ]
        },
        "UserRoles": {},
        "UserSetting": {
            "DateFormatType": [
                195
            ],
            "Email": [
                955
            ],
            "EmailDriverOnWayUpdates": [
                955
            ],
            "EmailJobCompletionUpdates": [
                955
            ],
            "EmailNotificationsEnabled": [
                955
            ],
            "EmailReceiveServiceScheduleUpdates": [
                955
            ],
            "SMSDriverOnWayUpdates": [
                955
            ],
            "SMSJobCompletionUpdates": [
                955
            ],
            "SMSNotificationsEnabled": [
                955
            ],
            "SMSPhoneNumber": [
                955
            ],
            "SMSReceiveServiceScheduleUpdates": [
                955
            ],
            "receiveNotifications": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "UserSettingNames": {},
        "Variable": {
            "createdAt": [
                194
            ],
            "creator": [
                1037
            ],
            "creatorId": [
                955
            ],
            "deletedAt": [
                194
            ],
            "description": [
                955
            ],
            "endDate": [
                194
            ],
            "name": [
                955
            ],
            "startDate": [
                194
            ],
            "updatedAt": [
                194
            ],
            "value": [
                286
            ],
            "variableId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "VariableConnection": {
            "edges": [
                1053
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "VariableEdge": {
            "cursor": [
                955
            ],
            "node": [
                1051
            ],
            "__typename": [
                955
            ]
        },
        "VariableId": {},
        "VehicleBodyStyle": {},
        "VehicleColor": {},
        "VehicleType": {},
        "VehicleTypes": {},
        "VoidPhysicalCountJournalInput": {
            "id": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "VoucherTemplate": {
            "centralizedCompanyId": [
                955
            ],
            "displayAccountNumber": [
                85
            ],
            "displayBankAccount": [
                85
            ],
            "displayCheckNumber": [
                85
            ],
            "displayDate": [
                85
            ],
            "displayPayeeName": [
                85
            ],
            "displayRoutingNumber": [
                85
            ],
            "displayTicketDate": [
                85
            ],
            "displayTicketNumber": [
                85
            ],
            "displayTicketPrice": [
                85
            ],
            "displayTotalPrice": [
                85
            ],
            "marginBottom": [
                357
            ],
            "marginTop": [
                357
            ],
            "voucherTemplateId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "VoucherTemplateConnection": {
            "edges": [
                1062
            ],
            "total": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "VoucherTemplateEdge": {
            "cursor": [
                955
            ],
            "node": [
                1060
            ],
            "__typename": [
                955
            ]
        },
        "WarehouseCredential": {
            "createdAt": [
                198
            ],
            "host": [
                955
            ],
            "password": [
                955
            ],
            "port": [
                357
            ],
            "ssl": [
                85
            ],
            "updatedAt": [
                198
            ],
            "username": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "WeightCaptureMethod": {},
        "WeightInputMethod": {},
        "WeightUnit": {},
        "aggregatePaymentInput": {
            "achNumber": [
                955
            ],
            "atmId": [
                955
            ],
            "checkAttn": [
                955
            ],
            "checkLocationId": [
                955
            ],
            "checkMemo": [
                955
            ],
            "checkNumber": [
                955
            ],
            "financialAccountId": [
                955
            ],
            "legalHold": [
                85
            ],
            "payableNoteEligibleDate": [
                194
            ],
            "payeeName": [
                955
            ],
            "preferredPaymentType": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "apiKeyInput": {
            "apiKeyName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "assetAdjustmentInput": {
            "assetIds": [
                955
            ],
            "locationId": [
                955
            ],
            "status": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "assetBulkMoveInput": {
            "assetIds": [
                955
            ],
            "date": [
                194
            ],
            "deployedLocationId": [
                955
            ],
            "inventoryLocationId": [
                955
            ],
            "status": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "assetInput": {
            "assetDescriptionId": [
                955
            ],
            "assetId": [
                955
            ],
            "assetName": [
                955
            ],
            "assetTare": [
                357
            ],
            "assetTypeId": [
                955
            ],
            "assignedCompanyIds": [
                955
            ],
            "currentLocationId": [
                955
            ],
            "customAttributes": [
                446
            ],
            "gpsIdentifier": [
                956
            ],
            "lastMoved": [
                194
            ],
            "materialId": [
                955
            ],
            "notes": [
                955
            ],
            "primaryGroupId": [
                955
            ],
            "privilegedFacilityIds": [
                955
            ],
            "privilegedGroupIds": [
                955
            ],
            "status": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "assetTypeInput": {
            "assetDescriptionIds": [
                955
            ],
            "assetTypeCategory": [
                955
            ],
            "assetTypeId": [
                955
            ],
            "assetTypeValue": [
                955
            ],
            "flexibleQuantity": [
                85
            ],
            "transportationTypeIds": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "atmInput": {
            "atmId": [
                955
            ],
            "facilityId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "bankAccountInput": {
            "accountNumber": [
                955
            ],
            "accountType": [
                70
            ],
            "bankAccountId": [
                955
            ],
            "bankName": [
                955
            ],
            "routingNumber": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "catalyticConverterInput": {
            "catalyticConverterId": [
                955
            ],
            "materialGroupId": [
                955
            ],
            "materialName": [
                955
            ],
            "materialNotes": [
                955
            ],
            "skuNumber": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "centralizedCompanyInput": {
            "centralizedCompanyId": [
                955
            ],
            "companyName": [
                955
            ],
            "credentialledCentralizedCompanyId": [
                955
            ],
            "defaultCurrency": [
                173
            ],
            "equipmentAccountManagerIds": [
                955
            ],
            "onboarded": [
                85
            ],
            "ssoLoginDomain": [
                955
            ],
            "timezone": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "checkTemplateInput": {
            "checkElementsPosition": [
                446
            ],
            "checkFont": [
                955
            ],
            "checkFontSize": [
                357
            ],
            "checkLayout": [
                955
            ],
            "checkTemplateId": [
                955
            ],
            "checkType": [
                955
            ],
            "displayAttn": [
                85
            ],
            "displayBankName": [
                85
            ],
            "displayCheckNumber": [
                85
            ],
            "displayCutLine": [
                85
            ],
            "displayMemo": [
                85
            ],
            "displayMicr": [
                85
            ],
            "displayPayeeAddress": [
                85
            ],
            "displayPayeeName": [
                85
            ],
            "displayPayeeNameDuplicate": [
                85
            ],
            "displayPhoneNumber": [
                85
            ],
            "displayRecyclerAddress": [
                85
            ],
            "displayRecyclerLogo": [
                85
            ],
            "displayRecyclerName": [
                85
            ],
            "displayScaleTicketNumbers": [
                85
            ],
            "displaySecondSignature": [
                85
            ],
            "displaySignature": [
                85
            ],
            "micrSettings": [
                446
            ],
            "minAmountSecondSignature": [
                357
            ],
            "minAmountSignature": [
                357
            ],
            "secondSignature": [
                1205
            ],
            "secondSignatureId": [
                955
            ],
            "signature": [
                1205
            ],
            "signatureId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "cloneJobInput": {
            "deadlineDate": [
                194
            ],
            "driverId": [
                955
            ],
            "jobId": [
                955
            ],
            "numInstances": [
                357
            ],
            "scheduledDate": [
                194
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "companyInput": {
            "accountManagerIds": [
                955
            ],
            "businessLicenseNumber": [
                955
            ],
            "companyId": [
                955
            ],
            "companyName": [
                955
            ],
            "contacts": [
                1081
            ],
            "customAttributes": [
                446
            ],
            "customCompanyId": [
                955
            ],
            "defaultPaymentSchedule": [
                624
            ],
            "defaultPaymentTermId": [
                955
            ],
            "defaultPaymentType": [
                637
            ],
            "defaultShipToLocationId": [
                955
            ],
            "files": [
                1205
            ],
            "inboundTaxRateId": [
                955
            ],
            "inboundTaxRateIds": [
                955
            ],
            "isCustomer": [
                85
            ],
            "isServiceProvider": [
                85
            ],
            "isSupplier": [
                85
            ],
            "locations": [
                1167
            ],
            "notes": [
                955
            ],
            "onboarded": [
                85
            ],
            "outboundTaxRateId": [
                955
            ],
            "outboundTaxRateIds": [
                955
            ],
            "payeeName": [
                955
            ],
            "paymentAddressId": [
                955
            ],
            "priceListGroupIds": [
                955
            ],
            "privilegedFacilityIds": [
                955
            ],
            "privilegedGroupIds": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "confirmPaymentsInput": {
            "paymentTransactionIds": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "contactInput": {
            "acceptsPayment": [
                85
            ],
            "cellNumber": [
                955
            ],
            "contactAddress": [
                955
            ],
            "contactId": [
                955
            ],
            "contactableId": [
                955
            ],
            "contactableType": [
                955
            ],
            "dateOfBirth": [
                194
            ],
            "email": [
                955
            ],
            "eyeColor": [
                955
            ],
            "fingerprint": [
                1205
            ],
            "firstName": [
                955
            ],
            "hairColor": [
                955
            ],
            "height": [
                286
            ],
            "identificationBack": [
                1205
            ],
            "identificationExpiresDate": [
                194
            ],
            "identificationFront": [
                1205
            ],
            "identificationIssuedDate": [
                194
            ],
            "identificationNumber": [
                955
            ],
            "identificationState": [
                955
            ],
            "identificationType": [
                955
            ],
            "isDefault": [
                85
            ],
            "isPriceListContact": [
                85
            ],
            "lastName": [
                955
            ],
            "middleName": [
                955
            ],
            "notes": [
                955
            ],
            "phoneNumber": [
                955
            ],
            "race": [
                955
            ],
            "role": [
                955
            ],
            "sex": [
                955
            ],
            "suffix": [
                955
            ],
            "user": [
                1276
            ],
            "weight": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "createAccountingAgingCategoryInput": {
            "accountingAgingCategoryId": [
                955
            ],
            "accountingAgingCategoryName": [
                955
            ],
            "endDays": [
                357
            ],
            "startDays": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "createAssetDescriptionInput": {
            "assetDescription": [
                955
            ],
            "assetDescriptionId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createBankAccountInput": {
            "accountNumber": [
                955
            ],
            "accountType": [
                70
            ],
            "bankAccountId": [
                955
            ],
            "bankName": [
                955
            ],
            "routingNumber": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createCrvBatchInput": {
            "crvBatchId": [
                955
            ],
            "crvMaterialId": [
                955
            ],
            "endDate": [
                194
            ],
            "facilityId": [
                955
            ],
            "startDate": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "createCustomAttributeInput": {
            "customAttributeId": [
                955
            ],
            "customAttributeName": [
                955
            ],
            "customAttributeType": [
                183
            ],
            "entityType": [
                178
            ],
            "maxLength": [
                357
            ],
            "maxNumber": [
                286
            ],
            "minLength": [
                357
            ],
            "minNumber": [
                286
            ],
            "options": [
                1124
            ],
            "required": [
                85
            ],
            "__typename": [
                955
            ]
        },
        "createDeductionTypeInput": {
            "deductionTypeCategory": [
                200
            ],
            "deductionTypeId": [
                955
            ],
            "deductionTypeMethod": [
                203
            ],
            "deductionTypeName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createEquipmentChecklistInput": {
            "equipmentChecklistId": [
                955
            ],
            "equipmentChecklistTemplateId": [
                955
            ],
            "equipmentHours": [
                286
            ],
            "equipmentId": [
                955
            ],
            "recyclerCentralizedCompanyId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createEquipmentChecklistTemplateInput": {
            "equipmentChecklistTemplateId": [
                955
            ],
            "equipmentChecklistTemplateName": [
                955
            ],
            "equipmentTypeId": [
                955
            ],
            "items": [
                1128
            ],
            "repeatFrequency": [
                236
            ],
            "repeatInterval": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "createEquipmentGroupInput": {
            "equipmentGroupId": [
                955
            ],
            "equipmentGroupName": [
                955
            ],
            "equipmentGroupNotes": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createEquipmentInput": {
            "equipmentId": [
                955
            ],
            "equipmentName": [
                955
            ],
            "equipmentTypeId": [
                955
            ],
            "installDate": [
                194
            ],
            "lastEquipmentChecklistId": [
                955
            ],
            "locationId": [
                955
            ],
            "notes": [
                955
            ],
            "recyclerCentralizedCompanyId": [
                955
            ],
            "serialNumber": [
                955
            ],
            "status": [
                251
            ],
            "__typename": [
                955
            ]
        },
        "createEquipmentTypeInput": {
            "equipmentGroupId": [
                955
            ],
            "equipmentTypeId": [
                955
            ],
            "equipmentTypeName": [
                955
            ],
            "equipmentTypeNotes": [
                955
            ],
            "fileType": [
                955
            ],
            "s3Key": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createExternalServiceLogInput": {
            "centralizedCompanyId": [
                955
            ],
            "duration": [
                357
            ],
            "endpoint": [
                955
            ],
            "externalServiceLogId": [
                955
            ],
            "requestBody": [
                446
            ],
            "requestMethod": [
                955
            ],
            "responseBody": [
                446
            ],
            "responseStatus": [
                357
            ],
            "serviceName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createGovernmentReportingConfigurationInput": {
            "daysOfWeek": [
                955
            ],
            "facilities": [
                1141
            ],
            "fields": [
                955
            ],
            "governmentReportingConfigurationId": [
                955
            ],
            "loginEmail": [
                955
            ],
            "loginPassword": [
                955
            ],
            "recyclerId": [
                955
            ],
            "uploadService": [
                324
            ],
            "uploadState": [
                955
            ],
            "uploadTimezone": [
                955
            ],
            "uploadType": [
                336
            ],
            "__typename": [
                955
            ]
        },
        "createIntegrationInvitationInput": {
            "companyDomain": [
                955
            ],
            "companyName": [
                955
            ],
            "integrationInvitationId": [
                955
            ],
            "integrationType": [
                103
            ],
            "invitationEmail": [
                955
            ],
            "inviteeFirstName": [
                955
            ],
            "inviteeLastName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createJobPauseReasonInput": {
            "description": [
                955
            ],
            "jobPauseReasonId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createMaterialIntegrationInput": {
            "integrationData": [
                446
            ],
            "integrationType": [
                549
            ],
            "materialIntegrationId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createOutboundScaleTicketFreightInput": {
            "deliveryNumber": [
                955
            ],
            "freightAccrualAmount": [
                286
            ],
            "freightDeductionAmount": [
                286
            ],
            "freightLaneCostId": [
                955
            ],
            "notes": [
                955
            ],
            "outboundScaleTicketFreightId": [
                955
            ],
            "outboundScaleTicketId": [
                955
            ],
            "paymentDueDate": [
                955
            ],
            "shouldCreateFreightBill": [
                85
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createPaymentTermInput": {
            "dateDrivenDiscountPercentage": [
                286
            ],
            "discountDueBeforeDayOfMonth": [
                357
            ],
            "discountIfPaidWithin": [
                357
            ],
            "discountPercentage": [
                286
            ],
            "netDueBeforeDayOfMonth": [
                357
            ],
            "netDueInDays": [
                357
            ],
            "nextMonthDueIfIssuedWithinDays": [
                357
            ],
            "paymentTermId": [
                955
            ],
            "paymentTermName": [
                955
            ],
            "paymentTermType": [
                631
            ],
            "__typename": [
                955
            ]
        },
        "createPositivePayTemplateInput": {
            "centralizedCompanyId": [
                955
            ],
            "definition": [
                446
            ],
            "fileType": [
                680
            ],
            "positivePayTemplateId": [
                955
            ],
            "templateName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createPriceListGroupInput": {
            "companyIds": [
                955
            ],
            "name": [
                955
            ],
            "priceListGroupId": [
                955
            ],
            "publicSupplierIds": [
                955
            ],
            "type": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createPriceListInput": {
            "endDate": [
                194
            ],
            "facilityId": [
                955
            ],
            "name": [
                955
            ],
            "priceListGroupId": [
                955
            ],
            "priceListId": [
                955
            ],
            "startDate": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "createPriceListMaterialInput": {
            "materialId": [
                955
            ],
            "priceListId": [
                955
            ],
            "priceListMaterialId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescriptionId": [
                955
            ],
            "tiers": [
                1191
            ],
            "__typename": [
                955
            ]
        },
        "createProcessExecutionInput": {
            "facilityId": [
                955
            ],
            "processExecutionId": [
                955
            ],
            "processExecutionMaterialsInput": [
                720
            ],
            "processId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createProcessInput": {
            "name": [
                955
            ],
            "processId": [
                955
            ],
            "status": [
                740
            ],
            "__typename": [
                955
            ]
        },
        "createProcessLineBurdenInput": {
            "cost": [
                286
            ],
            "costUnit": [
                732
            ],
            "name": [
                955
            ],
            "processId": [
                955
            ],
            "processLineBurdenId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createProcessMappingInput": {
            "cost": [
                286
            ],
            "costUnit": [
                732
            ],
            "inputMaterialId": [
                955
            ],
            "outputMaterialId": [
                955
            ],
            "percentage": [
                286
            ],
            "processId": [
                955
            ],
            "processMappingId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createProductDescriptionInput": {
            "materialId": [
                955
            ],
            "productDescriptionId": [
                955
            ],
            "productDescriptionName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createPuertoRicoPoliceFormConfigurationInput": {
            "buyerFullName": [
                955
            ],
            "buyerMobileNumber": [
                955
            ],
            "buyerPhoneNumber": [
                955
            ],
            "buyerPostalAddress": [
                955
            ],
            "facilityLocationId": [
                955
            ],
            "puertoRicoPoliceFormConfigurationId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createReceivedOutboundScaleTicketDeductionInput": {
            "deductionCategory": [
                200
            ],
            "deductionMethod": [
                203
            ],
            "deductionReason": [
                955
            ],
            "deductionTypeId": [
                955
            ],
            "notes": [
                955
            ],
            "outboundScaleTicketId": [
                955
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "priceDeduction": [
                286
            ],
            "receivedOutboundScaleTicketDeductionId": [
                955
            ],
            "receivedOutboundScaleTicketMaterialId": [
                955
            ],
            "reversedDeductionId": [
                955
            ],
            "scaleId": [
                955
            ],
            "weightDeduction": [
                286
            ],
            "weightDeductionCaptureMethod": [
                1064
            ],
            "__typename": [
                955
            ]
        },
        "createReceivedOutboundScaleTicketFreightInput": {
            "deliveryNumber": [
                955
            ],
            "freightAccrualAmount": [
                286
            ],
            "freightDeductionAmount": [
                286
            ],
            "freightLaneCostId": [
                955
            ],
            "notes": [
                955
            ],
            "outboundScaleTicketId": [
                955
            ],
            "receivedOutboundScaleTicketFreightId": [
                955
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createReceivedOutboundScaleTicketMaterialInput": {
            "deductions": [
                1262
            ],
            "grossWeight": [
                286
            ],
            "inventoryTagId": [
                955
            ],
            "materialId": [
                955
            ],
            "netWeight": [
                286
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescriptionId": [
                955
            ],
            "quantity": [
                286
            ],
            "receivedOutboundScaleTicketMaterialId": [
                955
            ],
            "tareWeight": [
                286
            ],
            "totalPrice": [
                286
            ],
            "unitPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "createReportScheduleInput": {
            "creatorId": [
                955
            ],
            "endDate": [
                194
            ],
            "fileType": [
                836
            ],
            "hourToBeRunAt": [
                357
            ],
            "isCustomSchedule": [
                85
            ],
            "monthlyRepeatMode": [
                955
            ],
            "notifiableUsers": [
                955
            ],
            "repeatFrequency": [
                357
            ],
            "repeatMagnitude": [
                936
            ],
            "repeatedDateOfMonth": [
                357
            ],
            "repeatedDaysOfWeek": [
                357
            ],
            "repeatedWeekOfMonth": [
                357
            ],
            "reportScheduleId": [
                955
            ],
            "reportTemplateId": [
                955
            ],
            "startDate": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "createReportTemplateInput": {
            "definition": [
                446
            ],
            "description": [
                955
            ],
            "name": [
                955
            ],
            "privilegedFacilityIds": [
                955
            ],
            "privilegedGroupIds": [
                955
            ],
            "reportId": [
                828
            ],
            "reportPeriodColumnName": [
                955
            ],
            "reportTemplateId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createSalesOrderLoadReceivingTicketInput": {
            "externalNotes": [
                955
            ],
            "files": [
                1205
            ],
            "internalNotes": [
                955
            ],
            "loadReceivedDate": [
                194
            ],
            "millReceivedWeightPostDate": [
                194
            ],
            "outboundScaleTicketId": [
                955
            ],
            "receivingTicketIssueDate": [
                194
            ],
            "receivingTicketNumber": [
                955
            ],
            "salesOrderLoadReceivingTicketId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createScaleTicketFreightInput": {
            "deliveryNumber": [
                955
            ],
            "freightAccrualAmount": [
                286
            ],
            "freightDeductionAmount": [
                286
            ],
            "freightLaneCostId": [
                955
            ],
            "notes": [
                955
            ],
            "paymentDueDate": [
                955
            ],
            "scaleTicketFreightId": [
                955
            ],
            "scaleTicketId": [
                955
            ],
            "shouldCreateFreightBill": [
                85
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createScaleTicketVehicleItemInput": {
            "attachableId": [
                955
            ],
            "files": [
                1205
            ],
            "kansasScrapMetalVehicleMakeCode": [
                955
            ],
            "kansasScrapMetalVehicleModelCode": [
                955
            ],
            "loadPercentage": [
                286
            ],
            "reportVehicle": [
                85
            ],
            "scaleTicketVehicleId": [
                955
            ],
            "scaleTicketVehicleItemId": [
                955
            ],
            "vehicleBodyStyle": [
                1055
            ],
            "vehicleColor": [
                955
            ],
            "vehicleMake": [
                955
            ],
            "vehicleModel": [
                955
            ],
            "vehicleOrder": [
                357
            ],
            "vehiclePlate": [
                955
            ],
            "vehicleStateOfTitleIssuance": [
                955
            ],
            "vehicleTagState": [
                955
            ],
            "vehicleTitle": [
                955
            ],
            "vehicleType": [
                1057
            ],
            "vehicleVin": [
                955
            ],
            "vehicleYear": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "createSupplierSignatureInput": {
            "publicSupplierId": [
                955
            ],
            "signature": [
                446
            ],
            "supplierSignatureId": [
                955
            ],
            "uploadedById": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createTaxRateInput": {
            "taxRateAmount": [
                286
            ],
            "taxRateCalculationType": [
                981
            ],
            "taxRateId": [
                955
            ],
            "taxRateName": [
                955
            ],
            "taxRateNotes": [
                955
            ],
            "taxRateType": [
                984
            ],
            "__typename": [
                955
            ]
        },
        "createTexasCashCardConfigurationInput": {
            "expirationNumberOfMonths": [
                357
            ],
            "facilityId": [
                955
            ],
            "recyclerName": [
                955
            ],
            "recyclerSignature": [
                1205
            ],
            "stateRegistrationNumber": [
                955
            ],
            "texasCashCardConfigurationId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createTexasCashCardInput": {
            "applicationType": [
                986
            ],
            "cardExpirationDate": [
                194
            ],
            "cardIssueDate": [
                194
            ],
            "facilityId": [
                955
            ],
            "fingerprint": [
                1205
            ],
            "fingerprintType": [
                993
            ],
            "publicSupplierId": [
                955
            ],
            "signature": [
                1205
            ],
            "supplierPhoto": [
                1205
            ],
            "texasCashCardId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createUserRoleTemplateInput": {
            "attributes": [
                1279
            ],
            "userRoleTemplateId": [
                955
            ],
            "userRoleTemplateName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "createVariableInput": {
            "description": [
                955
            ],
            "name": [
                955
            ],
            "value": [
                286
            ],
            "variableId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "customAttributeOptionInput": {
            "customAttributeOptionId": [
                955
            ],
            "customAttributeOptionName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "detentionInput": {
            "carrierId": [
                955
            ],
            "companyId": [
                955
            ],
            "detentionId": [
                955
            ],
            "detentionIncidence": [
                357
            ],
            "detentionValue": [
                286
            ],
            "startDate": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "driverInput": {
            "address": [
                1167
            ],
            "cdlExpirationDate": [
                194
            ],
            "cdlNumber": [
                955
            ],
            "centralizedCompanyId": [
                955
            ],
            "currentTruck": [
                1231
            ],
            "customAttributes": [
                446
            ],
            "customDriverId": [
                955
            ],
            "driverId": [
                955
            ],
            "driverOrder": [
                357
            ],
            "email": [
                955
            ],
            "firstName": [
                955
            ],
            "idleTime": [
                286
            ],
            "isAssignableToJobs": [
                85
            ],
            "isInternalUser": [
                85
            ],
            "lastName": [
                955
            ],
            "latitude": [
                286
            ],
            "longitude": [
                286
            ],
            "phoneNumber": [
                955
            ],
            "primaryFacilityId": [
                955
            ],
            "privilegedFacilityIds": [
                955
            ],
            "privilegedGroupIds": [
                955
            ],
            "truckId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "editPaymentCheckNumberInput": {
            "checkNumber": [
                955
            ],
            "checkNumberDate": [
                194
            ],
            "paymentTransactionId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "equipmentChecklistItemInput": {
            "checklistItemType": [
                238
            ],
            "description": [
                955
            ],
            "equipmentChecklistItemId": [
                955
            ],
            "photoRequired": [
                240
            ],
            "positionNumber": [
                357
            ],
            "title": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "equipmentChecklistPhotoInput": {
            "equipmentChecklistAnswerId": [
                955
            ],
            "equipmentChecklistId": [
                955
            ],
            "s3Key": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "extraLocationDataInput": {
            "defaultStartFacilityId": [
                345
            ],
            "driverNotes": [
                955
            ],
            "endTime": [
                194
            ],
            "estimatedJobDistance": [
                286
            ],
            "estimatedJobTime": [
                286
            ],
            "extraLocationDataId": [
                955
            ],
            "locationId": [
                955
            ],
            "locationNotes": [
                955
            ],
            "serviceDays": [
                955
            ],
            "startTime": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "facilitySettingInput": {
            "alertFailedJob": [
                85
            ],
            "alertTimeOnSite": [
                85
            ],
            "alertTimeOnSiteDays": [
                357
            ],
            "allowAssetsToBeAssignedToSpecificCompanies": [
                85
            ],
            "allowCarryOverNotes": [
                85
            ],
            "allowDriverJobCreation": [
                85
            ],
            "allowDuplicateObjectNames": [
                85
            ],
            "allowEditingActiveJobs": [
                85
            ],
            "billOfLadingLiabilityNotice": [
                955
            ],
            "billOfLadingNumberPostfix": [
                955
            ],
            "billOfLadingNumberPrefix": [
                955
            ],
            "billOfSalesDisclaimer": [
                955
            ],
            "blankScaleTicketIdentifier": [
                72
            ],
            "blankScaleTicketInternalNoteFieldStatus": [
                272
            ],
            "blankScaleTicketLicensePlateNumberFieldStatus": [
                272
            ],
            "blankScaleTicketTruckNumberFieldStatus": [
                272
            ],
            "canHaveMultipleActiveJobs": [
                85
            ],
            "canStartJobsOutOfOrder": [
                85
            ],
            "centralizedCompanyId": [
                955
            ],
            "clearDriverTruckTrailerAssignment": [
                955
            ],
            "clearSuccessfulJobs": [
                85
            ],
            "dateFormatType": [
                195
            ],
            "deadlineDays": [
                357
            ],
            "defaultTransactionDateType": [
                213
            ],
            "dismantlerNumber": [
                357
            ],
            "displayCheckNumber": [
                85
            ],
            "displayDeadlineDate": [
                85
            ],
            "displayExternalNotes": [
                85
            ],
            "displayHundredweight": [
                85
            ],
            "displayInventoryTagPrimaryWeight": [
                430
            ],
            "displayMaterialAssetName": [
                85
            ],
            "displayMaterialAssetSelector": [
                85
            ],
            "displayPreviousJobAssetsSelectionInDriverApp": [
                85
            ],
            "displayProductDescription": [
                220
            ],
            "displayReturnFacility": [
                85
            ],
            "displaySupplierDriversLicense": [
                85
            ],
            "displaySupplierVehiclePlate": [
                85
            ],
            "displayWeighedByName": [
                85
            ],
            "displayWeightCaptureMethod": [
                85
            ],
            "displayWeightCaptureMethodLegend": [
                85
            ],
            "documentLogoId": [
                955
            ],
            "driverAppRequiresAssetPhotos": [
                843
            ],
            "driverAppRequiresLocationPhotos": [
                844
            ],
            "enforceAssetTransportationCompatibility": [
                85
            ],
            "facilityId": [
                955
            ],
            "floridaDerelictLicenseNumber": [
                955
            ],
            "invoiceDisclaimer": [
                955
            ],
            "isBillOfLadingLiabilityNoticeActive": [
                85
            ],
            "isBillOfSalesActive": [
                85
            ],
            "isCrvActive": [
                85
            ],
            "isInvoiceDisclaimerActive": [
                85
            ],
            "isLiabilityWaiverActive": [
                85
            ],
            "isPurchaseOrderDisclaimerActive": [
                85
            ],
            "isSalesOrderDisclaimerActive": [
                85
            ],
            "isWeightMasterCertificateActive": [
                85
            ],
            "jobCompletedPastDeadline": [
                85
            ],
            "jobEstimates": [
                85
            ],
            "liabilityWaiverDisclaimer": [
                955
            ],
            "measurementSystem": [
                560
            ],
            "minimumAge": [
                357
            ],
            "printPublicFingerprint": [
                85
            ],
            "promptDriverToConfirmTruckTrailer": [
                955
            ],
            "promptForMaterialEntry": [
                85
            ],
            "purchaseOrderDisclaimer": [
                955
            ],
            "requireAllVehicleDetails": [
                85
            ],
            "requireBusinessLicenseNumber": [
                85
            ],
            "requireConverterVehicleIdentificationNumber": [
                85
            ],
            "requireConverterVehicleLicensePlate": [
                85
            ],
            "requireConverterVehicleMake": [
                85
            ],
            "requireConverterVehicleModel": [
                85
            ],
            "requireConverterVehicleTitle": [
                85
            ],
            "requireConverterVehicleYear": [
                85
            ],
            "requireDefaultSignature": [
                85
            ],
            "requireDriverCameraPhotos": [
                85
            ],
            "requireDriverLicenseBack": [
                85
            ],
            "requireDriverLicenseFront": [
                85
            ],
            "requireDriverNotes": [
                85
            ],
            "requireMaterialPhoto": [
                85
            ],
            "requireMinimumAge": [
                85
            ],
            "requireSupplierAddress": [
                85
            ],
            "requireSupplierDateOfBirth": [
                85
            ],
            "requireSupplierEmployerName": [
                85
            ],
            "requireSupplierHeight": [
                85
            ],
            "requireSupplierIdentificationIssuingState": [
                85
            ],
            "requireSupplierIdentificationNumber": [
                85
            ],
            "requireSupplierIdentificationType": [
                85
            ],
            "requireSupplierPhoto": [
                85
            ],
            "requireSupplierSex": [
                85
            ],
            "requireSupplierWeight": [
                85
            ],
            "requireThumbprint": [
                85
            ],
            "requireValidDateLicense": [
                85
            ],
            "requireVehicleColor": [
                85
            ],
            "requireVehicleLicense": [
                85
            ],
            "requireVehicleLicenseExpiration": [
                85
            ],
            "requireVehicleLicenseState": [
                85
            ],
            "requireVehicleMake": [
                85
            ],
            "requireVehicleModel": [
                85
            ],
            "requireVehicleScalePhoto": [
                85
            ],
            "requireVehicleType": [
                85
            ],
            "requireVehicleYear": [
                85
            ],
            "salesMeasurementSystem": [
                560
            ],
            "salesOrderDisclaimer": [
                955
            ],
            "salesOrderLoadMaterialSlippage": [
                286
            ],
            "savePublicSupplierSignature": [
                85
            ],
            "scaleTicketDocumentThermalMarginOffset": [
                357
            ],
            "scaleTicketDocumentsBodyFontSize": [
                357
            ],
            "scaleTicketDocumentsDisclaimerFontSize": [
                357
            ],
            "scaleTicketEmail": [
                955
            ],
            "scaleTicketPhoneNumber": [
                955
            ],
            "scaleTicketReceiptType": [
                906
            ],
            "scaleTicketRequiresSignature": [
                845
            ],
            "scaleTicketTableFormat": [
                913
            ],
            "scaleTicketThermalReceiptWidthInches": [
                914
            ],
            "scaleTicketThumbnailDisplayOption": [
                915
            ],
            "scaleTicketWebsite": [
                955
            ],
            "showDeductionReason": [
                85
            ],
            "supplierPhotoOnPayment": [
                85
            ],
            "taxRatesAffectsWACCalculation": [
                85
            ],
            "useDoubleScaleSplitWeight": [
                85
            ],
            "usePresetPricing": [
                85
            ],
            "weightConversion": [
                85
            ],
            "weightConversionBOL": [
                85
            ],
            "weightConversionInvoice": [
                85
            ],
            "weightConversionOST": [
                85
            ],
            "weightConversionPackingList": [
                85
            ],
            "weightMasterCertificateDisclaimer": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "financialAccountAdjustmentInput": {
            "adjustmentQuantity": [
                286
            ],
            "adjustmentReason": [
                955
            ],
            "adjustmentType": [
                955
            ],
            "date": [
                194
            ],
            "financialAccountAdjustmentId": [
                955
            ],
            "fromAccountId": [
                955
            ],
            "toAccountId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "financialAccountInput": {
            "allowRepeatedCheckNumbers": [
                85
            ],
            "bankAccount": [
                1074
            ],
            "currentBalance": [
                286
            ],
            "customAttributes": [
                446
            ],
            "facilityIds": [
                955
            ],
            "financialAccountId": [
                955
            ],
            "financialAccountName": [
                955
            ],
            "financialAccountType": [
                282
            ],
            "scaleTicketRoundingMethod": [
                907
            ],
            "scaleTicketRoundingPrecision": [
                908
            ],
            "visibleInPayments": [
                85
            ],
            "warningThreshold": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "finishOutboundScaleTicketInput": {
            "dateShipped": [
                194
            ],
            "files": [
                1144
            ],
            "outboundScaleTicketId": [
                955
            ],
            "pdfId": [
                955
            ],
            "transactionDate": [
                194
            ],
            "vehicleHeavyWeight": [
                286
            ],
            "vehicleLightWeight": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "finishScaleTicketInput": {
            "payment": [
                1188
            ],
            "payments": [
                1188
            ],
            "pdfId": [
                955
            ],
            "scaleTicketId": [
                955
            ],
            "signature": [
                446
            ],
            "supplierSignature": [
                1118
            ],
            "transactionDate": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "freightLaneCostInput": {
            "costType": [
                295
            ],
            "freightLaneCostId": [
                955
            ],
            "freightLaneId": [
                955
            ],
            "roundTripCost": [
                286
            ],
            "startDate": [
                194
            ],
            "weightUnit": [
                534
            ],
            "__typename": [
                955
            ]
        },
        "freightLaneInput": {
            "carrierId": [
                955
            ],
            "costType": [
                295
            ],
            "distance": [
                286
            ],
            "freightLaneId": [
                955
            ],
            "fuelSurchargeType": [
                309
            ],
            "fuelSurchargeValue": [
                286
            ],
            "locationAId": [
                955
            ],
            "locationBId": [
                955
            ],
            "roundTripCost": [
                286
            ],
            "startDate": [
                194
            ],
            "transportationTypeIds": [
                955
            ],
            "weightUnit": [
                534
            ],
            "__typename": [
                955
            ]
        },
        "fuelSurchargeInput": {
            "carrierId": [
                955
            ],
            "companyId": [
                955
            ],
            "fuelSurchargeId": [
                955
            ],
            "startDate": [
                194
            ],
            "surchargeType": [
                309
            ],
            "surchargeValue": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "getAtmPaymentsThatRequireConfirmationToBeVoidedInput": {
            "paymentTransactionIds": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "getPresignedURLOptionsInput": {
            "action": [
                955
            ],
            "contentType": [
                955
            ],
            "humanReadableFilename": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "governmentReportingFacilityInput": {
            "facilityId": [
                955
            ],
            "mlid": [
                955
            ],
            "reportingFacilityId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "groupInput": {
            "areFacilitySettingsLocked": [
                85
            ],
            "customGroupId": [
                955
            ],
            "defaultFacilityId": [
                955
            ],
            "facilities": [
                1167
            ],
            "groupId": [
                955
            ],
            "groupName": [
                955
            ],
            "privilegedUsers": [
                1276
            ],
            "__typename": [
                955
            ]
        },
        "idScanningSessionInput": {
            "barcodeData": [
                955
            ],
            "identificationBackS3Key": [
                955
            ],
            "identificationFrontS3Key": [
                955
            ],
            "mrzData": [
                955
            ],
            "scanDataType": [
                931
            ],
            "scanningSessionId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "inboundOutboundScaleTicketAttachableInput": {
            "file": [
                1205
            ],
            "inboundOutboundScaleTicketAttachableId": [
                955
            ],
            "objectType": [
                878
            ],
            "__typename": [
                955
            ]
        },
        "initialAmountInput": {
            "accountingDate": [
                194
            ],
            "currency": [
                173
            ],
            "facilityId": [
                955
            ],
            "id": [
                955
            ],
            "initialAmountType": [
                355
            ],
            "net": [
                286
            ],
            "totalPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "inventoryTagInput": {
            "creatorId": [
                955
            ],
            "grossWeight": [
                286
            ],
            "grossWeightCaptureMethod": [
                1064
            ],
            "inventoryTagId": [
                955
            ],
            "inventoryTagNumber": [
                357
            ],
            "locationId": [
                955
            ],
            "materialId": [
                955
            ],
            "notes": [
                955
            ],
            "photos": [
                1205
            ],
            "printedAt": [
                194
            ],
            "productDescriptionId": [
                955
            ],
            "quantity": [
                286
            ],
            "scaleId": [
                955
            ],
            "status": [
                431
            ],
            "tagType": [
                432
            ],
            "tareTypeId": [
                955
            ],
            "tareWeight": [
                286
            ],
            "tareWeightCaptureMethod": [
                1064
            ],
            "visibleMaterialName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "inventoryTagPhotoInput": {
            "inventoryTagId": [
                955
            ],
            "inventoryTagPhotoId": [
                955
            ],
            "photoId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ipCameraInput": {
            "facilityId": [
                955
            ],
            "ipCameraId": [
                955
            ],
            "ipCameraName": [
                955
            ],
            "ipCameraUrl": [
                955
            ],
            "isStillImage": [
                85
            ],
            "scaleIds": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "jobInput": {
            "contactId": [
                955
            ],
            "creatorPlatform": [
                162
            ],
            "deadlineChangeNotes": [
                955
            ],
            "deadlineDate": [
                194
            ],
            "dispatcherAcceptTime": [
                194
            ],
            "driverEndTime": [
                194
            ],
            "driverId": [
                955
            ],
            "driverNotes": [
                955
            ],
            "driverOrder": [
                955
            ],
            "driverStartTime": [
                194
            ],
            "estimatedEndTime": [
                955
            ],
            "estimatedStartTime": [
                955
            ],
            "failedJobNotes": [
                955
            ],
            "failedJobReason": [
                955
            ],
            "files": [
                1205
            ],
            "groupId": [
                955
            ],
            "highPriority": [
                85
            ],
            "isDraft": [
                85
            ],
            "isNonDefaultTrailer": [
                85
            ],
            "isNonDefaultTruck": [
                85
            ],
            "isServiceRequest": [
                85
            ],
            "jobId": [
                955
            ],
            "jobLocations": [
                1150
            ],
            "jobScheduleId": [
                955
            ],
            "jobTemplateId": [
                955
            ],
            "jobType": [
                492
            ],
            "scheduledDate": [
                194
            ],
            "serviceRequestNotes": [
                955
            ],
            "shareLocationNotesWithDriver": [
                85
            ],
            "shareServiceRequestNotesWithDriver": [
                85
            ],
            "status": [
                955
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "timeAssigned": [
                194
            ],
            "trailerId": [
                955
            ],
            "truckId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "jobLocationInput": {
            "collectSignature": [
                85
            ],
            "dispatcherNotes": [
                955
            ],
            "driverStatus": [
                955
            ],
            "externalNotes": [
                955
            ],
            "heavyWeight": [
                286
            ],
            "jobId": [
                955
            ],
            "jobLocationId": [
                955
            ],
            "jobLocationMaterials": [
                1151
            ],
            "jobLocationOrder": [
                357
            ],
            "jobLocationPayloadActions": [
                1152
            ],
            "lightWeight": [
                286
            ],
            "locationId": [
                955
            ],
            "noAction": [
                85
            ],
            "requireMaterialEntry": [
                85
            ],
            "signatureId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "jobLocationMaterialInput": {
            "centralizedCompanyId": [
                955
            ],
            "files": [
                1205
            ],
            "grossWeight": [
                286
            ],
            "jobLocationId": [
                955
            ],
            "jobLocationMaterialId": [
                955
            ],
            "materialId": [
                955
            ],
            "tareWeight": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "jobLocationPayloadActionInput": {
            "action": [
                458
            ],
            "jobLocationId": [
                955
            ],
            "payload": [
                1187
            ],
            "payloadId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "jobLocationPayloadActionPhotoInput": {
            "assetImageType": [
                955
            ],
            "jobLocationPayloadActionId": [
                955
            ],
            "photoId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "jobLocationPhotoInput": {
            "jobLocationId": [
                955
            ],
            "payloadAction": [
                458
            ],
            "photoId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "jobScheduleAssetTypeInput": {
            "assetDescriptionId": [
                955
            ],
            "assetTypeId": [
                955
            ],
            "assetTypeValue": [
                955
            ],
            "jobScheduleId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "jobScheduleInput": {
            "assetTypesFromFacility": [
                1155
            ],
            "assetTypesToFacility": [
                1155
            ],
            "companyLocationId": [
                955
            ],
            "dispatcherNotes": [
                955
            ],
            "driverId": [
                955
            ],
            "dropoffFacilityId": [
                955
            ],
            "endDate": [
                194
            ],
            "externalNotes": [
                955
            ],
            "facilityId": [
                955
            ],
            "groupId": [
                955
            ],
            "jobScheduleId": [
                955
            ],
            "jobType": [
                955
            ],
            "numberOfInstancesToCreate": [
                357
            ],
            "repeatFrequency": [
                357
            ],
            "repeatMagnitude": [
                476
            ],
            "repeatedDateOfMonth": [
                357
            ],
            "repeatedDaysOfWeek": [
                357
            ],
            "repeatedWeekOfMonth": [
                357
            ],
            "shareLocationNotesWithDriver": [
                85
            ],
            "startDate": [
                194
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "jobTemplateInput": {
            "groupId": [
                955
            ],
            "jobTemplateId": [
                955
            ],
            "jobTemplateLocations": [
                1158
            ],
            "jobType": [
                492
            ],
            "templateName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "jobTemplateLocationInput": {
            "collectSignature": [
                85
            ],
            "jobLocationOrder": [
                357
            ],
            "jobTemplateLocationId": [
                955
            ],
            "jobTemplatePayloadActions": [
                1159
            ],
            "locationId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "jobTemplatePayloadActionInput": {
            "action": [
                458
            ],
            "jobTemplatePayload": [
                1160
            ],
            "jobTemplatePayloadActionId": [
                955
            ],
            "jobTemplatePayloadId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "jobTemplatePayloadInput": {
            "assetDescriptionId": [
                955
            ],
            "assetTypeId": [
                955
            ],
            "jobTemplatePayloadId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "leadDeleteInput": {
            "leadId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "leadInput": {
            "companyName": [
                955
            ],
            "contacts": [
                1081
            ],
            "isCustomer": [
                85
            ],
            "isServiceProvider": [
                85
            ],
            "isSupplier": [
                85
            ],
            "leadId": [
                955
            ],
            "locations": [
                1167
            ],
            "__typename": [
                955
            ]
        },
        "leadUpdateInput": {
            "companyName": [
                955
            ],
            "isCustomer": [
                85
            ],
            "isServiceProvider": [
                85
            ],
            "isSupplier": [
                85
            ],
            "leadId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "leadUpdateNotesInput": {
            "leadId": [
                955
            ],
            "notes": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "leadUpdatePriorityInput": {
            "leadId": [
                955
            ],
            "priority": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "leadUpdateStatusInput": {
            "leadId": [
                955
            ],
            "status": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "locationInput": {
            "addressInputType": [
                29
            ],
            "city": [
                955
            ],
            "contacts": [
                1081
            ],
            "country": [
                955
            ],
            "county": [
                955
            ],
            "customAttributes": [
                446
            ],
            "customLocationId": [
                955
            ],
            "extraLocationData": [
                1130
            ],
            "facilityType": [
                955
            ],
            "groupId": [
                955
            ],
            "isDefaultMailingAddress": [
                85
            ],
            "isDefaultShipToLocation": [
                85
            ],
            "latitude": [
                286
            ],
            "locatableId": [
                955
            ],
            "locatableType": [
                955
            ],
            "locationId": [
                955
            ],
            "locationName": [
                955
            ],
            "longitude": [
                286
            ],
            "mailingAddress": [
                85
            ],
            "state": [
                955
            ],
            "streetAddress": [
                955
            ],
            "timezone": [
                955
            ],
            "zipcode": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "materialAdjustmentInput": {
            "adjustmentQuantityEntryType": [
                30
            ],
            "adjustmentReason": [
                955
            ],
            "adjustmentType": [
                366
            ],
            "adjustmentWacEntryType": [
                32
            ],
            "fromMaterialId": [
                955
            ],
            "inventoryTagId": [
                955
            ],
            "isNewInventory": [
                85
            ],
            "locationId": [
                955
            ],
            "postedAt": [
                194
            ],
            "quantity": [
                286
            ],
            "toInventoryTagProductDescriptionId": [
                955
            ],
            "toMaterialId": [
                955
            ],
            "weightedAverageCost": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "materialGroupInput": {
            "darkColor": [
                955
            ],
            "darkTextColor": [
                955
            ],
            "defaultPricingUnitGroup": [
                535
            ],
            "defaultSalesPricingUnitGroup": [
                535
            ],
            "lightColor": [
                955
            ],
            "lightTextColor": [
                955
            ],
            "materialGroupId": [
                955
            ],
            "materialGroupName": [
                955
            ],
            "materialGroupNumber": [
                955
            ],
            "materialGroupType": [
                559
            ],
            "__typename": [
                955
            ]
        },
        "materialInput": {
            "customAttributes": [
                446
            ],
            "darkColor": [
                955
            ],
            "darkTextColor": [
                955
            ],
            "defaultUnitPriceToNegative": [
                85
            ],
            "kansasScrapMetalMaterialFormId": [
                955
            ],
            "kansasScrapMetalMaterialTypeId": [
                955
            ],
            "lightColor": [
                955
            ],
            "lightTextColor": [
                955
            ],
            "materialGroupId": [
                955
            ],
            "materialId": [
                955
            ],
            "materialIntegrations": [
                1097
            ],
            "materialName": [
                955
            ],
            "materialNotes": [
                955
            ],
            "ohioDpsMaterialCode": [
                955
            ],
            "skuNumber": [
                955
            ],
            "texasOnlineMetalsMaterialCodeId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "memberInput": {
            "email": [
                955
            ],
            "name": [
                955
            ],
            "phoneNumber": [
                955
            ],
            "role": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "netPayForSupplierInput": {
            "achNumber": [
                955
            ],
            "amount": [
                286
            ],
            "checkAttn": [
                955
            ],
            "checkLocationId": [
                955
            ],
            "checkMemo": [
                955
            ],
            "checkNumber": [
                955
            ],
            "facilityId": [
                955
            ],
            "financialAccountId": [
                955
            ],
            "paymentType": [
                618
            ],
            "supplierId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "netPaySelectedTransactionsInput": {
            "achNumber": [
                955
            ],
            "amount": [
                286
            ],
            "checkAttn": [
                955
            ],
            "checkLocationId": [
                955
            ],
            "checkMemo": [
                955
            ],
            "checkNumber": [
                955
            ],
            "facilityId": [
                955
            ],
            "financialAccountId": [
                955
            ],
            "payableNoteIds": [
                955
            ],
            "paymentType": [
                618
            ],
            "receivableInvoiceIds": [
                955
            ],
            "supplierId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "optionInput": {
            "optionName": [
                955
            ],
            "optionValue": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "outboundScaleTicketCatalyticConverterInput": {
            "catalyticConverterId": [
                955
            ],
            "catalyticConverterSize": [
                95
            ],
            "converterNotes": [
                955
            ],
            "converterVehicleIdentificationNumber": [
                955
            ],
            "converterVehicleLicensePlate": [
                955
            ],
            "converterVehicleMake": [
                955
            ],
            "converterVehicleModel": [
                955
            ],
            "converterVehicleYear": [
                194
            ],
            "files": [
                1205
            ],
            "materialId": [
                955
            ],
            "outboundScaleTicketCatalyticConverterId": [
                955
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "quantity": [
                286
            ],
            "unitPrice": [
                286
            ],
            "vehicleTitle": [
                1205
            ],
            "vehicleTitleId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "outboundScaleTicketFileInput": {
            "fileType": [
                955
            ],
            "humanReadableFilename": [
                955
            ],
            "outboundScaleTicketId": [
                955
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "s3Key": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "outboundScaleTicketFromLoadInput": {
            "bookingId": [
                955
            ],
            "carrierDriverName": [
                955
            ],
            "carrierScac": [
                955
            ],
            "dateShipped": [
                194
            ],
            "expectedShipDate": [
                194
            ],
            "facilityLocationId": [
                955
            ],
            "loadBookingNumber": [
                955
            ],
            "loadContainerNumber": [
                955
            ],
            "loadDeliveryNumber": [
                955
            ],
            "loadMaterials": [
                1181
            ],
            "loadRailCar": [
                955
            ],
            "loadReceivedDate": [
                194
            ],
            "loadReleaseNumber": [
                955
            ],
            "loadSealNumber": [
                955
            ],
            "loadTrailerNumber": [
                955
            ],
            "loadTruckNumber": [
                955
            ],
            "numberOfInstances": [
                357
            ],
            "outboundScaleTicketId": [
                955
            ],
            "salesOrderId": [
                955
            ],
            "shippingCarrierName": [
                955
            ],
            "status": [
                606
            ],
            "__typename": [
                955
            ]
        },
        "outboundScaleTicketInput": {
            "activeScaleId": [
                955
            ],
            "allInventoryTagsAreReserved": [
                85
            ],
            "bookingId": [
                955
            ],
            "carrierDriverName": [
                955
            ],
            "carrierScac": [
                955
            ],
            "companyId": [
                955
            ],
            "companyLocationId": [
                955
            ],
            "completionNotes": [
                955
            ],
            "creationType": [
                589
            ],
            "creatorPlatform": [
                607
            ],
            "dateShipped": [
                194
            ],
            "expectedShipDate": [
                194
            ],
            "externalNotes": [
                955
            ],
            "facilityLocationId": [
                955
            ],
            "files": [
                1144
            ],
            "frontendUrl": [
                955
            ],
            "internalNotes": [
                955
            ],
            "inventoryTags": [
                1180
            ],
            "lastNonReceivedSalesOrderLoad": [
                85
            ],
            "loadBookingNumber": [
                955
            ],
            "loadContainerNumber": [
                955
            ],
            "loadDeliveryNumber": [
                955
            ],
            "loadRailCar": [
                955
            ],
            "loadReceivedDate": [
                194
            ],
            "loadReleaseNumber": [
                955
            ],
            "loadSealNumber": [
                955
            ],
            "loadTrailerNumber": [
                955
            ],
            "loadTruckNumber": [
                955
            ],
            "materials": [
                1182
            ],
            "numberOfMaterials": [
                357
            ],
            "outboundScaleTicketId": [
                955
            ],
            "pdfId": [
                955
            ],
            "receivingFacilityLocationId": [
                955
            ],
            "requestedQuantity": [
                286
            ],
            "requestedWeight": [
                286
            ],
            "salesOrderId": [
                955
            ],
            "shippedPrice": [
                286
            ],
            "shippedWeight": [
                286
            ],
            "shippingCarrierName": [
                955
            ],
            "status": [
                606
            ],
            "transactionDate": [
                194
            ],
            "vehicleHeavyWeight": [
                286
            ],
            "vehicleHeavyWeightCaptureMethod": [
                1064
            ],
            "vehicleLightWeight": [
                286
            ],
            "vehicleLightWeightCaptureMethod": [
                1064
            ],
            "__typename": [
                955
            ]
        },
        "outboundScaleTicketInventoryTagFromLoadInput": {
            "grossWeight": [
                286
            ],
            "inventoryTagId": [
                955
            ],
            "netWeight": [
                286
            ],
            "outboundScaleTicketInventoryTagId": [
                955
            ],
            "quantity": [
                286
            ],
            "tareWeight": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "outboundScaleTicketInventoryTagInput": {
            "grossWeight": [
                286
            ],
            "inventoryTagId": [
                955
            ],
            "outboundScaleTicketInventoryTagId": [
                955
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "priceListId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "quantity": [
                286
            ],
            "requestedWeight": [
                286
            ],
            "salesOrderId": [
                955
            ],
            "salesOrderMaterialId": [
                955
            ],
            "tareWeight": [
                286
            ],
            "totalRequestedWeight": [
                286
            ],
            "unitPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "outboundScaleTicketMaterialFromLoadInput": {
            "grossWeight": [
                286
            ],
            "inventoryTags": [
                1179
            ],
            "materialId": [
                955
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "outboundScaleTicketRawMaterialId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescriptionId": [
                955
            ],
            "quantity": [
                286
            ],
            "salesOrderMaterialId": [
                955
            ],
            "tareWeight": [
                286
            ],
            "unitPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "outboundScaleTicketMaterialInput": {
            "convertRawToInventoryTag": [
                85
            ],
            "files": [
                1183
            ],
            "outboundScaleTicketCatalyticConverter": [
                1175
            ],
            "outboundScaleTicketId": [
                955
            ],
            "outboundScaleTicketInventoryTag": [
                1180
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "outboundScaleTicketRawMaterial": [
                1184
            ],
            "salesOrderId": [
                955
            ],
            "salesOrderMaterialId": [
                955
            ],
            "scaleId": [
                955
            ],
            "secondaryScaleId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "outboundScaleTicketMaterialsFileInput": {
            "fileType": [
                955
            ],
            "humanReadableFilename": [
                955
            ],
            "s3Key": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "outboundScaleTicketRawMaterialInput": {
            "gradingConfidence": [
                357
            ],
            "grossWeight": [
                286
            ],
            "grossWeightCaptureMethod": [
                1064
            ],
            "materialId": [
                955
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "outboundScaleTicketRawMaterialId": [
                955
            ],
            "priceListId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescriptionId": [
                955
            ],
            "quantity": [
                286
            ],
            "salesOrderId": [
                955
            ],
            "scrapValue": [
                286
            ],
            "splitGrossWeight1": [
                286
            ],
            "splitGrossWeight1CaptureMethod": [
                1064
            ],
            "splitGrossWeight2": [
                286
            ],
            "splitGrossWeight2CaptureMethod": [
                1064
            ],
            "splitTareWeight1": [
                286
            ],
            "splitTareWeight1CaptureMethod": [
                1064
            ],
            "splitTareWeight2": [
                286
            ],
            "splitTareWeight2CaptureMethod": [
                1064
            ],
            "tareWeight": [
                286
            ],
            "tareWeightCaptureMethod": [
                1064
            ],
            "unitPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "paySupplierInput": {
            "aggregatePaymentData": [
                1067
            ],
            "facilityId": [
                955
            ],
            "payableNotesIdsToBeDeleted": [
                955
            ],
            "payments": [
                1186
            ],
            "signature": [
                955
            ],
            "supplierPhoto": [
                1205
            ],
            "__typename": [
                955
            ]
        },
        "paySupplierPaymentInput": {
            "achNumber": [
                955
            ],
            "amount": [
                286
            ],
            "atmId": [
                955
            ],
            "checkAttn": [
                955
            ],
            "checkLocationId": [
                955
            ],
            "checkMemo": [
                955
            ],
            "checkNumber": [
                955
            ],
            "financialAccountId": [
                955
            ],
            "isFreightBill": [
                85
            ],
            "legalHold": [
                85
            ],
            "outboundScaleTicketId": [
                955
            ],
            "payableNoteEligibleDate": [
                194
            ],
            "payableNoteId": [
                955
            ],
            "payeeName": [
                955
            ],
            "paymentSchedule": [
                624
            ],
            "preferredPaymentType": [
                955
            ],
            "scaleTicketId": [
                955
            ],
            "supplierId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "payloadInput": {
            "asset": [
                1071
            ],
            "assetDescriptionId": [
                955
            ],
            "assetId": [
                955
            ],
            "assetName": [
                955
            ],
            "assetType": [
                1072
            ],
            "assetTypeId": [
                955
            ],
            "binNotes": [
                955
            ],
            "grade": [
                337
            ],
            "isWrongBin": [
                85
            ],
            "payloadId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "paymentInput": {
            "achNumber": [
                955
            ],
            "amount": [
                286
            ],
            "atmId": [
                955
            ],
            "barcode": [
                955
            ],
            "centralizedCompanyId": [
                955
            ],
            "checkAttn": [
                955
            ],
            "checkMemo": [
                955
            ],
            "checkNumber": [
                955
            ],
            "checkNumberDate": [
                955
            ],
            "defaultPaymentTermId": [
                955
            ],
            "email": [
                955
            ],
            "facilityId": [
                955
            ],
            "financialAccountId": [
                955
            ],
            "latestEligiblePaymentDate": [
                194
            ],
            "legalHold": [
                85
            ],
            "locationId": [
                955
            ],
            "payableNoteId": [
                955
            ],
            "payablePaymentCurrency": [
                173
            ],
            "payeeName": [
                955
            ],
            "paymentId": [
                955
            ],
            "paymentSchedule": [
                624
            ],
            "paymentSettingsId": [
                955
            ],
            "paymentType": [
                955
            ],
            "scaleTicketId": [
                955
            ],
            "signatureForPayment": [
                955
            ],
            "supplierPhoto": [
                1205
            ],
            "__typename": [
                955
            ]
        },
        "paymentSettingsInput": {
            "accountNumber": [
                955
            ],
            "bank": [
                955
            ],
            "businessName": [
                955
            ],
            "checkNumberGeneration": [
                85
            ],
            "logo": [
                955
            ],
            "mailingAddress": [
                955
            ],
            "paymentSettingsId": [
                955
            ],
            "phoneNumber": [
                955
            ],
            "routingNumber": [
                955
            ],
            "signature": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "positivePayFileInput": {
            "bankAccountId": [
                955
            ],
            "endDate": [
                955
            ],
            "positivePayTemplateId": [
                955
            ],
            "startDate": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "priceListMaterialTierInput": {
            "priceListMaterialId": [
                955
            ],
            "priceListMaterialTierId": [
                955
            ],
            "priceMax": [
                955
            ],
            "priceMin": [
                955
            ],
            "priceTarget": [
                955
            ],
            "weightMax": [
                286
            ],
            "weightMin": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "publicSupplierFilesInput": {
            "files": [
                1205
            ],
            "publicSupplierId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "publicSupplierInput": {
            "businessLicenseNumber": [
                955
            ],
            "centralizedCompanyId": [
                955
            ],
            "customAttributes": [
                446
            ],
            "dateOfBirth": [
                194
            ],
            "doNotBuy": [
                85
            ],
            "doNotBuyOriginType": [
                221
            ],
            "email": [
                955
            ],
            "employerName": [
                955
            ],
            "eyeColor": [
                955
            ],
            "fingerprint": [
                1205
            ],
            "firstName": [
                955
            ],
            "hairColor": [
                955
            ],
            "height": [
                286
            ],
            "identificationBack": [
                1205
            ],
            "identificationExpiresDate": [
                194
            ],
            "identificationFront": [
                1205
            ],
            "identificationIssuedDate": [
                194
            ],
            "identificationNumber": [
                955
            ],
            "identificationState": [
                955
            ],
            "identificationType": [
                955
            ],
            "inboundTaxRateIds": [
                955
            ],
            "lastName": [
                955
            ],
            "location": [
                1167
            ],
            "middleName": [
                955
            ],
            "notes": [
                955
            ],
            "paymentDatePreference": [
                194
            ],
            "paymentHoldDays": [
                286
            ],
            "paymentSchedulePreference": [
                624
            ],
            "paymentTypePreference": [
                955
            ],
            "phoneNumber": [
                955
            ],
            "priceListGroupId": [
                955
            ],
            "publicSupplierId": [
                955
            ],
            "race": [
                955
            ],
            "sex": [
                955
            ],
            "suffix": [
                955
            ],
            "supplierSignatureId": [
                955
            ],
            "trailers": [
                1229
            ],
            "vehicles": [
                1229
            ],
            "weight": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "purchaseOrderInput": {
            "accountRepresentativeId": [
                955
            ],
            "attachableId": [
                955
            ],
            "completionNotes": [
                955
            ],
            "contactId": [
                955
            ],
            "counterpartySalesOrderNumber": [
                955
            ],
            "defaultPaymentTermId": [
                955
            ],
            "endDate": [
                194
            ],
            "facilityLocationId": [
                955
            ],
            "files": [
                1205
            ],
            "freightTerm": [
                303
            ],
            "locationId": [
                955
            ],
            "notes": [
                955
            ],
            "paymentCurrency": [
                173
            ],
            "paymentTerm": [
                630
            ],
            "pdfId": [
                955
            ],
            "purchaseOrderId": [
                955
            ],
            "purchaseOrderNumber": [
                357
            ],
            "startDate": [
                194
            ],
            "status": [
                782
            ],
            "supplierId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "purchaseOrderMaterialInput": {
            "materialId": [
                955
            ],
            "netWeight": [
                286
            ],
            "priceListId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescriptionId": [
                955
            ],
            "purchaseOrderId": [
                955
            ],
            "purchaseOrderMaterialId": [
                955
            ],
            "quantity": [
                286
            ],
            "unitPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "readableFinancialAccountTypes": {},
        "receivePaymentForInvoicesInput": {
            "achNumber": [
                955
            ],
            "checkAttn": [
                955
            ],
            "checkLocationId": [
                955
            ],
            "checkMemo": [
                955
            ],
            "checkNumber": [
                955
            ],
            "facilityId": [
                955
            ],
            "financialAccountId": [
                955
            ],
            "paymentTransactionAmount": [
                286
            ],
            "paymentTransactionCurrency": [
                173
            ],
            "paymentTransactionDate": [
                194
            ],
            "paymentType": [
                810
            ],
            "receivableInvoiceIds": [
                955
            ],
            "receivablePaymentDate": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "receivedOutboundScaleTicketMaterialInput": {
            "grossWeight": [
                286
            ],
            "inventoryTagId": [
                955
            ],
            "materialId": [
                955
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescriptionId": [
                955
            ],
            "quantity": [
                286
            ],
            "receivedOutboundScaleTicketMaterialId": [
                955
            ],
            "splitGrossWeight1": [
                286
            ],
            "splitGrossWeight2": [
                286
            ],
            "splitTareWeight1": [
                286
            ],
            "splitTareWeight2": [
                286
            ],
            "tareWeight": [
                286
            ],
            "unitPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "reportColumnWithAliasInput": {
            "aggregate": [
                823
            ],
            "alias": [
                955
            ],
            "name": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "reportFilterDataInput": {
            "isGlobalFilter": [
                85
            ],
            "type": [
                825
            ],
            "value": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "reportFilterInput": {
            "aggregate": [
                823
            ],
            "columnName": [
                955
            ],
            "data": [
                1200
            ],
            "isPeriodColumn": [
                85
            ],
            "op": [
                826
            ],
            "__typename": [
                955
            ]
        },
        "reportInput": {
            "aggregateBy": [
                955
            ],
            "columns": [
                1199
            ],
            "filters": [
                1201
            ],
            "includeSummary": [
                85
            ],
            "reportId": [
                955
            ],
            "sorters": [
                1203
            ],
            "__typename": [
                955
            ]
        },
        "reportSorterInput": {
            "aggregate": [
                823
            ],
            "columnName": [
                955
            ],
            "order": [
                837
            ],
            "__typename": [
                955
            ]
        },
        "resourceSettingInput": {
            "facilitySetting": [
                1131
            ],
            "resourceId": [
                955
            ],
            "resourceType": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "s3ObjectMetadataInput": {
            "assetImageType": [
                955
            ],
            "attachableId": [
                955
            ],
            "bucket": [
                955
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "equipmentChecklistAnswerId": [
                955
            ],
            "equipmentChecklistId": [
                955
            ],
            "fileType": [
                955
            ],
            "humanReadableFilename": [
                955
            ],
            "identificationId": [
                955
            ],
            "inventoryTagId": [
                955
            ],
            "jobLocationId": [
                955
            ],
            "jobLocationPayloadActionId": [
                955
            ],
            "payloadAction": [
                955
            ],
            "s3Key": [
                955
            ],
            "s3ObjectMetadataId": [
                955
            ],
            "scaleTicketAttachableType": [
                1211
            ],
            "scaleTicketId": [
                955
            ],
            "scaleTicketMaterialId": [
                955
            ],
            "uploadedBy": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "salesOrderInput": {
            "accountRepresentativeId": [
                955
            ],
            "attachableId": [
                955
            ],
            "billToLocationId": [
                955
            ],
            "completionNotes": [
                955
            ],
            "contactId": [
                955
            ],
            "counterpartyPurchaseOrderNumber": [
                955
            ],
            "customerId": [
                955
            ],
            "customerName": [
                955
            ],
            "defaultPaymentTermId": [
                955
            ],
            "doNotShip": [
                85
            ],
            "endDate": [
                955
            ],
            "facilityLocationId": [
                955
            ],
            "files": [
                1205
            ],
            "freightTerm": [
                303
            ],
            "loadMillOrderNumber": [
                955
            ],
            "locationId": [
                955
            ],
            "notes": [
                955
            ],
            "outboundScaleTicketId": [
                955
            ],
            "paymentCurrency": [
                173
            ],
            "paymentTerm": [
                630
            ],
            "pdfId": [
                955
            ],
            "salesOrderId": [
                955
            ],
            "salesOrderLoadId": [
                955
            ],
            "salesOrderMaterials": [
                1209
            ],
            "salesOrderNumber": [
                357
            ],
            "salesOrderType": [
                868
            ],
            "startDate": [
                955
            ],
            "status": [
                867
            ],
            "__typename": [
                955
            ]
        },
        "salesOrderLoadInput": {
            "carrierDriverName": [
                955
            ],
            "carrierScac": [
                955
            ],
            "expectedShipDate": [
                194
            ],
            "facilityId": [
                955
            ],
            "loadContainerNumber": [
                955
            ],
            "loadDeliveryNumber": [
                955
            ],
            "loadReceivedDate": [
                194
            ],
            "loadReleaseNumber": [
                955
            ],
            "loadSealNumber": [
                955
            ],
            "loadTrailerNumber": [
                955
            ],
            "loadTruckNumber": [
                955
            ],
            "salesOrderId": [
                955
            ],
            "salesOrderLoadId": [
                955
            ],
            "salesOrderLoadMaterials": [
                1208
            ],
            "shippingCarrierName": [
                955
            ],
            "status": [
                862
            ],
            "__typename": [
                955
            ]
        },
        "salesOrderLoadMaterialInput": {
            "grossWeight": [
                286
            ],
            "inventoryTagIds": [
                955
            ],
            "materialId": [
                955
            ],
            "productDescriptionId": [
                955
            ],
            "quantity": [
                286
            ],
            "salesOrderLoadId": [
                955
            ],
            "salesOrderLoadMaterialId": [
                955
            ],
            "salesOrderMaterialId": [
                955
            ],
            "tareWeight": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "salesOrderMaterialInput": {
            "materialId": [
                955
            ],
            "netWeight": [
                286
            ],
            "priceListId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescriptionId": [
                955
            ],
            "quantity": [
                357
            ],
            "salesOrderId": [
                955
            ],
            "salesOrderMaterialId": [
                955
            ],
            "totalPrice": [
                286
            ],
            "unitPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "scaleInput": {
            "defaultTareToZero": [
                85
            ],
            "facilityId": [
                955
            ],
            "maxWeight": [
                286
            ],
            "measurementIncrement": [
                286
            ],
            "minWeight": [
                286
            ],
            "scaleId": [
                955
            ],
            "scaleModel": [
                955
            ],
            "scaleName": [
                955
            ],
            "scaleType": [
                928
            ],
            "takePhotoOn": [
                876
            ],
            "unitOfMeasurement": [
                929
            ],
            "__typename": [
                955
            ]
        },
        "scaleTicketAttachableTypeInput": {
            "attachableType": [
                878
            ],
            "fileId": [
                955
            ],
            "scaleTicketAttachableTypeId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "scaleTicketCatalyticConverterInput": {
            "catalyticConverterId": [
                955
            ],
            "catalyticConverterSize": [
                95
            ],
            "converterNotes": [
                955
            ],
            "converterVehicleIdentificationNumber": [
                955
            ],
            "converterVehicleLicensePlate": [
                955
            ],
            "converterVehicleMake": [
                955
            ],
            "converterVehicleModel": [
                955
            ],
            "converterVehicleYear": [
                194
            ],
            "files": [
                1205
            ],
            "materialId": [
                955
            ],
            "quantity": [
                286
            ],
            "scaleTicketCatalyticConverterId": [
                955
            ],
            "scaleTicketMaterialId": [
                955
            ],
            "unitPrice": [
                286
            ],
            "vehicleTitle": [
                1205
            ],
            "vehicleTitleId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "scaleTicketDeductionInput": {
            "deductionTypeId": [
                955
            ],
            "notes": [
                955
            ],
            "priceDeduction": [
                286
            ],
            "reversedDeductionId": [
                955
            ],
            "scaleId": [
                955
            ],
            "scaleTicketDeductionId": [
                955
            ],
            "scaleTicketId": [
                955
            ],
            "scaleTicketMaterialId": [
                955
            ],
            "taxRateId": [
                955
            ],
            "weightDeduction": [
                286
            ],
            "weightDeductionCaptureMethod": [
                1064
            ],
            "__typename": [
                955
            ]
        },
        "scaleTicketInput": {
            "activeScaleId": [
                955
            ],
            "centralizedCompanyId": [
                955
            ],
            "companyId": [
                955
            ],
            "companyLocationId": [
                955
            ],
            "completionNotes": [
                955
            ],
            "creatorPlatform": [
                162
            ],
            "externalNotes": [
                955
            ],
            "facilityLocationId": [
                955
            ],
            "files": [
                1205
            ],
            "fingerPrint": [
                955
            ],
            "inboundJobId": [
                955
            ],
            "internalNotes": [
                955
            ],
            "licensePlateNumber": [
                955
            ],
            "materials": [
                1217
            ],
            "outboundScaleTicketId": [
                955
            ],
            "pdfId": [
                955
            ],
            "publicSupplierId": [
                955
            ],
            "purchaseOrderId": [
                955
            ],
            "receipt": [
                955
            ],
            "scaleTicketId": [
                955
            ],
            "scaleTicketNumber": [
                955
            ],
            "status": [
                909
            ],
            "supplierDriverId": [
                955
            ],
            "supplierSignatureId": [
                955
            ],
            "trailerId": [
                955
            ],
            "transactionDate": [
                194
            ],
            "truckNumber": [
                955
            ],
            "vehicleId": [
                955
            ],
            "vehicleIdentificationNumber": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "scaleTicketInventoryTagInput": {
            "grossWeightCaptureMethod": [
                1064
            ],
            "inventoryTag": [
                1146
            ],
            "priceListId": [
                955
            ],
            "pricingUnit": [
                955
            ],
            "purchaseOrderId": [
                955
            ],
            "scaleTicketInventoryTagId": [
                955
            ],
            "scaleTicketMaterialId": [
                955
            ],
            "tareWeightCaptureMethod": [
                1064
            ],
            "unitPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "scaleTicketMaterialFiltersInput": {
            "scaleTicketId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "scaleTicketMaterialInput": {
            "assetId": [
                955
            ],
            "assetIds": [
                955
            ],
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "files": [
                1205
            ],
            "isTareOnTruck": [
                85
            ],
            "reversedScaleTicketMaterialId": [
                955
            ],
            "scaleId": [
                955
            ],
            "scaleTicketCatalyticConverter": [
                1212
            ],
            "scaleTicketId": [
                955
            ],
            "scaleTicketInventoryTag": [
                1215
            ],
            "scaleTicketMaterialId": [
                955
            ],
            "scaleTicketMixedMaterial": [
                1220
            ],
            "scaleTicketRawMaterial": [
                1222
            ],
            "scaleTicketVehicle": [
                923
            ],
            "secondaryScaleId": [
                955
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "scaleTicketMaterialsFileInput": {
            "fileType": [
                955
            ],
            "humanReadableFilename": [
                955
            ],
            "s3Key": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "scaleTicketMaterialsFiltersInput": {
            "scaleTicketId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "scaleTicketMixedMaterialInput": {
            "grossWeight": [
                286
            ],
            "grossWeightCaptureMethod": [
                1064
            ],
            "materialId": [
                955
            ],
            "productDescriptionId": [
                955
            ],
            "scaleTicketMaterialId": [
                955
            ],
            "scaleTicketMixedMaterialId": [
                955
            ],
            "scaleTicketMixedMaterialItems": [
                1221
            ],
            "splitGrossWeight1": [
                286
            ],
            "splitGrossWeight1CaptureMethod": [
                1064
            ],
            "splitGrossWeight2": [
                286
            ],
            "splitGrossWeight2CaptureMethod": [
                1064
            ],
            "splitTareWeight1": [
                286
            ],
            "splitTareWeight1CaptureMethod": [
                1064
            ],
            "splitTareWeight2": [
                286
            ],
            "splitTareWeight2CaptureMethod": [
                1064
            ],
            "tareWeight": [
                286
            ],
            "tareWeightCaptureMethod": [
                1064
            ],
            "__typename": [
                955
            ]
        },
        "scaleTicketMixedMaterialItemInput": {
            "centralizedCompanyId": [
                955
            ],
            "materialId": [
                955
            ],
            "percentage": [
                286
            ],
            "priceListId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescriptionId": [
                955
            ],
            "purchaseOrderId": [
                955
            ],
            "scaleTicketMixedMaterialId": [
                955
            ],
            "scaleTicketMixedMaterialItemId": [
                955
            ],
            "unitPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "scaleTicketRawMaterialInput": {
            "centralizedCompanyId": [
                955
            ],
            "createdAt": [
                194
            ],
            "grossWeight": [
                286
            ],
            "grossWeightCaptureMethod": [
                1064
            ],
            "materialId": [
                955
            ],
            "priceListId": [
                955
            ],
            "pricingUnit": [
                955
            ],
            "productDescriptionId": [
                955
            ],
            "purchaseOrderId": [
                955
            ],
            "quantity": [
                286
            ],
            "scaleTicketMaterialId": [
                955
            ],
            "scaleTicketRawMaterialId": [
                955
            ],
            "scrapValue": [
                286
            ],
            "splitGrossWeight1": [
                286
            ],
            "splitGrossWeight1CaptureMethod": [
                1064
            ],
            "splitGrossWeight2": [
                286
            ],
            "splitGrossWeight2CaptureMethod": [
                1064
            ],
            "splitTareWeight1": [
                286
            ],
            "splitTareWeight1CaptureMethod": [
                1064
            ],
            "splitTareWeight2": [
                286
            ],
            "splitTareWeight2CaptureMethod": [
                1064
            ],
            "tareWeight": [
                286
            ],
            "tareWeightCaptureMethod": [
                1064
            ],
            "unitPrice": [
                286
            ],
            "updatedAt": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "scanningSessionInput": {
            "scannableId": [
                955
            ],
            "scannableType": [
                932
            ],
            "__typename": [
                955
            ]
        },
        "shippingCarrierInput": {
            "carrierName": [
                955
            ],
            "carrierType": [
                86
            ],
            "contacts": [
                1081
            ],
            "locations": [
                1167
            ],
            "notes": [
                955
            ],
            "scacNumber": [
                955
            ],
            "shippingCarrierId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "ssoConfigurationInput": {
            "emailAttribute": [
                955
            ],
            "familyNameAttribute": [
                955
            ],
            "givenNameAttribute": [
                955
            ],
            "idpMetadata": [
                955
            ],
            "ssoLoginDomain": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "tareTypeInput": {
            "tareTypeId": [
                955
            ],
            "tareTypeMassUnit": [
                534
            ],
            "tareTypeName": [
                955
            ],
            "tareTypeNotes": [
                955
            ],
            "tareTypeWeight": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "thirdPartyHaulerInput": {
            "accountManagerIds": [
                955
            ],
            "contacts": [
                1081
            ],
            "customHaulerId": [
                955
            ],
            "locations": [
                1167
            ],
            "onboarded": [
                85
            ],
            "privilegedFacilityIds": [
                955
            ],
            "privilegedGroupIds": [
                955
            ],
            "scac": [
                955
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "thirdPartyHaulerName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "trailerInput": {
            "files": [
                1205
            ],
            "licensePlateNumber": [
                955
            ],
            "notes": [
                955
            ],
            "plateExpiration": [
                194
            ],
            "primaryGroupId": [
                955
            ],
            "privilegedFacilityIds": [
                955
            ],
            "privilegedGroupIds": [
                955
            ],
            "state": [
                955
            ],
            "status": [
                955
            ],
            "trailerId": [
                955
            ],
            "trailerNumber": [
                955
            ],
            "trailerTypeId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "transportInput": {
            "kansasScrapMetalVehicleMakeCode": [
                955
            ],
            "kansasScrapMetalVehicleModelCode": [
                955
            ],
            "licensePlateExpiration": [
                194
            ],
            "licensePlateNumber": [
                955
            ],
            "licensePlateState": [
                955
            ],
            "texasOnlineMetalsVehicleCodeId": [
                955
            ],
            "transportId": [
                955
            ],
            "transportType": [
                955
            ],
            "transportableId": [
                955
            ],
            "transportableType": [
                1015
            ],
            "truckNumber": [
                955
            ],
            "type": [
                955
            ],
            "vehicleColor": [
                955
            ],
            "vehicleMake": [
                955
            ],
            "vehicleModel": [
                955
            ],
            "vehicleYear": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "transportationTypeInput": {
            "compatibleTransportationTypeIds": [
                955
            ],
            "transportationType": [
                955
            ],
            "transportationTypeId": [
                955
            ],
            "transportationTypeValue": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "truckInput": {
            "defaultTrailerId": [
                955
            ],
            "files": [
                1205
            ],
            "licensePlateNumber": [
                955
            ],
            "notes": [
                955
            ],
            "plateExpiration": [
                194
            ],
            "primaryGroupId": [
                955
            ],
            "privilegedFacilityIds": [
                955
            ],
            "privilegedGroupIds": [
                955
            ],
            "state": [
                955
            ],
            "status": [
                955
            ],
            "trailerId": [
                955
            ],
            "truckId": [
                955
            ],
            "truckModelId": [
                955
            ],
            "truckModelName": [
                955
            ],
            "truckNumber": [
                955
            ],
            "truckTypeId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "truckModelInput": {
            "name": [
                955
            ],
            "truckModelId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateAccountingAgingCategoryInput": {
            "accountingAgingCategoryId": [
                955
            ],
            "accountingAgingCategoryName": [
                955
            ],
            "endDays": [
                357
            ],
            "startDays": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "updateAssetDescriptionInput": {
            "assetDescription": [
                955
            ],
            "assetDescriptionId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateBankAccountInput": {
            "accountNumber": [
                955
            ],
            "accountType": [
                70
            ],
            "bankAccountId": [
                955
            ],
            "bankName": [
                955
            ],
            "routingNumber": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateCrvBatchInput": {
            "crvBatchId": [
                955
            ],
            "crvMaterialId": [
                955
            ],
            "endDate": [
                194
            ],
            "facilityId": [
                955
            ],
            "startDate": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "updateCrvRateInput": {
            "containersPerSegregatedPound": [
                286
            ],
            "crvRateId": [
                955
            ],
            "refundValuePerLargeContainer": [
                286
            ],
            "refundValuePerSegregatedPound": [
                286
            ],
            "refundValuePerSmallContainer": [
                286
            ],
            "refundValuePerWineAndDistilledSpirits": [
                286
            ],
            "scrapValue": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "updateCustomAttributeInput": {
            "customAttributeId": [
                955
            ],
            "customAttributeName": [
                955
            ],
            "maxLength": [
                357
            ],
            "maxNumber": [
                286
            ],
            "minLength": [
                357
            ],
            "minNumber": [
                286
            ],
            "options": [
                1124
            ],
            "required": [
                85
            ],
            "__typename": [
                955
            ]
        },
        "updateDeductionTypeInput": {
            "deductionTypeId": [
                955
            ],
            "deductionTypeName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateEquipmentChecklistAnswerInput": {
            "answer": [
                233
            ],
            "answerNotes": [
                955
            ],
            "equipmentChecklistAnswerId": [
                955
            ],
            "photos": [
                1205
            ],
            "__typename": [
                955
            ]
        },
        "updateEquipmentChecklistInput": {
            "equipmentChecklistId": [
                955
            ],
            "equipmentChecklistTemplateId": [
                955
            ],
            "equipmentHours": [
                286
            ],
            "equipmentId": [
                955
            ],
            "recyclerCentralizedCompanyId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateEquipmentChecklistTemplateInput": {
            "equipmentChecklistTemplateId": [
                955
            ],
            "equipmentChecklistTemplateName": [
                955
            ],
            "equipmentTypeId": [
                955
            ],
            "items": [
                1128
            ],
            "repeatFrequency": [
                236
            ],
            "repeatInterval": [
                357
            ],
            "__typename": [
                955
            ]
        },
        "updateEquipmentGroupInput": {
            "equipmentGroupId": [
                955
            ],
            "equipmentGroupName": [
                955
            ],
            "equipmentGroupNotes": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateEquipmentInput": {
            "equipmentId": [
                955
            ],
            "equipmentName": [
                955
            ],
            "equipmentTypeId": [
                955
            ],
            "installDate": [
                194
            ],
            "lastEquipmentChecklistId": [
                955
            ],
            "locationId": [
                955
            ],
            "notes": [
                955
            ],
            "recyclerCentralizedCompanyId": [
                955
            ],
            "serialNumber": [
                955
            ],
            "status": [
                251
            ],
            "__typename": [
                955
            ]
        },
        "updateEquipmentTypeInput": {
            "equipmentGroupId": [
                955
            ],
            "equipmentTypeId": [
                955
            ],
            "equipmentTypeName": [
                955
            ],
            "equipmentTypeNotes": [
                955
            ],
            "fileType": [
                955
            ],
            "s3Key": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateGovernmentReportingConfigurationInput": {
            "daysOfWeek": [
                955
            ],
            "facilities": [
                1141
            ],
            "fields": [
                955
            ],
            "governmentReportingConfigurationId": [
                955
            ],
            "loginEmail": [
                955
            ],
            "loginPassword": [
                955
            ],
            "recyclerId": [
                955
            ],
            "uploadService": [
                324
            ],
            "uploadState": [
                955
            ],
            "uploadTimezone": [
                955
            ],
            "uploadType": [
                336
            ],
            "__typename": [
                955
            ]
        },
        "updateJobLocationMaterialInput": {
            "grossWeight": [
                286
            ],
            "jobLocationMaterialId": [
                955
            ],
            "tareWeight": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "updateJobPauseReasonInput": {
            "description": [
                955
            ],
            "jobPauseReasonId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateMaterialIntegrationInput": {
            "integrationData": [
                446
            ],
            "materialIntegrationId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateOutboundScaleTicketFreightInput": {
            "deliveryNumber": [
                955
            ],
            "freightAccrualAmount": [
                286
            ],
            "freightDeductionAmount": [
                286
            ],
            "freightLaneCostId": [
                955
            ],
            "notes": [
                955
            ],
            "outboundScaleTicketFreightId": [
                955
            ],
            "outboundScaleTicketId": [
                955
            ],
            "paymentDueDate": [
                955
            ],
            "shouldCreateFreightBill": [
                85
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updatePaymentTermInput": {
            "dateDrivenDiscountPercentage": [
                286
            ],
            "discountDueBeforeDayOfMonth": [
                357
            ],
            "discountIfPaidWithin": [
                357
            ],
            "discountPercentage": [
                286
            ],
            "netDueBeforeDayOfMonth": [
                357
            ],
            "netDueInDays": [
                357
            ],
            "nextMonthDueIfIssuedWithinDays": [
                357
            ],
            "paymentTermId": [
                955
            ],
            "paymentTermName": [
                955
            ],
            "paymentTermType": [
                631
            ],
            "__typename": [
                955
            ]
        },
        "updatePositivePayTemplateInput": {
            "centralizedCompanyId": [
                955
            ],
            "definition": [
                446
            ],
            "fileType": [
                680
            ],
            "positivePayTemplateId": [
                955
            ],
            "templateName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updatePriceListGroupInput": {
            "companyIds": [
                955
            ],
            "name": [
                955
            ],
            "priceListGroupId": [
                955
            ],
            "publicSupplierIds": [
                955
            ],
            "type": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updatePriceListInput": {
            "endDate": [
                194
            ],
            "facilityId": [
                955
            ],
            "name": [
                955
            ],
            "priceListGroupId": [
                955
            ],
            "priceListId": [
                955
            ],
            "startDate": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "updatePriceListMaterialInput": {
            "materialId": [
                955
            ],
            "priceListId": [
                955
            ],
            "priceListMaterialId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescriptionId": [
                955
            ],
            "tiers": [
                1191
            ],
            "__typename": [
                955
            ]
        },
        "updateProcessExecutionInput": {
            "facilityId": [
                955
            ],
            "processExecutionId": [
                955
            ],
            "processExecutionMaterialsInput": [
                720
            ],
            "processId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateProcessInput": {
            "name": [
                955
            ],
            "processId": [
                955
            ],
            "status": [
                740
            ],
            "__typename": [
                955
            ]
        },
        "updateProcessLineBurdenInput": {
            "cost": [
                286
            ],
            "costUnit": [
                732
            ],
            "name": [
                955
            ],
            "processId": [
                955
            ],
            "processLineBurdenId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateProcessMappingInput": {
            "cost": [
                286
            ],
            "costUnit": [
                732
            ],
            "inputMaterialId": [
                955
            ],
            "outputMaterialId": [
                955
            ],
            "percentage": [
                286
            ],
            "processId": [
                955
            ],
            "processMappingId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateProductDescriptionInput": {
            "productDescriptionId": [
                955
            ],
            "productDescriptionName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updatePuertoRicoPoliceFormConfigurationInput": {
            "buyerFullName": [
                955
            ],
            "buyerMobileNumber": [
                955
            ],
            "buyerPhoneNumber": [
                955
            ],
            "buyerPostalAddress": [
                955
            ],
            "facilityLocationId": [
                955
            ],
            "puertoRicoPoliceFormConfigurationId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateReceivedOutboundScaleTicketDeductionInput": {
            "deductionCategory": [
                200
            ],
            "deductionMethod": [
                203
            ],
            "deductionReason": [
                955
            ],
            "deductionTypeId": [
                955
            ],
            "notes": [
                955
            ],
            "outboundScaleTicketId": [
                955
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "priceDeduction": [
                286
            ],
            "receivedOutboundScaleTicketDeductionId": [
                955
            ],
            "receivedOutboundScaleTicketMaterialId": [
                955
            ],
            "reversedDeductionId": [
                955
            ],
            "scaleId": [
                955
            ],
            "weightDeduction": [
                286
            ],
            "weightDeductionCaptureMethod": [
                1064
            ],
            "__typename": [
                955
            ]
        },
        "updateReceivedOutboundScaleTicketFreightInput": {
            "deliveryNumber": [
                955
            ],
            "freightAccrualAmount": [
                286
            ],
            "freightDeductionAmount": [
                286
            ],
            "freightLaneCostId": [
                955
            ],
            "notes": [
                955
            ],
            "outboundScaleTicketId": [
                955
            ],
            "receivedOutboundScaleTicketFreightId": [
                955
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateReceivedOutboundScaleTicketMaterialInput": {
            "deductions": [
                1262
            ],
            "grossWeight": [
                286
            ],
            "inventoryTagId": [
                955
            ],
            "materialId": [
                955
            ],
            "netWeight": [
                286
            ],
            "outboundScaleTicketMaterialId": [
                955
            ],
            "pricingUnit": [
                534
            ],
            "productDescriptionId": [
                955
            ],
            "quantity": [
                286
            ],
            "receivedOutboundScaleTicketMaterialId": [
                955
            ],
            "tareWeight": [
                286
            ],
            "totalPrice": [
                286
            ],
            "unitPrice": [
                286
            ],
            "__typename": [
                955
            ]
        },
        "updateReportScheduleInput": {
            "creatorId": [
                955
            ],
            "endDate": [
                194
            ],
            "fileType": [
                836
            ],
            "hourToBeRunAt": [
                357
            ],
            "isCustomSchedule": [
                85
            ],
            "monthlyRepeatMode": [
                955
            ],
            "notifiableUsers": [
                955
            ],
            "repeatFrequency": [
                357
            ],
            "repeatMagnitude": [
                936
            ],
            "repeatedDateOfMonth": [
                357
            ],
            "repeatedDaysOfWeek": [
                357
            ],
            "repeatedWeekOfMonth": [
                357
            ],
            "reportScheduleId": [
                955
            ],
            "reportTemplateId": [
                955
            ],
            "startDate": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "updateReportTemplateInput": {
            "definition": [
                446
            ],
            "description": [
                955
            ],
            "name": [
                955
            ],
            "privilegedFacilityIds": [
                955
            ],
            "privilegedGroupIds": [
                955
            ],
            "reportId": [
                828
            ],
            "reportPeriodColumnName": [
                955
            ],
            "reportTemplateId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateSalesOrderLoadReceivingTicketInput": {
            "externalNotes": [
                955
            ],
            "files": [
                1205
            ],
            "internalNotes": [
                955
            ],
            "loadReceivedDate": [
                194
            ],
            "millReceivedWeightPostDate": [
                194
            ],
            "outboundScaleTicketId": [
                955
            ],
            "receivingTicketIssueDate": [
                194
            ],
            "receivingTicketNumber": [
                955
            ],
            "salesOrderLoadReceivingTicketId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateScaleTicketFreightInput": {
            "deliveryNumber": [
                955
            ],
            "freightAccrualAmount": [
                286
            ],
            "freightDeductionAmount": [
                286
            ],
            "freightLaneCostId": [
                955
            ],
            "notes": [
                955
            ],
            "paymentDueDate": [
                955
            ],
            "scaleTicketFreightId": [
                955
            ],
            "scaleTicketId": [
                955
            ],
            "shouldCreateFreightBill": [
                85
            ],
            "thirdPartyHaulerId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateScaleTicketVehicleItemInput": {
            "attachableId": [
                955
            ],
            "files": [
                1205
            ],
            "kansasScrapMetalVehicleMakeCode": [
                955
            ],
            "kansasScrapMetalVehicleModelCode": [
                955
            ],
            "loadPercentage": [
                286
            ],
            "reportVehicle": [
                85
            ],
            "scaleTicketVehicleId": [
                955
            ],
            "scaleTicketVehicleItemId": [
                955
            ],
            "vehicleBodyStyle": [
                1055
            ],
            "vehicleColor": [
                955
            ],
            "vehicleMake": [
                955
            ],
            "vehicleModel": [
                955
            ],
            "vehicleOrder": [
                357
            ],
            "vehiclePlate": [
                955
            ],
            "vehicleStateOfTitleIssuance": [
                955
            ],
            "vehicleTagState": [
                955
            ],
            "vehicleTitle": [
                955
            ],
            "vehicleType": [
                1057
            ],
            "vehicleVin": [
                955
            ],
            "vehicleYear": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "updateSupplierSignatureInput": {
            "publicSupplierId": [
                955
            ],
            "signature": [
                446
            ],
            "supplierSignatureId": [
                955
            ],
            "uploadedById": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateTaxRateInput": {
            "taxRateAmount": [
                286
            ],
            "taxRateCalculationType": [
                981
            ],
            "taxRateId": [
                955
            ],
            "taxRateName": [
                955
            ],
            "taxRateNotes": [
                955
            ],
            "taxRateType": [
                984
            ],
            "__typename": [
                955
            ]
        },
        "updateTexasCashCardConfigurationInput": {
            "expirationNumberOfMonths": [
                357
            ],
            "facilityId": [
                955
            ],
            "recyclerName": [
                955
            ],
            "recyclerSignature": [
                1205
            ],
            "stateRegistrationNumber": [
                955
            ],
            "texasCashCardConfigurationId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateTexasCashCardInput": {
            "applicationType": [
                986
            ],
            "cardExpirationDate": [
                194
            ],
            "cardIssueDate": [
                194
            ],
            "facilityId": [
                955
            ],
            "fingerprint": [
                1205
            ],
            "fingerprintType": [
                993
            ],
            "publicSupplierId": [
                955
            ],
            "signature": [
                1205
            ],
            "supplierPhoto": [
                1205
            ],
            "texasCashCardId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateUserRoleTemplateInput": {
            "attributes": [
                1279
            ],
            "userRoleTemplateId": [
                955
            ],
            "userRoleTemplateName": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "updateVariableInput": {
            "description": [
                955
            ],
            "name": [
                955
            ],
            "value": [
                286
            ],
            "variableId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "userInput": {
            "company": [
                1076
            ],
            "defaultCashDrawerId": [
                955
            ],
            "email": [
                955
            ],
            "firstName": [
                955
            ],
            "isAdmin": [
                85
            ],
            "isDefaultPrintingEnabled": [
                85
            ],
            "lastName": [
                955
            ],
            "password": [
                955
            ],
            "permissionedFacilities": [
                1167
            ],
            "permissionedGroups": [
                1142
            ],
            "phoneNumber": [
                955
            ],
            "primaryFacilityId": [
                955
            ],
            "primaryScaleId": [
                955
            ],
            "role": [
                955
            ],
            "scalePaymentBehavior": [
                875
            ],
            "scaleTicketTableFormat": [
                913
            ],
            "timezone": [
                955
            ],
            "userId": [
                955
            ],
            "userPolicies": [
                1278
            ],
            "userSub": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "userPolicyAttributeInput": {
            "action": [
                955
            ],
            "attributeName": [
                955
            ],
            "enabled": [
                85
            ],
            "userPolicyAttributeId": [
                955
            ],
            "userPolicyId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "userPolicyInput": {
            "attributes": [
                1277
            ],
            "facility": [
                1167
            ],
            "group": [
                1142
            ],
            "user": [
                1276
            ],
            "userPolicyId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "userRoleTemplateAttributeInput": {
            "action": [
                955
            ],
            "attributeName": [
                955
            ],
            "userRoleTemplateAttributeId": [
                955
            ],
            "userRoleTemplateId": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "userSettingInput": {
            "name": [
                955
            ],
            "value": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "voidOutboundScaleTicketInput": {
            "outboundScaleTicketId": [
                955
            ],
            "reason": [
                955
            ],
            "transactionDate": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "voidOutboundScaleTicketsInput": {
            "outboundScaleTicketIds": [
                955
            ],
            "reason": [
                955
            ],
            "transactionDate": [
                194
            ],
            "__typename": [
                955
            ]
        },
        "voidPaymentsInput": {
            "paymentTransactionIds": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "voidReceivedPaymentsInput": {
            "paymentTransactionIds": [
                955
            ],
            "__typename": [
                955
            ]
        },
        "voucherTemplateInput": {
            "centralizedCompanyId": [
                955
            ],
            "displayAccountNumber": [
                85
            ],
            "displayBankAccount": [
                85
            ],
            "displayCheckNumber": [
                85
            ],
            "displayDate": [
                85
            ],
            "displayPayeeName": [
                85
            ],
            "displayRoutingNumber": [
                85
            ],
            "displayTicketDate": [
                85
            ],
            "displayTicketNumber": [
                85
            ],
            "displayTicketPrice": [
                85
            ],
            "displayTotalPrice": [
                85
            ],
            "marginBottom": [
                357
            ],
            "marginTop": [
                357
            ],
            "voucherTemplateId": [
                955
            ],
            "__typename": [
                955
            ]
        }
    }
}